import React, { useRef, useCallback, useEffect, useState, useMemo, forwardRef, isValidElement, cloneElement, useId } from 'react';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';

function decode(text = "") {
  try {
    return decodeURIComponent("" + text);
  } catch {
    return "" + text;
  }
}

const PROTOCOL_STRICT_REGEX = /^[\s\w\0+.-]{2,}:([/\\]{1,2})/;
const PROTOCOL_REGEX = /^[\s\w\0+.-]{2,}:([/\\]{2})?/;
const PROTOCOL_RELATIVE_REGEX = /^([/\\]\s*){2,}[^/\\]/;
const TRAILING_SLASH_RE = /\/$|\/\?|\/#/;
function hasProtocol(inputString, opts = {}) {
  if (typeof opts === "boolean") {
    opts = { acceptRelative: opts };
  }
  if (opts.strict) {
    return PROTOCOL_STRICT_REGEX.test(inputString);
  }
  return PROTOCOL_REGEX.test(inputString) || (opts.acceptRelative ? PROTOCOL_RELATIVE_REGEX.test(inputString) : false);
}
function hasTrailingSlash(input = "", respectQueryAndFragment) {
  if (!respectQueryAndFragment) {
    return input.endsWith("/");
  }
  return TRAILING_SLASH_RE.test(input);
}
function withoutTrailingSlash(input = "", respectQueryAndFragment) {
  if (!respectQueryAndFragment) {
    return (hasTrailingSlash(input) ? input.slice(0, -1) : input) || "/";
  }
  if (!hasTrailingSlash(input, true)) {
    return input || "/";
  }
  let path = input;
  let fragment = "";
  const fragmentIndex = input.indexOf("#");
  if (fragmentIndex !== -1) {
    path = input.slice(0, fragmentIndex);
    fragment = input.slice(fragmentIndex);
  }
  const [s0, ...s] = path.split("?");
  const cleanPath = s0.endsWith("/") ? s0.slice(0, -1) : s0;
  return (cleanPath || "/") + (s.length > 0 ? `?${s.join("?")}` : "") + fragment;
}
function isSamePath(p1, p2) {
  return decode(withoutTrailingSlash(p1)) === decode(withoutTrailingSlash(p2));
}

const protocolRelative = Symbol.for("ufo:protocolRelative");
function parseURL(input = "", defaultProto) {
  const _specialProtoMatch = input.match(
    /^[\s\0]*(blob:|data:|javascript:|vbscript:)(.*)/i
  );
  if (_specialProtoMatch) {
    const [, _proto, _pathname = ""] = _specialProtoMatch;
    return {
      protocol: _proto.toLowerCase(),
      pathname: _pathname,
      href: _proto + _pathname,
      auth: "",
      host: "",
      search: "",
      hash: ""
    };
  }
  if (!hasProtocol(input, { acceptRelative: true })) {
    return defaultProto ? parseURL(defaultProto + input) : parsePath(input);
  }
  const [, protocol = "", auth, hostAndPath = ""] = input.replace(/\\/g, "/").match(/^[\s\0]*([\w+.-]{2,}:)?\/\/([^/@]+@)?(.*)/) || [];
  let [, host = "", path = ""] = hostAndPath.match(/([^#/?]*)(.*)?/) || [];
  if (protocol === "file:") {
    path = path.replace(/\/(?=[A-Za-z]:)/, "");
  }
  const { pathname, search, hash } = parsePath(path);
  return {
    protocol: protocol.toLowerCase(),
    auth: auth ? auth.slice(0, Math.max(0, auth.length - 1)) : "",
    host,
    pathname,
    search,
    hash,
    [protocolRelative]: !protocol
  };
}
function parsePath(input = "") {
  const [pathname = "", search = "", hash = ""] = (input.match(/([^#?]*)(\?[^#]*)?(#.*)?/) || []).splice(1);
  return {
    pathname,
    search,
    hash
  };
}

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

var react = {exports: {}};

var react_production_min = {};

/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReact_production_min;

function requireReact_production_min () {
	if (hasRequiredReact_production_min) return react_production_min;
	hasRequiredReact_production_min = 1;
var l=Symbol.for("react.element"),n=Symbol.for("react.portal"),p=Symbol.for("react.fragment"),q=Symbol.for("react.strict_mode"),r=Symbol.for("react.profiler"),t=Symbol.for("react.provider"),u=Symbol.for("react.context"),v=Symbol.for("react.forward_ref"),w=Symbol.for("react.suspense"),x=Symbol.for("react.memo"),y=Symbol.for("react.lazy"),z=Symbol.iterator;function A(a){if(null===a||"object"!==typeof a)return null;a=z&&a[z]||a["@@iterator"];return "function"===typeof a?a:null}
	var B={isMounted:function(){return !1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},C=Object.assign,D={};function E(a,b,e){this.props=a;this.context=b;this.refs=D;this.updater=e||B;}E.prototype.isReactComponent={};
	E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");this.updater.enqueueSetState(this,a,b,"setState");};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate");};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=D;this.updater=e||B;}var H=G.prototype=new F;
	H.constructor=G;C(H,E.prototype);H.isPureReactComponent=!0;var I=Array.isArray,J=Object.prototype.hasOwnProperty,K={current:null},L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,e){var d,c={},k=null,h=null;if(null!=b)for(d in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)J.call(b,d)&&!L.hasOwnProperty(d)&&(c[d]=b[d]);var g=arguments.length-2;if(1===g)c.children=e;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];c.children=f;}if(a&&a.defaultProps)for(d in g=a.defaultProps,g)void 0===c[d]&&(c[d]=g[d]);return {$$typeof:l,type:a,key:k,ref:h,props:c,_owner:K.current}}
	function N(a,b){return {$$typeof:l,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return "object"===typeof a&&null!==a&&a.$$typeof===l}function escape(a){var b={"=":"=0",":":"=2"};return "$"+a.replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g;function Q(a,b){return "object"===typeof a&&null!==a&&null!=a.key?escape(""+a.key):b.toString(36)}
	function R(a,b,e,d,c){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case l:case n:h=!0;}}if(h)return h=a,c=c(h),a=""===d?"."+Q(h,0):d,I(c)?(e="",null!=a&&(e=a.replace(P,"$&/")+"/"),R(c,b,e,"",function(a){return a})):null!=c&&(O(c)&&(c=N(c,e+(!c.key||h&&h.key===c.key?"":(""+c.key).replace(P,"$&/")+"/")+a)),b.push(c)),1;h=0;d=""===d?".":d+":";if(I(a))for(var g=0;g<a.length;g++){k=
	a[g];var f=d+Q(k,g);h+=R(k,b,e,f,c);}else if(f=A(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=d+Q(k,g++),h+=R(k,b,e,f,c);else if("object"===k)throw b=String(a),Error("Objects are not valid as a React child (found: "+("[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b)+"). If you meant to render a collection of children, use an array instead.");return h}
	function S(a,b,e){if(null==a)return a;var d=[],c=0;R(a,d,"","",function(a){return b.call(e,a,c++)});return d}function T(a){if(-1===a._status){var b=a._result;b=b();b.then(function(b){if(0===a._status||-1===a._status)a._status=1,a._result=b;},function(b){if(0===a._status||-1===a._status)a._status=2,a._result=b;});-1===a._status&&(a._status=0,a._result=b);}if(1===a._status)return a._result.default;throw a._result;}
	var U={current:null},V={transition:null},W={ReactCurrentDispatcher:U,ReactCurrentBatchConfig:V,ReactCurrentOwner:K};function X(){throw Error("act(...) is not supported in production builds of React.");}
	react_production_min.Children={map:S,forEach:function(a,b,e){S(a,function(){b.apply(this,arguments);},e);},count:function(a){var b=0;S(a,function(){b++;});return b},toArray:function(a){return S(a,function(a){return a})||[]},only:function(a){if(!O(a))throw Error("React.Children.only expected to receive a single React element child.");return a}};react_production_min.Component=E;react_production_min.Fragment=p;react_production_min.Profiler=r;react_production_min.PureComponent=G;react_production_min.StrictMode=q;react_production_min.Suspense=w;
	react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=W;react_production_min.act=X;
	react_production_min.cloneElement=function(a,b,e){if(null===a||void 0===a)throw Error("React.cloneElement(...): The argument must be a React element, but you passed "+a+".");var d=C({},a.props),c=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=K.current);void 0!==b.key&&(c=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)J.call(b,f)&&!L.hasOwnProperty(f)&&(d[f]=void 0===b[f]&&void 0!==g?g[f]:b[f]);}var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){g=Array(f);
	for(var m=0;m<f;m++)g[m]=arguments[m+2];d.children=g;}return {$$typeof:l,type:a.type,key:c,ref:k,props:d,_owner:h}};react_production_min.createContext=function(a){a={$$typeof:u,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null,_defaultValue:null,_globalName:null};a.Provider={$$typeof:t,_context:a};return a.Consumer=a};react_production_min.createElement=M;react_production_min.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};react_production_min.createRef=function(){return {current:null}};
	react_production_min.forwardRef=function(a){return {$$typeof:v,render:a}};react_production_min.isValidElement=O;react_production_min.lazy=function(a){return {$$typeof:y,_payload:{_status:-1,_result:a},_init:T}};react_production_min.memo=function(a,b){return {$$typeof:x,type:a,compare:void 0===b?null:b}};react_production_min.startTransition=function(a){var b=V.transition;V.transition={};try{a();}finally{V.transition=b;}};react_production_min.unstable_act=X;react_production_min.useCallback=function(a,b){return U.current.useCallback(a,b)};react_production_min.useContext=function(a){return U.current.useContext(a)};
	react_production_min.useDebugValue=function(){};react_production_min.useDeferredValue=function(a){return U.current.useDeferredValue(a)};react_production_min.useEffect=function(a,b){return U.current.useEffect(a,b)};react_production_min.useId=function(){return U.current.useId()};react_production_min.useImperativeHandle=function(a,b,e){return U.current.useImperativeHandle(a,b,e)};react_production_min.useInsertionEffect=function(a,b){return U.current.useInsertionEffect(a,b)};react_production_min.useLayoutEffect=function(a,b){return U.current.useLayoutEffect(a,b)};
	react_production_min.useMemo=function(a,b){return U.current.useMemo(a,b)};react_production_min.useReducer=function(a,b,e){return U.current.useReducer(a,b,e)};react_production_min.useRef=function(a){return U.current.useRef(a)};react_production_min.useState=function(a){return U.current.useState(a)};react_production_min.useSyncExternalStore=function(a,b,e){return U.current.useSyncExternalStore(a,b,e)};react_production_min.useTransition=function(){return U.current.useTransition()};react_production_min.version="18.3.1";
	return react_production_min;
}

var react_development = {exports: {}};

/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
react_development.exports;

var hasRequiredReact_development;

function requireReact_development () {
	if (hasRequiredReact_development) return react_development.exports;
	hasRequiredReact_development = 1;
	(function (module, exports) {

		if (process.env.NODE_ENV !== "production") {
		  (function() {

		/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
		if (
		  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
		  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart ===
		    'function'
		) {
		  __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
		}
		          var ReactVersion = '18.3.1';

		// ATTENTION
		// When adding new symbols to this file,
		// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
		// The Symbol used to tag the ReactElement-like types.
		var REACT_ELEMENT_TYPE = Symbol.for('react.element');
		var REACT_PORTAL_TYPE = Symbol.for('react.portal');
		var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
		var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
		var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
		var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
		var REACT_CONTEXT_TYPE = Symbol.for('react.context');
		var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
		var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
		var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
		var REACT_MEMO_TYPE = Symbol.for('react.memo');
		var REACT_LAZY_TYPE = Symbol.for('react.lazy');
		var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
		var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
		var FAUX_ITERATOR_SYMBOL = '@@iterator';
		function getIteratorFn(maybeIterable) {
		  if (maybeIterable === null || typeof maybeIterable !== 'object') {
		    return null;
		  }

		  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

		  if (typeof maybeIterator === 'function') {
		    return maybeIterator;
		  }

		  return null;
		}

		/**
		 * Keeps track of the current dispatcher.
		 */
		var ReactCurrentDispatcher = {
		  /**
		   * @internal
		   * @type {ReactComponent}
		   */
		  current: null
		};

		/**
		 * Keeps track of the current batch's configuration such as how long an update
		 * should suspend for if it needs to.
		 */
		var ReactCurrentBatchConfig = {
		  transition: null
		};

		var ReactCurrentActQueue = {
		  current: null,
		  // Used to reproduce behavior of `batchedUpdates` in legacy mode.
		  isBatchingLegacy: false,
		  didScheduleLegacyUpdate: false
		};

		/**
		 * Keeps track of the current owner.
		 *
		 * The current owner is the component who should own any components that are
		 * currently being constructed.
		 */
		var ReactCurrentOwner = {
		  /**
		   * @internal
		   * @type {ReactComponent}
		   */
		  current: null
		};

		var ReactDebugCurrentFrame = {};
		var currentExtraStackFrame = null;
		function setExtraStackFrame(stack) {
		  {
		    currentExtraStackFrame = stack;
		  }
		}

		{
		  ReactDebugCurrentFrame.setExtraStackFrame = function (stack) {
		    {
		      currentExtraStackFrame = stack;
		    }
		  }; // Stack implementation injected by the current renderer.


		  ReactDebugCurrentFrame.getCurrentStack = null;

		  ReactDebugCurrentFrame.getStackAddendum = function () {
		    var stack = ''; // Add an extra top frame while an element is being validated

		    if (currentExtraStackFrame) {
		      stack += currentExtraStackFrame;
		    } // Delegate to the injected renderer-specific implementation


		    var impl = ReactDebugCurrentFrame.getCurrentStack;

		    if (impl) {
		      stack += impl() || '';
		    }

		    return stack;
		  };
		}

		// -----------------------------------------------------------------------------

		var enableScopeAPI = false; // Experimental Create Event Handle API.
		var enableCacheElement = false;
		var enableTransitionTracing = false; // No known bugs, but needs performance testing

		var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
		// stuff. Intended to enable React core members to more easily debug scheduling
		// issues in DEV builds.

		var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

		var ReactSharedInternals = {
		  ReactCurrentDispatcher: ReactCurrentDispatcher,
		  ReactCurrentBatchConfig: ReactCurrentBatchConfig,
		  ReactCurrentOwner: ReactCurrentOwner
		};

		{
		  ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
		  ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
		}

		// by calls to these methods by a Babel plugin.
		//
		// In PROD (or in packages without access to React internals),
		// they are left as they are instead.

		function warn(format) {
		  {
		    {
		      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		        args[_key - 1] = arguments[_key];
		      }

		      printWarning('warn', format, args);
		    }
		  }
		}
		function error(format) {
		  {
		    {
		      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
		        args[_key2 - 1] = arguments[_key2];
		      }

		      printWarning('error', format, args);
		    }
		  }
		}

		function printWarning(level, format, args) {
		  // When changing this logic, you might want to also
		  // update consoleWithStackDev.www.js as well.
		  {
		    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
		    var stack = ReactDebugCurrentFrame.getStackAddendum();

		    if (stack !== '') {
		      format += '%s';
		      args = args.concat([stack]);
		    } // eslint-disable-next-line react-internal/safe-string-coercion


		    var argsWithFormat = args.map(function (item) {
		      return String(item);
		    }); // Careful: RN currently depends on this prefix

		    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
		    // breaks IE9: https://github.com/facebook/react/issues/13610
		    // eslint-disable-next-line react-internal/no-production-logging

		    Function.prototype.apply.call(console[level], console, argsWithFormat);
		  }
		}

		var didWarnStateUpdateForUnmountedComponent = {};

		function warnNoop(publicInstance, callerName) {
		  {
		    var _constructor = publicInstance.constructor;
		    var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
		    var warningKey = componentName + "." + callerName;

		    if (didWarnStateUpdateForUnmountedComponent[warningKey]) {
		      return;
		    }

		    error("Can't call %s on a component that is not yet mounted. " + 'This is a no-op, but it might indicate a bug in your application. ' + 'Instead, assign to `this.state` directly or define a `state = {};` ' + 'class property with the desired state in the %s component.', callerName, componentName);

		    didWarnStateUpdateForUnmountedComponent[warningKey] = true;
		  }
		}
		/**
		 * This is the abstract API for an update queue.
		 */


		var ReactNoopUpdateQueue = {
		  /**
		   * Checks whether or not this composite component is mounted.
		   * @param {ReactClass} publicInstance The instance we want to test.
		   * @return {boolean} True if mounted, false otherwise.
		   * @protected
		   * @final
		   */
		  isMounted: function (publicInstance) {
		    return false;
		  },

		  /**
		   * Forces an update. This should only be invoked when it is known with
		   * certainty that we are **not** in a DOM transaction.
		   *
		   * You may want to call this when you know that some deeper aspect of the
		   * component's state has changed but `setState` was not called.
		   *
		   * This will not invoke `shouldComponentUpdate`, but it will invoke
		   * `componentWillUpdate` and `componentDidUpdate`.
		   *
		   * @param {ReactClass} publicInstance The instance that should rerender.
		   * @param {?function} callback Called after component is updated.
		   * @param {?string} callerName name of the calling function in the public API.
		   * @internal
		   */
		  enqueueForceUpdate: function (publicInstance, callback, callerName) {
		    warnNoop(publicInstance, 'forceUpdate');
		  },

		  /**
		   * Replaces all of the state. Always use this or `setState` to mutate state.
		   * You should treat `this.state` as immutable.
		   *
		   * There is no guarantee that `this.state` will be immediately updated, so
		   * accessing `this.state` after calling this method may return the old value.
		   *
		   * @param {ReactClass} publicInstance The instance that should rerender.
		   * @param {object} completeState Next state.
		   * @param {?function} callback Called after component is updated.
		   * @param {?string} callerName name of the calling function in the public API.
		   * @internal
		   */
		  enqueueReplaceState: function (publicInstance, completeState, callback, callerName) {
		    warnNoop(publicInstance, 'replaceState');
		  },

		  /**
		   * Sets a subset of the state. This only exists because _pendingState is
		   * internal. This provides a merging strategy that is not available to deep
		   * properties which is confusing. TODO: Expose pendingState or don't use it
		   * during the merge.
		   *
		   * @param {ReactClass} publicInstance The instance that should rerender.
		   * @param {object} partialState Next partial state to be merged with state.
		   * @param {?function} callback Called after component is updated.
		   * @param {?string} Name of the calling function in the public API.
		   * @internal
		   */
		  enqueueSetState: function (publicInstance, partialState, callback, callerName) {
		    warnNoop(publicInstance, 'setState');
		  }
		};

		var assign = Object.assign;

		var emptyObject = {};

		{
		  Object.freeze(emptyObject);
		}
		/**
		 * Base class helpers for the updating state of a component.
		 */


		function Component(props, context, updater) {
		  this.props = props;
		  this.context = context; // If a component has string refs, we will assign a different object later.

		  this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
		  // renderer.

		  this.updater = updater || ReactNoopUpdateQueue;
		}

		Component.prototype.isReactComponent = {};
		/**
		 * Sets a subset of the state. Always use this to mutate
		 * state. You should treat `this.state` as immutable.
		 *
		 * There is no guarantee that `this.state` will be immediately updated, so
		 * accessing `this.state` after calling this method may return the old value.
		 *
		 * There is no guarantee that calls to `setState` will run synchronously,
		 * as they may eventually be batched together.  You can provide an optional
		 * callback that will be executed when the call to setState is actually
		 * completed.
		 *
		 * When a function is provided to setState, it will be called at some point in
		 * the future (not synchronously). It will be called with the up to date
		 * component arguments (state, props, context). These values can be different
		 * from this.* because your function may be called after receiveProps but before
		 * shouldComponentUpdate, and this new state, props, and context will not yet be
		 * assigned to this.
		 *
		 * @param {object|function} partialState Next partial state or function to
		 *        produce next partial state to be merged with current state.
		 * @param {?function} callback Called after state is updated.
		 * @final
		 * @protected
		 */

		Component.prototype.setState = function (partialState, callback) {
		  if (typeof partialState !== 'object' && typeof partialState !== 'function' && partialState != null) {
		    throw new Error('setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.');
		  }

		  this.updater.enqueueSetState(this, partialState, callback, 'setState');
		};
		/**
		 * Forces an update. This should only be invoked when it is known with
		 * certainty that we are **not** in a DOM transaction.
		 *
		 * You may want to call this when you know that some deeper aspect of the
		 * component's state has changed but `setState` was not called.
		 *
		 * This will not invoke `shouldComponentUpdate`, but it will invoke
		 * `componentWillUpdate` and `componentDidUpdate`.
		 *
		 * @param {?function} callback Called after update is complete.
		 * @final
		 * @protected
		 */


		Component.prototype.forceUpdate = function (callback) {
		  this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
		};
		/**
		 * Deprecated APIs. These APIs used to exist on classic React classes but since
		 * we would like to deprecate them, we're not going to move them over to this
		 * modern base class. Instead, we define a getter that warns if it's accessed.
		 */


		{
		  var deprecatedAPIs = {
		    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
		    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
		  };

		  var defineDeprecationWarning = function (methodName, info) {
		    Object.defineProperty(Component.prototype, methodName, {
		      get: function () {
		        warn('%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);

		        return undefined;
		      }
		    });
		  };

		  for (var fnName in deprecatedAPIs) {
		    if (deprecatedAPIs.hasOwnProperty(fnName)) {
		      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
		    }
		  }
		}

		function ComponentDummy() {}

		ComponentDummy.prototype = Component.prototype;
		/**
		 * Convenience component with default shallow equality check for sCU.
		 */

		function PureComponent(props, context, updater) {
		  this.props = props;
		  this.context = context; // If a component has string refs, we will assign a different object later.

		  this.refs = emptyObject;
		  this.updater = updater || ReactNoopUpdateQueue;
		}

		var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
		pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.

		assign(pureComponentPrototype, Component.prototype);
		pureComponentPrototype.isPureReactComponent = true;

		// an immutable object with a single mutable value
		function createRef() {
		  var refObject = {
		    current: null
		  };

		  {
		    Object.seal(refObject);
		  }

		  return refObject;
		}

		var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

		function isArray(a) {
		  return isArrayImpl(a);
		}

		/*
		 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
		 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
		 *
		 * The functions in this module will throw an easier-to-understand,
		 * easier-to-debug exception with a clear errors message message explaining the
		 * problem. (Instead of a confusing exception thrown inside the implementation
		 * of the `value` object).
		 */
		// $FlowFixMe only called in DEV, so void return is not possible.
		function typeName(value) {
		  {
		    // toStringTag is needed for namespaced types like Temporal.Instant
		    var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
		    var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
		    return type;
		  }
		} // $FlowFixMe only called in DEV, so void return is not possible.


		function willCoercionThrow(value) {
		  {
		    try {
		      testStringCoercion(value);
		      return false;
		    } catch (e) {
		      return true;
		    }
		  }
		}

		function testStringCoercion(value) {
		  // If you ended up here by following an exception call stack, here's what's
		  // happened: you supplied an object or symbol value to React (as a prop, key,
		  // DOM attribute, CSS property, string ref, etc.) and when React tried to
		  // coerce it to a string using `'' + value`, an exception was thrown.
		  //
		  // The most common types that will cause this exception are `Symbol` instances
		  // and Temporal objects like `Temporal.Instant`. But any object that has a
		  // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
		  // exception. (Library authors do this to prevent users from using built-in
		  // numeric operators like `+` or comparison operators like `>=` because custom
		  // methods are needed to perform accurate arithmetic or comparison.)
		  //
		  // To fix the problem, coerce this object or symbol value to a string before
		  // passing it to React. The most reliable way is usually `String(value)`.
		  //
		  // To find which value is throwing, check the browser or debugger console.
		  // Before this exception was thrown, there should be `console.error` output
		  // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
		  // problem and how that type was used: key, atrribute, input value prop, etc.
		  // In most cases, this console output also shows the component and its
		  // ancestor components where the exception happened.
		  //
		  // eslint-disable-next-line react-internal/safe-string-coercion
		  return '' + value;
		}
		function checkKeyStringCoercion(value) {
		  {
		    if (willCoercionThrow(value)) {
		      error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));

		      return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
		    }
		  }
		}

		function getWrappedName(outerType, innerType, wrapperName) {
		  var displayName = outerType.displayName;

		  if (displayName) {
		    return displayName;
		  }

		  var functionName = innerType.displayName || innerType.name || '';
		  return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
		} // Keep in sync with react-reconciler/getComponentNameFromFiber


		function getContextName(type) {
		  return type.displayName || 'Context';
		} // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.


		function getComponentNameFromType(type) {
		  if (type == null) {
		    // Host root, text node or just invalid type.
		    return null;
		  }

		  {
		    if (typeof type.tag === 'number') {
		      error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
		    }
		  }

		  if (typeof type === 'function') {
		    return type.displayName || type.name || null;
		  }

		  if (typeof type === 'string') {
		    return type;
		  }

		  switch (type) {
		    case REACT_FRAGMENT_TYPE:
		      return 'Fragment';

		    case REACT_PORTAL_TYPE:
		      return 'Portal';

		    case REACT_PROFILER_TYPE:
		      return 'Profiler';

		    case REACT_STRICT_MODE_TYPE:
		      return 'StrictMode';

		    case REACT_SUSPENSE_TYPE:
		      return 'Suspense';

		    case REACT_SUSPENSE_LIST_TYPE:
		      return 'SuspenseList';

		  }

		  if (typeof type === 'object') {
		    switch (type.$$typeof) {
		      case REACT_CONTEXT_TYPE:
		        var context = type;
		        return getContextName(context) + '.Consumer';

		      case REACT_PROVIDER_TYPE:
		        var provider = type;
		        return getContextName(provider._context) + '.Provider';

		      case REACT_FORWARD_REF_TYPE:
		        return getWrappedName(type, type.render, 'ForwardRef');

		      case REACT_MEMO_TYPE:
		        var outerName = type.displayName || null;

		        if (outerName !== null) {
		          return outerName;
		        }

		        return getComponentNameFromType(type.type) || 'Memo';

		      case REACT_LAZY_TYPE:
		        {
		          var lazyComponent = type;
		          var payload = lazyComponent._payload;
		          var init = lazyComponent._init;

		          try {
		            return getComponentNameFromType(init(payload));
		          } catch (x) {
		            return null;
		          }
		        }

		      // eslint-disable-next-line no-fallthrough
		    }
		  }

		  return null;
		}

		var hasOwnProperty = Object.prototype.hasOwnProperty;

		var RESERVED_PROPS = {
		  key: true,
		  ref: true,
		  __self: true,
		  __source: true
		};
		var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;

		{
		  didWarnAboutStringRefs = {};
		}

		function hasValidRef(config) {
		  {
		    if (hasOwnProperty.call(config, 'ref')) {
		      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

		      if (getter && getter.isReactWarning) {
		        return false;
		      }
		    }
		  }

		  return config.ref !== undefined;
		}

		function hasValidKey(config) {
		  {
		    if (hasOwnProperty.call(config, 'key')) {
		      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

		      if (getter && getter.isReactWarning) {
		        return false;
		      }
		    }
		  }

		  return config.key !== undefined;
		}

		function defineKeyPropWarningGetter(props, displayName) {
		  var warnAboutAccessingKey = function () {
		    {
		      if (!specialPropKeyWarningShown) {
		        specialPropKeyWarningShown = true;

		        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
		      }
		    }
		  };

		  warnAboutAccessingKey.isReactWarning = true;
		  Object.defineProperty(props, 'key', {
		    get: warnAboutAccessingKey,
		    configurable: true
		  });
		}

		function defineRefPropWarningGetter(props, displayName) {
		  var warnAboutAccessingRef = function () {
		    {
		      if (!specialPropRefWarningShown) {
		        specialPropRefWarningShown = true;

		        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
		      }
		    }
		  };

		  warnAboutAccessingRef.isReactWarning = true;
		  Object.defineProperty(props, 'ref', {
		    get: warnAboutAccessingRef,
		    configurable: true
		  });
		}

		function warnIfStringRefCannotBeAutoConverted(config) {
		  {
		    if (typeof config.ref === 'string' && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
		      var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);

		      if (!didWarnAboutStringRefs[componentName]) {
		        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);

		        didWarnAboutStringRefs[componentName] = true;
		      }
		    }
		  }
		}
		/**
		 * Factory method to create a new React element. This no longer adheres to
		 * the class pattern, so do not use new to call it. Also, instanceof check
		 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
		 * if something is a React Element.
		 *
		 * @param {*} type
		 * @param {*} props
		 * @param {*} key
		 * @param {string|object} ref
		 * @param {*} owner
		 * @param {*} self A *temporary* helper to detect places where `this` is
		 * different from the `owner` when React.createElement is called, so that we
		 * can warn. We want to get rid of owner and replace string `ref`s with arrow
		 * functions, and as long as `this` and owner are the same, there will be no
		 * change in behavior.
		 * @param {*} source An annotation object (added by a transpiler or otherwise)
		 * indicating filename, line number, and/or other information.
		 * @internal
		 */


		var ReactElement = function (type, key, ref, self, source, owner, props) {
		  var element = {
		    // This tag allows us to uniquely identify this as a React Element
		    $$typeof: REACT_ELEMENT_TYPE,
		    // Built-in properties that belong on the element
		    type: type,
		    key: key,
		    ref: ref,
		    props: props,
		    // Record the component responsible for creating this element.
		    _owner: owner
		  };

		  {
		    // The validation flag is currently mutative. We put it on
		    // an external backing store so that we can freeze the whole object.
		    // This can be replaced with a WeakMap once they are implemented in
		    // commonly used development environments.
		    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
		    // the validation flag non-enumerable (where possible, which should
		    // include every environment we run tests in), so the test framework
		    // ignores it.

		    Object.defineProperty(element._store, 'validated', {
		      configurable: false,
		      enumerable: false,
		      writable: true,
		      value: false
		    }); // self and source are DEV only properties.

		    Object.defineProperty(element, '_self', {
		      configurable: false,
		      enumerable: false,
		      writable: false,
		      value: self
		    }); // Two elements created in two different places should be considered
		    // equal for testing purposes and therefore we hide it from enumeration.

		    Object.defineProperty(element, '_source', {
		      configurable: false,
		      enumerable: false,
		      writable: false,
		      value: source
		    });

		    if (Object.freeze) {
		      Object.freeze(element.props);
		      Object.freeze(element);
		    }
		  }

		  return element;
		};
		/**
		 * Create and return a new ReactElement of the given type.
		 * See https://reactjs.org/docs/react-api.html#createelement
		 */

		function createElement(type, config, children) {
		  var propName; // Reserved names are extracted

		  var props = {};
		  var key = null;
		  var ref = null;
		  var self = null;
		  var source = null;

		  if (config != null) {
		    if (hasValidRef(config)) {
		      ref = config.ref;

		      {
		        warnIfStringRefCannotBeAutoConverted(config);
		      }
		    }

		    if (hasValidKey(config)) {
		      {
		        checkKeyStringCoercion(config.key);
		      }

		      key = '' + config.key;
		    }

		    self = config.__self === undefined ? null : config.__self;
		    source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object

		    for (propName in config) {
		      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
		        props[propName] = config[propName];
		      }
		    }
		  } // Children can be more than one argument, and those are transferred onto
		  // the newly allocated props object.


		  var childrenLength = arguments.length - 2;

		  if (childrenLength === 1) {
		    props.children = children;
		  } else if (childrenLength > 1) {
		    var childArray = Array(childrenLength);

		    for (var i = 0; i < childrenLength; i++) {
		      childArray[i] = arguments[i + 2];
		    }

		    {
		      if (Object.freeze) {
		        Object.freeze(childArray);
		      }
		    }

		    props.children = childArray;
		  } // Resolve default props


		  if (type && type.defaultProps) {
		    var defaultProps = type.defaultProps;

		    for (propName in defaultProps) {
		      if (props[propName] === undefined) {
		        props[propName] = defaultProps[propName];
		      }
		    }
		  }

		  {
		    if (key || ref) {
		      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

		      if (key) {
		        defineKeyPropWarningGetter(props, displayName);
		      }

		      if (ref) {
		        defineRefPropWarningGetter(props, displayName);
		      }
		    }
		  }

		  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
		}
		function cloneAndReplaceKey(oldElement, newKey) {
		  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
		  return newElement;
		}
		/**
		 * Clone and return a new ReactElement using element as the starting point.
		 * See https://reactjs.org/docs/react-api.html#cloneelement
		 */

		function cloneElement(element, config, children) {
		  if (element === null || element === undefined) {
		    throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
		  }

		  var propName; // Original props are copied

		  var props = assign({}, element.props); // Reserved names are extracted

		  var key = element.key;
		  var ref = element.ref; // Self is preserved since the owner is preserved.

		  var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
		  // transpiler, and the original source is probably a better indicator of the
		  // true owner.

		  var source = element._source; // Owner will be preserved, unless ref is overridden

		  var owner = element._owner;

		  if (config != null) {
		    if (hasValidRef(config)) {
		      // Silently steal the ref from the parent.
		      ref = config.ref;
		      owner = ReactCurrentOwner.current;
		    }

		    if (hasValidKey(config)) {
		      {
		        checkKeyStringCoercion(config.key);
		      }

		      key = '' + config.key;
		    } // Remaining properties override existing props


		    var defaultProps;

		    if (element.type && element.type.defaultProps) {
		      defaultProps = element.type.defaultProps;
		    }

		    for (propName in config) {
		      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
		        if (config[propName] === undefined && defaultProps !== undefined) {
		          // Resolve default props
		          props[propName] = defaultProps[propName];
		        } else {
		          props[propName] = config[propName];
		        }
		      }
		    }
		  } // Children can be more than one argument, and those are transferred onto
		  // the newly allocated props object.


		  var childrenLength = arguments.length - 2;

		  if (childrenLength === 1) {
		    props.children = children;
		  } else if (childrenLength > 1) {
		    var childArray = Array(childrenLength);

		    for (var i = 0; i < childrenLength; i++) {
		      childArray[i] = arguments[i + 2];
		    }

		    props.children = childArray;
		  }

		  return ReactElement(element.type, key, ref, self, source, owner, props);
		}
		/**
		 * Verifies the object is a ReactElement.
		 * See https://reactjs.org/docs/react-api.html#isvalidelement
		 * @param {?object} object
		 * @return {boolean} True if `object` is a ReactElement.
		 * @final
		 */

		function isValidElement(object) {
		  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
		}

		var SEPARATOR = '.';
		var SUBSEPARATOR = ':';
		/**
		 * Escape and wrap key so it is safe to use as a reactid
		 *
		 * @param {string} key to be escaped.
		 * @return {string} the escaped key.
		 */

		function escape(key) {
		  var escapeRegex = /[=:]/g;
		  var escaperLookup = {
		    '=': '=0',
		    ':': '=2'
		  };
		  var escapedString = key.replace(escapeRegex, function (match) {
		    return escaperLookup[match];
		  });
		  return '$' + escapedString;
		}
		/**
		 * TODO: Test that a single child and an array with one item have the same key
		 * pattern.
		 */


		var didWarnAboutMaps = false;
		var userProvidedKeyEscapeRegex = /\/+/g;

		function escapeUserProvidedKey(text) {
		  return text.replace(userProvidedKeyEscapeRegex, '$&/');
		}
		/**
		 * Generate a key string that identifies a element within a set.
		 *
		 * @param {*} element A element that could contain a manual key.
		 * @param {number} index Index that is used if a manual key is not provided.
		 * @return {string}
		 */


		function getElementKey(element, index) {
		  // Do some typechecking here since we call this blindly. We want to ensure
		  // that we don't block potential future ES APIs.
		  if (typeof element === 'object' && element !== null && element.key != null) {
		    // Explicit key
		    {
		      checkKeyStringCoercion(element.key);
		    }

		    return escape('' + element.key);
		  } // Implicit key determined by the index in the set


		  return index.toString(36);
		}

		function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
		  var type = typeof children;

		  if (type === 'undefined' || type === 'boolean') {
		    // All of the above are perceived as null.
		    children = null;
		  }

		  var invokeCallback = false;

		  if (children === null) {
		    invokeCallback = true;
		  } else {
		    switch (type) {
		      case 'string':
		      case 'number':
		        invokeCallback = true;
		        break;

		      case 'object':
		        switch (children.$$typeof) {
		          case REACT_ELEMENT_TYPE:
		          case REACT_PORTAL_TYPE:
		            invokeCallback = true;
		        }

		    }
		  }

		  if (invokeCallback) {
		    var _child = children;
		    var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
		    // so that it's consistent if the number of children grows:

		    var childKey = nameSoFar === '' ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;

		    if (isArray(mappedChild)) {
		      var escapedChildKey = '';

		      if (childKey != null) {
		        escapedChildKey = escapeUserProvidedKey(childKey) + '/';
		      }

		      mapIntoArray(mappedChild, array, escapedChildKey, '', function (c) {
		        return c;
		      });
		    } else if (mappedChild != null) {
		      if (isValidElement(mappedChild)) {
		        {
		          // The `if` statement here prevents auto-disabling of the safe
		          // coercion ESLint rule, so we must manually disable it below.
		          // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
		          if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) {
		            checkKeyStringCoercion(mappedChild.key);
		          }
		        }

		        mappedChild = cloneAndReplaceKey(mappedChild, // Keep both the (mapped) and old keys if they differ, just as
		        // traverseAllChildren used to do for objects as children
		        escapedPrefix + ( // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
		        mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
		        // eslint-disable-next-line react-internal/safe-string-coercion
		        escapeUserProvidedKey('' + mappedChild.key) + '/' : '') + childKey);
		      }

		      array.push(mappedChild);
		    }

		    return 1;
		  }

		  var child;
		  var nextName;
		  var subtreeCount = 0; // Count of children found in the current subtree.

		  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

		  if (isArray(children)) {
		    for (var i = 0; i < children.length; i++) {
		      child = children[i];
		      nextName = nextNamePrefix + getElementKey(child, i);
		      subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
		    }
		  } else {
		    var iteratorFn = getIteratorFn(children);

		    if (typeof iteratorFn === 'function') {
		      var iterableChildren = children;

		      {
		        // Warn about using Maps as children
		        if (iteratorFn === iterableChildren.entries) {
		          if (!didWarnAboutMaps) {
		            warn('Using Maps as children is not supported. ' + 'Use an array of keyed ReactElements instead.');
		          }

		          didWarnAboutMaps = true;
		        }
		      }

		      var iterator = iteratorFn.call(iterableChildren);
		      var step;
		      var ii = 0;

		      while (!(step = iterator.next()).done) {
		        child = step.value;
		        nextName = nextNamePrefix + getElementKey(child, ii++);
		        subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
		      }
		    } else if (type === 'object') {
		      // eslint-disable-next-line react-internal/safe-string-coercion
		      var childrenString = String(children);
		      throw new Error("Objects are not valid as a React child (found: " + (childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString) + "). " + 'If you meant to render a collection of children, use an array ' + 'instead.');
		    }
		  }

		  return subtreeCount;
		}

		/**
		 * Maps children that are typically specified as `props.children`.
		 *
		 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
		 *
		 * The provided mapFunction(child, index) will be called for each
		 * leaf child.
		 *
		 * @param {?*} children Children tree container.
		 * @param {function(*, int)} func The map function.
		 * @param {*} context Context for mapFunction.
		 * @return {object} Object containing the ordered map of results.
		 */
		function mapChildren(children, func, context) {
		  if (children == null) {
		    return children;
		  }

		  var result = [];
		  var count = 0;
		  mapIntoArray(children, result, '', '', function (child) {
		    return func.call(context, child, count++);
		  });
		  return result;
		}
		/**
		 * Count the number of children that are typically specified as
		 * `props.children`.
		 *
		 * See https://reactjs.org/docs/react-api.html#reactchildrencount
		 *
		 * @param {?*} children Children tree container.
		 * @return {number} The number of children.
		 */


		function countChildren(children) {
		  var n = 0;
		  mapChildren(children, function () {
		    n++; // Don't return anything
		  });
		  return n;
		}

		/**
		 * Iterates through children that are typically specified as `props.children`.
		 *
		 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
		 *
		 * The provided forEachFunc(child, index) will be called for each
		 * leaf child.
		 *
		 * @param {?*} children Children tree container.
		 * @param {function(*, int)} forEachFunc
		 * @param {*} forEachContext Context for forEachContext.
		 */
		function forEachChildren(children, forEachFunc, forEachContext) {
		  mapChildren(children, function () {
		    forEachFunc.apply(this, arguments); // Don't return anything.
		  }, forEachContext);
		}
		/**
		 * Flatten a children object (typically specified as `props.children`) and
		 * return an array with appropriately re-keyed children.
		 *
		 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
		 */


		function toArray(children) {
		  return mapChildren(children, function (child) {
		    return child;
		  }) || [];
		}
		/**
		 * Returns the first child in a collection of children and verifies that there
		 * is only one child in the collection.
		 *
		 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
		 *
		 * The current implementation of this function assumes that a single child gets
		 * passed without a wrapper, but the purpose of this helper function is to
		 * abstract away the particular structure of children.
		 *
		 * @param {?object} children Child collection structure.
		 * @return {ReactElement} The first and only `ReactElement` contained in the
		 * structure.
		 */


		function onlyChild(children) {
		  if (!isValidElement(children)) {
		    throw new Error('React.Children.only expected to receive a single React element child.');
		  }

		  return children;
		}

		function createContext(defaultValue) {
		  // TODO: Second argument used to be an optional `calculateChangedBits`
		  // function. Warn to reserve for future use?
		  var context = {
		    $$typeof: REACT_CONTEXT_TYPE,
		    // As a workaround to support multiple concurrent renderers, we categorize
		    // some renderers as primary and others as secondary. We only expect
		    // there to be two concurrent renderers at most: React Native (primary) and
		    // Fabric (secondary); React DOM (primary) and React ART (secondary).
		    // Secondary renderers store their context values on separate fields.
		    _currentValue: defaultValue,
		    _currentValue2: defaultValue,
		    // Used to track how many concurrent renderers this context currently
		    // supports within in a single renderer. Such as parallel server rendering.
		    _threadCount: 0,
		    // These are circular
		    Provider: null,
		    Consumer: null,
		    // Add these to use same hidden class in VM as ServerContext
		    _defaultValue: null,
		    _globalName: null
		  };
		  context.Provider = {
		    $$typeof: REACT_PROVIDER_TYPE,
		    _context: context
		  };
		  var hasWarnedAboutUsingNestedContextConsumers = false;
		  var hasWarnedAboutUsingConsumerProvider = false;
		  var hasWarnedAboutDisplayNameOnConsumer = false;

		  {
		    // A separate object, but proxies back to the original context object for
		    // backwards compatibility. It has a different $$typeof, so we can properly
		    // warn for the incorrect usage of Context as a Consumer.
		    var Consumer = {
		      $$typeof: REACT_CONTEXT_TYPE,
		      _context: context
		    }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here

		    Object.defineProperties(Consumer, {
		      Provider: {
		        get: function () {
		          if (!hasWarnedAboutUsingConsumerProvider) {
		            hasWarnedAboutUsingConsumerProvider = true;

		            error('Rendering <Context.Consumer.Provider> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Provider> instead?');
		          }

		          return context.Provider;
		        },
		        set: function (_Provider) {
		          context.Provider = _Provider;
		        }
		      },
		      _currentValue: {
		        get: function () {
		          return context._currentValue;
		        },
		        set: function (_currentValue) {
		          context._currentValue = _currentValue;
		        }
		      },
		      _currentValue2: {
		        get: function () {
		          return context._currentValue2;
		        },
		        set: function (_currentValue2) {
		          context._currentValue2 = _currentValue2;
		        }
		      },
		      _threadCount: {
		        get: function () {
		          return context._threadCount;
		        },
		        set: function (_threadCount) {
		          context._threadCount = _threadCount;
		        }
		      },
		      Consumer: {
		        get: function () {
		          if (!hasWarnedAboutUsingNestedContextConsumers) {
		            hasWarnedAboutUsingNestedContextConsumers = true;

		            error('Rendering <Context.Consumer.Consumer> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
		          }

		          return context.Consumer;
		        }
		      },
		      displayName: {
		        get: function () {
		          return context.displayName;
		        },
		        set: function (displayName) {
		          if (!hasWarnedAboutDisplayNameOnConsumer) {
		            warn('Setting `displayName` on Context.Consumer has no effect. ' + "You should set it directly on the context with Context.displayName = '%s'.", displayName);

		            hasWarnedAboutDisplayNameOnConsumer = true;
		          }
		        }
		      }
		    }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty

		    context.Consumer = Consumer;
		  }

		  {
		    context._currentRenderer = null;
		    context._currentRenderer2 = null;
		  }

		  return context;
		}

		var Uninitialized = -1;
		var Pending = 0;
		var Resolved = 1;
		var Rejected = 2;

		function lazyInitializer(payload) {
		  if (payload._status === Uninitialized) {
		    var ctor = payload._result;
		    var thenable = ctor(); // Transition to the next state.
		    // This might throw either because it's missing or throws. If so, we treat it
		    // as still uninitialized and try again next time. Which is the same as what
		    // happens if the ctor or any wrappers processing the ctor throws. This might
		    // end up fixing it if the resolution was a concurrency bug.

		    thenable.then(function (moduleObject) {
		      if (payload._status === Pending || payload._status === Uninitialized) {
		        // Transition to the next state.
		        var resolved = payload;
		        resolved._status = Resolved;
		        resolved._result = moduleObject;
		      }
		    }, function (error) {
		      if (payload._status === Pending || payload._status === Uninitialized) {
		        // Transition to the next state.
		        var rejected = payload;
		        rejected._status = Rejected;
		        rejected._result = error;
		      }
		    });

		    if (payload._status === Uninitialized) {
		      // In case, we're still uninitialized, then we're waiting for the thenable
		      // to resolve. Set it as pending in the meantime.
		      var pending = payload;
		      pending._status = Pending;
		      pending._result = thenable;
		    }
		  }

		  if (payload._status === Resolved) {
		    var moduleObject = payload._result;

		    {
		      if (moduleObject === undefined) {
		        error('lazy: Expected the result of a dynamic imp' + 'ort() call. ' + 'Instead received: %s\n\nYour code should look like: \n  ' + // Break up imports to avoid accidentally parsing them as dependencies.
		        'const MyComponent = lazy(() => imp' + "ort('./MyComponent'))\n\n" + 'Did you accidentally put curly braces around the import?', moduleObject);
		      }
		    }

		    {
		      if (!('default' in moduleObject)) {
		        error('lazy: Expected the result of a dynamic imp' + 'ort() call. ' + 'Instead received: %s\n\nYour code should look like: \n  ' + // Break up imports to avoid accidentally parsing them as dependencies.
		        'const MyComponent = lazy(() => imp' + "ort('./MyComponent'))", moduleObject);
		      }
		    }

		    return moduleObject.default;
		  } else {
		    throw payload._result;
		  }
		}

		function lazy(ctor) {
		  var payload = {
		    // We use these fields to store the result.
		    _status: Uninitialized,
		    _result: ctor
		  };
		  var lazyType = {
		    $$typeof: REACT_LAZY_TYPE,
		    _payload: payload,
		    _init: lazyInitializer
		  };

		  {
		    // In production, this would just set it on the object.
		    var defaultProps;
		    var propTypes; // $FlowFixMe

		    Object.defineProperties(lazyType, {
		      defaultProps: {
		        configurable: true,
		        get: function () {
		          return defaultProps;
		        },
		        set: function (newDefaultProps) {
		          error('React.lazy(...): It is not supported to assign `defaultProps` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');

		          defaultProps = newDefaultProps; // Match production behavior more closely:
		          // $FlowFixMe

		          Object.defineProperty(lazyType, 'defaultProps', {
		            enumerable: true
		          });
		        }
		      },
		      propTypes: {
		        configurable: true,
		        get: function () {
		          return propTypes;
		        },
		        set: function (newPropTypes) {
		          error('React.lazy(...): It is not supported to assign `propTypes` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');

		          propTypes = newPropTypes; // Match production behavior more closely:
		          // $FlowFixMe

		          Object.defineProperty(lazyType, 'propTypes', {
		            enumerable: true
		          });
		        }
		      }
		    });
		  }

		  return lazyType;
		}

		function forwardRef(render) {
		  {
		    if (render != null && render.$$typeof === REACT_MEMO_TYPE) {
		      error('forwardRef requires a render function but received a `memo` ' + 'component. Instead of forwardRef(memo(...)), use ' + 'memo(forwardRef(...)).');
		    } else if (typeof render !== 'function') {
		      error('forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
		    } else {
		      if (render.length !== 0 && render.length !== 2) {
		        error('forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.');
		      }
		    }

		    if (render != null) {
		      if (render.defaultProps != null || render.propTypes != null) {
		        error('forwardRef render functions do not support propTypes or defaultProps. ' + 'Did you accidentally pass a React component?');
		      }
		    }
		  }

		  var elementType = {
		    $$typeof: REACT_FORWARD_REF_TYPE,
		    render: render
		  };

		  {
		    var ownName;
		    Object.defineProperty(elementType, 'displayName', {
		      enumerable: false,
		      configurable: true,
		      get: function () {
		        return ownName;
		      },
		      set: function (name) {
		        ownName = name; // The inner component shouldn't inherit this display name in most cases,
		        // because the component may be used elsewhere.
		        // But it's nice for anonymous functions to inherit the name,
		        // so that our component-stack generation logic will display their frames.
		        // An anonymous function generally suggests a pattern like:
		        //   React.forwardRef((props, ref) => {...});
		        // This kind of inner function is not used elsewhere so the side effect is okay.

		        if (!render.name && !render.displayName) {
		          render.displayName = name;
		        }
		      }
		    });
		  }

		  return elementType;
		}

		var REACT_MODULE_REFERENCE;

		{
		  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
		}

		function isValidElementType(type) {
		  if (typeof type === 'string' || typeof type === 'function') {
		    return true;
		  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


		  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
		    return true;
		  }

		  if (typeof type === 'object' && type !== null) {
		    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
		    // types supported by any Flight configuration anywhere since
		    // we don't know which Flight build this will end up being used
		    // with.
		    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
		      return true;
		    }
		  }

		  return false;
		}

		function memo(type, compare) {
		  {
		    if (!isValidElementType(type)) {
		      error('memo: The first argument must be a component. Instead ' + 'received: %s', type === null ? 'null' : typeof type);
		    }
		  }

		  var elementType = {
		    $$typeof: REACT_MEMO_TYPE,
		    type: type,
		    compare: compare === undefined ? null : compare
		  };

		  {
		    var ownName;
		    Object.defineProperty(elementType, 'displayName', {
		      enumerable: false,
		      configurable: true,
		      get: function () {
		        return ownName;
		      },
		      set: function (name) {
		        ownName = name; // The inner component shouldn't inherit this display name in most cases,
		        // because the component may be used elsewhere.
		        // But it's nice for anonymous functions to inherit the name,
		        // so that our component-stack generation logic will display their frames.
		        // An anonymous function generally suggests a pattern like:
		        //   React.memo((props) => {...});
		        // This kind of inner function is not used elsewhere so the side effect is okay.

		        if (!type.name && !type.displayName) {
		          type.displayName = name;
		        }
		      }
		    });
		  }

		  return elementType;
		}

		function resolveDispatcher() {
		  var dispatcher = ReactCurrentDispatcher.current;

		  {
		    if (dispatcher === null) {
		      error('Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for' + ' one of the following reasons:\n' + '1. You might have mismatching versions of React and the renderer (such as React DOM)\n' + '2. You might be breaking the Rules of Hooks\n' + '3. You might have more than one copy of React in the same app\n' + 'See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.');
		    }
		  } // Will result in a null access error if accessed outside render phase. We
		  // intentionally don't throw our own error because this is in a hot path.
		  // Also helps ensure this is inlined.


		  return dispatcher;
		}
		function useContext(Context) {
		  var dispatcher = resolveDispatcher();

		  {
		    // TODO: add a more generic warning for invalid values.
		    if (Context._context !== undefined) {
		      var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
		      // and nobody should be using this in existing code.

		      if (realContext.Consumer === Context) {
		        error('Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be ' + 'removed in a future major release. Did you mean to call useContext(Context) instead?');
		      } else if (realContext.Provider === Context) {
		        error('Calling useContext(Context.Provider) is not supported. ' + 'Did you mean to call useContext(Context) instead?');
		      }
		    }
		  }

		  return dispatcher.useContext(Context);
		}
		function useState(initialState) {
		  var dispatcher = resolveDispatcher();
		  return dispatcher.useState(initialState);
		}
		function useReducer(reducer, initialArg, init) {
		  var dispatcher = resolveDispatcher();
		  return dispatcher.useReducer(reducer, initialArg, init);
		}
		function useRef(initialValue) {
		  var dispatcher = resolveDispatcher();
		  return dispatcher.useRef(initialValue);
		}
		function useEffect(create, deps) {
		  var dispatcher = resolveDispatcher();
		  return dispatcher.useEffect(create, deps);
		}
		function useInsertionEffect(create, deps) {
		  var dispatcher = resolveDispatcher();
		  return dispatcher.useInsertionEffect(create, deps);
		}
		function useLayoutEffect(create, deps) {
		  var dispatcher = resolveDispatcher();
		  return dispatcher.useLayoutEffect(create, deps);
		}
		function useCallback(callback, deps) {
		  var dispatcher = resolveDispatcher();
		  return dispatcher.useCallback(callback, deps);
		}
		function useMemo(create, deps) {
		  var dispatcher = resolveDispatcher();
		  return dispatcher.useMemo(create, deps);
		}
		function useImperativeHandle(ref, create, deps) {
		  var dispatcher = resolveDispatcher();
		  return dispatcher.useImperativeHandle(ref, create, deps);
		}
		function useDebugValue(value, formatterFn) {
		  {
		    var dispatcher = resolveDispatcher();
		    return dispatcher.useDebugValue(value, formatterFn);
		  }
		}
		function useTransition() {
		  var dispatcher = resolveDispatcher();
		  return dispatcher.useTransition();
		}
		function useDeferredValue(value) {
		  var dispatcher = resolveDispatcher();
		  return dispatcher.useDeferredValue(value);
		}
		function useId() {
		  var dispatcher = resolveDispatcher();
		  return dispatcher.useId();
		}
		function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
		  var dispatcher = resolveDispatcher();
		  return dispatcher.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
		}

		// Helpers to patch console.logs to avoid logging during side-effect free
		// replaying on render function. This currently only patches the object
		// lazily which won't cover if the log function was extracted eagerly.
		// We could also eagerly patch the method.
		var disabledDepth = 0;
		var prevLog;
		var prevInfo;
		var prevWarn;
		var prevError;
		var prevGroup;
		var prevGroupCollapsed;
		var prevGroupEnd;

		function disabledLog() {}

		disabledLog.__reactDisabledLog = true;
		function disableLogs() {
		  {
		    if (disabledDepth === 0) {
		      /* eslint-disable react-internal/no-production-logging */
		      prevLog = console.log;
		      prevInfo = console.info;
		      prevWarn = console.warn;
		      prevError = console.error;
		      prevGroup = console.group;
		      prevGroupCollapsed = console.groupCollapsed;
		      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

		      var props = {
		        configurable: true,
		        enumerable: true,
		        value: disabledLog,
		        writable: true
		      }; // $FlowFixMe Flow thinks console is immutable.

		      Object.defineProperties(console, {
		        info: props,
		        log: props,
		        warn: props,
		        error: props,
		        group: props,
		        groupCollapsed: props,
		        groupEnd: props
		      });
		      /* eslint-enable react-internal/no-production-logging */
		    }

		    disabledDepth++;
		  }
		}
		function reenableLogs() {
		  {
		    disabledDepth--;

		    if (disabledDepth === 0) {
		      /* eslint-disable react-internal/no-production-logging */
		      var props = {
		        configurable: true,
		        enumerable: true,
		        writable: true
		      }; // $FlowFixMe Flow thinks console is immutable.

		      Object.defineProperties(console, {
		        log: assign({}, props, {
		          value: prevLog
		        }),
		        info: assign({}, props, {
		          value: prevInfo
		        }),
		        warn: assign({}, props, {
		          value: prevWarn
		        }),
		        error: assign({}, props, {
		          value: prevError
		        }),
		        group: assign({}, props, {
		          value: prevGroup
		        }),
		        groupCollapsed: assign({}, props, {
		          value: prevGroupCollapsed
		        }),
		        groupEnd: assign({}, props, {
		          value: prevGroupEnd
		        })
		      });
		      /* eslint-enable react-internal/no-production-logging */
		    }

		    if (disabledDepth < 0) {
		      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
		    }
		  }
		}

		var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
		var prefix;
		function describeBuiltInComponentFrame(name, source, ownerFn) {
		  {
		    if (prefix === undefined) {
		      // Extract the VM specific prefix used by each line.
		      try {
		        throw Error();
		      } catch (x) {
		        var match = x.stack.trim().match(/\n( *(at )?)/);
		        prefix = match && match[1] || '';
		      }
		    } // We use the prefix to ensure our stacks line up with native stack frames.


		    return '\n' + prefix + name;
		  }
		}
		var reentry = false;
		var componentFrameCache;

		{
		  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
		  componentFrameCache = new PossiblyWeakMap();
		}

		function describeNativeComponentFrame(fn, construct) {
		  // If something asked for a stack inside a fake render, it should get ignored.
		  if ( !fn || reentry) {
		    return '';
		  }

		  {
		    var frame = componentFrameCache.get(fn);

		    if (frame !== undefined) {
		      return frame;
		    }
		  }

		  var control;
		  reentry = true;
		  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

		  Error.prepareStackTrace = undefined;
		  var previousDispatcher;

		  {
		    previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
		    // for warnings.

		    ReactCurrentDispatcher$1.current = null;
		    disableLogs();
		  }

		  try {
		    // This should throw.
		    if (construct) {
		      // Something should be setting the props in the constructor.
		      var Fake = function () {
		        throw Error();
		      }; // $FlowFixMe


		      Object.defineProperty(Fake.prototype, 'props', {
		        set: function () {
		          // We use a throwing setter instead of frozen or non-writable props
		          // because that won't throw in a non-strict mode function.
		          throw Error();
		        }
		      });

		      if (typeof Reflect === 'object' && Reflect.construct) {
		        // We construct a different control for this case to include any extra
		        // frames added by the construct call.
		        try {
		          Reflect.construct(Fake, []);
		        } catch (x) {
		          control = x;
		        }

		        Reflect.construct(fn, [], Fake);
		      } else {
		        try {
		          Fake.call();
		        } catch (x) {
		          control = x;
		        }

		        fn.call(Fake.prototype);
		      }
		    } else {
		      try {
		        throw Error();
		      } catch (x) {
		        control = x;
		      }

		      fn();
		    }
		  } catch (sample) {
		    // This is inlined manually because closure doesn't do it for us.
		    if (sample && control && typeof sample.stack === 'string') {
		      // This extracts the first frame from the sample that isn't also in the control.
		      // Skipping one frame that we assume is the frame that calls the two.
		      var sampleLines = sample.stack.split('\n');
		      var controlLines = control.stack.split('\n');
		      var s = sampleLines.length - 1;
		      var c = controlLines.length - 1;

		      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
		        // We expect at least one stack frame to be shared.
		        // Typically this will be the root most one. However, stack frames may be
		        // cut off due to maximum stack limits. In this case, one maybe cut off
		        // earlier than the other. We assume that the sample is longer or the same
		        // and there for cut off earlier. So we should find the root most frame in
		        // the sample somewhere in the control.
		        c--;
		      }

		      for (; s >= 1 && c >= 0; s--, c--) {
		        // Next we find the first one that isn't the same which should be the
		        // frame that called our sample function and the control.
		        if (sampleLines[s] !== controlLines[c]) {
		          // In V8, the first line is describing the message but other VMs don't.
		          // If we're about to return the first line, and the control is also on the same
		          // line, that's a pretty good indicator that our sample threw at same line as
		          // the control. I.e. before we entered the sample frame. So we ignore this result.
		          // This can happen if you passed a class to function component, or non-function.
		          if (s !== 1 || c !== 1) {
		            do {
		              s--;
		              c--; // We may still have similar intermediate frames from the construct call.
		              // The next one that isn't the same should be our match though.

		              if (c < 0 || sampleLines[s] !== controlLines[c]) {
		                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
		                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
		                // but we have a user-provided "displayName"
		                // splice it in to make the stack more readable.


		                if (fn.displayName && _frame.includes('<anonymous>')) {
		                  _frame = _frame.replace('<anonymous>', fn.displayName);
		                }

		                {
		                  if (typeof fn === 'function') {
		                    componentFrameCache.set(fn, _frame);
		                  }
		                } // Return the line we found.


		                return _frame;
		              }
		            } while (s >= 1 && c >= 0);
		          }

		          break;
		        }
		      }
		    }
		  } finally {
		    reentry = false;

		    {
		      ReactCurrentDispatcher$1.current = previousDispatcher;
		      reenableLogs();
		    }

		    Error.prepareStackTrace = previousPrepareStackTrace;
		  } // Fallback to just using the name if we couldn't make it throw.


		  var name = fn ? fn.displayName || fn.name : '';
		  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

		  {
		    if (typeof fn === 'function') {
		      componentFrameCache.set(fn, syntheticFrame);
		    }
		  }

		  return syntheticFrame;
		}
		function describeFunctionComponentFrame(fn, source, ownerFn) {
		  {
		    return describeNativeComponentFrame(fn, false);
		  }
		}

		function shouldConstruct(Component) {
		  var prototype = Component.prototype;
		  return !!(prototype && prototype.isReactComponent);
		}

		function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

		  if (type == null) {
		    return '';
		  }

		  if (typeof type === 'function') {
		    {
		      return describeNativeComponentFrame(type, shouldConstruct(type));
		    }
		  }

		  if (typeof type === 'string') {
		    return describeBuiltInComponentFrame(type);
		  }

		  switch (type) {
		    case REACT_SUSPENSE_TYPE:
		      return describeBuiltInComponentFrame('Suspense');

		    case REACT_SUSPENSE_LIST_TYPE:
		      return describeBuiltInComponentFrame('SuspenseList');
		  }

		  if (typeof type === 'object') {
		    switch (type.$$typeof) {
		      case REACT_FORWARD_REF_TYPE:
		        return describeFunctionComponentFrame(type.render);

		      case REACT_MEMO_TYPE:
		        // Memo may contain any component type so we recursively resolve it.
		        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

		      case REACT_LAZY_TYPE:
		        {
		          var lazyComponent = type;
		          var payload = lazyComponent._payload;
		          var init = lazyComponent._init;

		          try {
		            // Lazy may contain any component type so we recursively resolve it.
		            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
		          } catch (x) {}
		        }
		    }
		  }

		  return '';
		}

		var loggedTypeFailures = {};
		var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

		function setCurrentlyValidatingElement(element) {
		  {
		    if (element) {
		      var owner = element._owner;
		      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
		      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
		    } else {
		      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
		    }
		  }
		}

		function checkPropTypes(typeSpecs, values, location, componentName, element) {
		  {
		    // $FlowFixMe This is okay but Flow doesn't know it.
		    var has = Function.call.bind(hasOwnProperty);

		    for (var typeSpecName in typeSpecs) {
		      if (has(typeSpecs, typeSpecName)) {
		        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.

		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          if (typeof typeSpecs[typeSpecName] !== 'function') {
		            // eslint-disable-next-line react-internal/prod-error-codes
		            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
		            err.name = 'Invariant Violation';
		            throw err;
		          }

		          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
		        } catch (ex) {
		          error$1 = ex;
		        }

		        if (error$1 && !(error$1 instanceof Error)) {
		          setCurrentlyValidatingElement(element);

		          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

		          setCurrentlyValidatingElement(null);
		        }

		        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error$1.message] = true;
		          setCurrentlyValidatingElement(element);

		          error('Failed %s type: %s', location, error$1.message);

		          setCurrentlyValidatingElement(null);
		        }
		      }
		    }
		  }
		}

		function setCurrentlyValidatingElement$1(element) {
		  {
		    if (element) {
		      var owner = element._owner;
		      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
		      setExtraStackFrame(stack);
		    } else {
		      setExtraStackFrame(null);
		    }
		  }
		}

		var propTypesMisspellWarningShown;

		{
		  propTypesMisspellWarningShown = false;
		}

		function getDeclarationErrorAddendum() {
		  if (ReactCurrentOwner.current) {
		    var name = getComponentNameFromType(ReactCurrentOwner.current.type);

		    if (name) {
		      return '\n\nCheck the render method of `' + name + '`.';
		    }
		  }

		  return '';
		}

		function getSourceInfoErrorAddendum(source) {
		  if (source !== undefined) {
		    var fileName = source.fileName.replace(/^.*[\\\/]/, '');
		    var lineNumber = source.lineNumber;
		    return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
		  }

		  return '';
		}

		function getSourceInfoErrorAddendumForProps(elementProps) {
		  if (elementProps !== null && elementProps !== undefined) {
		    return getSourceInfoErrorAddendum(elementProps.__source);
		  }

		  return '';
		}
		/**
		 * Warn if there's no key explicitly set on dynamic arrays of children or
		 * object keys are not valid. This allows us to keep track of children between
		 * updates.
		 */


		var ownerHasKeyUseWarning = {};

		function getCurrentComponentErrorInfo(parentType) {
		  var info = getDeclarationErrorAddendum();

		  if (!info) {
		    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

		    if (parentName) {
		      info = "\n\nCheck the top-level render call using <" + parentName + ">.";
		    }
		  }

		  return info;
		}
		/**
		 * Warn if the element doesn't have an explicit key assigned to it.
		 * This element is in an array. The array could grow and shrink or be
		 * reordered. All children that haven't already been validated are required to
		 * have a "key" property assigned to it. Error statuses are cached so a warning
		 * will only be shown once.
		 *
		 * @internal
		 * @param {ReactElement} element Element that requires a key.
		 * @param {*} parentType element's parent's type.
		 */


		function validateExplicitKey(element, parentType) {
		  if (!element._store || element._store.validated || element.key != null) {
		    return;
		  }

		  element._store.validated = true;
		  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

		  if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
		    return;
		  }

		  ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
		  // property, it may be the creator of the child that's responsible for
		  // assigning it a key.

		  var childOwner = '';

		  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
		    // Give the component that originally created this child.
		    childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
		  }

		  {
		    setCurrentlyValidatingElement$1(element);

		    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

		    setCurrentlyValidatingElement$1(null);
		  }
		}
		/**
		 * Ensure that every element either is passed in a static location, in an
		 * array with an explicit keys property defined, or in an object literal
		 * with valid key property.
		 *
		 * @internal
		 * @param {ReactNode} node Statically passed child of any type.
		 * @param {*} parentType node's parent's type.
		 */


		function validateChildKeys(node, parentType) {
		  if (typeof node !== 'object') {
		    return;
		  }

		  if (isArray(node)) {
		    for (var i = 0; i < node.length; i++) {
		      var child = node[i];

		      if (isValidElement(child)) {
		        validateExplicitKey(child, parentType);
		      }
		    }
		  } else if (isValidElement(node)) {
		    // This element was passed in a valid location.
		    if (node._store) {
		      node._store.validated = true;
		    }
		  } else if (node) {
		    var iteratorFn = getIteratorFn(node);

		    if (typeof iteratorFn === 'function') {
		      // Entry iterators used to provide implicit keys,
		      // but now we print a separate warning for them later.
		      if (iteratorFn !== node.entries) {
		        var iterator = iteratorFn.call(node);
		        var step;

		        while (!(step = iterator.next()).done) {
		          if (isValidElement(step.value)) {
		            validateExplicitKey(step.value, parentType);
		          }
		        }
		      }
		    }
		  }
		}
		/**
		 * Given an element, validate that its props follow the propTypes definition,
		 * provided by the type.
		 *
		 * @param {ReactElement} element
		 */


		function validatePropTypes(element) {
		  {
		    var type = element.type;

		    if (type === null || type === undefined || typeof type === 'string') {
		      return;
		    }

		    var propTypes;

		    if (typeof type === 'function') {
		      propTypes = type.propTypes;
		    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
		    // Inner props are checked in the reconciler.
		    type.$$typeof === REACT_MEMO_TYPE)) {
		      propTypes = type.propTypes;
		    } else {
		      return;
		    }

		    if (propTypes) {
		      // Intentionally inside to avoid triggering lazy initializers:
		      var name = getComponentNameFromType(type);
		      checkPropTypes(propTypes, element.props, 'prop', name, element);
		    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
		      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

		      var _name = getComponentNameFromType(type);

		      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
		    }

		    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
		      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
		    }
		  }
		}
		/**
		 * Given a fragment, validate that it can only be provided with fragment props
		 * @param {ReactElement} fragment
		 */


		function validateFragmentProps(fragment) {
		  {
		    var keys = Object.keys(fragment.props);

		    for (var i = 0; i < keys.length; i++) {
		      var key = keys[i];

		      if (key !== 'children' && key !== 'key') {
		        setCurrentlyValidatingElement$1(fragment);

		        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

		        setCurrentlyValidatingElement$1(null);
		        break;
		      }
		    }

		    if (fragment.ref !== null) {
		      setCurrentlyValidatingElement$1(fragment);

		      error('Invalid attribute `ref` supplied to `React.Fragment`.');

		      setCurrentlyValidatingElement$1(null);
		    }
		  }
		}
		function createElementWithValidation(type, props, children) {
		  var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
		  // succeed and there will likely be errors in render.

		  if (!validType) {
		    var info = '';

		    if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
		      info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
		    }

		    var sourceInfo = getSourceInfoErrorAddendumForProps(props);

		    if (sourceInfo) {
		      info += sourceInfo;
		    } else {
		      info += getDeclarationErrorAddendum();
		    }

		    var typeString;

		    if (type === null) {
		      typeString = 'null';
		    } else if (isArray(type)) {
		      typeString = 'array';
		    } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
		      typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
		      info = ' Did you accidentally export a JSX literal instead of a component?';
		    } else {
		      typeString = typeof type;
		    }

		    {
		      error('React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
		    }
		  }

		  var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
		  // TODO: Drop this when these are no longer allowed as the type argument.

		  if (element == null) {
		    return element;
		  } // Skip key warning if the type isn't valid since our key validation logic
		  // doesn't expect a non-string/function type and can throw confusing errors.
		  // We don't want exception behavior to differ between dev and prod.
		  // (Rendering will throw with a helpful message and as soon as the type is
		  // fixed, the key warnings will appear.)


		  if (validType) {
		    for (var i = 2; i < arguments.length; i++) {
		      validateChildKeys(arguments[i], type);
		    }
		  }

		  if (type === REACT_FRAGMENT_TYPE) {
		    validateFragmentProps(element);
		  } else {
		    validatePropTypes(element);
		  }

		  return element;
		}
		var didWarnAboutDeprecatedCreateFactory = false;
		function createFactoryWithValidation(type) {
		  var validatedFactory = createElementWithValidation.bind(null, type);
		  validatedFactory.type = type;

		  {
		    if (!didWarnAboutDeprecatedCreateFactory) {
		      didWarnAboutDeprecatedCreateFactory = true;

		      warn('React.createFactory() is deprecated and will be removed in ' + 'a future major release. Consider using JSX ' + 'or use React.createElement() directly instead.');
		    } // Legacy hook: remove it


		    Object.defineProperty(validatedFactory, 'type', {
		      enumerable: false,
		      get: function () {
		        warn('Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');

		        Object.defineProperty(this, 'type', {
		          value: type
		        });
		        return type;
		      }
		    });
		  }

		  return validatedFactory;
		}
		function cloneElementWithValidation(element, props, children) {
		  var newElement = cloneElement.apply(this, arguments);

		  for (var i = 2; i < arguments.length; i++) {
		    validateChildKeys(arguments[i], newElement.type);
		  }

		  validatePropTypes(newElement);
		  return newElement;
		}

		function startTransition(scope, options) {
		  var prevTransition = ReactCurrentBatchConfig.transition;
		  ReactCurrentBatchConfig.transition = {};
		  var currentTransition = ReactCurrentBatchConfig.transition;

		  {
		    ReactCurrentBatchConfig.transition._updatedFibers = new Set();
		  }

		  try {
		    scope();
		  } finally {
		    ReactCurrentBatchConfig.transition = prevTransition;

		    {
		      if (prevTransition === null && currentTransition._updatedFibers) {
		        var updatedFibersCount = currentTransition._updatedFibers.size;

		        if (updatedFibersCount > 10) {
		          warn('Detected a large number of updates inside startTransition. ' + 'If this is due to a subscription please re-write it to use React provided hooks. ' + 'Otherwise concurrent mode guarantees are off the table.');
		        }

		        currentTransition._updatedFibers.clear();
		      }
		    }
		  }
		}

		var didWarnAboutMessageChannel = false;
		var enqueueTaskImpl = null;
		function enqueueTask(task) {
		  if (enqueueTaskImpl === null) {
		    try {
		      // read require off the module object to get around the bundlers.
		      // we don't want them to detect a require and bundle a Node polyfill.
		      var requireString = ('require' + Math.random()).slice(0, 7);
		      var nodeRequire = module && module[requireString]; // assuming we're in node, let's try to get node's
		      // version of setImmediate, bypassing fake timers if any.

		      enqueueTaskImpl = nodeRequire.call(module, 'timers').setImmediate;
		    } catch (_err) {
		      // we're in a browser
		      // we can't use regular timers because they may still be faked
		      // so we try MessageChannel+postMessage instead
		      enqueueTaskImpl = function (callback) {
		        {
		          if (didWarnAboutMessageChannel === false) {
		            didWarnAboutMessageChannel = true;

		            if (typeof MessageChannel === 'undefined') {
		              error('This browser does not have a MessageChannel implementation, ' + 'so enqueuing tasks via await act(async () => ...) will fail. ' + 'Please file an issue at https://github.com/facebook/react/issues ' + 'if you encounter this warning.');
		            }
		          }
		        }

		        var channel = new MessageChannel();
		        channel.port1.onmessage = callback;
		        channel.port2.postMessage(undefined);
		      };
		    }
		  }

		  return enqueueTaskImpl(task);
		}

		var actScopeDepth = 0;
		var didWarnNoAwaitAct = false;
		function act(callback) {
		  {
		    // `act` calls can be nested, so we track the depth. This represents the
		    // number of `act` scopes on the stack.
		    var prevActScopeDepth = actScopeDepth;
		    actScopeDepth++;

		    if (ReactCurrentActQueue.current === null) {
		      // This is the outermost `act` scope. Initialize the queue. The reconciler
		      // will detect the queue and use it instead of Scheduler.
		      ReactCurrentActQueue.current = [];
		    }

		    var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
		    var result;

		    try {
		      // Used to reproduce behavior of `batchedUpdates` in legacy mode. Only
		      // set to `true` while the given callback is executed, not for updates
		      // triggered during an async event, because this is how the legacy
		      // implementation of `act` behaved.
		      ReactCurrentActQueue.isBatchingLegacy = true;
		      result = callback(); // Replicate behavior of original `act` implementation in legacy mode,
		      // which flushed updates immediately after the scope function exits, even
		      // if it's an async function.

		      if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
		        var queue = ReactCurrentActQueue.current;

		        if (queue !== null) {
		          ReactCurrentActQueue.didScheduleLegacyUpdate = false;
		          flushActQueue(queue);
		        }
		      }
		    } catch (error) {
		      popActScope(prevActScopeDepth);
		      throw error;
		    } finally {
		      ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
		    }

		    if (result !== null && typeof result === 'object' && typeof result.then === 'function') {
		      var thenableResult = result; // The callback is an async function (i.e. returned a promise). Wait
		      // for it to resolve before exiting the current scope.

		      var wasAwaited = false;
		      var thenable = {
		        then: function (resolve, reject) {
		          wasAwaited = true;
		          thenableResult.then(function (returnValue) {
		            popActScope(prevActScopeDepth);

		            if (actScopeDepth === 0) {
		              // We've exited the outermost act scope. Recursively flush the
		              // queue until there's no remaining work.
		              recursivelyFlushAsyncActWork(returnValue, resolve, reject);
		            } else {
		              resolve(returnValue);
		            }
		          }, function (error) {
		            // The callback threw an error.
		            popActScope(prevActScopeDepth);
		            reject(error);
		          });
		        }
		      };

		      {
		        if (!didWarnNoAwaitAct && typeof Promise !== 'undefined') {
		          // eslint-disable-next-line no-undef
		          Promise.resolve().then(function () {}).then(function () {
		            if (!wasAwaited) {
		              didWarnNoAwaitAct = true;

		              error('You called act(async () => ...) without await. ' + 'This could lead to unexpected testing behaviour, ' + 'interleaving multiple act calls and mixing their ' + 'scopes. ' + 'You should - await act(async () => ...);');
		            }
		          });
		        }
		      }

		      return thenable;
		    } else {
		      var returnValue = result; // The callback is not an async function. Exit the current scope
		      // immediately, without awaiting.

		      popActScope(prevActScopeDepth);

		      if (actScopeDepth === 0) {
		        // Exiting the outermost act scope. Flush the queue.
		        var _queue = ReactCurrentActQueue.current;

		        if (_queue !== null) {
		          flushActQueue(_queue);
		          ReactCurrentActQueue.current = null;
		        } // Return a thenable. If the user awaits it, we'll flush again in
		        // case additional work was scheduled by a microtask.


		        var _thenable = {
		          then: function (resolve, reject) {
		            // Confirm we haven't re-entered another `act` scope, in case
		            // the user does something weird like await the thenable
		            // multiple times.
		            if (ReactCurrentActQueue.current === null) {
		              // Recursively flush the queue until there's no remaining work.
		              ReactCurrentActQueue.current = [];
		              recursivelyFlushAsyncActWork(returnValue, resolve, reject);
		            } else {
		              resolve(returnValue);
		            }
		          }
		        };
		        return _thenable;
		      } else {
		        // Since we're inside a nested `act` scope, the returned thenable
		        // immediately resolves. The outer scope will flush the queue.
		        var _thenable2 = {
		          then: function (resolve, reject) {
		            resolve(returnValue);
		          }
		        };
		        return _thenable2;
		      }
		    }
		  }
		}

		function popActScope(prevActScopeDepth) {
		  {
		    if (prevActScopeDepth !== actScopeDepth - 1) {
		      error('You seem to have overlapping act() calls, this is not supported. ' + 'Be sure to await previous act() calls before making a new one. ');
		    }

		    actScopeDepth = prevActScopeDepth;
		  }
		}

		function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
		  {
		    var queue = ReactCurrentActQueue.current;

		    if (queue !== null) {
		      try {
		        flushActQueue(queue);
		        enqueueTask(function () {
		          if (queue.length === 0) {
		            // No additional work was scheduled. Finish.
		            ReactCurrentActQueue.current = null;
		            resolve(returnValue);
		          } else {
		            // Keep flushing work until there's none left.
		            recursivelyFlushAsyncActWork(returnValue, resolve, reject);
		          }
		        });
		      } catch (error) {
		        reject(error);
		      }
		    } else {
		      resolve(returnValue);
		    }
		  }
		}

		var isFlushing = false;

		function flushActQueue(queue) {
		  {
		    if (!isFlushing) {
		      // Prevent re-entrance.
		      isFlushing = true;
		      var i = 0;

		      try {
		        for (; i < queue.length; i++) {
		          var callback = queue[i];

		          do {
		            callback = callback(true);
		          } while (callback !== null);
		        }

		        queue.length = 0;
		      } catch (error) {
		        // If something throws, leave the remaining callbacks on the queue.
		        queue = queue.slice(i + 1);
		        throw error;
		      } finally {
		        isFlushing = false;
		      }
		    }
		  }
		}

		var createElement$1 =  createElementWithValidation ;
		var cloneElement$1 =  cloneElementWithValidation ;
		var createFactory =  createFactoryWithValidation ;
		var Children = {
		  map: mapChildren,
		  forEach: forEachChildren,
		  count: countChildren,
		  toArray: toArray,
		  only: onlyChild
		};

		exports.Children = Children;
		exports.Component = Component;
		exports.Fragment = REACT_FRAGMENT_TYPE;
		exports.Profiler = REACT_PROFILER_TYPE;
		exports.PureComponent = PureComponent;
		exports.StrictMode = REACT_STRICT_MODE_TYPE;
		exports.Suspense = REACT_SUSPENSE_TYPE;
		exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
		exports.act = act;
		exports.cloneElement = cloneElement$1;
		exports.createContext = createContext;
		exports.createElement = createElement$1;
		exports.createFactory = createFactory;
		exports.createRef = createRef;
		exports.forwardRef = forwardRef;
		exports.isValidElement = isValidElement;
		exports.lazy = lazy;
		exports.memo = memo;
		exports.startTransition = startTransition;
		exports.unstable_act = act;
		exports.useCallback = useCallback;
		exports.useContext = useContext;
		exports.useDebugValue = useDebugValue;
		exports.useDeferredValue = useDeferredValue;
		exports.useEffect = useEffect;
		exports.useId = useId;
		exports.useImperativeHandle = useImperativeHandle;
		exports.useInsertionEffect = useInsertionEffect;
		exports.useLayoutEffect = useLayoutEffect;
		exports.useMemo = useMemo;
		exports.useReducer = useReducer;
		exports.useRef = useRef;
		exports.useState = useState;
		exports.useSyncExternalStore = useSyncExternalStore;
		exports.useTransition = useTransition;
		exports.version = ReactVersion;
		          /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
		if (
		  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
		  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop ===
		    'function'
		) {
		  __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
		}
		        
		  })();
		} 
	} (react_development, react_development.exports));
	return react_development.exports;
}

var hasRequiredReact;

function requireReact () {
	if (hasRequiredReact) return react.exports;
	hasRequiredReact = 1;

	if (process.env.NODE_ENV === 'production') {
	  react.exports = requireReact_production_min();
	} else {
	  react.exports = requireReact_development();
	}
	return react.exports;
}

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min () {
	if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
	hasRequiredReactJsxRuntime_production_min = 1;
var f=requireReact(),k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
	function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}reactJsxRuntime_production_min.Fragment=l;reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;
	return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development () {
	if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
	hasRequiredReactJsxRuntime_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	var React = requireReact();

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types.
	var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	var REACT_MEMO_TYPE = Symbol.for('react.memo');
	var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
	var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator';
	function getIteratorFn(maybeIterable) {
	  if (maybeIterable === null || typeof maybeIterable !== 'object') {
	    return null;
	  }

	  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

	  if (typeof maybeIterator === 'function') {
	    return maybeIterator;
	  }

	  return null;
	}

	var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

	function error(format) {
	  {
	    {
	      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }

	      printWarning('error', format, args);
	    }
	  }
	}

	function printWarning(level, format, args) {
	  // When changing this logic, you might want to also
	  // update consoleWithStackDev.www.js as well.
	  {
	    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	    var stack = ReactDebugCurrentFrame.getStackAddendum();

	    if (stack !== '') {
	      format += '%s';
	      args = args.concat([stack]);
	    } // eslint-disable-next-line react-internal/safe-string-coercion


	    var argsWithFormat = args.map(function (item) {
	      return String(item);
	    }); // Careful: RN currently depends on this prefix

	    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
	    // breaks IE9: https://github.com/facebook/react/issues/13610
	    // eslint-disable-next-line react-internal/no-production-logging

	    Function.prototype.apply.call(console[level], console, argsWithFormat);
	  }
	}

	// -----------------------------------------------------------------------------

	var enableScopeAPI = false; // Experimental Create Event Handle API.
	var enableCacheElement = false;
	var enableTransitionTracing = false; // No known bugs, but needs performance testing

	var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
	// stuff. Intended to enable React core members to more easily debug scheduling
	// issues in DEV builds.

	var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

	var REACT_MODULE_REFERENCE;

	{
	  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
	}

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
	    // types supported by any Flight configuration anywhere since
	    // we don't know which Flight build this will end up being used
	    // with.
	    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
	      return true;
	    }
	  }

	  return false;
	}

	function getWrappedName(outerType, innerType, wrapperName) {
	  var displayName = outerType.displayName;

	  if (displayName) {
	    return displayName;
	  }

	  var functionName = innerType.displayName || innerType.name || '';
	  return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
	} // Keep in sync with react-reconciler/getComponentNameFromFiber


	function getContextName(type) {
	  return type.displayName || 'Context';
	} // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.


	function getComponentNameFromType(type) {
	  if (type == null) {
	    // Host root, text node or just invalid type.
	    return null;
	  }

	  {
	    if (typeof type.tag === 'number') {
	      error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
	    }
	  }

	  if (typeof type === 'function') {
	    return type.displayName || type.name || null;
	  }

	  if (typeof type === 'string') {
	    return type;
	  }

	  switch (type) {
	    case REACT_FRAGMENT_TYPE:
	      return 'Fragment';

	    case REACT_PORTAL_TYPE:
	      return 'Portal';

	    case REACT_PROFILER_TYPE:
	      return 'Profiler';

	    case REACT_STRICT_MODE_TYPE:
	      return 'StrictMode';

	    case REACT_SUSPENSE_TYPE:
	      return 'Suspense';

	    case REACT_SUSPENSE_LIST_TYPE:
	      return 'SuspenseList';

	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_CONTEXT_TYPE:
	        var context = type;
	        return getContextName(context) + '.Consumer';

	      case REACT_PROVIDER_TYPE:
	        var provider = type;
	        return getContextName(provider._context) + '.Provider';

	      case REACT_FORWARD_REF_TYPE:
	        return getWrappedName(type, type.render, 'ForwardRef');

	      case REACT_MEMO_TYPE:
	        var outerName = type.displayName || null;

	        if (outerName !== null) {
	          return outerName;
	        }

	        return getComponentNameFromType(type.type) || 'Memo';

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            return getComponentNameFromType(init(payload));
	          } catch (x) {
	            return null;
	          }
	        }

	      // eslint-disable-next-line no-fallthrough
	    }
	  }

	  return null;
	}

	var assign = Object.assign;

	// Helpers to patch console.logs to avoid logging during side-effect free
	// replaying on render function. This currently only patches the object
	// lazily which won't cover if the log function was extracted eagerly.
	// We could also eagerly patch the method.
	var disabledDepth = 0;
	var prevLog;
	var prevInfo;
	var prevWarn;
	var prevError;
	var prevGroup;
	var prevGroupCollapsed;
	var prevGroupEnd;

	function disabledLog() {}

	disabledLog.__reactDisabledLog = true;
	function disableLogs() {
	  {
	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      prevLog = console.log;
	      prevInfo = console.info;
	      prevWarn = console.warn;
	      prevError = console.error;
	      prevGroup = console.group;
	      prevGroupCollapsed = console.groupCollapsed;
	      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

	      var props = {
	        configurable: true,
	        enumerable: true,
	        value: disabledLog,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        info: props,
	        log: props,
	        warn: props,
	        error: props,
	        group: props,
	        groupCollapsed: props,
	        groupEnd: props
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    disabledDepth++;
	  }
	}
	function reenableLogs() {
	  {
	    disabledDepth--;

	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      var props = {
	        configurable: true,
	        enumerable: true,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        log: assign({}, props, {
	          value: prevLog
	        }),
	        info: assign({}, props, {
	          value: prevInfo
	        }),
	        warn: assign({}, props, {
	          value: prevWarn
	        }),
	        error: assign({}, props, {
	          value: prevError
	        }),
	        group: assign({}, props, {
	          value: prevGroup
	        }),
	        groupCollapsed: assign({}, props, {
	          value: prevGroupCollapsed
	        }),
	        groupEnd: assign({}, props, {
	          value: prevGroupEnd
	        })
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    if (disabledDepth < 0) {
	      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
	    }
	  }
	}

	var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
	var prefix;
	function describeBuiltInComponentFrame(name, source, ownerFn) {
	  {
	    if (prefix === undefined) {
	      // Extract the VM specific prefix used by each line.
	      try {
	        throw Error();
	      } catch (x) {
	        var match = x.stack.trim().match(/\n( *(at )?)/);
	        prefix = match && match[1] || '';
	      }
	    } // We use the prefix to ensure our stacks line up with native stack frames.


	    return '\n' + prefix + name;
	  }
	}
	var reentry = false;
	var componentFrameCache;

	{
	  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
	  componentFrameCache = new PossiblyWeakMap();
	}

	function describeNativeComponentFrame(fn, construct) {
	  // If something asked for a stack inside a fake render, it should get ignored.
	  if ( !fn || reentry) {
	    return '';
	  }

	  {
	    var frame = componentFrameCache.get(fn);

	    if (frame !== undefined) {
	      return frame;
	    }
	  }

	  var control;
	  reentry = true;
	  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

	  Error.prepareStackTrace = undefined;
	  var previousDispatcher;

	  {
	    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
	    // for warnings.

	    ReactCurrentDispatcher.current = null;
	    disableLogs();
	  }

	  try {
	    // This should throw.
	    if (construct) {
	      // Something should be setting the props in the constructor.
	      var Fake = function () {
	        throw Error();
	      }; // $FlowFixMe


	      Object.defineProperty(Fake.prototype, 'props', {
	        set: function () {
	          // We use a throwing setter instead of frozen or non-writable props
	          // because that won't throw in a non-strict mode function.
	          throw Error();
	        }
	      });

	      if (typeof Reflect === 'object' && Reflect.construct) {
	        // We construct a different control for this case to include any extra
	        // frames added by the construct call.
	        try {
	          Reflect.construct(Fake, []);
	        } catch (x) {
	          control = x;
	        }

	        Reflect.construct(fn, [], Fake);
	      } else {
	        try {
	          Fake.call();
	        } catch (x) {
	          control = x;
	        }

	        fn.call(Fake.prototype);
	      }
	    } else {
	      try {
	        throw Error();
	      } catch (x) {
	        control = x;
	      }

	      fn();
	    }
	  } catch (sample) {
	    // This is inlined manually because closure doesn't do it for us.
	    if (sample && control && typeof sample.stack === 'string') {
	      // This extracts the first frame from the sample that isn't also in the control.
	      // Skipping one frame that we assume is the frame that calls the two.
	      var sampleLines = sample.stack.split('\n');
	      var controlLines = control.stack.split('\n');
	      var s = sampleLines.length - 1;
	      var c = controlLines.length - 1;

	      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
	        // We expect at least one stack frame to be shared.
	        // Typically this will be the root most one. However, stack frames may be
	        // cut off due to maximum stack limits. In this case, one maybe cut off
	        // earlier than the other. We assume that the sample is longer or the same
	        // and there for cut off earlier. So we should find the root most frame in
	        // the sample somewhere in the control.
	        c--;
	      }

	      for (; s >= 1 && c >= 0; s--, c--) {
	        // Next we find the first one that isn't the same which should be the
	        // frame that called our sample function and the control.
	        if (sampleLines[s] !== controlLines[c]) {
	          // In V8, the first line is describing the message but other VMs don't.
	          // If we're about to return the first line, and the control is also on the same
	          // line, that's a pretty good indicator that our sample threw at same line as
	          // the control. I.e. before we entered the sample frame. So we ignore this result.
	          // This can happen if you passed a class to function component, or non-function.
	          if (s !== 1 || c !== 1) {
	            do {
	              s--;
	              c--; // We may still have similar intermediate frames from the construct call.
	              // The next one that isn't the same should be our match though.

	              if (c < 0 || sampleLines[s] !== controlLines[c]) {
	                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
	                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
	                // but we have a user-provided "displayName"
	                // splice it in to make the stack more readable.


	                if (fn.displayName && _frame.includes('<anonymous>')) {
	                  _frame = _frame.replace('<anonymous>', fn.displayName);
	                }

	                {
	                  if (typeof fn === 'function') {
	                    componentFrameCache.set(fn, _frame);
	                  }
	                } // Return the line we found.


	                return _frame;
	              }
	            } while (s >= 1 && c >= 0);
	          }

	          break;
	        }
	      }
	    }
	  } finally {
	    reentry = false;

	    {
	      ReactCurrentDispatcher.current = previousDispatcher;
	      reenableLogs();
	    }

	    Error.prepareStackTrace = previousPrepareStackTrace;
	  } // Fallback to just using the name if we couldn't make it throw.


	  var name = fn ? fn.displayName || fn.name : '';
	  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

	  {
	    if (typeof fn === 'function') {
	      componentFrameCache.set(fn, syntheticFrame);
	    }
	  }

	  return syntheticFrame;
	}
	function describeFunctionComponentFrame(fn, source, ownerFn) {
	  {
	    return describeNativeComponentFrame(fn, false);
	  }
	}

	function shouldConstruct(Component) {
	  var prototype = Component.prototype;
	  return !!(prototype && prototype.isReactComponent);
	}

	function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

	  if (type == null) {
	    return '';
	  }

	  if (typeof type === 'function') {
	    {
	      return describeNativeComponentFrame(type, shouldConstruct(type));
	    }
	  }

	  if (typeof type === 'string') {
	    return describeBuiltInComponentFrame(type);
	  }

	  switch (type) {
	    case REACT_SUSPENSE_TYPE:
	      return describeBuiltInComponentFrame('Suspense');

	    case REACT_SUSPENSE_LIST_TYPE:
	      return describeBuiltInComponentFrame('SuspenseList');
	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_FORWARD_REF_TYPE:
	        return describeFunctionComponentFrame(type.render);

	      case REACT_MEMO_TYPE:
	        // Memo may contain any component type so we recursively resolve it.
	        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            // Lazy may contain any component type so we recursively resolve it.
	            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
	          } catch (x) {}
	        }
	    }
	  }

	  return '';
	}

	var hasOwnProperty = Object.prototype.hasOwnProperty;

	var loggedTypeFailures = {};
	var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame.setExtraStackFrame(null);
	    }
	  }
	}

	function checkPropTypes(typeSpecs, values, location, componentName, element) {
	  {
	    // $FlowFixMe This is okay but Flow doesn't know it.
	    var has = Function.call.bind(hasOwnProperty);

	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.

	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            // eslint-disable-next-line react-internal/prod-error-codes
	            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
	            err.name = 'Invariant Violation';
	            throw err;
	          }

	          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        } catch (ex) {
	          error$1 = ex;
	        }

	        if (error$1 && !(error$1 instanceof Error)) {
	          setCurrentlyValidatingElement(element);

	          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

	          setCurrentlyValidatingElement(null);
	        }

	        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error$1.message] = true;
	          setCurrentlyValidatingElement(element);

	          error('Failed %s type: %s', location, error$1.message);

	          setCurrentlyValidatingElement(null);
	        }
	      }
	    }
	  }
	}

	var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

	function isArray(a) {
	  return isArrayImpl(a);
	}

	/*
	 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
	 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
	 *
	 * The functions in this module will throw an easier-to-understand,
	 * easier-to-debug exception with a clear errors message message explaining the
	 * problem. (Instead of a confusing exception thrown inside the implementation
	 * of the `value` object).
	 */
	// $FlowFixMe only called in DEV, so void return is not possible.
	function typeName(value) {
	  {
	    // toStringTag is needed for namespaced types like Temporal.Instant
	    var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
	    var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
	    return type;
	  }
	} // $FlowFixMe only called in DEV, so void return is not possible.


	function willCoercionThrow(value) {
	  {
	    try {
	      testStringCoercion(value);
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	}

	function testStringCoercion(value) {
	  // If you ended up here by following an exception call stack, here's what's
	  // happened: you supplied an object or symbol value to React (as a prop, key,
	  // DOM attribute, CSS property, string ref, etc.) and when React tried to
	  // coerce it to a string using `'' + value`, an exception was thrown.
	  //
	  // The most common types that will cause this exception are `Symbol` instances
	  // and Temporal objects like `Temporal.Instant`. But any object that has a
	  // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
	  // exception. (Library authors do this to prevent users from using built-in
	  // numeric operators like `+` or comparison operators like `>=` because custom
	  // methods are needed to perform accurate arithmetic or comparison.)
	  //
	  // To fix the problem, coerce this object or symbol value to a string before
	  // passing it to React. The most reliable way is usually `String(value)`.
	  //
	  // To find which value is throwing, check the browser or debugger console.
	  // Before this exception was thrown, there should be `console.error` output
	  // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
	  // problem and how that type was used: key, atrribute, input value prop, etc.
	  // In most cases, this console output also shows the component and its
	  // ancestor components where the exception happened.
	  //
	  // eslint-disable-next-line react-internal/safe-string-coercion
	  return '' + value;
	}
	function checkKeyStringCoercion(value) {
	  {
	    if (willCoercionThrow(value)) {
	      error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));

	      return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
	    }
	  }
	}

	var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	var specialPropKeyWarningShown;
	var specialPropRefWarningShown;
	var didWarnAboutStringRefs;

	{
	  didWarnAboutStringRefs = {};
	}

	function hasValidRef(config) {
	  {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.ref !== undefined;
	}

	function hasValidKey(config) {
	  {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.key !== undefined;
	}

	function warnIfStringRefCannotBeAutoConverted(config, self) {
	  {
	    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
	      var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);

	      if (!didWarnAboutStringRefs[componentName]) {
	        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);

	        didWarnAboutStringRefs[componentName] = true;
	      }
	    }
	  }
	}

	function defineKeyPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingKey = function () {
	      if (!specialPropKeyWarningShown) {
	        specialPropKeyWarningShown = true;

	        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingKey.isReactWarning = true;
	    Object.defineProperty(props, 'key', {
	      get: warnAboutAccessingKey,
	      configurable: true
	    });
	  }
	}

	function defineRefPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingRef = function () {
	      if (!specialPropRefWarningShown) {
	        specialPropRefWarningShown = true;

	        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingRef.isReactWarning = true;
	    Object.defineProperty(props, 'ref', {
	      get: warnAboutAccessingRef,
	      configurable: true
	    });
	  }
	}
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, instanceof check
	 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} props
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} owner
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @internal
	 */


	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allows us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };

	  {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.

	    Object.defineProperty(element._store, 'validated', {
	      configurable: false,
	      enumerable: false,
	      writable: true,
	      value: false
	    }); // self and source are DEV only properties.

	    Object.defineProperty(element, '_self', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: self
	    }); // Two elements created in two different places should be considered
	    // equal for testing purposes and therefore we hide it from enumeration.

	    Object.defineProperty(element, '_source', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: source
	    });

	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }

	  return element;
	};
	/**
	 * https://github.com/reactjs/rfcs/pull/107
	 * @param {*} type
	 * @param {object} props
	 * @param {string} key
	 */

	function jsxDEV(type, config, maybeKey, source, self) {
	  {
	    var propName; // Reserved names are extracted

	    var props = {};
	    var key = null;
	    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
	    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
	    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
	    // but as an intermediary step, we will use jsxDEV for everything except
	    // <div {...props} key="Hi" />, because we aren't currently able to tell if
	    // key is explicitly declared to be undefined or not.

	    if (maybeKey !== undefined) {
	      {
	        checkKeyStringCoercion(maybeKey);
	      }

	      key = '' + maybeKey;
	    }

	    if (hasValidKey(config)) {
	      {
	        checkKeyStringCoercion(config.key);
	      }

	      key = '' + config.key;
	    }

	    if (hasValidRef(config)) {
	      ref = config.ref;
	      warnIfStringRefCannotBeAutoConverted(config, self);
	    } // Remaining properties are added to a new props object


	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    } // Resolve default props


	    if (type && type.defaultProps) {
	      var defaultProps = type.defaultProps;

	      for (propName in defaultProps) {
	        if (props[propName] === undefined) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    }

	    if (key || ref) {
	      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

	      if (key) {
	        defineKeyPropWarningGetter(props, displayName);
	      }

	      if (ref) {
	        defineRefPropWarningGetter(props, displayName);
	      }
	    }

	    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	  }
	}

	var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
	var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement$1(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
	    }
	  }
	}

	var propTypesMisspellWarningShown;

	{
	  propTypesMisspellWarningShown = false;
	}
	/**
	 * Verifies the object is a ReactElement.
	 * See https://reactjs.org/docs/react-api.html#isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a ReactElement.
	 * @final
	 */


	function isValidElement(object) {
	  {
	    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	  }
	}

	function getDeclarationErrorAddendum() {
	  {
	    if (ReactCurrentOwner$1.current) {
	      var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);

	      if (name) {
	        return '\n\nCheck the render method of `' + name + '`.';
	      }
	    }

	    return '';
	  }
	}

	function getSourceInfoErrorAddendum(source) {
	  {
	    if (source !== undefined) {
	      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
	      var lineNumber = source.lineNumber;
	      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
	    }

	    return '';
	  }
	}
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */


	var ownerHasKeyUseWarning = {};

	function getCurrentComponentErrorInfo(parentType) {
	  {
	    var info = getDeclarationErrorAddendum();

	    if (!info) {
	      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

	      if (parentName) {
	        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
	      }
	    }

	    return info;
	  }
	}
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it. Error statuses are cached so a warning
	 * will only be shown once.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */


	function validateExplicitKey(element, parentType) {
	  {
	    if (!element._store || element._store.validated || element.key != null) {
	      return;
	    }

	    element._store.validated = true;
	    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

	    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
	      return;
	    }

	    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
	    // property, it may be the creator of the child that's responsible for
	    // assigning it a key.

	    var childOwner = '';

	    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
	      // Give the component that originally created this child.
	      childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
	    }

	    setCurrentlyValidatingElement$1(element);

	    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

	    setCurrentlyValidatingElement$1(null);
	  }
	}
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */


	function validateChildKeys(node, parentType) {
	  {
	    if (typeof node !== 'object') {
	      return;
	    }

	    if (isArray(node)) {
	      for (var i = 0; i < node.length; i++) {
	        var child = node[i];

	        if (isValidElement(child)) {
	          validateExplicitKey(child, parentType);
	        }
	      }
	    } else if (isValidElement(node)) {
	      // This element was passed in a valid location.
	      if (node._store) {
	        node._store.validated = true;
	      }
	    } else if (node) {
	      var iteratorFn = getIteratorFn(node);

	      if (typeof iteratorFn === 'function') {
	        // Entry iterators used to provide implicit keys,
	        // but now we print a separate warning for them later.
	        if (iteratorFn !== node.entries) {
	          var iterator = iteratorFn.call(node);
	          var step;

	          while (!(step = iterator.next()).done) {
	            if (isValidElement(step.value)) {
	              validateExplicitKey(step.value, parentType);
	            }
	          }
	        }
	      }
	    }
	  }
	}
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */


	function validatePropTypes(element) {
	  {
	    var type = element.type;

	    if (type === null || type === undefined || typeof type === 'string') {
	      return;
	    }

	    var propTypes;

	    if (typeof type === 'function') {
	      propTypes = type.propTypes;
	    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
	    // Inner props are checked in the reconciler.
	    type.$$typeof === REACT_MEMO_TYPE)) {
	      propTypes = type.propTypes;
	    } else {
	      return;
	    }

	    if (propTypes) {
	      // Intentionally inside to avoid triggering lazy initializers:
	      var name = getComponentNameFromType(type);
	      checkPropTypes(propTypes, element.props, 'prop', name, element);
	    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
	      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

	      var _name = getComponentNameFromType(type);

	      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
	    }

	    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
	      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
	    }
	  }
	}
	/**
	 * Given a fragment, validate that it can only be provided with fragment props
	 * @param {ReactElement} fragment
	 */


	function validateFragmentProps(fragment) {
	  {
	    var keys = Object.keys(fragment.props);

	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];

	      if (key !== 'children' && key !== 'key') {
	        setCurrentlyValidatingElement$1(fragment);

	        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

	        setCurrentlyValidatingElement$1(null);
	        break;
	      }
	    }

	    if (fragment.ref !== null) {
	      setCurrentlyValidatingElement$1(fragment);

	      error('Invalid attribute `ref` supplied to `React.Fragment`.');

	      setCurrentlyValidatingElement$1(null);
	    }
	  }
	}

	var didWarnAboutKeySpread = {};
	function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
	  {
	    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.

	    if (!validType) {
	      var info = '';

	      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
	      }

	      var sourceInfo = getSourceInfoErrorAddendum(source);

	      if (sourceInfo) {
	        info += sourceInfo;
	      } else {
	        info += getDeclarationErrorAddendum();
	      }

	      var typeString;

	      if (type === null) {
	        typeString = 'null';
	      } else if (isArray(type)) {
	        typeString = 'array';
	      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
	        typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
	        info = ' Did you accidentally export a JSX literal instead of a component?';
	      } else {
	        typeString = typeof type;
	      }

	      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
	    }

	    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.

	    if (element == null) {
	      return element;
	    } // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)


	    if (validType) {
	      var children = props.children;

	      if (children !== undefined) {
	        if (isStaticChildren) {
	          if (isArray(children)) {
	            for (var i = 0; i < children.length; i++) {
	              validateChildKeys(children[i], type);
	            }

	            if (Object.freeze) {
	              Object.freeze(children);
	            }
	          } else {
	            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
	          }
	        } else {
	          validateChildKeys(children, type);
	        }
	      }
	    }

	    {
	      if (hasOwnProperty.call(props, 'key')) {
	        var componentName = getComponentNameFromType(type);
	        var keys = Object.keys(props).filter(function (k) {
	          return k !== 'key';
	        });
	        var beforeExample = keys.length > 0 ? '{key: someKey, ' + keys.join(': ..., ') + ': ...}' : '{key: someKey}';

	        if (!didWarnAboutKeySpread[componentName + beforeExample]) {
	          var afterExample = keys.length > 0 ? '{' + keys.join(': ..., ') + ': ...}' : '{}';

	          error('A props object containing a "key" prop is being spread into JSX:\n' + '  let props = %s;\n' + '  <%s {...props} />\n' + 'React keys must be passed directly to JSX without using spread:\n' + '  let props = %s;\n' + '  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);

	          didWarnAboutKeySpread[componentName + beforeExample] = true;
	        }
	      }
	    }

	    if (type === REACT_FRAGMENT_TYPE) {
	      validateFragmentProps(element);
	    } else {
	      validatePropTypes(element);
	    }

	    return element;
	  }
	} // These two functions exist to still get child warnings in dev
	// even with the prod transform. This means that jsxDEV is purely
	// opt-in behavior for better messages but that we won't stop
	// giving you warnings if you use production apis.

	function jsxWithValidationStatic(type, props, key) {
	  {
	    return jsxWithValidation(type, props, key, true);
	  }
	}
	function jsxWithValidationDynamic(type, props, key) {
	  {
	    return jsxWithValidation(type, props, key, false);
	  }
	}

	var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
	// for now we can ship identical prod functions

	var jsxs =  jsxWithValidationStatic ;

	reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
	reactJsxRuntime_development.jsx = jsx;
	reactJsxRuntime_development.jsxs = jsxs;
	  })();
	}
	return reactJsxRuntime_development;
}

if (process.env.NODE_ENV === 'production') {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}

var jsxRuntimeExports = jsxRuntime.exports;

function assertDashboardMetaResponse(u) {
  if (!u) {
    throw "u is null";
  }
  if (typeof u !== "object") {
    throw "u is not object";
  }
  if ("navigation" in u && typeof u.navigation === "object" && u.navigation) {
    if ("apps" in u.navigation) {
      if (!Array.isArray(u.navigation.apps)) {
        throw "apps is not array";
      } else {
        u.navigation.apps.forEach((appLink) => {
          assertAppLink(appLink);
        });
      }
    } else {
      throw "apps is required";
    }
    if ("visible" in u.navigation && typeof u.navigation.visible !== "boolean") {
      throw "visible is not boolean";
    }
    if ("home" in u.navigation && u.navigation.home) {
      assertAppLink(u.navigation.home);
    }
    if ("userSetting" in u.navigation && u.navigation.userSetting) {
      assertAppLink(u.navigation.userSetting);
    }
  } else {
    throw "u does not have navigation";
  }
  if ("employee" in u && u.employee) {
    if (typeof u.employee === "object") {
      if ("name" in u.employee && typeof u.employee.name !== "string") {
        throw "name is not string";
      }
    } else {
      throw "employee is not object";
    }
    if ("storesUser" in u.employee && u.employee.storesUser) {
      if (typeof u.employee.storesUser === "object") {
        if ("email" in u.employee.storesUser && typeof u.employee.storesUser.email !== "string") {
          throw "email is not string";
        }
        if ("id" in u.employee.storesUser && typeof u.employee.storesUser.id !== "string") {
          throw "id is not string";
        }
      } else {
        throw "storesUser is not object";
      }
    } else {
      throw "storesUser is required";
    }
    if ("businessEntity" in u.employee && u.employee.businessEntity) {
      if (typeof u.employee.businessEntity === "object") {
        if ("id" in u.employee.businessEntity && typeof u.employee.businessEntity.id !== "string") {
          throw "id is not string";
        }
        if ("name" in u.employee.businessEntity && typeof u.employee.businessEntity.name !== "string") {
          throw "id is not string";
        }
      } else {
        throw "businessEntity is not object";
      }
    } else {
      throw "businessEntity is required";
    }
  }
}
function assertAppLink(u) {
  if (!u) {
    throw "u is null";
  }
  if (typeof u !== "object") {
    throw "u is not object";
  }
  if (!isStringProperty(u, "appId")) {
    throw "appId is not expected";
  }
  if (!isStringProperty(u, "name")) {
    throw "name is not expected";
  }
  if (!isStringProperty(u, "href")) {
    throw "href is not expected";
  }
}
function isStringProperty(u, key) {
  if (u instanceof Object) {
    if (!u) {
      return false;
    }
    if (key in u) {
      return typeof u[key] === "string";
    }
    return false;
  }
  return false;
}
function asUiState(maybeUiState) {
  if (!maybeUiState) {
    return false;
  }
  if ("navigationApps" in maybeUiState) {
    return true;
  } else {
    return false;
  }
}

const createUniversalDashboardFetchers = ({
  getDashboardMetaUrl,
  putNavigationUrl,
  overrideHeaders = {},
  overrideFetchOptions = {}
}) => {
  const getDashboardMeta = (options = {}) => fetch(getDashboardMetaUrl, {
    method: "GET",
    headers: overrideHeaders,
    ...options,
    ...overrideFetchOptions
  }).then(async (res) => {
    const data = await res.json();
    try {
      assertDashboardMetaResponse(data);
      return data;
    } catch {
      if ("error" in data) {
        return data;
      }
      return { error: "unexpected response body type" };
    }
  }).catch(async (e) => {
    console.error(e);
    const ret = {
      error: "Failed to get dashboard meta"
    };
    return ret;
  });
  const putNavigation = (apps, options = {}) => fetch(putNavigationUrl, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...overrideHeaders
    },
    body: JSON.stringify({ navigation: { apps } }),
    keepalive: true,
    // https://developer.mozilla.org/ja/docs/Web/API/RequestInit#keepalive すぐにページ遷移したとしてもfetchが生き続ける
    ...options,
    ...overrideFetchOptions
  }).then(async (res) => {
    const data = await res.json();
    return data;
  }).catch(async (e) => {
    console.error(e);
    const ret = {
      error: "Failed to put navigation"
    };
    return ret;
  });
  return {
    getDashboardMeta,
    putNavigation
  };
};

const STAND_NAVI_ROOT_QUERY_SELECTOR = "#stand-navi-root";
const STAND_NAVI_LIST_ITEM_QUERY_SELECTOR = '[data-stand-navi-list-item="true"]';
const STAND_NAVI_LIST_ITEM_HIDE_THRESHOLD = 60;
const mutateStandNaviA11yDOMStyle = () => {
  const rootElement = document.querySelector(
    STAND_NAVI_ROOT_QUERY_SELECTOR
  );
  if (!rootElement) {
    console.warn(
      "No StandNavi root element found. Try calling this function after StandNavi is mounted"
    );
    return;
  }
  if (rootElement) {
    const listItems = rootElement.querySelectorAll(
      STAND_NAVI_LIST_ITEM_QUERY_SELECTOR
    );
    if (!listItems.length) {
      console.warn(
        "No StandNavi list items found. Try calling this function after StandNavi is mounted"
      );
      return;
    }
    const applyStyles = () => {
      const rootRectTop = rootElement.getBoundingClientRect().top;
      listItems.forEach((item) => {
        const itemRectTop = item.getBoundingClientRect().top;
        const relativeDistanceFromItemToRoot = itemRectTop - rootRectTop;
        const shouldHide = relativeDistanceFromItemToRoot > STAND_NAVI_LIST_ITEM_HIDE_THRESHOLD;
        item.style.visibility = shouldHide ? "hidden" : "";
      });
    };
    applyStyles();
    const resizeObserver = new ResizeObserver(() => {
      applyStyles();
    });
    resizeObserver.observe(rootElement);
    listItems.forEach((item) => {
      resizeObserver.observe(item);
    });
    return () => {
      resizeObserver.disconnect();
    };
  }
};

function initBeamer(beamerConfig) {
  const { product_id, user_id, filter, language } = beamerConfig;
  const scriptElement = document.createElement("script");
  scriptElement.type = "text/javascript";
  scriptElement.defer = true;
  scriptElement.innerHTML = `
      var beamer_config = {
        product_id: '${product_id}',
        language: '${language}',
        filter: '${filter}',
        user_id: '${user_id}',
        button: false, // \u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30DC\u30BF\u30F3\u3092\u4F7F\u308F\u306A\u3044\u3001beamerTrigger class\u306E\u30DC\u30BF\u30F3\u3092\u4F7F\u3046
      };
    `;
  document.head.appendChild(scriptElement);
  const beamerScriptElement = document.createElement("script");
  beamerScriptElement.type = "text/javascript";
  beamerScriptElement.src = "https://app.getbeamer.com/js/beamer-embed.js";
  beamerScriptElement.defer = true;
  document.head.appendChild(beamerScriptElement);
}

class LocalStorageCacheStore {
  set(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.error(e);
    }
  }
  get(key) {
    try {
      const item = localStorage.getItem(key);
      if (item) {
        return JSON.parse(item);
      } else {
        return;
      }
    } catch (e) {
      console.error(e);
    }
  }
}

const appDefinitions = {
  home: { name: "\u30DB\u30FC\u30E0", service: "dashboard" },
  navigation_setting: { name: "\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u8A2D\u5B9A", service: "dashboard" },
  organization_business_entity: { name: "\u4E8B\u696D\u8005\u60C5\u5831", service: "organization" },
  organization_shop: { name: "\u5E97\u8217", service: "organization" },
  organization_employee: { name: "\u5F93\u696D\u54E1", service: "organization" },
  user_setting: { name: "\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A", service: "idp" },
  bi_analysis: { name: "\u5206\u6790", service: "bi" },
  cdp_dashboard: { name: "\u9867\u5BA2\u7BA1\u7406", service: "cdp" },
  mobile_order_catalog: { name: "\u30AB\u30BF\u30ED\u30B0", service: "mobile_order" },
  mobile_order_itemset: { name: "\u30A2\u30A4\u30C6\u30E0\u30BB\u30C3\u30C8", service: "mobile_order" },
  mobile_order_remittance: {
    name: "\u5165\u91D1\uFF08\u30E2\u30D0\u30A4\u30EB\u30AA\u30FC\u30C0\u30FC\uFF09",
    service: "mobile_order"
  },
  mobile_order_site_setting: {
    name: "\u30B5\u30A4\u30C8\u8A2D\u5B9A\uFF08\u30E2\u30D0\u30A4\u30EB\u30AA\u30FC\u30C0\u30FC\uFF09",
    service: "mobile_order"
  },
  mobile_order_view_site: {
    name: "STORES \u30E2\u30D0\u30A4\u30EB\u30AA\u30FC\u30C0\u30FC",
    service: "mobile_order"
  },
  netshop_addon: { name: "\u30CD\u30C3\u30C8\u30B7\u30E7\u30C3\u30D7\u306E\u3059\u3079\u3066\u306E\u6A5F\u80FD", service: "netshop" },
  netshop_category: { name: "\u30AB\u30C6\u30B4\u30EA", service: "netshop" },
  netshop_coupon: { name: "\u30AF\u30FC\u30DD\u30F3", service: "netshop" },
  netshop_customer: { name: "\u9867\u5BA2", service: "netshop" },
  netshop_depot: { name: "\u5009\u5EAB", service: "netshop" },
  netshop_inquiry: { name: "\u30CD\u30C3\u30C8\u30B7\u30E7\u30C3\u30D7\u554F\u3044\u5408\u308F\u305B", service: "netshop" },
  netshop_inventory: { name: "\u5728\u5EAB", service: "netshop" },
  netshop_item: { name: "\u30A2\u30A4\u30C6\u30E0", service: "netshop" },
  netshop_mail_magazine: { name: "\u30E1\u30FC\u30EB\u30DE\u30AC\u30B8\u30F3", service: "netshop" },
  netshop_news: { name: "\u30CB\u30E5\u30FC\u30B9", service: "netshop" },
  netshop_order: { name: "\u30AA\u30FC\u30C0\u30FC", service: "netshop" },
  netshop_remittance: { name: "\u58F2\u4E0A\uFF08\u30CD\u30C3\u30C8\u30B7\u30E7\u30C3\u30D7\uFF09", service: "netshop" },
  netshop_setting: { name: "\u4E8B\u696D\u8005\u8A2D\u5B9A\uFF08\u30CD\u30C3\u30C8\u30B7\u30E7\u30C3\u30D7\uFF09", service: "netshop" },
  netshop_shipping: { name: "\u767A\u9001", service: "netshop" },
  netshop_site_setting: {
    name: "\u30B5\u30A4\u30C8\u8A2D\u5B9A\uFF08\u30CD\u30C3\u30C8\u30B7\u30E7\u30C3\u30D7\uFF09",
    service: "netshop"
  },
  netshop_store_design: { name: "\u30B9\u30C8\u30A2\u30C7\u30B6\u30A4\u30F3", service: "netshop" },
  netshop_view_site: { name: "STORES \u30CD\u30C3\u30C8\u30B7\u30E7\u30C3\u30D7", service: "netshop" },
  pos_category: { name: "\u30AB\u30C6\u30B4\u30EA", service: "pos" },
  pos_inventory: { name: "\u5E97\u8217\u5728\u5EAB", service: "pos" },
  pos_item: { name: "\u5E97\u8217\u30A2\u30A4\u30C6\u30E0", service: "pos" },
  pos_order: { name: "\u30AA\u30FC\u30C0\u30FC\u7BA1\u7406\u03B2", service: "pos" },
  pos_setting: { name: "\u8A2D\u5B9A\uFF08\u30EC\u30B8\uFF09", service: "pos" },
  pos_analysis: { name: "\u5E97\u8217\u58F2\u4E0A", service: "pos" },
  reserve_account_setting: { name: "\u4E88\u7D04\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A", service: "reserve" },
  reserve_analysis: { name: "\u5206\u6790\uFF08\u4E88\u7D04\uFF09", service: "reserve" },
  reserve_calendar: { name: "\u30AB\u30EC\u30F3\u30C0\u30FC", service: "reserve" },
  reserve_customer: { name: "\u9867\u5BA2\uFF08\u4E88\u7D04\uFF09", service: "reserve" },
  reserve_message: { name: "\u30E1\u30C3\u30BB\u30FC\u30B8\u914D\u4FE1\uFF08\u4E88\u7D04\uFF09", service: "reserve" },
  reserve_organization_setting: { name: "\u4E88\u7D04\u7D44\u7E54\u7BA1\u7406", service: "reserve" },
  reserve_reservation_page: { name: "\u4E88\u7D04\u30DA\u30FC\u30B8", service: "reserve" },
  reserve_setting: { name: "\u8A2D\u5B9A\uFF08\u4E88\u7D04\uFF09", service: "reserve" },
  reserve_site_setting: { name: "\u30B5\u30A4\u30C8\u8A2D\u5B9A\uFF08\u4E88\u7D04\uFF09", service: "reserve" },
  reserve_staff: { name: "\u30B9\u30BF\u30C3\u30D5\uFF08\u4E88\u7D04\uFF09", service: "reserve" },
  reserve_staff_schedule: { name: "\u30B7\u30D5\u30C8\u7BA1\u7406", service: "reserve" },
  reserve_subscription_or_ticket_book: {
    name: "\u56DE\u6570\u5238\u30FB\u6708\u8B1D",
    service: "reserve"
  },
  reserve_transfer: { name: "\u5165\u91D1\uFF08\u4E88\u7D04\uFF09", service: "reserve" },
  reserve_view_site: { name: "STORES \u4E88\u7D04", service: "reserve" },
  reserve_business_hour: { name: "\u55B6\u696D\u6642\u9593\u8A2D\u5B9A\uFF08\u4E88\u7D04\uFF09", service: "reserve" },
  reserve_reservation_page_type_choose: {
    name: "\u4E88\u7D04\u30DA\u30FC\u30B8\u4F5C\u6210",
    service: "reserve"
  },
  payment_transaction: { name: "\u58F2\u4E0A\uFF08\u6C7A\u6E08\uFF09", service: "payment" },
  payment_deposit: { name: "\u5165\u91D1\uFF08\u6C7A\u6E08\uFF09", service: "payment" },
  payment_online_payment_creation: {
    name: "\u8ACB\u6C42\u66F8\u6C7A\u6E08 \u4F5C\u6210",
    service: "payment"
  },
  payment_online_payment_history: {
    name: "\u8ACB\u6C42\u66F8\u6C7A\u6E08 \u5C65\u6B74",
    service: "payment"
  },
  payment_online_payment_design: {
    name: "\u8ACB\u6C42\u66F8\u6C7A\u6E08 \u30C7\u30B6\u30A4\u30F3",
    service: "payment"
  },
  payment_online_payment_development: {
    name: "\u958B\u767A\u8005\u7528\u8A2D\u5B9A",
    service: "payment"
  },
  payment_application_status: { name: "\u65E7\u6C7A\u6E08\u30DB\u30FC\u30E0", service: "payment" },
  payment_terminal_purchase: { name: "\u6C7A\u6E08\u7AEF\u672B\u306E\u8CFC\u5165", service: "payment" },
  payment_staff: { name: "\u30B9\u30BF\u30C3\u30D5\uFF08\u6C7A\u6E08\uFF09", service: "payment" },
  payment_deposit_setting: { name: "\u5165\u91D1\u8A2D\u5B9A\u306E\u78BA\u8A8D", service: "payment" },
  payment_setting: { name: "\u8A2D\u5B9A\uFF08\u6C7A\u6E08\uFF09", service: "payment" },
  stores_help: { name: "\u3088\u304F\u3042\u308B\u8CEA\u554F", service: "external_stores_site" },
  stores_inquiry: { name: "\u304A\u554F\u3044\u5408\u308F\u305B", service: "external_stores_site" },
  stores_send_feedback: {
    name: "\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF\u3092\u9001\u308B",
    service: "external_stores_site"
  },
  download_pos_app: {
    name: "\u30EC\u30B8\u30A2\u30D7\u30EA\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
    service: "external_stores_site"
  },
  faq_pos_payment_setting: {
    name: "\u6C7A\u6E08\u624B\u6BB5\u8A2D\u5B9A\uFF08\u30EC\u30B8\uFF09",
    service: "external_stores_site"
  },
  stores_mart_netshop: {
    name: "STORES \u5468\u8FBA\u6A5F\u5668\u8CA9\u58F2\u30B9\u30C8\u30A2",
    service: "external_stores_site"
  },
  faq_pos_how_to_setup_payment: {
    name: "\u30C6\u30B9\u30C8\u4F1A\u8A08\uFF08\u30EC\u30B8\uFF09",
    service: "external_stores_site"
  },
  fun_onboarding_reserve: {
    name: "STORES \u4E88\u7D04\u306B\u3064\u3044\u3066\u5B66\u3076",
    service: "external_stores_site"
  },
  faq_payment_terminal_setting: {
    name: "\u6C7A\u6E08\u7AEF\u672B\u306E\u8A2D\u5B9A\u65B9\u6CD5",
    service: "external_stores_site"
  },
  faq_mobile_order_tokushoho: {
    name: "\u7279\u5B9A\u5546\u53D6\u5F15\u6CD5\u306B\u95A2\u3059\u308B\u8868\u8A18\u306E\u8A2D\u5B9A",
    service: "external_stores_site"
  },
  faq_mobile_order_credit_payment: {
    name: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u6C7A\u6E08\u306E\u5229\u7528\u7533\u8ACB",
    service: "external_stores_site"
  },
  faq_mobile_order_item: {
    name: "\u30A2\u30A4\u30C6\u30E0\u306E\u4F5C\u6210",
    service: "external_stores_site"
  },
  faq_mobile_order_catalog: {
    name: "\u30AB\u30BF\u30ED\u30B0\u306E\u4F5C\u6210",
    service: "external_stores_site"
  },
  faq_mobile_order_store_url: {
    name: "\u30B9\u30C8\u30A2URL\u306E\u8A2D\u5B9A",
    service: "external_stores_site"
  },
  faq_mobile_order_delivery: {
    name: "\u53D7\u3051\u6E21\u3057\u6642\u9593\u306E\u8A2D\u5B9A",
    service: "external_stores_site"
  },
  faq_mobile_order_kds: {
    name: "\u30AD\u30C3\u30C1\u30F3\u30C7\u30A3\u30B9\u30D7\u30EC\u30A4\u306E\u8A2D\u5B9A",
    service: "external_stores_site"
  },
  faq_mobile_order_remittance: {
    name: "\u58F2\u4E0A\u91D1\u306E\u5165\u91D1\u53E3\u5EA7\u8A2D\u5B9A",
    service: "external_stores_site"
  },
  faq_mobile_order_store_publish: {
    name: "\u30B9\u30C8\u30A2\u306E\u516C\u958B",
    service: "external_stores_site"
  },
  faq_payment_purchase: {
    name: "\u6C7A\u6E08\u7AEF\u672B\u306E\u8CFC\u5165",
    service: "external_stores_site"
  }
};

function inferEnabled(state) {
  return state?.uiState.visible === true;
}
function shouldBlockRendering(state) {
  if (state?.uiState.visible) {
    return false;
  }
  return state?.phase !== "completed";
}
function initialState() {
  return {
    uiState: {
      navigationApps: [],
      visible: false,
      version: ""
    },
    phase: "initialized"
  };
}
function StartNavigationLifecycle(state, trigger, appId, alreadyInAnotherLifecycle, onLifecycleStart) {
  onLifecycleStart();
  if (state.phase === "transition" || alreadyInAnotherLifecycle) {
    return state;
  }
  if (trigger === "revalidate") {
    return { ...state, phase: "optimisticUI", userAction: "pageOpen", appId };
  }
  return { ...state, phase: "optimisticUI", userAction: trigger, appId };
}
async function Phase_OptimisticUI(state) {
  if (!state.userAction) {
    throw "userAction is null";
  }
  const storage = new LocalStorageCacheStore();
  const newState = { ...state };
  const maybeUiState = storage.get("navigation:uiState");
  if (asUiState(maybeUiState)) {
    newState.uiState = maybeUiState;
  }
  const nextPhase = state.userAction === "pageOpen" ? "fetch" : "persist";
  const removedAppLink = state.userAction === "appRemove" ? transitionTargetWhenAppClosed(
    newState.uiState.navigationApps,
    state.appId ?? ""
  ) : null;
  const refreshedAppsState = updateNavigationAppsState(
    newState.uiState.navigationApps,
    state.appId ?? null,
    state.userAction
  );
  newState.removedAppLink = removedAppLink ?? void 0;
  newState.uiState.navigationApps = refreshedAppsState;
  return { state: { ...newState, phase: nextPhase } };
}
async function Phase_Fetch(state, options) {
  if (!state.userAction) {
    throw "userAction is null";
  }
  if (state.userAction !== "pageOpen") {
    throw "pageOpen userAction is expected";
  }
  const getResponse = await options.getDashboardMetaFetcher();
  if ("error" in getResponse) {
    options.onError(getResponse);
    return { state: { ...state, phase: "completed" } };
  }
  const refreshedAppsState = updateNavigationAppsState(
    getResponse.navigation.apps,
    state.appId ?? null,
    state.userAction
  );
  const serverSideApps = getResponse.navigation.apps;
  const hasDiffWithServerSide = !isSameAppIds(
    serverSideApps,
    refreshedAppsState
  );
  const nextPhase = hasDiffWithServerSide ? "persist" : "completed";
  const newState = {
    ...state,
    uiState: {
      navigationApps: refreshedAppsState,
      visible: getResponse.navigation.visible,
      version: getResponse.navigation.version,
      employee: getResponse?.employee,
      home: getResponse?.navigation?.home,
      userSetting: getResponse?.navigation?.userSetting,
      mobileOrderViewSite: getResponse?.navigation?.mobileOrderViewSite,
      netshopViewSite: getResponse?.navigation?.netshopViewSite,
      reserveViewSite: getResponse?.navigation?.reserveViewSite,
      navigationSetting: getResponse?.navigation?.navigationSetting,
      metadata: getResponse?.navigation?.metadata
    },
    beamerConfig: getResponse.beamerConfig,
    phase: nextPhase
  };
  const storage = new LocalStorageCacheStore();
  storage.set("navigation:uiState", filterPersonalInfo(newState.uiState));
  return {
    state: newState
  };
}
async function Phase_Persist(state, options) {
  if (!state.userAction) {
    throw "userAction is null";
  }
  if (state.userAction === "pageOpen") {
    const putResponse = await options.putNavigationFetcher(
      cleanPutNavigationBody(state.uiState.navigationApps)
    );
    if ("error" in putResponse) {
      options.onError(putResponse);
      return { state: { ...state, phase: "completed" } };
    }
    const getResponse = await options.getDashboardMetaFetcher();
    if ("error" in getResponse) {
      options.onError(getResponse);
      return { state: { ...state, phase: "completed" } };
    }
    const refreshedAppsState = updateNavigationAppsState(
      getResponse?.navigation?.apps,
      state.appId ?? null,
      "pageOpen"
    );
    const newState = {
      ...state,
      appId: null,
      userAction: void 0,
      removedAppLink: void 0,
      uiState: {
        ...state.uiState,
        navigationApps: refreshedAppsState
      },
      phase: "completed"
    };
    const storage = new LocalStorageCacheStore();
    storage.set("navigation:uiState", filterPersonalInfo(newState.uiState));
    return { state: newState };
  }
  if (state.userAction === "appRemove") {
    const storage = new LocalStorageCacheStore();
    storage.set("navigation:uiState", filterPersonalInfo(state.uiState));
    options.putNavigationFetcher(
      cleanPutNavigationBody(state.uiState.navigationApps)
    ).then((putResponse) => {
      if ("error" in putResponse) {
        options.onError(putResponse);
      }
    });
    const appLink = state.removedAppLink;
    if (appLink) {
      window.location.href = appLink.href;
    } else {
      window.location.href = state.uiState.home?.href ?? "/";
    }
    return {
      state: {
        ...state,
        appId: null,
        userAction: void 0,
        removedAppLink: void 0,
        phase: "transition"
      }
    };
  }
  const _never = state.userAction;
  throw _never;
}
function isSamePathWithMatch(currentPath, targetPath) {
  return currentPath.match(`^${targetPath}`) !== null;
}
function detectAppId(currentPath, relatedPathsMap) {
  let resultAppId = null;
  currentPath = parseURL(currentPath).pathname;
  relatedPathsMap.forEach((p) => {
    if (isSamePath(currentPath, p.path)) {
      resultAppId = p.appId;
    }
    p.relatedPaths.forEach((relatedPath) => {
      if (isSamePathWithMatch(currentPath, relatedPath)) {
        resultAppId = p.appId;
      }
    });
  });
  return resultAppId;
}
function updateNavigationAppsState(apps, detectedAppId, action) {
  if (!detectedAppId) {
    return apps;
  }
  if (action === "pageOpen") {
    if (apps.find((app) => app.appId === detectedAppId)) {
      return apps;
    }
    const appDef = appDefinitions[detectedAppId];
    return [
      ...apps,
      { appId: detectedAppId, name: appDef?.name ?? "", href: "#" }
    ];
  }
  if (action === "appRemove") {
    return apps.filter((app) => app.appId !== detectedAppId);
  }
  const never = action;
  return never;
}
function isSameAppIds(prev, next) {
  if (prev.length !== next.length) {
    return false;
  }
  return prev.every((_, i) => prev[i].appId === next[i].appId);
}
function transitionTargetWhenAppClosed(apps, appId) {
  const appIndex = apps.findIndex((app) => app.appId === appId);
  if (appIndex === -1) {
    return null;
  }
  return apps[appIndex + 1] ?? apps[appIndex - 1] ?? null;
}
function cleanPutNavigationBody(apps) {
  return apps.map((app) => ({ appId: app.appId }));
}
function filterPersonalInfo(uiState) {
  return {
    ...uiState,
    employee: {
      ...uiState.employee,
      name: "",
      storesUser: {
        email: "",
        id: uiState.employee?.storesUser?.id ?? ""
      },
      businessEntity: {
        id: uiState.employee?.businessEntity?.id ?? "",
        name: ""
      }
    }
  };
}

const STAND_NAVI_ROOT = "#stand-navi-root";
const STAND_NAVI_LIST_ITEM_SELECTOR = '[data-stand-navi-list-item="true"]';
const OVERFLOW_THRESHOLD = 60;
const BREAKPOINTS = {
  sp: 0,
  pc: 520
};
const getCurrentBreakpoint = (width) => {
  if (width >= BREAKPOINTS.pc)
    return "pc";
  return "sp";
};
const getNavListItems = () => {
  const listItems = document.querySelectorAll(
    STAND_NAVI_LIST_ITEM_SELECTOR
  );
  if (!listItems.length)
    return null;
  return listItems;
};
const getStandNaviRoot = () => {
  const root = document.querySelector(STAND_NAVI_ROOT);
  if (!root)
    return null;
  return root;
};
const calculateOverflowCount = (listItems, getContainer) => {
  const container = getContainer();
  if (!container)
    return 0;
  const rootRectTop = container.getBoundingClientRect().top;
  let overflowCount = 0;
  listItems.forEach((item) => {
    const itemRectTop = item.getBoundingClientRect().top;
    const relativeDistanceFromItemToRoot = itemRectTop - rootRectTop;
    if (relativeDistanceFromItemToRoot > OVERFLOW_THRESHOLD) {
      overflowCount++;
    }
  });
  return overflowCount;
};
const startIntersectionObserver = (config) => {
  const {
    onNavChange,
    getContainer,
    getListItems,
    clearListItems: clearListItemsRef,
    setListItems
  } = config;
  const container = getContainer();
  const observer = new IntersectionObserver(
    (_entries, observer2) => {
      const listItems2 = getNavListItems();
      if (!listItems2)
        return;
      const currentlyObserved = getListItems() || [];
      const newItems = Array.from(listItems2);
      if (currentlyObserved.length !== newItems.length || !currentlyObserved.every((item, i) => item === newItems[i])) {
        currentlyObserved.forEach((item) => observer2.unobserve(item));
        clearListItemsRef();
        newItems.forEach((item) => {
          observer2.observe(item);
          setListItems([...getListItems() || [], item]);
        });
      }
      const count = calculateOverflowCount(listItems2, getContainer);
      const xPosition = listItems2[listItems2.length - count - 1]?.getBoundingClientRect().right ?? 0;
      onNavChange({ count, position: { left: xPosition } });
    },
    {
      root: container,
      threshold: 0.5,
      rootMargin: "0px"
    }
  );
  const listItems = getNavListItems();
  if (!listItems)
    return null;
  clearListItemsRef();
  listItems.forEach((item) => {
    observer.observe(item);
    setListItems([...getListItems() || [], item]);
  });
  return observer;
};
const startResizeObserver = (config) => {
  const {
    getBreakpoint,
    setBreakpoint,
    getListItems,
    clearListItems: clearListItemsRef,
    setListItems,
    getIntersectionObserver
  } = config;
  const observer = new ResizeObserver((_entries) => {
    const currentBreakpoint = getBreakpoint();
    const newBreakpoint = getCurrentBreakpoint(
      getStandNaviRoot()?.clientWidth ?? 0
    );
    const intersectionObserver = getIntersectionObserver();
    if (currentBreakpoint !== newBreakpoint) {
      const listItems = getNavListItems();
      if (!listItems)
        return;
      const currentlyObserved = getListItems() || [];
      const newItems = Array.from(listItems);
      currentlyObserved.forEach(
        (item) => intersectionObserver?.unobserve(item)
      );
      clearListItemsRef();
      newItems.forEach((item) => {
        intersectionObserver?.observe(item);
        setListItems([...getListItems() || [], item]);
      });
    }
    setBreakpoint(newBreakpoint);
  });
  setBreakpoint(getCurrentBreakpoint(getStandNaviRoot()?.clientWidth ?? 0));
  observer.observe(getStandNaviRoot() ?? document.body);
  return observer;
};
const createCollapsedAppsObserver = (config) => {
  const {
    onNavChange,
    getContainer,
    getListItems,
    clearListItems,
    setListItems,
    getBreakpoint,
    setBreakpoint,
    getIntersectionObserver
  } = config;
  return new Promise((resolve) => {
    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach(() => {
        const listItems = getNavListItems();
        const container = getContainer();
        if (listItems && container) {
          const intersectionObserver = startIntersectionObserver({
            onNavChange,
            getContainer,
            getListItems,
            clearListItems,
            setListItems
          });
          if (intersectionObserver) {
            const resizeObserver = startResizeObserver({
              getBreakpoint,
              setBreakpoint,
              getListItems,
              clearListItems,
              setListItems,
              getIntersectionObserver
            });
            mutationObserver.disconnect();
            resolve({ intersectionObserver, resizeObserver });
          }
        }
      });
    });
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
};

const hardcodedAppGroups = [
  {
    id: "analysis",
    appIds: ["bi_analysis", "reserve_analysis"]
  },
  {
    id: "customer",
    appIds: ["netshop_customer", "reserve_customer"]
  },
  {
    id: "sales",
    appIds: [
      "netshop_remittance",
      "mobile_order_remittance",
      "payment_transaction",
      "payment_deposit",
      "reserve_transfer"
    ]
  },
  {
    id: "order",
    appIds: ["netshop_order", "pos_order"]
  },
  {
    id: "message",
    appIds: ["reserve_message", "netshop_mail_magazine"]
  },
  {
    id: "payment_online_payment",
    appIds: [
      "payment_online_payment_creation",
      "payment_online_payment_history",
      "payment_online_payment_design",
      "payment_online_payment_development"
    ]
  },
  {
    id: "item",
    appIds: ["netshop_item", "pos_item"]
  },
  {
    id: "inventory",
    appIds: ["netshop_inventory", "pos_inventory"]
  },
  {
    id: "employee",
    appIds: ["organization_employee", "reserve_staff", "payment_staff"]
  },
  {
    id: "setting",
    appIds: ["reserve_setting", "pos_setting", "netshop_setting"]
  },
  {
    id: "site_setting",
    appIds: [
      "reserve_site_setting",
      "netshop_site_setting",
      "mobile_order_site_setting"
    ]
  },
  {
    id: "view_site",
    appIds: [
      "reserve_view_site",
      "netshop_view_site",
      "mobile_order_view_site"
    ]
  }
];

const hardcodedIconMapping = {
  customer: "customer",
  sales: "money",
  analysis: "analysis",
  order: "order",
  message: "message",
  employee: "employee",
  setting: "setting",
  site_setting: "site_setting",
  my_site: "my_site",
  reserve_calendar: "calendar",
  reserve_reservation_page: "resources",
  reserve_subscription_or_ticket_book: "tickets",
  reserve_staff_schedule: "shift",
  mobile_order_catalog: "catalog",
  mobile_order_itemset: "item_set",
  netshop_category: "catalog",
  netshop_shipping: "shipping",
  item: "item",
  inventory: "stock",
  netshop_coupon: "coupon",
  payment_online_payment: "invoice",
  netshop_inquiry: "contact",
  netshop_news: "news",
  netshop_depot: "warehouse",
  netshop_store_design: "store_design",
  payment_application_status: "old_home",
  pos_category: "category",
  cdp_dashboard: "customer"
};

const ProfileSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M23.9996%206.47422C19.6481%206.47422%2016.1194%2010.0039%2016.1194%2014.3566C16.1194%2018.7092%2019.6481%2022.2391%2023.9996%2022.2391C28.3538%2022.2391%2031.8822%2018.709%2031.8822%2014.3566C31.8822%2010.0042%2028.3538%206.47422%2023.9996%206.47422ZM12.7194%2014.3566C12.7194%208.12715%2017.7693%203.07422%2023.9996%203.07422C30.232%203.07422%2035.2822%208.12688%2035.2822%2014.3566C35.2822%2020.5862%2030.232%2025.6391%2023.9996%2025.6391C17.7693%2025.6391%2012.7194%2020.586%2012.7194%2014.3566Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M12.9237%2030.468C15.9357%2029.4579%2019.9164%2029.1555%2024%2029.1555C28.1071%2029.1555%2032.0896%2029.469%2035.0984%2030.492C36.6118%2031.0065%2038.003%2031.741%2039.0305%2032.818C40.0972%2033.9362%2040.7%2035.352%2040.7%2037.0217C40.7%2038.6946%2040.0912%2040.1095%2039.0183%2041.2231C37.9856%2042.2948%2036.5896%2043.0223%2035.0749%2043.5305C32.0625%2044.5412%2028.0819%2044.8445%2024%2044.8445C19.8938%2044.8445%2015.9113%2044.531%2012.9023%2043.5081C11.3888%2042.9935%209.99755%2042.2591%208.96987%2041.1821C7.90301%2040.064%207.29999%2038.6482%207.29999%2036.9783C7.29999%2035.3051%207.90802%2033.8898%208.98073%2032.7758C10.0131%2031.7035%2011.409%2030.976%2012.9237%2030.468ZM11.4299%2035.134C10.955%2035.6272%2010.7%2036.202%2010.7%2036.9783C10.7%2037.7579%2010.9551%2038.3376%2011.4297%2038.8349C11.9435%2039.3734%2012.7769%2039.8743%2013.9967%2040.289C16.4539%2041.1244%2019.9714%2041.4445%2024%2041.4445C28.0091%2041.4445%2031.5285%2041.134%2033.9934%2040.3071C35.2173%2039.8965%2036.0542%2039.3992%2036.5698%2038.864C37.0452%2038.3707%2037.3%2037.7964%2037.3%2037.0217C37.3%2036.242%2037.0449%2035.6623%2036.5704%2035.165C36.0568%2034.6266%2035.2235%2034.1257%2034.004%2033.711C31.547%2032.8757%2028.0295%2032.5555%2024%2032.5555C19.9883%2032.5555%2016.469%2032.8651%2014.0048%2033.6916C12.7814%2034.1019%2011.9451%2034.5989%2011.4299%2035.134Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const LogoutSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M15.1182%207.79522C13.9893%207.88746%2013.3241%208.06051%2012.8123%208.32132C11.7397%208.86779%2010.8677%209.73979%2010.3213%2010.8123C10.0604%2011.3242%209.88739%2011.9893%209.79516%2013.1182C9.70131%2014.2669%209.69999%2015.7398%209.69999%2017.84V30.16C9.69999%2032.2603%209.70131%2033.7332%209.79516%2034.8819C9.88739%2036.0108%2010.0604%2036.676%2010.3213%2037.1879C10.8677%2038.2604%2011.7397%2039.1323%2012.8122%2039.6787C13.3241%2039.9395%2013.9893%2040.1126%2015.1182%2040.2049C16.267%2040.2987%2017.74%2040.3%2019.8403%2040.3H20C20.9389%2040.3%2021.7%2041.0612%2021.7%2042C21.7%2042.9389%2020.9389%2043.7001%2020%2043.7001H19.7671C17.7569%2043.7001%2016.1448%2043.7001%2014.8413%2043.5936C13.5022%2043.4842%2012.3398%2043.2539%2011.2687%2042.7082C9.55644%2041.8358%208.16429%2040.4437%207.29184%2038.7314C6.7461%2037.6603%206.51586%2036.4979%206.40645%2035.1588C6.29996%2033.8554%206.29997%2032.2434%206.29999%2030.2335V17.7666C6.29997%2015.7567%206.29996%2014.1447%206.40645%2012.8413C6.51586%2011.5022%206.7461%2010.3398%207.29184%209.26872C8.16428%207.55647%209.55641%206.16434%2011.2687%205.2919C12.3398%204.74615%2013.5022%204.51592%2014.8413%204.40652C16.1448%204.30002%2017.7569%204.30003%2019.7669%204.30005L20%204.30005C20.9389%204.30005%2021.7%205.06117%2021.7%206.00005C21.7%206.93893%2020.9389%207.70005%2020%207.70005H19.8403C17.74%207.70005%2016.267%207.70137%2015.1182%207.79522Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M34.092%2014.3783C34.746%2013.7047%2035.8223%2013.6889%2036.4959%2014.3429L45.1845%2022.7799C45.5142%2023.1%2045.7002%2023.54%2045.7002%2023.9995C45.7002%2024.459%2045.5142%2024.899%2045.1845%2025.2191L36.4959%2033.6561C35.8223%2034.3102%2034.746%2034.2944%2034.092%2033.6208C33.4379%2032.9472%2033.4537%2031.8709%2034.1273%2031.2169L39.8094%2025.6993L18.8984%2025.6985C17.9595%2025.6985%2017.1984%2024.9373%2017.1984%2023.9984C17.1985%2023.0595%2017.9596%2022.2985%2018.8985%2022.2985L39.809%2022.2993L34.1273%2016.7822C33.4537%2016.1281%2033.4379%2015.0518%2034.092%2014.3783Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const BrowserSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M9.82186%209.97767C8.5073%2011.3876%207.69999%2013.4614%207.69999%2016.0532V31.9468C7.69999%2034.5409%208.5042%2036.6144%209.81605%2038.0233C11.1152%2039.4184%2013.0378%2040.299%2015.5657%2040.299H32.4324C34.9614%2040.299%2036.884%2039.4184%2038.1827%2038.0234C39.4943%2036.6146%2040.2982%2034.5411%2040.2982%2031.9468V16.0532C40.2982%2013.4591%2039.4943%2011.3855%2038.1829%209.97668C36.8842%208.58163%2034.9622%207.70103%2032.4342%207.70103H15.5657C13.0477%207.70103%2011.1241%208.58096%209.82186%209.97767ZM7.33509%207.65906C9.34612%205.50217%2012.2055%204.30103%2015.5657%204.30103H32.4342C35.8022%204.30103%2038.6621%205.5015%2040.6715%207.66005C42.6681%209.80485%2043.6982%2012.7573%2043.6982%2016.0532V31.9468C43.6982%2035.2428%2042.6681%2038.1954%2040.6712%2040.3402C38.6615%2042.4987%2035.8011%2043.699%2032.4324%2043.699H15.5657C12.1978%2043.699%209.33755%2042.4986%207.32776%2040.3403C5.33071%2038.1956%204.29999%2035.243%204.29999%2031.9468V16.0532C4.29999%2012.755%205.33636%209.80275%207.33509%207.65906Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M10.8781%2013.0997C10.8781%2012.1608%2011.6392%2011.3997%2012.5781%2011.3997H12.689C13.6279%2011.3997%2014.389%2012.1608%2014.389%2013.0997C14.389%2014.0385%2013.6279%2014.7997%2012.689%2014.7997H12.5781C11.6392%2014.7997%2010.8781%2014.0385%2010.8781%2013.0997ZM15.8491%2013.0997C15.8491%2012.1608%2016.6102%2011.3997%2017.5491%2011.3997H17.6601C18.5989%2011.3997%2019.3601%2012.1608%2019.3601%2013.0997C19.3601%2014.0385%2018.5989%2014.7997%2017.6601%2014.7997H17.5491C16.6102%2014.7997%2015.8491%2014.0385%2015.8491%2013.0997ZM20.822%2013.0997C20.822%2012.1608%2021.5831%2011.3997%2022.522%2011.3997H22.633C23.5719%2011.3997%2024.333%2012.1608%2024.333%2013.0997C24.333%2014.0385%2023.5719%2014.7997%2022.633%2014.7997H22.522C21.5831%2014.7997%2020.822%2014.0385%2020.822%2013.0997Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M4.29999%2018.9834C4.29999%2018.0446%205.0611%2017.2834%205.99999%2017.2834H41.9982C42.9371%2017.2834%2043.6982%2018.0446%2043.6982%2018.9834C43.6982%2019.9223%2042.9371%2020.6834%2041.9982%2020.6834H5.99999C5.0611%2020.6834%204.29999%2019.9223%204.29999%2018.9834Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

function Popover({
  trigger,
  children,
  isOpen,
  className = "",
  isCollapsed = false,
  position
}) {
  const AlignmentClasses = "right-0";
  const style = position ? { left: `${position.left}px` } : {};
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: `${isCollapsed ? "absolute" : "relative"} z-10 ${className}`,
      style,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cursor-pointer", children: trigger() }),
        isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: `absolute mt-xs min-w-[280px] origin-top-right overflow-hidden rounded-md
            bg-white shadow-lg transition-all focus:outline-none ${AlignmentClasses} max-h-[600px] overflow-y-auto`,
            role: "menu",
            "aria-orientation": "vertical",
            "aria-labelledby": "menu-button",
            tabIndex: -1,
            children: children()
          }
        )
      ]
    }
  );
}
function ViewSitePopover({
  onClickMobileOrderViewSite,
  mobileOrderViewSiteName,
  onClickNetshopViewSite,
  netshopViewSiteName,
  onClickReserveViewSite,
  reserveViewSiteName,
  onClickViewSiteIcon,
  isOpen
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Popover,
    {
      isOpen,
      trigger: () => /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "button",
        {
          className: "box-border block rounded-full p-sm active:scale-95 active:transition-transform active:duration-100 pc:border pc:border-solid pc:border-border-tertiary",
          onClick: onClickViewSiteIcon,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                className: "block align-middle",
                width: 24,
                height: 24,
                src: BrowserSVG
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "sr-only", children: "View site menu" })
          ]
        }
      ),
      children: () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "py-xs", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col gap-0", children: [
        onClickNetshopViewSite && netshopViewSiteName && /* @__PURE__ */ jsxRuntimeExports.jsx(
          ViewSiteButton,
          {
            onClick: onClickNetshopViewSite,
            name: netshopViewSiteName
          }
        ),
        onClickReserveViewSite && reserveViewSiteName && /* @__PURE__ */ jsxRuntimeExports.jsx(
          ViewSiteButton,
          {
            onClick: onClickReserveViewSite,
            name: reserveViewSiteName
          }
        ),
        onClickMobileOrderViewSite && mobileOrderViewSiteName && /* @__PURE__ */ jsxRuntimeExports.jsx(
          ViewSiteButton,
          {
            onClick: onClickMobileOrderViewSite,
            name: mobileOrderViewSiteName
          }
        )
      ] }) })
    }
  );
}
const ViewSiteButton = ({
  onClick,
  name
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "button",
    {
      className: "flex h-48 w-full items-center justify-start px-lg py-sm text-body-md text-label-primary hover:bg-surface-quaternary",
      onClick,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "block text-label-primary", children: name })
    }
  );
};
function UserPopover({
  onClickUserSettings,
  onClickUser,
  onClickLogout,
  businessEntityName,
  businessEntityId,
  userName,
  userEmail,
  userId,
  isOpen
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Popover,
    {
      isOpen,
      trigger: () => /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "button",
        {
          className: "box-border block rounded-full p-sm active:scale-95 active:transition-transform active:duration-100 pc:border pc:border-solid pc:border-border-tertiary",
          onClick: onClickUser,
          "data-user-id": userId ?? "",
          title: `\u30A2\u30AB\u30A6\u30F3\u30C8: ${userEmail} (${userName})`,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                className: "block align-middle",
                width: 24,
                height: 24,
                src: ProfileSVG
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "sr-only", children: "User menu" })
          ]
        }
      ),
      children: () => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "py-xs", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center justify-between px-lg py-sm", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "p",
          {
            className: "text-body-md text-label-primary",
            title: `${businessEntityName} (${businessEntityId})`,
            children: businessEntityName
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mt-xs border-b border-solid border-surface-tertiary" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "my-xs" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col gap-0", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "button",
            {
              className: "flex h-48 w-full items-center justify-start px-lg py-sm text-body-md text-label-primary hover:bg-surface-quaternary",
              onClick: onClickUserSettings,
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "img",
                  {
                    className: "mr-xs block align-middle",
                    width: 20,
                    height: 20,
                    src: ProfileSVG
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "block text-label-primary", children: "\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A" })
              ]
            }
          ),
          onClickLogout && /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "button",
            {
              onClick: onClickLogout,
              className: "flex h-48 w-full items-center justify-start px-lg py-sm text-body-md text-label-primary hover:bg-surface-quaternary",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "img",
                  {
                    className: "mr-xs block align-middle",
                    width: 20,
                    height: 20,
                    src: LogoutSVG
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "block text-label-primary", children: "\u30ED\u30B0\u30A2\u30A6\u30C8" })
              ]
            }
          )
        ] })
      ] })
    }
  );
}

const CloseSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M10.7979%2010.798C11.4618%2010.1341%2012.5382%2010.1341%2013.2021%2010.798L37.2021%2034.798C37.866%2035.4619%2037.866%2036.5382%2037.2021%2037.2021C36.5382%2037.866%2035.4618%2037.866%2034.7979%2037.2021L10.7979%2013.2021C10.134%2012.5382%2010.134%2011.4619%2010.7979%2010.798Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M37.2021%2010.798C37.866%2011.4619%2037.866%2012.5382%2037.2021%2013.2021L13.2021%2037.2021C12.5382%2037.866%2011.4618%2037.866%2010.7979%2037.2021C10.134%2036.5382%2010.134%2035.4619%2010.7979%2034.798L34.7979%2010.798C35.4618%2010.1341%2036.5382%2010.1341%2037.2021%2010.798Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const CloseButton = ({
  appId,
  onCloseClick
}) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center pl-sm", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
  "button",
  {
    type: "button",
    className: "flex h-20 w-20 items-center justify-center rounded-2xs hover:bg-gray-50",
    style: { padding: "2px" },
    onClick: (e) => {
      e.preventDefault();
      onCloseClick(appId);
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        className: "block brightness-[.96] contrast-[.72] hue-rotate-[22deg] invert-[.44] saturate-[29.9] sepia-[.01]",
        width: 16,
        height: 16,
        src: CloseSVG
      }
    )
  }
) });

const ChevronSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M8.79791%2016.798C9.4618%2016.1341%2010.5382%2016.1341%2011.2021%2016.798L24%2029.5959L36.7979%2016.798C37.4618%2016.1341%2038.5382%2016.1341%2039.2021%2016.798C39.866%2017.4619%2039.866%2018.5382%2039.2021%2019.2021L25.2021%2033.2021C24.5382%2033.866%2023.4618%2033.866%2022.7979%2033.2021L8.79791%2019.2021C8.13401%2018.5382%208.13401%2017.4619%208.79791%2016.798Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const CommonElement = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center px-sm py-xs text-body-lg font-bold hover:rounded-sm hover:bg-surface-quaternary", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "\u305D\u306E\u4ED6" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center px-0.5", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "img",
    {
      className: "block align-middle brightness-[.96] contrast-[.72] hue-rotate-[22deg] invert-[.44] saturate-[29.9] sepia-[.01]",
      width: 16,
      src: ChevronSVG
    }
  ) })
] });
const CollapsedAppsTrigger = ({
  type,
  onClickTrigger,
  isActive
}) => {
  const marginLeft = "ml-md";
  if (type === "button") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        type: "button",
        onClick: (e) => {
          e.preventDefault();
          e.stopPropagation();
          onClickTrigger();
        },
        className: `${marginLeft} ${isActive ? "rounded-sm bg-surface-quaternary text-label-primary" : "text-label-secondary"} active:scale-95 active:transition-transform active:duration-100`,
        "data-testid": "collapsed-items-button",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(CommonElement, {})
      }
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `${marginLeft} invisible`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CommonElement, {}) });
};

const CollapsedAppsMenu = ({
  apps,
  isOpen,
  onClick,
  onClickRemoveApp,
  appId,
  position
}) => {
  if (apps.length === 0)
    return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Popover,
    {
      isOpen,
      isCollapsed: true,
      position,
      trigger: () => /* @__PURE__ */ jsxRuntimeExports.jsx(
        CollapsedAppsTrigger,
        {
          type: "button",
          onClickTrigger: onClick,
          isActive: apps.some((app) => app.appId === appId)
        }
      ),
      children: () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "py-xs", children: apps.map((app) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "a",
        {
          href: app.href,
          className: `flex h-48 items-center justify-between no-underline ${app.appId === appId ? "bg-surface-quaternary" : "hover:bg-surface-quaternary"}`,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex w-full items-center px-md text-body-md text-label-primary no-underline", children: app.name }),
            app.appId === appId && /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                className: "flex items-center pr-sm",
                "data-testid": `collapsed-items-close-${app.appId}`,
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  CloseButton,
                  {
                    appId: app.appId,
                    onCloseClick: onClickRemoveApp
                  }
                )
              }
            )
          ]
        },
        app.appId
      )) })
    }
  );
};

const Badge = ({ count }) => count > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "span",
  {
    className: `relative ml-xs box-border flex items-center justify-center rounded-full border-white bg-red-700 text-body-xs font-bold text-white ${count >= 10 ? "px-[10px]" : "px-xs"}`,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "span",
        {
          className: `invisible ${count >= 100 ? "px-[2px]" : count >= 10 ? "" : "text-[0px]"}`,
          children: Math.floor(count / 100) || "|"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "absolute inset-0 flex items-center justify-center", children: count })
    ]
  }
) : null;

const AnalysisSVG = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M9.82865%2012.4688C10.4546%2012.4688%2010.962%2012.9762%2010.962%2013.6021V22.7489C10.962%2023.3749%2010.4546%2023.8823%209.82865%2023.8823C9.20272%2023.8823%208.69531%2023.3749%208.69531%2022.7489V13.6021C8.69531%2012.9762%209.20272%2012.4688%209.82865%2012.4688Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M16.0508%208.0918C16.6767%208.0918%2017.1841%208.59921%2017.1841%209.22513V22.7488C17.1841%2023.3747%2016.6767%2023.8821%2016.0508%2023.8821C15.4249%2023.8821%2014.9175%2023.3747%2014.9175%2022.7488V9.22513C14.9175%208.59921%2015.4249%208.0918%2016.0508%208.0918Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M22.1714%2017.3027C22.7973%2017.3027%2023.3048%2017.8101%2023.3048%2018.4361V22.7494C23.3048%2023.3753%2022.7973%2023.8828%2022.1714%2023.8828C21.5455%2023.8828%2021.0381%2023.3753%2021.0381%2022.7494V18.4361C21.0381%2017.8101%2021.5455%2017.3027%2022.1714%2017.3027Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M3.74707%203.98064C5.21039%202.41091%207.29384%201.5332%209.75225%201.5332H22.2475C24.7115%201.5332%2026.7956%202.41045%2028.2579%203.98118C29.7118%205.54275%2030.4665%207.69747%2030.4665%2010.1134V21.8863C30.4665%2024.3023%2029.7118%2026.457%2028.2579%2028.0186C26.7956%2029.5893%2024.7115%2030.4665%2022.2475%2030.4665H9.75225C7.28821%2030.4665%205.20416%2029.5893%203.74181%2028.0186C2.28797%2026.457%201.5332%2024.3023%201.5332%2021.8863V10.1134C1.5332%207.69608%202.29198%205.54154%203.74707%203.98064ZM5.40505%205.52624C4.40618%206.59775%203.79987%208.16665%203.79987%2010.1134V21.8863C3.79987%2023.8345%204.40383%2025.4032%205.40079%2026.474C6.38923%2027.5357%207.84803%2028.1999%209.75225%2028.1999H22.2475C24.1517%2028.1999%2025.6105%2027.5357%2026.599%2026.474C27.5959%2025.4032%2028.1999%2023.8345%2028.1999%2021.8863V10.1134C28.1999%208.16526%2027.5959%206.59654%2026.599%205.5257C25.6105%204.46401%2024.1517%203.79987%2022.2475%203.79987H9.75225C7.8551%203.79987%206.3957%204.46355%205.40505%205.52624Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const CalendarSVG$1 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M2.99023%2012.5396C2.99023%2011.9137%203.49765%2011.4062%204.12357%2011.4062H27.8888C28.5148%2011.4062%2029.0222%2011.9137%2029.0222%2012.5396C29.0222%2013.1655%2028.5148%2013.6729%2027.8888%2013.6729H4.12357C3.49765%2013.6729%202.99023%2013.1655%202.99023%2012.5396Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M20.7896%2017.7466C20.7896%2017.1207%2021.297%2016.6133%2021.9229%2016.6133H21.9352C22.5612%2016.6133%2023.0686%2017.1207%2023.0686%2017.7466C23.0686%2018.3725%2022.5612%2018.8799%2021.9352%2018.8799H21.9229C21.297%2018.8799%2020.7896%2018.3725%2020.7896%2017.7466Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M14.873%2017.7466C14.873%2017.1207%2015.3805%2016.6133%2016.0064%2016.6133H16.0187C16.6447%2016.6133%2017.1521%2017.1207%2017.1521%2017.7466C17.1521%2018.3725%2016.6447%2018.8799%2016.0187%2018.8799H16.0064C15.3805%2018.8799%2014.873%2018.3725%2014.873%2017.7466Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M8.94385%2017.7466C8.94385%2017.1207%209.45126%2016.6133%2010.0772%2016.6133H10.0895C10.7155%2016.6133%2011.2229%2017.1207%2011.2229%2017.7466C11.2229%2018.3725%2010.7155%2018.8799%2010.0895%2018.8799H10.0772C9.45126%2018.8799%208.94385%2018.3725%208.94385%2017.7466Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M20.7896%2022.9283C20.7896%2022.3023%2021.297%2021.7949%2021.9229%2021.7949H21.9352C22.5612%2021.7949%2023.0686%2022.3023%2023.0686%2022.9283C23.0686%2023.5542%2022.5612%2024.0616%2021.9352%2024.0616H21.9229C21.297%2024.0616%2020.7896%2023.5542%2020.7896%2022.9283Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M14.873%2022.9283C14.873%2022.3023%2015.3805%2021.7949%2016.0064%2021.7949H16.0187C16.6447%2021.7949%2017.1521%2022.3023%2017.1521%2022.9283C17.1521%2023.5542%2016.6447%2024.0616%2016.0187%2024.0616H16.0064C15.3805%2024.0616%2014.873%2023.5542%2014.873%2022.9283Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M8.94385%2022.9283C8.94385%2022.3023%209.45126%2021.7949%2010.0772%2021.7949H10.0895C10.7155%2021.7949%2011.2229%2022.3023%2011.2229%2022.9283C11.2229%2023.5542%2010.7155%2024.0616%2010.0895%2024.0616H10.0772C9.45126%2024.0616%208.94385%2023.5542%208.94385%2022.9283Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M21.3916%201.5332C22.0176%201.5332%2022.525%202.04061%2022.525%202.66654V7.05424C22.525%207.68017%2022.0176%208.18758%2021.3916%208.18758C20.7657%208.18758%2020.2583%207.68017%2020.2583%207.05424V2.66654C20.2583%202.04061%2020.7657%201.5332%2021.3916%201.5332Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M10.6206%201.5332C11.2466%201.5332%2011.754%202.04061%2011.754%202.66654V7.05424C11.754%207.68017%2011.2466%208.18758%2010.6206%208.18758C9.99472%208.18758%209.4873%207.68017%209.4873%207.05424V2.66654C9.4873%202.04061%209.99472%201.5332%2010.6206%201.5332Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M4.93149%205.54239C6.29831%204.24308%208.19937%203.63867%2010.3613%203.63867H21.6511C23.8182%203.63867%2025.7204%204.24257%2027.0851%205.54349C28.4583%206.8525%2029.1399%208.72674%2029.1334%2010.9645V23.1298C29.1334%2025.3674%2028.4483%2027.2434%2027.075%2028.5547C25.7096%2029.8583%2023.8077%2030.4664%2021.6387%2030.4664H10.3613C8.19257%2030.4664%206.28907%2029.8455%204.92357%2028.522C3.55243%2027.1931%202.8667%2025.2944%202.8667%2023.0289V10.9627C2.8667%208.72333%203.5559%206.85003%204.93149%205.54239ZM6.49317%207.18523C5.66701%207.97058%205.13337%209.19263%205.13337%2010.9627V23.0289C5.13337%2024.8359%205.67049%2026.0893%206.50109%2026.8944C7.33733%2027.7049%208.61448%2028.1997%2010.3613%2028.1997H21.6387C23.3976%2028.1997%2024.6764%2027.7109%2025.5097%2026.9153C26.335%2026.1273%2026.8667%2024.9016%2026.8667%2023.1298V10.9627L26.8667%2010.9592C26.8721%209.18827%2026.3432%207.96777%2025.5211%207.18413C24.6902%206.39206%2023.4119%205.90534%2021.6511%205.90534H10.3613C8.60768%205.90534%207.32809%206.39155%206.49317%207.18523Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const CatalogSVG$1 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M16.0002%2029.1476C15.2402%2029.1476%2014.4735%2028.9543%2013.8002%2028.5543C12.0802%2027.5543%209.38686%2026.321%206.31353%2026.101C3.96686%2025.9343%202.2002%2024.0676%202.2002%2021.761V7.20764C2.2002%205.97431%202.72686%204.80097%203.64686%203.97431C4.57353%203.14097%205.8202%202.74097%207.06686%202.88097C10.3402%203.24097%2013.1535%204.54764%2014.9335%205.58097C15.6002%205.96764%2016.4002%205.96764%2017.0669%205.58097C18.8469%204.54764%2021.6602%203.24097%2024.9335%202.88097C26.1735%202.74097%2027.4269%203.14764%2028.3535%203.98097C29.2735%204.80097%2029.8002%205.98097%2029.8002%207.21431V21.7676C29.8002%2024.0743%2028.0335%2025.9343%2025.6869%2026.1076C22.6202%2026.3276%2019.9202%2027.561%2018.2002%2028.561C17.5202%2028.9543%2016.7602%2029.1543%2016.0002%2029.1543V29.1476ZM6.58686%205.12097C6.06019%205.12097%205.55353%205.31431%205.16019%205.66097C4.71353%206.06097%204.46686%206.60764%204.46686%207.20764V21.761C4.46686%2022.861%205.32686%2023.7543%206.47353%2023.8343C9.97353%2024.0876%2013.0069%2025.4676%2014.9335%2026.5876C15.6002%2026.9743%2016.4002%2026.9743%2017.0669%2026.5876C18.9935%2025.4743%2022.0269%2024.0876%2025.5269%2023.8343C26.6735%2023.7543%2027.5335%2022.861%2027.5335%2021.761V7.20764C27.5335%206.61431%2027.2869%206.06097%2026.8402%205.66097C26.3935%205.25431%2025.7802%205.06764%2025.1802%205.12764C22.3002%205.44097%2019.7935%206.61431%2018.2002%207.53431C16.8402%208.32097%2015.1535%208.32097%2013.7935%207.53431C12.2002%206.60764%209.69353%205.44097%206.81353%205.12764C6.73353%205.12097%206.65353%205.11431%206.58019%205.11431L6.58686%205.12097Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20d%3D%22M16%2023.3272C15.3734%2023.3272%2014.8667%2022.8205%2014.8667%2022.1939V12.6939C14.8667%2012.0672%2015.3734%2011.5605%2016%2011.5605C16.6267%2011.5605%2017.1334%2012.0672%2017.1334%2012.6939V22.1939C17.1334%2022.8205%2016.6267%2023.3272%2016%2023.3272Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20d%3D%22M10.9067%2020.3943C10.7667%2020.3943%2010.6267%2020.3676%2010.4867%2020.3143L7.37332%2019.081C6.79332%2018.8476%206.50665%2018.1943%206.73999%2017.6076C6.97332%2017.0276%207.62665%2016.741%208.21332%2016.9743L11.3267%2018.2076C11.9067%2018.441%2012.1933%2019.0943%2011.96%2019.681C11.7867%2020.1276%2011.36%2020.3943%2010.9067%2020.3943ZM10.9067%2013.9876C10.7667%2013.9876%2010.6267%2013.961%2010.4867%2013.9076L7.37332%2012.6743C6.79332%2012.441%206.50665%2011.7876%206.73999%2011.201C6.97332%2010.621%207.62665%2010.3343%208.21332%2010.5676L11.3267%2011.801C11.9067%2012.0343%2012.1933%2012.6876%2011.96%2013.2743C11.7867%2013.721%2011.36%2013.9876%2010.9067%2013.9876Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const CategorySVG = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.88581%204.46589C6.97905%204.46589%206.10943%204.8261%205.46825%205.46727C4.82707%206.10845%204.46686%206.97808%204.46686%207.88484V15.4042C4.46686%2016.3392%204.83747%2017.2361%205.49748%2017.8984L12.6451%2025.0705L25.0895%2012.6261L17.8998%205.49124C17.238%204.83445%2016.3434%204.46589%2015.411%204.46589H7.88581ZM26.6984%2014.2228L14.2451%2026.676L15.2844%2027.7188C16.6635%2029.1027%2018.904%2029.1046%2020.2855%2027.7231L27.7477%2020.261C29.1312%2018.8774%2029.127%2016.6328%2027.7381%2015.2545L26.6984%2014.2228ZM3.86547%203.8645C4.93174%202.79824%206.37789%202.19922%207.88581%202.19922L15.411%202.19922C16.9416%202.19922%2018.4101%202.80422%2019.4965%203.88235L29.3347%2013.6456C31.6146%2015.9081%2031.6216%2019.5926%2029.3504%2021.8637L21.8883%2029.3259C19.6205%2031.5936%2015.9428%2031.5905%2013.6789%2029.3188L3.89197%2019.4984C2.80855%2018.4113%202.2002%2016.939%202.2002%2015.4042V7.88484C2.2002%206.37692%202.79921%204.93076%203.86547%203.8645ZM11.2321%209.94035C10.5026%209.93723%209.95639%2010.4838%209.95158%2011.1937C9.94823%2011.8433%2010.5109%2012.4174%2011.1833%2012.4189C11.8703%2012.4204%2012.4286%2011.8554%2012.4316%2011.202M11.2414%207.6737C9.27297%207.66551%207.69768%209.20868%207.68496%2011.1795L7.68495%2011.1805C7.67419%2013.0992%209.26491%2014.6813%2011.1782%2014.6855C13.0944%2014.6898%2014.6896%2013.1359%2014.6982%2011.2121C14.7066%209.2999%2013.1712%207.68078%2011.2414%207.6737ZM12.4316%2011.202C12.4346%2010.494%2011.8629%209.94248%2011.2331%209.94035L11.2321%209.94035%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const ContactSVG = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M5.40685%205.53209C4.40706%206.60803%203.79987%208.18364%203.79987%2010.1382V15.5755H9.02477C10.7719%2015.5755%2012.3643%2016.5678%2013.1385%2018.1348C13.6632%2019.196%2014.7507%2019.9188%2016.0028%2019.9188C17.2551%2019.9188%2018.3426%2019.1959%2018.8671%2018.1347C19.6414%2016.5678%2021.2337%2015.5755%2022.9807%2015.5755H28.1999V10.1382C28.1999%208.18207%2027.5953%206.60663%2026.5978%205.53143C25.6092%204.46576%2024.151%203.79987%2022.2485%203.79987H9.75266C7.85734%203.79987%206.39814%204.46531%205.40685%205.53209ZM28.1999%2017.8422H22.9807C22.0988%2017.8422%2021.2926%2018.3426%2020.8992%2019.1389L20.8991%2019.139C20.0082%2020.9415%2018.1523%2022.1854%2016.0028%2022.1854C13.8533%2022.1854%2011.9974%2020.9415%2011.1064%2019.1391L11.1063%2019.1389C10.7129%2018.3426%209.90678%2017.8422%209.02477%2017.8422H3.79987V21.9517C3.79987%2023.9077%204.40465%2025.4831%205.4025%2026.5584C6.39154%2027.6242%207.85013%2028.2901%209.75266%2028.2901H22.247C24.1503%2028.2901%2025.6089%2027.6241%2026.5977%2026.5584C27.5953%2025.4832%2028.1999%2023.9078%2028.1999%2021.9517V17.8422ZM3.7464%203.98915C5.20952%202.4146%207.29338%201.5332%209.75266%201.5332H22.2485C24.7135%201.5332%2026.7977%202.41415%2028.2595%203.98981C29.7125%205.55595%2030.4665%207.71634%2030.4665%2010.1382V21.9517C30.4665%2024.3736%2029.7125%2026.534%2028.2593%2028.1002C26.7972%2029.6759%2024.7127%2030.5568%2022.247%2030.5568H9.75266C7.28762%2030.5568%205.20315%2029.6758%203.74102%2028.1002C2.2877%2026.5341%201.5332%2024.3737%201.5332%2021.9517V10.1382C1.5332%207.71477%202.29178%205.55455%203.7464%203.98915ZM10.3613%209.93542C10.3613%209.30949%2010.8687%208.80208%2011.4947%208.80208H20.5094C21.1353%208.80208%2021.6427%209.30949%2021.6427%209.93542C21.6427%2010.5613%2021.1353%2011.0687%2020.5094%2011.0687H11.4947C10.8687%2011.0687%2010.3613%2010.5613%2010.3613%209.93542Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const CouponSVG = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M18.4663%204.5332C19.0923%204.5332%2019.5997%205.04061%2019.5997%205.66654V8.8932C19.5997%209.51913%2019.0923%2010.0265%2018.4663%2010.0265C17.8404%2010.0265%2017.333%209.51913%2017.333%208.8932V5.66654C17.333%205.04061%2017.8404%204.5332%2018.4663%204.5332Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M18.4663%2022.5469C19.0923%2022.5469%2019.5997%2023.0543%2019.5997%2023.6802V26.3789C19.5997%2027.0048%2019.0923%2027.5122%2018.4663%2027.5122C17.8404%2027.5122%2017.333%2027.0048%2017.333%2026.3789V23.6802C17.333%2023.0543%2017.8404%2022.5469%2018.4663%2022.5469Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M18.4663%2011.5371C19.0923%2011.5371%2019.5997%2012.0445%2019.5997%2012.6704V19.0984C19.5997%2019.7244%2019.0923%2020.2318%2018.4663%2020.2318C17.8404%2020.2318%2017.333%2019.7244%2017.333%2019.0984V12.6704C17.333%2012.0445%2017.8404%2011.5371%2018.4663%2011.5371Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M1.53459%209.67458C1.53483%206.63609%204.02493%204.19922%207.06509%204.19922H24.9347C27.9748%204.19922%2030.4649%206.63609%2030.4651%209.67457C30.4651%209.67442%2030.4651%209.67472%2030.4651%209.67457L30.4665%2013.1326C30.4667%2013.4333%2030.3473%2013.7217%2030.1348%2013.9343C29.9222%2014.1469%2029.6339%2014.2664%2029.3332%2014.2664C28.3389%2014.2664%2027.5643%2015.0516%2027.5643%2016.0006C27.5643%2016.9489%2028.3381%2017.7334%2029.3332%2017.7334C29.9591%2017.7334%2030.4665%2018.2408%2030.4665%2018.8667V22.3234C30.4665%2025.3619%2027.978%2027.7992%2024.936%2027.7992H7.0637C4.02177%2027.7992%201.5332%2025.3619%201.5332%2022.3234V18.8667C1.5332%2018.2408%202.04061%2017.7334%202.66654%2017.7334C3.66159%2017.7334%204.43544%2016.9489%204.43544%2016.0006C4.43544%2015.11%203.72166%2014.379%202.66654%2014.379C2.36588%2014.379%202.07755%2014.2596%201.86499%2014.0469C1.65244%2013.8343%201.53309%2013.5459%201.5332%2013.2452L1.53459%209.67458ZM7.06509%206.46589C5.24933%206.46589%203.80126%207.9153%203.80126%209.67503L3.80025%2012.264C5.44315%2012.7142%206.70211%2014.1289%206.70211%2016.0006C6.70211%2017.8332%205.47258%2019.3581%203.79987%2019.8407V22.3234C3.79987%2024.0834%205.24678%2025.5326%207.0637%2025.5326H24.936C26.753%2025.5326%2028.1999%2024.0834%2028.1999%2022.3234V19.8407C26.5272%2019.3581%2025.2976%2017.8331%2025.2976%2016.0006C25.2976%2014.1687%2026.5266%2012.6424%2028.1995%2012.1593L28.1985%209.67548C28.1985%207.91576%2026.7504%206.46589%2024.9347%206.46589H7.06509Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const CustomerSVG$1 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M5.21555%2022.9652C4.94431%2023.2495%204.79938%2023.5774%204.79938%2024.0252C4.79938%2024.4705%204.94406%2024.7947%205.21526%2025.0759C5.51348%2025.385%206.00587%2025.68%206.74181%2025.9261C8.22515%2026.4221%2010.3523%2026.6092%2012.7887%2026.6092C15.2365%2026.6092%2017.3624%2026.4153%2018.841%2025.9138C19.5744%2025.6651%2020.0649%2025.3677%2020.3622%2025.0566C20.6333%2024.773%2020.778%2024.4458%2020.778%2023.9986C20.778%2023.5538%2020.6334%2023.2293%2020.3617%2022.9474C20.0631%2022.6377%2019.5703%2022.3421%2018.8343%2022.0953C17.3509%2021.598%2015.2238%2021.4092%2012.7887%2021.4092C10.3406%2021.4092%208.21488%2021.6041%206.73663%2022.1066C6.00345%2022.3558%205.51293%2022.6536%205.21555%2022.9652ZM6.00714%2019.9605C7.85322%2019.333%2010.2889%2019.1426%2012.7887%2019.1426C15.2723%2019.1426%2017.7065%2019.3265%2019.5548%2019.9462C20.4846%2020.2579%2021.3502%2020.7069%2021.9936%2021.3743C22.6639%2022.0696%2023.0447%2022.9547%2023.0447%2023.9986C23.0447%2025.04%2022.6675%2025.9251%2022.001%2026.6226C21.3607%2027.2927%2020.498%2027.7453%2019.5691%2028.0604C17.723%2028.6865%2015.2876%2028.8759%2012.7887%2028.8759C10.3052%2028.8759%207.87094%2028.6937%206.02296%2028.0757C5.09323%2027.7648%204.22745%2027.3167%203.58392%2026.6495C2.91337%2025.9544%202.53271%2025.0693%202.53271%2024.0252C2.53271%2022.9838%202.90962%2022.0984%203.57575%2021.4003C4.21575%2020.7297%205.07815%2020.2763%206.00714%2019.9605Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M12.7889%205.46589C10.1852%205.46589%208.07428%207.57614%208.07428%2010.1792C8.07428%2012.7823%2010.1852%2014.8926%2012.7889%2014.8926H12.828C15.4191%2014.8818%2017.512%2012.7737%2017.5023%2010.1834L17.5023%2010.1792C17.5023%207.57599%2015.3912%205.46589%2012.7889%205.46589ZM5.80762%2010.1792C5.80762%206.32363%208.93403%203.19922%2012.7889%203.19922C16.6421%203.19922%2019.768%206.32283%2019.769%2010.1775C19.782%2014.0201%2016.6764%2017.1449%2012.8345%2017.1592L12.8303%2017.1592H12.7889C8.93403%2017.1592%205.80762%2014.0348%205.80762%2010.1792Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M20.9593%205.63368C21.0606%205.01601%2021.6435%204.59741%2022.2611%204.69871C24.8893%205.12975%2026.8937%207.40895%2026.8937%2010.1584L26.8937%2010.1605C26.8887%2012.95%2024.8209%2015.2527%2022.1354%2015.6301C21.5156%2015.7172%2020.9425%2015.2853%2020.8554%2014.6655C20.7683%2014.0457%2021.2002%2013.4726%2021.82%2013.3855C23.4035%2013.1629%2024.6236%2011.8021%2024.627%2010.1574C24.6266%208.5367%2023.4444%207.18973%2021.8943%206.93549C21.2766%206.83419%2020.858%206.25135%2020.9593%205.63368Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M23.6732%2019.4763C23.7654%2018.8572%2024.342%2018.4301%2024.9611%2018.5223C26.0565%2018.6854%2027.1253%2018.9751%2027.9474%2019.5145C28.8264%2020.0913%2029.4395%2020.975%2029.4395%2022.1699C29.4395%2022.9605%2029.1683%2023.6513%2028.6776%2024.2059C28.2079%2024.7368%2027.5822%2025.0936%2026.9299%2025.3414C26.3448%2025.5637%2025.6903%2025.2695%2025.468%2024.6844C25.2457%2024.0992%2025.5399%2023.4447%2026.125%2023.2224C26.5714%2023.0529%2026.8351%2022.8677%2026.98%2022.7039C27.104%2022.5638%2027.1728%2022.4073%2027.1728%2022.1699C27.1728%2021.8715%2027.0639%2021.6459%2026.7039%2021.4096C26.287%2021.1361%2025.5997%2020.9091%2024.6272%2020.7642C24.0081%2020.672%2023.581%2020.0954%2023.6732%2019.4763Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const InvoiceSVG = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M13.0799%208.00602C13.5332%207.55268%2014.2599%207.55268%2014.7132%208.00602L15.9599%209.25268C16.0066%209.29935%2016.0466%209.34602%2016.0799%209.39268C16.1132%209.34602%2016.1532%209.29935%2016.1999%209.25268L17.4466%208.00602C17.8999%207.55268%2018.6266%207.55268%2019.0799%208.00602C19.5332%208.45935%2019.5332%209.18602%2019.0799%209.63935L17.6932%2010.726L18.5732%2010.5927C19.2132%2010.5927%2019.7266%2011.1127%2019.7266%2011.746C19.7266%2012.3794%2019.2066%2012.8993%2018.5732%2012.8993L17.1466%2012.766L17.2799%2013.3127H18.5732C19.2132%2013.3127%2019.7266%2013.8327%2019.7266%2014.466C19.7266%2015.0994%2019.2066%2015.6193%2018.5732%2015.6193L17.1466%2015.5594L17.2799%2017.1794C17.2799%2017.8194%2016.7599%2018.3327%2016.1266%2018.3327C15.4932%2018.3327%2014.9732%2017.8127%2014.9732%2017.1794L15.1066%2015.5594L13.4066%2015.6193C12.7666%2015.6193%2012.2532%2015.0994%2012.2532%2014.466C12.2532%2013.8327%2012.7732%2013.3127%2013.4066%2013.3127H14.9666L15.0999%2012.766L13.3999%2012.8993C12.7599%2012.8993%2012.2466%2012.3794%2012.2466%2011.746C12.2466%2011.1127%2012.7666%2010.5927%2013.3999%2010.5927L14.2799%2010.726L13.0599%209.63935C12.6066%209.18602%2012.6066%208.45935%2013.0599%208.00602H13.0799Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20d%3D%22M16.0001%2029.8067C15.2134%2029.8067%2014.4201%2029.6534%2013.6734%2029.3467L10.6534%2028.1134C10.2934%2027.9667%209.88676%2027.98%209.54009%2028.1467L8.47342%2028.66C7.59342%2029.08%206.57342%2029.02%205.74676%2028.5C4.92009%2027.98%204.42676%2027.0867%204.42676%2026.1067L4.44009%208.85336C4.44009%204.74669%206.90676%202.19336%2010.8801%202.19336H21.1601C25.1134%202.19336%2027.5668%204.74669%2027.5668%208.85336L27.5934%2026.1067C27.5934%2027.0867%2027.1001%2027.98%2026.2734%2028.5C25.4468%2029.02%2024.4268%2029.08%2023.5468%2028.66L22.4868%2028.1534C22.1401%2027.9867%2021.7334%2027.9734%2021.3734%2028.12L18.3468%2029.3534C17.5934%2029.66%2016.8068%2029.8134%2016.0201%2029.8134L16.0001%2029.8067ZM10.1334%2025.7467C10.6001%2025.7467%2011.0734%2025.84%2011.5134%2026.02L14.5268%2027.2534C15.4734%2027.64%2016.5201%2027.64%2017.4734%2027.2534L20.4934%2026.02C21.4401%2025.6334%2022.5201%2025.66%2023.4468%2026.1067L24.5068%2026.6134C24.7468%2026.7267%2024.9534%2026.6467%2025.0468%2026.58C25.1268%2026.5334%2025.3068%2026.3867%2025.3068%2026.1067L25.2801%208.85336C25.2801%206.84669%2024.5601%204.46003%2021.1401%204.46003H10.8601C7.41343%204.46003%206.69342%206.84669%206.69342%208.85336L6.68009%2026.1134C6.68009%2026.3867%206.84676%2026.5267%206.94009%2026.5867C7.04009%2026.6467%207.24009%2026.7334%207.48009%2026.62L8.54676%2026.1067C9.04009%2025.8667%209.58009%2025.7534%2010.1201%2025.7534L10.1334%2025.7467Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20d%3D%22M19.6865%2022.96H12.1465C11.5198%2022.96%2011.0132%2022.4534%2011.0132%2021.8267C11.0132%2021.2%2011.5198%2020.6934%2012.1465%2020.6934H19.6865C20.3132%2020.6934%2020.8198%2021.2%2020.8198%2021.8267C20.8198%2022.4534%2020.3132%2022.96%2019.6865%2022.96Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const ItemSVG$1 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M10.3895%202.3449C10.9864%202.29594%2011.4621%202.60981%2011.7231%202.96881C12.6181%204.20004%2014.2484%204.89515%2016.0004%204.89515C17.7524%204.89515%2019.3826%204.20004%2020.2777%202.96881C20.5385%202.61006%2021.0144%202.29561%2021.6119%202.345C22.2981%202.40171%2023.024%202.64649%2023.7015%202.9489C24.3929%203.25752%2025.1045%203.65844%2025.7786%204.08621C27.1218%204.93849%2028.3944%205.94742%2029.1638%206.67738C29.5568%207.05028%2029.7056%207.5899%2029.5986%208.08914L28.5675%2012.901C28.4174%2013.6012%2027.7987%2014.1014%2027.0826%2014.1014H25.4913V28.148C25.4913%2028.9866%2024.8115%2029.6665%2023.9728%2029.6665H8.02804C7.18937%2029.6665%206.50949%2028.9866%206.50949%2028.148V14.1014H4.91821C4.20215%2014.1014%203.5834%2013.6012%203.43337%2012.901L2.39835%208.07096C2.30061%207.61483%202.41389%207.10678%202.76683%206.72951C3.48855%205.95803%204.7928%204.93243%206.1535%204.08372C6.84197%203.65429%207.57107%203.25361%208.27661%202.94569C8.96741%202.64421%209.70385%202.40115%2010.3895%202.3449ZM10.1768%204.68434C9.90217%204.7518%209.57013%204.86646%209.18772%205.03336C8.61029%205.28537%207.98125%205.62828%207.35898%206.01641C6.28844%206.68413%205.31389%207.4376%204.71339%208.00333L5.53202%2011.8236H7.26876C8.10743%2011.8236%208.78731%2012.5034%208.78731%2013.3421V27.3887H23.2135V13.3421C23.2135%2012.5034%2023.8934%2011.8236%2024.7321%2011.8236H26.4688L27.2794%208.04075C26.6043%207.44453%2025.6089%206.6762%2024.5582%206.00951C23.9457%205.62086%2023.3342%205.27937%2022.7731%205.02892C22.4062%204.86517%2022.0878%204.7526%2021.8228%204.68574C20.3736%206.387%2018.1339%207.17297%2016.0004%207.17297C13.8663%207.17297%2011.626%206.38657%2010.1768%204.68434Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const ItemSetSVG = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M10.4099%202.34488C11.0046%202.2961%2011.4786%202.60882%2011.7386%202.96651C12.6304%204.19323%2014.2547%204.88579%2016.0003%204.88579C17.7459%204.88579%2019.3701%204.19323%2020.2619%202.96651C20.5218%202.60907%2020.9959%202.29577%2021.5913%202.34498C22.2749%202.40149%2022.9981%202.64537%2023.6732%202.94667C24.3621%203.25416%2025.071%203.65361%2025.7427%204.07981C27.0809%204.92897%2028.3489%205.93421%2029.1154%206.66149C29.507%207.03303%2029.6553%207.57068%2029.5487%208.06809L28.5213%2012.8624C28.3718%2013.5599%2027.7554%2014.0583%2027.0419%2014.0583H25.4565H24.5268C24.5268%2014.0583%2023.3323%2014.0583%2023.3323%2012.8624C23.3323%2011.6664%2024.5268%2011.7888%2024.7%2011.7888H26.4304L27.238%208.01988C26.5653%207.42583%2025.5736%206.66032%2024.5268%205.99607C23.9165%205.60885%2023.3072%205.2686%2022.7481%205.01908C22.3826%204.85592%2022.0654%204.74376%2021.8013%204.67715C20.3575%206.37218%2018.126%207.15527%2016.0003%207.15527C13.874%207.15527%2011.6419%206.37175%2010.198%204.67575C9.92438%204.74297%209.59355%204.85721%209.21255%205.02349C8.63722%205.27458%208.01049%205.61624%207.39049%206.00294C6.32388%206.66822%205.35289%207.41893%204.7546%207.98259L5.57022%2011.7888H7.30061C8.13621%2011.7888%208.8136%2012.4662%208.8136%2013.3018V27.297H13.7177C13.7177%2027.297%2014.6036%2027.4717%2014.6036%2028.5192C14.6036%2029.5666%2013.5561%2029.5666%2013.5561%2029.5666L8.0571%2029.5664C7.22151%2029.5664%206.54412%2028.8891%206.54412%2028.0535V14.0583H4.95866C4.24523%2014.0583%203.62874%2013.5599%203.47926%2012.8624L2.44803%208.04997C2.35065%207.59552%202.46351%207.08932%202.81516%206.71343C3.53424%205.94479%204.83371%204.92294%206.18943%204.07733C6.87538%203.64948%207.60181%203.25026%208.30477%202.94347C8.99304%202.64309%209.72678%202.40093%2010.4099%202.34488Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M18.4626%2015.6515C18.9629%2015.2383%2019.5996%2015.0527%2020.2269%2015.0527H26.5951C27.2224%2015.0527%2027.8591%2015.2383%2028.3594%2015.6515C28.8783%2016.08%2029.1944%2016.7117%2029.1944%2017.4475L29.1937%2018.5516C29.1937%2018.5513%2029.1937%2018.5518%2029.1937%2018.5516C29.1935%2019.2872%2028.8774%2019.9193%2028.3587%2020.3476C28.3156%2020.3832%2028.2716%2020.417%2028.2267%2020.4492V25.5734C28.2267%2026.7526%2027.6215%2027.8493%2026.6237%2028.4779C26.6236%2028.4779%2026.6237%2028.4779%2026.6237%2028.4779L22.4556%2031.1039C20.5959%2032.2755%2018.1672%2031.9675%2016.6587%2030.369C14.578%2028.164%2015.1625%2024.5841%2017.8367%2023.1555L18.8437%2022.6175V20.6064C18.7099%2020.5329%2018.5819%2020.4468%2018.4618%2020.3476C17.9429%2019.9191%2017.6268%2019.2874%2017.6268%2018.5516L17.6276%2017.4475C17.6276%2017.4474%2017.6276%2017.4476%2017.6276%2017.4475C17.6276%2017.4474%2017.6276%2017.4469%2017.6276%2017.4468C17.6278%2016.7112%2017.9439%2016.0798%2018.4626%2015.6515ZM20.9386%2020.9464V23.2017C20.9386%2023.6154%2020.7107%2023.9951%2020.3462%2024.1899L18.8238%2025.0032C18.8238%2025.0032%2018.8238%2025.0032%2018.8238%2025.0032C17.3676%2025.7811%2017.0493%2027.7305%2018.1823%2028.9313C19.0038%2029.8017%2020.3263%2029.9694%2021.3389%2029.3314L22.5669%2028.5578C22.3537%2028.0054%2022.2369%2027.4055%2022.2369%2026.7795C22.2369%2024.4097%2023.9054%2022.4296%2026.1318%2021.9499V20.9464H20.9386ZM26.1318%2024.1322C25.0776%2024.5488%2024.3318%2025.5771%2024.3318%2026.7795C24.3318%2026.994%2024.3553%2027.2025%2024.4%2027.4029L25.507%2026.7055C25.8958%2026.4605%2026.1318%2026.0331%2026.1318%2025.5734V24.1322ZM19.7435%2017.3316C19.7346%2017.3502%2019.7225%2017.3851%2019.7225%2017.4475L19.7217%2018.5516C19.7217%2018.5515%2019.7217%2018.5516%2019.7217%2018.5516C19.7217%2018.6138%2019.7339%2018.6489%2019.7427%2018.6675C19.7518%2018.6868%2019.767%2018.7086%2019.7958%2018.7323C19.8571%2018.783%2019.9963%2018.8515%2020.2261%2018.8515H26.5944C26.8242%2018.8515%2026.9634%2018.783%2027.0247%2018.7323C27.0536%2018.7085%2027.0687%2018.6868%2027.0778%2018.6675C27.0866%2018.6489%2027.0988%2018.6139%2027.0988%2018.5516L27.0995%2017.4475C27.0995%2017.4474%2027.0995%2017.4477%2027.0995%2017.4475C27.0995%2017.3854%2027.0873%2017.3501%2027.0786%2017.3316C27.0694%2017.3123%2027.0543%2017.2905%2027.0255%2017.2667C26.9642%2017.2161%2026.825%2017.1476%2026.5951%2017.1476H20.2269C19.9971%2017.1476%2019.8578%2017.2161%2019.7965%2017.2667C19.7677%2017.2905%2019.7526%2017.3123%2019.7435%2017.3316Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const MessageSVG$1 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M20.1998%2029.1328C19.1998%2029.1328%2018.3331%2028.6662%2017.7998%2027.7995L12.6665%2019.4662L4.1998%2014.1995C3.26647%2013.5995%202.73313%2012.5328%202.86647%2011.3995C2.9998%2010.2662%203.7998%209.3995%204.86647%209.06617L25.4665%202.9995C26.4665%202.73284%2027.5331%202.9995%2028.2665%203.73284C28.9998%204.46617%2029.2665%205.53284%2028.9998%206.53284L22.9331%2027.1328C22.5998%2028.1995%2021.7331%2028.9995%2020.5998%2029.1328C20.4665%2029.1328%2020.3331%2029.1328%2020.1998%2029.1328ZM14.9331%2018.7995L19.7331%2026.5995C19.9331%2026.8662%2020.1998%2026.8662%2020.2665%2026.8662C20.3998%2026.8662%2020.6665%2026.7995%2020.7331%2026.4662L26.7998%205.86617C26.8665%205.5995%2026.7331%205.3995%2026.6665%205.26617C26.5998%205.1995%2026.3998%205.06617%2026.1331%205.13284L5.53313%2011.1995C5.1998%2011.2662%205.13313%2011.5328%205.13313%2011.6662C5.13313%2011.7995%205.13313%2012.0662%205.3998%2012.1995L13.3331%2017.1328L20.3331%2010.0662C20.7998%209.5995%2021.4665%209.5995%2021.9331%2010.0662C22.3998%2010.5328%2022.3998%2011.1995%2021.9331%2011.6662L14.9331%2018.7328V18.7995Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const MoneySVG$1 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M9.14874%203.77447L11.8239%208.48821C14.6927%209.05253%2017.5561%209.03629%2020.4251%208.43949L22.4961%203.94512C21.2653%204.03474%2019.752%204.13255%2019%204.13255C18.4865%204.13255%2017.8884%203.98229%2017.3596%203.82522C16.8665%203.67875%2016.3202%203.48995%2015.7901%203.3068C15.7228%203.28351%2015.6556%203.26031%2015.5889%203.23731C14.9825%203.02819%2014.3996%202.83112%2013.8712%202.68567C13.3267%202.53582%2012.9259%202.46589%2012.6667%202.46589C12.2419%202.46589%2011.4559%202.70854%2010.5287%203.1125C10.0288%203.33027%209.54656%203.56804%209.14874%203.77447ZM20.7309%2010.6906C17.6437%2011.3122%2014.5532%2011.3246%2011.4659%2010.7278C10.6587%2012.0179%209.03137%2014.5972%207.8638%2016.3054C7.14553%2017.3563%206.43153%2018.8982%206.03712%2020.4815C5.6352%2022.095%205.61355%2023.5539%206.04164%2024.5528C6.57022%2025.7861%207.27252%2026.977%208.6447%2027.8885C10.0309%2028.8093%2012.2348%2029.5326%2015.9281%2029.5326C19.6467%2029.5326%2021.9294%2028.8832%2023.368%2027.9936C24.7714%2027.1258%2025.4854%2025.959%2025.9248%2024.6408C26.3338%2023.4137%2026.2851%2021.9827%2025.9021%2020.489C25.5206%2019.0009%2024.8252%2017.5247%2024.0389%2016.2666C22.8395%2014.3474%2021.4364%2011.9226%2020.7309%2010.6906ZM9.68163%209.30579L6.77125%204.17756C6.38132%203.4905%206.59945%202.58733%207.32592%202.18164C7.76659%201.93554%208.65615%201.45585%209.62339%201.03447C10.5334%200.638041%2011.7157%200.199219%2012.6667%200.199219C13.2409%200.199219%2013.8817%200.337617%2014.4727%200.500267C15.0796%200.667316%2015.7259%200.886914%2016.3278%201.09446C16.3955%201.11781%2016.4626%201.14098%2016.529%201.16392C17.0677%201.34999%2017.5632%201.52115%2018.005%201.65238C18.5283%201.80781%2018.8469%201.86589%2019%201.86589C19.9661%201.86589%2022.5009%201.67521%2023.6758%201.58202C24.801%201.49278%2025.5897%202.64753%2025.1235%203.65933L22.5344%209.27824C23.1586%2010.3718%2024.6826%2013.0198%2025.961%2015.0652C26.8414%2016.4737%2027.646%2018.1642%2028.0978%2019.9261C28.5481%2021.6824%2028.6661%2023.5847%2028.0752%2025.3576C27.5146%2027.0395%2026.526%2028.7059%2024.5601%2029.9215C22.6295%2031.1153%2019.8763%2031.7992%2015.9281%2031.7992C11.9548%2031.7992%209.26609%2031.0225%207.39052%2029.7766C5.50098%2028.5214%204.57251%2026.879%203.95824%2025.4457C3.24347%2023.7779%203.38849%2021.7368%203.83767%2019.9336C4.29436%2018.1002%205.11589%2016.3088%205.9925%2015.0264C7.20445%2013.2532%208.94029%2010.493%209.68163%209.30579Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M13.1348%2015.6645C13.5774%2015.2219%2014.2949%2015.2219%2014.7375%2015.6645L15.9632%2016.8901C16.0067%2016.9337%2016.046%2016.9799%2016.0809%2017.0282C16.1159%2016.9799%2016.1551%2016.9337%2016.1987%2016.8902L17.4243%2015.6645C17.8669%2015.2219%2018.5845%2015.2219%2019.0271%2015.6645C19.4697%2016.1071%2019.4697%2016.8247%2019.0271%2017.2673L17.6667%2018.3326L18.5334%2018.1992C19.1593%2018.1992%2019.6667%2018.7066%2019.6667%2019.3326C19.6667%2019.9585%2019.1593%2020.4659%2018.5334%2020.4659L17.1334%2020.3326L17.2667%2020.8659H18.5334C19.1593%2020.8659%2019.6667%2021.3733%2019.6667%2021.9992C19.6667%2022.6251%2019.1593%2023.1325%2018.5334%2023.1325L17.1334%2023.073L17.2667%2024.6659C17.2667%2025.2918%2016.7593%2025.7992%2016.1334%2025.7992C15.5074%2025.7992%2015%2025.2918%2015%2024.6659L15.1334%2023.073L13.4667%2023.1326C12.8408%2023.1326%2012.3334%2022.6251%2012.3334%2021.9992C12.3334%2021.3733%2012.8408%2020.8659%2013.4667%2020.8659H15L15.1334%2020.3326L13.4667%2020.4659C12.8408%2020.4659%2012.3334%2019.9585%2012.3334%2019.3326C12.3334%2018.7066%2012.8408%2018.1992%2013.4667%2018.1992L14.3334%2018.3326L13.1348%2017.2673C12.6922%2016.8247%2012.6922%2016.1071%2013.1348%2015.6645Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const NewsSVG = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M22.3205%206.50862C21.6474%208.00682%2021.2018%2010.1559%2021.2018%2012.5898C21.2018%2015.0237%2021.6474%2017.1728%2022.3205%2018.671C23.0418%2020.2764%2023.804%2020.7138%2024.2274%2020.7138C24.6508%2020.7138%2025.413%2020.2764%2026.1342%2018.671C26.8073%2017.1728%2027.253%2015.0237%2027.253%2012.5898C27.253%2010.1559%2026.8073%208.00682%2026.1342%206.50862C25.413%204.90324%2024.6508%204.46589%2024.2274%204.46589C23.804%204.46589%2023.0418%204.90324%2022.3205%206.50862ZM23.4788%202.28983C23.7176%202.23078%2023.9671%202.19922%2024.2274%202.19922C26.1005%202.19922%2027.4177%203.83447%2028.2018%205.57971C29.034%207.43214%2029.5196%209.91166%2029.5196%2012.5898C29.5196%2015.268%2029.034%2017.7475%2028.2018%2019.5999C27.4177%2021.3452%2026.1005%2022.9805%2024.2274%2022.9805C24.0729%2022.9805%2023.9222%2022.9693%2023.7753%2022.9479C23.731%2022.9442%2023.6864%2022.9377%2023.6418%2022.9286L23.6424%2022.9256C23.6423%2022.9256%2023.6424%2022.9256%2023.6424%2022.9256C23.6418%2022.9286%2023.6418%2022.9286%2023.6418%2022.9286L23.017%2022.7999C22.6182%2022.7177%2022.0466%2022.5998%2021.3551%2022.4569C19.9722%2022.1711%2018.1095%2021.7854%2016.1908%2021.3858C16.0724%2021.3611%2015.9537%2021.3364%2015.8349%2021.3116V25.3217C15.8349%2027.7952%2013.8292%2029.7992%2011.3575%2029.7992C8.8848%2029.7992%206.87866%2027.7956%206.87866%2025.3217V19.348C5.84153%2018.9582%204.83123%2018.1619%204.05491%2017.1504C3.14356%2015.9631%202.48047%2014.3858%202.48047%2012.5928C2.48047%2010.7998%203.14353%209.22225%204.0548%208.03462C4.95072%206.86699%206.15843%205.98571%207.35953%205.68561M8.14234%2017.3556C8.04926%2017.3339%207.97117%2017.3151%207.90927%2017.2997C7.32316%2017.1533%206.52045%2016.6399%205.85298%2015.7703C5.2008%2014.9206%204.74714%2013.8179%204.74714%2012.5928C4.74714%2011.3676%205.20083%2010.2645%205.85309%209.41445C6.52065%208.54445%207.32315%208.03101%207.90907%207.88465C8.77353%207.66853%2012.7823%206.82398%2016.6181%206.02503C17.96%205.74553%2019.2744%205.47292%2020.4147%205.23689C20.3585%205.3504%2020.3046%205.46482%2020.2529%205.57971C19.4207%207.43214%2018.9351%209.91166%2018.9351%2012.5898C18.9351%2015.268%2019.4207%2017.7475%2020.2529%2019.5999C20.3054%2019.7167%2020.3602%2019.833%2020.4175%2019.9483C19.2834%2019.7135%2017.9816%2019.4435%2016.6531%2019.1667C13.2912%2018.4664%209.79793%2017.7314%208.38743%2017.4118C8.30929%2017.3844%208.22724%2017.3653%208.14234%2017.3556ZM9.14533%2019.8995C10.3135%2020.1524%2011.8897%2020.4858%2013.5682%2020.8378V25.3217C13.5682%2026.5429%2012.5778%2027.5325%2011.3575%2027.5325C10.1355%2027.5325%209.14533%2026.5425%209.14533%2025.3217V19.8995ZM23.4788%202.28983L22.9502%202.39869C22.5534%202.48048%2021.9845%202.5978%2021.2962%202.73999C19.9198%203.02435%2018.0659%203.40817%2016.1559%203.80598C12.3555%204.59755%208.28119%205.45521%207.35953%205.68561%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const OldHomeSVG = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M12.6474%202.6921C14.5969%201.1469%2017.365%201.1469%2019.3145%202.6921L19.3171%202.6942L28.0822%209.68434C29.1471%2010.5025%2029.7817%2011.7594%2029.8001%2013.1014L29.8002%2013.117V24.749C29.8002%2027.9174%2027.2088%2030.4665%2024.0363%2030.4665H21.4709C21.4621%2030.4665%2021.4534%2030.4664%2021.4446%2030.4662C19.9478%2030.4315%2018.734%2029.2168%2018.7342%2027.7078C18.7342%2027.7077%2018.7342%2027.7079%2018.7342%2027.7078V23.6061C18.7342%2023.1978%2018.3967%2022.8473%2017.9563%2022.8473H14.1127C13.676%2022.8518%2013.3431%2023.2006%2013.3431%2023.6061V27.6951C13.3431%2027.8024%2013.3282%2027.9062%2013.3004%2028.0045C13.1452%2029.3978%2011.9546%2030.4665%2010.5295%2030.4665H7.96408C4.79154%2030.4665%202.2002%2027.9174%202.2002%2024.749V13.1297L2.20025%2013.1185C2.21354%2011.7738%202.84922%2010.5135%203.91829%209.69689L12.6474%202.6921ZM11.0765%2027.4542V23.6061C11.0765%2023.6061%2011.0765%2023.6061%2011.0765%2023.6061C11.0765%2021.9325%2012.4378%2020.5917%2014.1007%2020.5807L14.1082%2020.5806L17.9563%2020.5807C19.627%2020.5807%2021.0009%2021.9245%2021.0009%2023.6061V27.7078C21.0008%2027.9618%2021.2061%2028.1884%2021.4876%2028.1999H24.0363C25.9785%2028.1999%2027.5335%2026.6441%2027.5335%2024.749V13.1256C27.5226%2012.4825%2027.2167%2011.8754%2026.6963%2011.478C26.69%2011.4731%2026.6837%2011.4683%2026.6775%2011.4633L17.9065%204.46844C17.9061%204.46811%2017.9057%204.46778%2017.9053%204.46745C16.7815%203.57765%2015.1819%203.57734%2014.0578%204.46654L5.32554%2011.4739C5.31735%2011.4804%205.30907%2011.4869%205.30069%2011.4932C4.77987%2011.8879%204.47474%2012.4942%204.46686%2013.1359V24.749C4.46686%2026.6441%206.02185%2028.1999%207.96408%2028.1999H10.5295C10.8282%2028.1999%2011.0508%2027.9632%2011.0508%2027.6951C11.0508%2027.6124%2011.0597%2027.5318%2011.0765%2027.4542Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const OrderSVG = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M0.100098%203.33294C0.100098%202.65179%200.652281%202.09961%201.33343%202.09961H4.4392C5.01112%202.09961%205.50801%202.4928%205.6395%203.0494L6.59977%207.11445L27.579%206.94446C27.5792%206.94446%2027.5795%206.94446%2027.5798%206.94445C27.5797%206.94445%2027.5799%206.94445%2027.5798%206.94445C29.5795%206.92708%2031.0214%208.85843%2030.436%2010.7705C30.4359%2010.7709%2030.4357%2010.7714%2030.4356%2010.7718L27.5864%2020.1094C26.9834%2022.0906%2025.2419%2023.508%2023.1819%2023.6996L12.3904%2024.7C12.3903%2024.7%2012.3904%2024.7%2012.3904%2024.7C10.0487%2024.9173%207.9072%2023.3754%207.36637%2021.089L3.46326%204.56628H1.33343C0.652281%204.56628%200.100098%204.0141%200.100098%203.33294ZM7.18137%209.57648L9.7668%2020.5212C9.76678%2020.521%209.76683%2020.5213%209.7668%2020.5212C10.0252%2021.6128%2011.0471%2022.3474%2012.1623%2022.2439L22.9535%2021.2435C24.0174%2021.1445%2024.9157%2020.4127%2025.2266%2019.3911L28.0773%2010.0486C28.1749%209.73054%2027.9343%209.40801%2027.6014%209.41103L7.18137%209.57648ZM8.83667%2027.6026C8.83667%2026.5575%209.68359%2025.7093%2010.7297%2025.7093C11.7749%2025.7093%2012.6232%2026.5565%2012.6232%2027.6026C12.6232%2028.6488%2011.7747%2029.4958%2010.7297%2029.4958C9.68376%2029.4958%208.83667%2028.6478%208.83667%2027.6026ZM22.7924%2027.6026C22.7924%2026.5574%2023.6394%2025.7093%2024.6854%2025.7093C25.7305%2025.7093%2026.5789%2026.5564%2026.5789%2027.6026C26.5789%2028.6488%2025.7303%2029.4958%2024.6854%2029.4958C23.6396%2029.4958%2022.7924%2028.6478%2022.7924%2027.6026Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const ResourcesSVG = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M16.0002%2029.1476C15.2402%2029.1476%2014.4735%2028.9543%2013.8002%2028.5543C12.0802%2027.5543%209.38686%2026.321%206.31353%2026.101C3.96686%2025.9343%202.2002%2024.0676%202.2002%2021.761V7.20764C2.2002%205.97431%202.72686%204.80097%203.64686%203.97431C4.57353%203.14097%205.8202%202.74097%207.06686%202.88097C10.3402%203.24097%2013.1535%204.54764%2014.9335%205.58097C15.6002%205.96764%2016.4002%205.96764%2017.0669%205.58097C18.8469%204.54764%2021.6602%203.24097%2024.9335%202.88097C26.1735%202.74097%2027.4269%203.14764%2028.3535%203.98097C29.2735%204.80097%2029.8002%205.98097%2029.8002%207.21431V21.7676C29.8002%2024.0743%2028.0335%2025.9343%2025.6869%2026.1076C22.6202%2026.3276%2019.9202%2027.561%2018.2002%2028.561C17.5202%2028.9543%2016.7602%2029.1543%2016.0002%2029.1543V29.1476ZM6.58686%205.12097C6.06019%205.12097%205.55353%205.31431%205.16019%205.66097C4.71353%206.06097%204.46686%206.60764%204.46686%207.20764V21.761C4.46686%2022.861%205.32686%2023.7543%206.47353%2023.8343C9.97353%2024.0876%2013.0069%2025.4676%2014.9335%2026.5876C15.6002%2026.9743%2016.4002%2026.9743%2017.0669%2026.5876C18.9935%2025.4743%2022.0269%2024.0876%2025.5269%2023.8343C26.6735%2023.7543%2027.5335%2022.861%2027.5335%2021.761V7.20764C27.5335%206.61431%2027.2869%206.06097%2026.8402%205.66097C26.3935%205.25431%2025.7802%205.06764%2025.1802%205.12764C22.3002%205.44097%2019.7935%206.61431%2018.2002%207.53431C16.8402%208.32097%2015.1535%208.32097%2013.7935%207.53431C12.2002%206.60764%209.69353%205.44097%206.81353%205.12764C6.73353%205.12097%206.65353%205.11431%206.58019%205.11431L6.58686%205.12097Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20d%3D%22M16%2023.3272C15.3734%2023.3272%2014.8667%2022.8205%2014.8667%2022.1939V12.6939C14.8667%2012.0672%2015.3734%2011.5605%2016%2011.5605C16.6267%2011.5605%2017.1334%2012.0672%2017.1334%2012.6939V22.1939C17.1334%2022.8205%2016.6267%2023.3272%2016%2023.3272Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20d%3D%22M10.9067%2020.3943C10.7667%2020.3943%2010.6267%2020.3676%2010.4867%2020.3143L7.37332%2019.081C6.79332%2018.8476%206.50665%2018.1943%206.73999%2017.6076C6.97332%2017.0276%207.62665%2016.741%208.21332%2016.9743L11.3267%2018.2076C11.9067%2018.441%2012.1933%2019.0943%2011.96%2019.681C11.7867%2020.1276%2011.36%2020.3943%2010.9067%2020.3943ZM10.9067%2013.9876C10.7667%2013.9876%2010.6267%2013.961%2010.4867%2013.9076L7.37332%2012.6743C6.79332%2012.441%206.50665%2011.7876%206.73999%2011.201C6.97332%2010.621%207.62665%2010.3343%208.21332%2010.5676L11.3267%2011.801C11.9067%2012.0343%2012.1933%2012.6876%2011.96%2013.2743C11.7867%2013.721%2011.36%2013.9876%2010.9067%2013.9876Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const ShiftSVG = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M2.38867%2012.1294C2.38867%2011.5035%202.89608%2010.9961%203.52201%2010.9961H27.4775C28.1034%2010.9961%2028.6108%2011.5035%2028.6108%2012.1294C28.6108%2012.7553%2028.1034%2013.2628%2027.4775%2013.2628H3.52201C2.89608%2013.2628%202.38867%2012.7553%202.38867%2012.1294Z%22%20fill%3D%22black%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M20.8838%201.13281C21.5097%201.13281%2022.0172%201.64022%2022.0172%202.26615V6.64922C22.0172%207.27515%2021.5097%207.78256%2020.8838%207.78256C20.2579%207.78256%2019.7505%207.27515%2019.7505%206.64922V2.26615C19.7505%201.64022%2020.2579%201.13281%2020.8838%201.13281Z%22%20fill%3D%22black%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M10.1216%201.13281C10.7475%201.13281%2011.2549%201.64022%2011.2549%202.26615V6.64922C11.2549%207.27515%2010.7475%207.78256%2010.1216%207.78256C9.49569%207.78256%208.98828%207.27515%208.98828%206.64922V2.26615C8.98828%201.64022%209.49569%201.13281%2010.1216%201.13281Z%22%20fill%3D%22black%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M4.43919%205.13868C5.8048%203.84036%207.70427%203.23633%209.86465%203.23633H21.1416C23.3063%203.23633%2025.2066%203.83992%2026.5699%205.1398C27.9416%206.44771%2028.6226%208.32013%2028.6165%2010.5553V15.0303C28.6165%2015.6562%2028.109%2016.1636%2027.4831%2016.1636C26.8572%2016.1636%2026.3498%2015.6562%2026.3498%2015.0303V10.5538L26.3498%2010.5504C26.355%208.78196%2025.8266%207.56298%2025.0058%206.78029C24.1761%205.98923%2022.8997%205.50299%2021.1416%205.50299H9.86465C8.11265%205.50299%206.83469%205.98879%206.00097%206.78142C5.17599%207.56574%204.64313%208.78616%204.64313%2010.5538V22.6073C4.64313%2024.4114%205.17943%2025.663%206.00886%2026.467C6.84391%2027.2763%208.11945%2027.7708%209.86465%2027.7708H13.146C13.7719%2027.7708%2014.2793%2028.2782%2014.2793%2028.9041C14.2793%2029.5301%2013.7719%2030.0375%2013.146%2030.0375H9.86465C7.69746%2030.0375%205.79558%2029.4169%204.4313%2028.0945C3.0614%2026.7668%202.37646%2024.87%202.37646%2022.6073V10.5538C2.37646%208.31693%203.06484%206.44529%204.43919%205.13868Z%22%20fill%3D%22black%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M22.8906%2019.0811C20.2623%2019.0811%2018.1309%2021.2133%2018.1309%2023.8424C18.1309%2026.4711%2020.2619%2028.6021%2022.8906%2028.6021C25.5211%2028.6021%2027.6519%2026.4709%2027.6519%2023.8424C27.6519%2021.2135%2025.5207%2019.0811%2022.8906%2019.0811ZM15.8643%2023.8424C15.8643%2019.9622%2019.0097%2016.8145%2022.8906%2016.8145C26.7729%2016.8145%2029.9186%2019.962%2029.9186%2023.8424C29.9186%2027.7231%2026.7725%2030.8688%2022.8906%2030.8688C19.0101%2030.8688%2015.8643%2027.7229%2015.8643%2023.8424Z%22%20fill%3D%22black%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M22.8584%2020.7305C23.4844%2020.7305%2023.9918%2021.2379%2023.9918%2021.8638V23.6157L25.3032%2024.3995C25.8405%2024.7206%2026.0158%2025.4165%2025.6946%2025.9538C25.3735%2026.4911%2024.6777%2026.6663%2024.1404%2026.3452L22.277%2025.2315C21.9347%2025.0269%2021.7251%2024.6575%2021.7251%2024.2587V21.8638C21.7251%2021.2379%2022.2325%2020.7305%2022.8584%2020.7305Z%22%20fill%3D%22black%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M8.3999%2017.438C8.3999%2016.8121%208.90731%2016.3047%209.53324%2016.3047H9.5479C10.1738%2016.3047%2010.6812%2016.8121%2010.6812%2017.438C10.6812%2018.0639%2010.1738%2018.5714%209.5479%2018.5714H9.53324C8.90731%2018.5714%208.3999%2018.0639%208.3999%2017.438Z%22%20fill%3D%22black%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M8.3999%2022.7427C8.3999%2022.1168%208.90731%2021.6094%209.53324%2021.6094H9.5479C10.1738%2021.6094%2010.6812%2022.1168%2010.6812%2022.7427C10.6812%2023.3686%2010.1738%2023.876%209.5479%2023.876H9.53324C8.90731%2023.876%208.3999%2023.3686%208.3999%2022.7427Z%22%20fill%3D%22black%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M13.9976%2017.438C13.9976%2016.8121%2014.505%2016.3047%2015.1309%2016.3047H15.1456C15.7715%2016.3047%2016.2789%2016.8121%2016.2789%2017.438C16.2789%2018.0639%2015.7715%2018.5714%2015.1456%2018.5714H15.1309C14.505%2018.5714%2013.9976%2018.0639%2013.9976%2017.438Z%22%20fill%3D%22black%22%2F%3E%3C%2Fsvg%3E";

const ShippingSVG = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M13.123%203.66297C10.4364%203.19434%208.37751%204.31448%207.29949%206.40883C7.10521%206.78626%206.7163%207.02348%206.29181%207.02348H2.68234C2.05642%207.02348%201.54901%206.51607%201.54901%205.89015C1.54901%205.26423%202.05642%204.75682%202.68234%204.75682H5.63388C7.26008%202.1633%2010.129%200.839113%2013.5145%201.43037L13.5178%201.43094L23.2626%203.16212L23.267%203.1629L25.1472%203.48925C27.4599%203.89957%2029.2735%205.06709%2030.3868%206.78623C31.4934%208.49476%2031.8399%2010.6408%2031.4376%2012.9025C31.4375%2012.9028%2031.4374%2012.9031%2031.4374%2012.9034L29.5018%2023.8764C29.5017%2023.8766%2029.5018%2023.8762%2029.5018%2023.8764C29.107%2026.1388%2028.0442%2028.0379%2026.4176%2029.2643C24.7811%2030.4983%2022.675%2030.9744%2020.3611%2030.5639L8.73519%2028.5062C8.73483%2028.5061%208.73448%2028.506%208.73413%2028.506C5.13553%2027.8795%202.83746%2025.4217%202.36768%2022.1505C2.27871%2021.5309%202.70884%2020.9565%203.32841%2020.8675C3.94797%2020.7786%204.52236%2021.2087%204.61133%2021.8283C4.93838%2024.1056%206.46845%2025.8111%209.12367%2026.273L9.12695%2026.2736L20.7566%2028.332C22.5197%2028.6448%2023.9728%2028.269%2025.053%2027.4545C26.143%2026.6326%2026.9549%2025.2865%2027.2688%2023.4869L29.2058%2012.5062C29.5265%2010.7043%2029.2254%209.16264%2028.4843%208.01839C27.7503%206.88495%2026.5166%206.03477%2024.7533%205.72143C24.7526%205.72131%2024.7519%205.72119%2024.7512%205.72107L24.5843%205.69209L22.9037%2015.1928C22.8404%2015.5506%2022.6094%2015.8564%2022.2825%2016.015C21.9556%2016.1737%2021.5724%2016.1659%2021.2522%2015.9942L17.8967%2014.1952L14.0991%2014.7354C13.7393%2014.7866%2013.3768%2014.6621%2013.1243%2014.4007C12.8718%2014.1393%2012.76%2013.7726%2012.8237%2013.4148L14.515%203.91025L13.1246%203.66324C13.1241%203.66315%2013.1236%203.66306%2013.123%203.66297ZM16.7467%204.30672L15.3295%2012.2709L17.9452%2011.8988C18.1841%2011.8648%2018.4277%2011.9079%2018.6403%2012.022L20.9442%2013.2572L22.3513%205.30238L16.7467%204.30672ZM3.76107%2011.4378C3.76107%2010.8119%204.26848%2010.3045%204.8944%2010.3045H9.54187C10.1678%2010.3045%2010.6752%2010.8119%2010.6752%2011.4378C10.6752%2012.0638%2010.1678%2012.5712%209.54187%2012.5712H4.8944C4.26848%2012.5712%203.76107%2012.0638%203.76107%2011.4378ZM1.33301%2016.9605C1.33301%2016.3345%201.84042%2015.8271%202.46634%2015.8271H7.47695C8.10287%2015.8271%208.61028%2016.3345%208.61028%2016.9605C8.61028%2017.5864%208.10287%2018.0938%207.47695%2018.0938H2.46634C1.84042%2018.0938%201.33301%2017.5864%201.33301%2016.9605Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const StockSVG$1 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M3.72467%204.93315C4.66584%202.86258%206.73037%201.5332%209.0048%201.5332H23.2002C25.5554%201.5332%2027.6767%202.95735%2028.5684%205.13713L30.0347%208.72144C30.3199%209.41848%2030.4665%2010.1644%2030.4665%2010.9175V24.6665C30.4665%2027.8698%2027.8698%2030.4665%2024.6665%2030.4665H7.3332C4.12995%2030.4665%201.5332%2027.8698%201.5332%2024.6665V11.0107C1.5332%2010.1828%201.71047%209.3644%202.05308%208.61066L3.72467%204.93315ZM9.0048%203.79987C7.61923%203.79987%206.36152%204.60972%205.78817%205.8711L4.38834%208.95073H14.8665V3.79987H9.0048ZM17.1332%203.79987V8.95073H27.6795L26.4705%205.99537C25.9273%204.66745%2024.635%203.79987%2023.2002%203.79987H17.1332ZM28.1999%2011.2174H16.0212C16.0141%2011.2175%2016.007%2011.2176%2015.9999%2011.2176C15.9927%2011.2176%2015.9856%2011.2175%2015.9786%2011.2174H3.79987V24.6665C3.79987%2026.6179%205.3818%2028.1999%207.3332%2028.1999H24.6665C26.6179%2028.1999%2028.1999%2026.6179%2028.1999%2024.6665V11.2174ZM17.8498%2016.162C17.8498%2014.8831%2018.8861%2013.8466%2020.1651%2013.8466H23.2194C24.4965%2013.8466%2025.5363%2014.8812%2025.5363%2016.162V19.2163C25.5363%2020.4977%2024.4974%2021.5331%2023.2194%2021.5331H20.1651C18.8853%2021.5331%2017.8498%2020.4957%2017.8498%2019.2163V16.162ZM20.1651%2016.1132C20.1382%2016.1132%2020.1165%2016.1348%2020.1165%2016.162V19.2163C20.1165%2019.2457%2020.139%2019.2664%2020.1651%2019.2664H23.2194C23.2476%2019.2664%2023.2696%2019.2438%2023.2696%2019.2163V16.162C23.2696%2016.1367%2023.2484%2016.1132%2023.2194%2016.1132H20.1651ZM7.61247%2018.4291C7.61247%2017.8032%208.11988%2017.2958%208.7458%2017.2958H10.5188C11.1447%2017.2958%2011.6521%2017.8032%2011.6521%2018.4291C11.6521%2019.055%2011.1447%2019.5625%2010.5188%2019.5625H8.7458C8.11988%2019.5625%207.61247%2019.055%207.61247%2018.4291ZM7.61247%2022.6339C7.61247%2022.0079%208.11988%2021.5005%208.7458%2021.5005H13.184C13.8099%2021.5005%2014.3173%2022.0079%2014.3173%2022.6339C14.3173%2023.2598%2013.8099%2023.7672%2013.184%2023.7672H8.7458C8.11988%2023.7672%207.61247%2023.2598%207.61247%2022.6339Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const StoreDesignSVG = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M3.80928%203.98039C5.27179%202.41091%207.35383%201.5332%209.8097%201.5332H17.0685C17.6944%201.5332%2018.2019%202.04061%2018.2019%202.66654C18.2019%203.29246%2017.6944%203.79987%2017.0685%203.79987H9.8097C7.91574%203.79987%206.45769%204.46312%205.46757%205.52566C4.46921%206.59704%203.86286%208.16586%203.86286%2010.1127V11.4505H12.5501C13.1761%2011.4505%2013.6835%2011.9579%2013.6835%2012.5839C13.6835%2013.2098%2013.1761%2013.7172%2012.5501%2013.7172H3.86286V21.8857C3.86286%2023.8339%204.46682%2025.4029%205.46332%2026.474C6.45127%2027.5359%207.90869%2028.1999%209.8097%2028.1999H22.3045C24.2088%2028.1999%2025.6659%2027.5357%2026.6528%2026.4743C27.6484%2025.4035%2028.2513%2023.8345%2028.2513%2021.8857V15.399C28.2513%2014.7731%2028.7587%2014.2656%2029.3847%2014.2656C30.0106%2014.2656%2030.518%2014.7731%2030.518%2015.399V21.8857C30.518%2024.301%2029.7651%2026.4558%2028.3128%2028.0177C26.8518%2029.589%2024.7689%2030.4665%2022.3045%2030.4665H9.8097C7.34792%2030.4665%205.26525%2029.5888%203.8038%2028.018C2.35092%2026.4563%201.59619%2024.3016%201.59619%2021.8857V10.1127C1.59619%207.69527%202.35501%205.54102%203.80928%203.98039ZM27.8556%203.45528L29.1752%204.67698C30.4319%205.84079%2030.5122%207.80422%2029.3467%209.06333L29.3442%209.066L23.1625%2015.8116C22.4691%2016.5866%2021.5341%2017.0994%2020.5114%2017.2711L19.0745%2017.5117C17.2816%2017.8115%2015.7008%2016.3178%2015.8945%2014.5125L15.8946%2014.5116L16.0546%2013.0305C16.1579%2012.0791%2016.5563%2011.184%2017.1941%2010.4714L17.2028%2010.4618L23.4667%203.62256C24.6318%202.36686%2026.5959%202.28885%2027.8556%203.45528ZM25.1303%205.16216L25.1284%205.16426L18.8792%2011.9874C18.5599%2012.346%2018.3602%2012.7955%2018.3081%2013.2743L18.1483%2014.7543L18.1482%2014.7551C18.1149%2015.0702%2018.3897%2015.3279%2018.7001%2015.2762M25.1303%205.16216C25.4466%204.8235%2025.9764%204.80435%2026.3155%205.11834L27.6352%206.34015C27.9769%206.65669%2027.9956%207.18693%2027.6826%207.52433L21.4866%2014.2854L21.4761%2014.297C21.1273%2014.6884%2020.6555%2014.9484%2020.1365%2015.0356L18.7001%2015.2762M6.38208%208.3026C6.38208%207.67668%206.88949%207.16927%207.51541%207.16927H7.59755C8.22347%207.16927%208.73088%207.67668%208.73088%208.3026C8.73088%208.92853%208.22347%209.43594%207.59755%209.43594H7.51541C6.88949%209.43594%206.38208%208.92853%206.38208%208.3026ZM10.001%208.3026C10.001%207.67668%2010.5084%207.16927%2011.1343%207.16927H11.2165C11.8424%207.16927%2012.3498%207.67668%2012.3498%208.3026C12.3498%208.92853%2011.8424%209.43594%2011.2165%209.43594H11.1343C10.5084%209.43594%2010.001%208.92853%2010.001%208.3026Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const TicketsSVG = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M18.4663%204.5332C19.0923%204.5332%2019.5997%205.04061%2019.5997%205.66654V8.8932C19.5997%209.51913%2019.0923%2010.0265%2018.4663%2010.0265C17.8404%2010.0265%2017.333%209.51913%2017.333%208.8932V5.66654C17.333%205.04061%2017.8404%204.5332%2018.4663%204.5332Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M18.4663%2022.5469C19.0923%2022.5469%2019.5997%2023.0543%2019.5997%2023.6802V26.3789C19.5997%2027.0048%2019.0923%2027.5122%2018.4663%2027.5122C17.8404%2027.5122%2017.333%2027.0048%2017.333%2026.3789V23.6802C17.333%2023.0543%2017.8404%2022.5469%2018.4663%2022.5469Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M18.4663%2011.5371C19.0923%2011.5371%2019.5997%2012.0445%2019.5997%2012.6704V19.0984C19.5997%2019.7244%2019.0923%2020.2318%2018.4663%2020.2318C17.8404%2020.2318%2017.333%2019.7244%2017.333%2019.0984V12.6704C17.333%2012.0445%2017.8404%2011.5371%2018.4663%2011.5371Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M1.53459%209.67458C1.53483%206.63609%204.02493%204.19922%207.06509%204.19922H24.9347C27.9748%204.19922%2030.4649%206.63609%2030.4651%209.67457C30.4651%209.67442%2030.4651%209.67472%2030.4651%209.67457L30.4665%2013.1326C30.4667%2013.4333%2030.3473%2013.7217%2030.1348%2013.9343C29.9222%2014.1469%2029.6339%2014.2664%2029.3332%2014.2664C28.3389%2014.2664%2027.5643%2015.0516%2027.5643%2016.0006C27.5643%2016.9489%2028.3381%2017.7334%2029.3332%2017.7334C29.9591%2017.7334%2030.4665%2018.2408%2030.4665%2018.8667V22.3234C30.4665%2025.3619%2027.978%2027.7992%2024.936%2027.7992H7.0637C4.02177%2027.7992%201.5332%2025.3619%201.5332%2022.3234V18.8667C1.5332%2018.2408%202.04061%2017.7334%202.66654%2017.7334C3.66159%2017.7334%204.43544%2016.9489%204.43544%2016.0006C4.43544%2015.11%203.72166%2014.379%202.66654%2014.379C2.36588%2014.379%202.07755%2014.2596%201.86499%2014.0469C1.65244%2013.8343%201.53309%2013.5459%201.5332%2013.2452L1.53459%209.67458ZM7.06509%206.46589C5.24933%206.46589%203.80126%207.9153%203.80126%209.67503L3.80025%2012.264C5.44315%2012.7142%206.70211%2014.1289%206.70211%2016.0006C6.70211%2017.8332%205.47258%2019.3581%203.79987%2019.8407V22.3234C3.79987%2024.0834%205.24678%2025.5326%207.0637%2025.5326H24.936C26.753%2025.5326%2028.1999%2024.0834%2028.1999%2022.3234V19.8407C26.5272%2019.3581%2025.2976%2017.8331%2025.2976%2016.0006C25.2976%2014.1687%2026.5266%2012.6424%2028.1995%2012.1593L28.1985%209.67548C28.1985%207.91576%2026.7504%206.46589%2024.9347%206.46589H7.06509Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const WarehouseSVG = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M12.7877%203.77611C14.6601%202.29612%2017.3032%202.29576%2019.1749%203.77639L19.1789%203.77953L27.4799%2010.4067C28.503%2011.1886%2029.1104%2012.3952%2029.1316%2013.6816L29.1318%2013.7003V27.7984C29.1318%2028.4243%2028.6244%2028.9317%2027.9984%2028.9317C27.3725%2028.9317%2026.8651%2028.4243%2026.8651%2027.7984V13.7107C26.8528%2013.1166%2026.5703%2012.5617%2026.098%2012.2034C26.0906%2012.1977%2026.0832%2012.192%2026.0759%2012.1862L17.7686%205.55409C17.768%205.55362%2017.7674%205.55315%2017.7669%205.55268C16.7207%204.72648%2015.2443%204.72579%2014.1962%205.55198L5.92483%2012.1896C5.91607%2012.1966%205.90721%2012.2035%205.89824%2012.2103C5.42358%2012.5685%205.14156%2013.1253%205.13337%2013.7189V27.7984C5.13337%2028.4243%204.62596%2028.9317%204.00003%2028.9317C3.37411%2028.9317%202.8667%2028.4243%202.8667%2027.7984V13.712L2.86677%2013.6996C2.88092%2012.4073%203.49065%2011.1946%204.5183%2010.412L12.7877%203.77611Z%22%20fill%3D%22black%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M12.0297%2018.2459C11.7423%2018.5544%2011.5318%2019.044%2011.5318%2019.7252V24.6701C11.5318%2025.353%2011.7417%2025.8423%2012.0279%2026.15C12.3054%2026.4484%2012.7366%2026.6657%2013.3743%2026.6657H18.624C19.2609%2026.6657%2019.6927%2026.4485%2019.971%2026.1496C20.2578%2025.8416%2020.4679%2025.3523%2020.4679%2024.6701V19.7252C20.4679%2019.043%2020.2578%2018.5536%2019.971%2018.2457C19.6927%2017.9468%2019.2609%2017.7296%2018.624%2017.7296H13.3743C12.7408%2017.7296%2012.3088%2017.9463%2012.0297%2018.2459ZM10.3713%2016.7008C11.1228%2015.8942%2012.1787%2015.4629%2013.3743%2015.4629H18.624C19.8214%2015.4629%2020.8782%2015.8937%2021.6299%2016.701C22.3732%2017.4993%2022.7346%2018.5744%2022.7346%2019.7252V24.6701C22.7346%2025.8208%2022.3732%2026.896%2021.6299%2027.6942C20.8782%2028.5016%2019.8214%2028.9324%2018.624%2028.9324H13.3743C12.1764%2028.9324%2011.1197%2028.5016%2010.3682%2027.6938C9.62541%2026.8953%209.26514%2025.8201%209.26514%2024.6701V19.7252C9.26514%2018.5734%209.62803%2017.4985%2010.3713%2016.7008Z%22%20fill%3D%22black%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M13.3223%2021.0591C13.3223%2020.4332%2013.8297%2019.9258%2014.4556%2019.9258H17.5416C18.1675%2019.9258%2018.6749%2020.4332%2018.6749%2021.0591C18.6749%2021.685%2018.1675%2022.1924%2017.5416%2022.1924H14.4556C13.8297%2022.1924%2013.3223%2021.685%2013.3223%2021.0591Z%22%20fill%3D%22black%22%2F%3E%3C%2Fsvg%3E";

const SettingSVG = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url%28%23clip0_23281_50722%29%22%3E%3Cpath%20d%3D%22M16.827%2029.9461H15.1536C13.1203%2029.9461%2011.467%2028.2927%2011.467%2026.2594C11.467%2026.0394%2011.4003%2025.8127%2011.287%2025.6194C11.0936%2025.2794%2010.787%2025.0461%2010.427%2024.9461C10.0736%2024.8527%209.6803%2024.8994%209.36697%2025.0861C8.5003%2025.5727%207.4803%2025.6927%206.5403%2025.4261C5.60697%2025.1594%204.79363%2024.5194%204.32697%2023.6661L3.49363%2022.2327C2.4803%2020.4794%203.0803%2018.2327%204.83363%2017.2194C5.27363%2016.9661%205.5403%2016.4994%205.5403%2015.9927C5.5403%2015.4861%205.26697%2015.0194%204.83363%2014.7661C3.08697%2013.7527%202.48697%2011.4994%203.5003%209.74607L4.40697%208.2594C5.40697%206.52607%207.6603%205.9194%209.41363%206.92607C9.62697%207.05273%209.85363%207.11273%2010.0803%207.1194C10.8403%207.1194%2011.4736%206.49273%2011.487%205.7194C11.487%204.77273%2011.8736%203.8194%2012.5536%203.13273C13.2336%202.44607%2014.187%202.05273%2015.1536%202.05273H16.827C17.8136%202.05273%2018.7803%202.4594%2019.467%203.16607C20.1603%203.8794%2020.5403%204.85273%2020.507%205.8394C20.507%206.02607%2020.5736%206.25273%2020.6936%206.44607C20.887%206.77273%2021.1936%207.00607%2021.5536%207.0994C21.9136%207.19273%2022.3003%207.1394%2022.6203%206.95273C24.3936%205.9394%2026.647%206.54607%2027.6536%208.30607L28.487%209.74607C28.5136%209.78607%2028.5336%209.83273%2028.547%209.87273C29.4536%2011.5994%2028.847%2013.7727%2027.147%2014.7661C26.927%2014.8927%2026.7536%2015.0661%2026.6336%2015.2794C26.4403%2015.6061%2026.387%2015.9994%2026.487%2016.3594C26.5803%2016.7194%2026.8203%2017.0327%2027.147%2017.2127C28.0003%2017.7061%2028.6136%2018.4994%2028.867%2019.4527C29.1203%2020.3861%2028.9803%2021.4061%2028.4936%2022.2461L27.607%2023.7261C26.5936%2025.4594%2024.3403%2026.0594%2022.5936%2025.0527C22.387%2024.9327%2022.147%2024.8661%2021.907%2024.8594C21.547%2024.8327%2021.2003%2025.0061%2020.9336%2025.2727C20.667%2025.5394%2020.5203%2025.8927%2020.5203%2026.2727C20.5136%2028.3061%2018.8603%2029.9527%2016.8336%2029.9527L16.827%2029.9461ZM10.0736%2022.6394C10.3936%2022.6394%2010.707%2022.6794%2011.0203%2022.7661C11.9536%2023.0194%2012.767%2023.6461%2013.2536%2024.4861C13.567%2025.0127%2013.7403%2025.6261%2013.747%2026.2594C13.747%2027.0527%2014.3803%2027.6861%2015.167%2027.6861H16.8403C17.6203%2027.6861%2018.2536%2027.0527%2018.2603%2026.2727C18.2603%2025.3127%2018.647%2024.3594%2019.3336%2023.6661C20.0203%2022.9727%2020.9603%2022.5927%2021.9336%2022.5927H21.9536C22.5936%2022.6127%2023.2003%2022.7794%2023.7336%2023.0861C24.407%2023.4727%2025.2803%2023.2461%2025.667%2022.5727L26.5536%2021.0927C26.7336%2020.7861%2026.787%2020.3927%2026.687%2020.0394C26.587%2019.6727%2026.3536%2019.3727%2026.027%2019.1861C25.187%2018.7061%2024.5603%2017.8861%2024.307%2016.9527C24.0536%2016.0127%2024.1936%2014.9927%2024.6803%2014.1594C24.9936%2013.6061%2025.4603%2013.1394%2026.0203%2012.8194C26.6803%2012.4327%2026.907%2011.5727%2026.527%2010.8994C26.507%2010.8661%2026.4936%2010.8327%2026.4736%2010.7994L25.7003%209.45273C25.3136%208.7794%2024.447%208.5394%2023.767%208.93273C22.947%209.4194%2021.927%209.5594%2020.9936%209.3194C20.047%209.07273%2019.247%208.47273%2018.747%207.62607C18.427%207.09273%2018.2536%206.47273%2018.247%205.84607C18.2603%205.4194%2018.1136%205.04607%2017.847%204.77273C17.5803%204.4994%2017.2136%204.34607%2016.8336%204.34607H15.1603C14.787%204.34607%2014.427%204.4994%2014.167%204.7594C13.9003%205.02607%2013.7536%205.3794%2013.7603%205.7594C13.7336%207.78607%2012.0803%209.41273%2010.0736%209.41273C9.43363%209.40607%208.81363%209.23273%208.27363%208.91273C7.61363%208.53273%206.74697%208.76607%206.35363%209.44607L5.44697%2010.9327C5.07363%2011.5861%205.3003%2012.4527%205.97363%2012.8394C7.10697%2013.4927%207.81363%2014.7127%207.81363%2016.0261C7.81363%2017.3394%207.10697%2018.5594%205.97363%2019.2194C5.30697%2019.6061%205.07363%2020.4661%205.4603%2021.1394L6.3003%2022.5861C6.49363%2022.9327%206.8003%2023.1794%207.1603%2023.2794C7.5203%2023.3794%207.91363%2023.3327%208.2403%2023.1527C8.78697%2022.8327%209.42697%2022.6661%2010.067%2022.6661L10.0736%2022.6394Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3Cpath%20d%3D%22M16.0002%2020.6527C13.4402%2020.6527%2011.3535%2018.566%2011.3535%2016.006C11.3535%2013.446%2013.4402%2011.3594%2016.0002%2011.3594C18.5602%2011.3594%2020.6468%2013.446%2020.6468%2016.006C20.6468%2018.566%2018.5602%2020.6527%2016.0002%2020.6527ZM16.0002%2013.6194C14.6868%2013.6194%2013.6202%2014.686%2013.6202%2015.9994C13.6202%2017.3127%2014.6868%2018.3794%2016.0002%2018.3794C17.3135%2018.3794%2018.3802%2017.3127%2018.3802%2015.9994C18.3802%2014.686%2017.3135%2013.6194%2016.0002%2013.6194Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_23281_50722%22%3E%3Crect%20width%3D%2225.98%22%20height%3D%2227.8933%22%20fill%3D%22white%22%20transform%3D%22translate%283.00684%202.05273%29%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

const HomeSVG$1 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M12.6474%202.6921C14.5969%201.1469%2017.365%201.1469%2019.3145%202.6921L19.3171%202.6942L28.0822%209.68434C29.1471%2010.5025%2029.7817%2011.7594%2029.8001%2013.1014L29.8002%2013.117V24.749C29.8002%2027.9174%2027.2088%2030.4665%2024.0363%2030.4665H21.4709C21.4621%2030.4665%2021.4534%2030.4664%2021.4446%2030.4662C19.9478%2030.4315%2018.734%2029.2168%2018.7342%2027.7078C18.7342%2027.7077%2018.7342%2027.7079%2018.7342%2027.7078V23.6061C18.7342%2023.1978%2018.3967%2022.8473%2017.9563%2022.8473H14.1127C13.676%2022.8518%2013.3431%2023.2006%2013.3431%2023.6061V27.6951C13.3431%2027.8024%2013.3282%2027.9062%2013.3004%2028.0045C13.1452%2029.3978%2011.9546%2030.4665%2010.5295%2030.4665H7.96408C4.79154%2030.4665%202.2002%2027.9174%202.2002%2024.749V13.1297L2.20025%2013.1185C2.21354%2011.7738%202.84922%2010.5135%203.91829%209.69689L12.6474%202.6921ZM11.0765%2027.4542V23.6061C11.0765%2023.6061%2011.0765%2023.6061%2011.0765%2023.6061C11.0765%2021.9325%2012.4378%2020.5917%2014.1007%2020.5807L14.1082%2020.5806L17.9563%2020.5807C19.627%2020.5807%2021.0009%2021.9245%2021.0009%2023.6061V27.7078C21.0008%2027.9618%2021.2061%2028.1884%2021.4876%2028.1999H24.0363C25.9785%2028.1999%2027.5335%2026.6441%2027.5335%2024.749V13.1256C27.5226%2012.4825%2027.2167%2011.8754%2026.6963%2011.478C26.69%2011.4731%2026.6837%2011.4683%2026.6775%2011.4633L17.9065%204.46844C17.9061%204.46811%2017.9057%204.46778%2017.9053%204.46745C16.7815%203.57765%2015.1819%203.57734%2014.0578%204.46654L5.32554%2011.4739C5.31735%2011.4804%205.30907%2011.4869%205.30069%2011.4932C4.77987%2011.8879%204.47474%2012.4942%204.46686%2013.1359V24.749C4.46686%2026.6441%206.02185%2028.1999%207.96408%2028.1999H10.5295C10.8282%2028.1999%2011.0508%2027.9632%2011.0508%2027.6951C11.0508%2027.6124%2011.0597%2027.5318%2011.0765%2027.4542Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

const AppResourceIcons = {
  default: SettingSVG,
  analysis: AnalysisSVG,
  calendar: CalendarSVG$1,
  catalog: CatalogSVG$1,
  category: CategorySVG,
  contact: ContactSVG,
  coupon: CouponSVG,
  customer: CustomerSVG$1,
  invoice: InvoiceSVG,
  item: ItemSVG$1,
  item_set: ItemSetSVG,
  message: MessageSVG$1,
  money: MoneySVG$1,
  news: NewsSVG,
  old_home: OldHomeSVG,
  order: OrderSVG,
  resources: ResourcesSVG,
  shift: ShiftSVG,
  shipping: ShippingSVG,
  stock: StockSVG$1,
  store_design: StoreDesignSVG,
  tickets: TicketsSVG,
  warehouse: WarehouseSVG,
  home: HomeSVG$1
};

const NotificationSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M8.93768%2015.8903C8.93768%209.3535%2015.007%202.30005%2024%202.30005C32.993%202.30005%2039.0623%209.3535%2039.0623%2015.8903C39.0623%2017.5202%2039.2696%2018.6527%2039.5486%2019.5172C39.8285%2020.3849%2040.2015%2021.0529%2040.6405%2021.7877C40.6854%2021.8627%2040.7315%2021.9394%2040.7787%2022.0178C41.1804%2022.6851%2041.6565%2023.4761%2042.0196%2024.4261C42.4399%2025.5259%2042.7%2026.7979%2042.7%2028.4411C42.7%2028.4901%2042.6979%2028.5391%2042.6936%2028.588C42.5456%2030.2935%2042.0375%2031.8027%2041.0621%2033.0643C40.0914%2034.3199%2038.7554%2035.2042%2037.1604%2035.8289C34.0524%2037.0461%2029.6332%2037.3953%2024%2037.3953C18.3695%2037.3953%2013.9505%2037.0518%2010.8425%2035.8377C9.24688%2035.2144%207.90997%2034.3305%206.93861%2033.0731C5.96278%2031.81%205.45474%2030.2979%205.30635%2028.588C5.30211%2028.5392%205.29999%2028.4901%205.29999%2028.4411C5.29999%2026.7979%205.56009%2025.5259%205.98039%2024.4261C6.34348%2023.4761%206.81963%2022.685%207.22127%2022.0178C7.26846%2021.9394%207.31462%2021.8627%207.35945%2021.7877C7.79844%2021.0529%208.17147%2020.3849%208.45141%2019.5172C8.73033%2018.6527%208.93768%2017.5202%208.93768%2015.8903ZM24%205.70005C16.8121%205.70005%2012.3377%2011.3032%2012.3377%2015.8903C12.3377%2017.8207%2012.0903%2019.3117%2011.6872%2020.5612C11.285%2021.8076%2010.7487%2022.7441%2010.2782%2023.5315C10.232%2023.6088%2010.187%2023.6839%2010.143%2023.7573C9.72666%2024.4516%209.40628%2024.9859%209.15637%2025.6399C8.89981%2026.3112%208.70776%2027.1485%208.70022%2028.3664C8.8117%2029.5332%209.14208%2030.3639%209.62922%2030.9945C10.1308%2031.6438%2010.898%2032.2091%2012.0796%2032.6707C14.526%2033.6264%2018.354%2033.9953%2024%2033.9953C29.6452%2033.9953%2033.4741%2033.6211%2035.9205%2032.663C37.1027%2032.2001%2037.8704%2031.6338%2038.3723%2030.9848C38.8593%2030.3548%2039.1888%2029.5266%2039.2998%2028.3664C39.2922%2027.1484%2039.1002%2026.3112%2038.8436%2025.6399C38.5937%2024.986%2038.2733%2024.4516%2037.857%2023.7573C37.813%2023.6839%2037.7679%2023.6088%2037.7218%2023.5315C37.2513%2022.7441%2036.7149%2021.8076%2036.3128%2020.5612C35.9097%2019.3117%2035.6623%2017.8207%2035.6623%2015.8903C35.6623%2011.3032%2031.1879%205.70005%2024%205.70005Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M17.9027%2040.4499C18.601%2039.8224%2019.6759%2039.8798%2020.3034%2040.5782C22.3758%2042.8845%2025.4547%2042.8637%2027.5143%2040.5768C28.1426%2039.8791%2029.2175%2039.8229%2029.9152%2040.4512C30.6129%2041.0795%2030.6691%2042.1544%2030.0408%2042.8521C26.6438%2046.624%2021.2107%2046.675%2017.7744%2042.8506C17.1468%2042.1523%2017.2043%2041.0774%2017.9027%2040.4499Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const ChevronRightSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M16.7979%208.79797C17.4618%208.13408%2018.5382%208.13408%2019.2021%208.79797L33.2021%2022.798C33.866%2023.4619%2033.866%2024.5382%2033.2021%2025.2021L19.2021%2039.2021C18.5382%2039.866%2017.4618%2039.866%2016.7979%2039.2021C16.134%2038.5382%2016.134%2037.4619%2016.7979%2036.798L29.5958%2024L16.7979%2011.2021C16.134%2010.5382%2016.134%209.46186%2016.7979%208.79797Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const getSPRoutesListBorderClasses = (appId, isHome, currentAppId, navigationApps, currentIndex) => {
  const baseClasses = "h-56 border-solid border-border-tertiary border-l-0 border-r-0";
  if (appId === "home" && isHome) {
    return `${baseClasses} border-b-0 border-t-0`;
  }
  const borderTop = appId === "home" && !isHome ? "border-t-1" : "border-t-0";
  const borderBottom = appId === currentAppId || navigationApps[currentIndex + 1]?.appId === currentAppId ? "border-b-0" : "border-b-1";
  return `${baseClasses} ${borderTop} ${borderBottom}`;
};
const showViewSiteIcon = (uiState) => !(!uiState.netshopViewSite && !uiState.mobileOrderViewSite && !uiState.reserveViewSite);
const showNavigationSettingIcon = (uiState) => !!uiState.navigationSetting;
const onClickViewSiteIcon = (props) => {
  const { uiState, viewSite, showViewSiteIcon: showViewSiteIcon2 } = props;
  if (!viewSite) {
    return;
  }
  if (!showViewSiteIcon2) {
    return;
  }
  const availableSites = [
    uiState.mobileOrderViewSite,
    uiState.netshopViewSite,
    uiState.reserveViewSite
  ].filter((v) => v != null);
  if (availableSites.length === 1) {
    openWindow(availableSites[0].href);
    return;
  }
  viewSite.onOpenStateChange(!viewSite.isOpen);
};
const openWindow = (url) => {
  window.open(url, "_blank", "noopener,noreferrer");
};
const resolveHref = (href, currentPath) => {
  const url = parseURL(href);
  const currentUrl = parseURL(currentPath || window.location.href);
  if (url.host === currentUrl.host) {
    return url.pathname + url.search;
  }
  return href;
};

const iconColor = "invert-[.45] sepia-[.06] saturate-[6.18] hue-rotate-[22deg] brightness-[.96] contrast-[.84]";

const StandNavi$1 = ({
  uiState,
  currentPath,
  showNotification,
  user: { onClick: onClickUser, isOpen: isUserOpen },
  relatedPathMap,
  renderRightContentsEl,
  isHome,
  onAppClosed,
  onClickLogout,
  onClickUserSettings,
  viewSite,
  collapsedApps: {
    onClick: onClickCollapsedApps,
    collapsedAppsState,
    isOpen: isCollapsedAppsOpen
  },
  observeContainerRef
}) => {
  const {
    home = {
      name: "home",
      href: "https://dashboard.stores.app",
      // apiの疎通に失敗したときに表示される。最悪のケースでもホームには戻れるようにしておく
      appId: "home"
    },
    navigationApps
  } = uiState;
  const currentAppId = detectAppId(currentPath ?? "/", relatedPathMap);
  const handleBarsClick = () => {
    const body = document.body;
    const root = document.getElementById("stand-navi-root");
    if (body) {
      body.style.overflow = body.style.overflow === "hidden" ? "" : "hidden";
    }
    if (root) {
      root.classList.toggle("show-navigation");
    }
  };
  const handleCloseClick = async (appId) => {
    if (onAppClosed) {
      onAppClosed(appId);
    }
  };
  const RootRoutesList = () => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative flex h-64 max-h-64 list-none flex-wrap justify-start gap-xs overflow-hidden p-none text-body-lg", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "li",
      {
        className: "relative box-border flex h-64 shrink items-center justify-center",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            href: resolveHref(home.href, currentPath),
            className: `flex items-center px-sm py-xs text-body-lg font-bold no-underline hover:rounded-sm hover:bg-surface-quaternary ${isHome ? "rounded-sm bg-surface-quaternary text-label-primary" : "text-label-secondary"}`,
            "data-stand-navi-list-item": true,
            children: home.name
          }
        )
      },
      home.appId
    ),
    navigationApps.map((item) => {
      const metadata = uiState.metadata?.find(
        (metadata2) => metadata2.appId === item.appId
      );
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: "relative flex items-center justify-center",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "relative box-border flex h-64 shrink items-center justify-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              href: resolveHref(item.href, currentPath),
              target: (
                /*item.target this is not defined now ||*/
                ""
              ),
              className: "flex items-center no-underline active:scale-95 active:transition-transform active:duration-100",
              children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                "div",
                {
                  className: `flex items-center px-sm py-xs text-body-lg font-bold no-underline hover:rounded-sm hover:bg-surface-quaternary ${item.appId === currentAppId ? "rounded-sm bg-surface-quaternary text-label-primary " : "text-label-secondary "}`,
                  "data-stand-navi-list-item": true,
                  children: [
                    item.name,
                    item.appId !== currentAppId && metadata?.badgeCount ? /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { count: metadata.badgeCount }) : null,
                    item.appId === currentAppId && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": `stand-navi-close-${item.appId}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                      CloseButton,
                      {
                        appId: item.appId,
                        onCloseClick: handleCloseClick
                      }
                    ) })
                  ]
                }
              )
            }
          ) })
        },
        item.appId
      );
    })
  ] }) });
  const SPRoutesList = (props) => {
    const { metadata } = props;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex h-auto flex-none items-center justify-center text-body-lg pc:text-heading-md", children: /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "box-border flex h-64 shrink items-center justify-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "hidden w-full bg-surface-primary group-[.show-navigation]/sp:block", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "ul",
      {
        className: `absolute left-none top-4xl z-5 box-border block h-[100svh] w-full list-none gap-x-lg overflow-y-auto bg-white px-md pb-[300px] pt-md `,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "block pc:hidden", children: renderRightContentsEl() }),
          [home, ...navigationApps].map((app) => {
            const appMeta = metadata?.find(
              (metadata2) => metadata2.appId === app.appId
            );
            return /* @__PURE__ */ jsxRuntimeExports.jsx(
              "li",
              {
                className: getSPRoutesListBorderClasses(
                  app.appId,
                  isHome ?? false,
                  currentAppId,
                  navigationApps,
                  navigationApps.indexOf(app)
                ),
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "a",
                  {
                    href: app.href,
                    className: `block size-full no-underline ${app.appId === currentAppId || app.appId === "home" && isHome ? "rounded-md bg-surface-quaternary text-label-primary" : "text-label-secondary"}`,
                    children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ml-md flex h-full items-center justify-between", children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "truncate text-heading-md font-bold", children: app.name || "\u30DB\u30FC\u30E0" }),
                      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-row items-center", children: [
                        app.appId !== currentAppId && appMeta?.badgeCount ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mr-1", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { count: appMeta.badgeCount }) }) : null,
                        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `mr-xs ${iconColor}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                          "img",
                          {
                            className: "m-xs block align-middle transition-transform",
                            width: 16,
                            src: ChevronRightSVG
                          }
                        ) })
                      ] })
                    ] })
                  }
                )
              },
              app.appId
            );
          }),
          showNavigationSettingIcon(uiState) && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mt-3 flex h-[40px] flex-row items-center justify-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              className: "box-border flex h-full items-center justify-center rounded-md border border-solid border-border-secondary no-underline active:scale-95 active:transition-transform active:duration-100 pc:hidden",
              type: "button",
              href: uiState.navigationSetting?.href,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mx-2 block align-middle text-body-md font-bold text-label-emphasis", children: "\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u3092\u7DE8\u96C6" })
            }
          ) })
        ]
      }
    ) }) }) }) });
  };
  const HamburgerToggleButton = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "button",
    {
      onClick: handleBarsClick,
      className: "mr-xs flex h-[40px] items-center justify-center",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mr-0.5 flex h-[40px] w-40 items-center justify-center transition-all", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            className: "block align-middle",
            width: 24,
            src: (() => {
              if (isHome)
                return AppResourceIcons.home;
              if (!currentAppId)
                return AppResourceIcons.default;
              const group = hardcodedAppGroups.find(
                (group2) => group2.appIds.includes(currentAppId)
              );
              const idToMap = group?.id || currentAppId;
              const iconId = hardcodedIconMapping[idToMap] || "default";
              return AppResourceIcons[iconId] || AppResourceIcons.default;
            })()
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-heading-lg font-bold text-label-primary", children: navigationApps.find((app) => app.appId === currentAppId)?.name || (isHome ? "\u30DB\u30FC\u30E0" : "") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center group-[.show-navigation]/sp:rotate-180", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            className: "m-xs block align-middle transition-transform",
            width: 16,
            src: ChevronSVG
          }
        ) })
      ]
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "nav",
    {
      id: "stand-navi-root",
      className: "group/pc group/sp relative box-border flex h-64 w-full items-center justify-between border-x-0 border-b border-t-0 border-solid border-b-border-tertiary bg-surface-primary px-xs text-label-primary antialiased pc:px-md",
      children: [
        collapsedAppsState.count > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
          CollapsedAppsMenu,
          {
            apps: navigationApps.slice(-collapsedAppsState.count),
            isOpen: isCollapsedAppsOpen,
            onClick: onClickCollapsedApps,
            onClickRemoveApp: onAppClosed ?? (async () => {
            }),
            appId: currentAppId,
            position: collapsedAppsState.position
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "w-full", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "box-border flex grow pc:hidden", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex shrink-0 items-center", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(HamburgerToggleButton, {}),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "hidden group-[.show-navigation]/sp:flex", children: /* @__PURE__ */ jsxRuntimeExports.jsx(SPRoutesList, { metadata: uiState.metadata }) })
          ] }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "ul",
            {
              className: "relative box-border hidden pc:flex pc:grow pc:justify-start",
              ref: observeContainerRef,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(RootRoutesList, {})
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex shrink-0 items-center justify-end", children: [
          collapsedAppsState.count > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(CollapsedAppsTrigger, { type: "skeleton" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ml-md hidden pc:block", children: renderRightContentsEl() }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ml-xs", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center pc:gap-xs", children: [
            showNavigationSettingIcon(uiState) && /* @__PURE__ */ jsxRuntimeExports.jsx(
              "a",
              {
                className: "box-border hidden rounded-full p-[4px] px-2 no-underline active:scale-95 active:transition-transform active:duration-100 pc:block pc:border pc:border-solid pc:border-border-tertiary",
                type: "button",
                href: uiState.navigationSetting?.href,
                children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "block align-middle text-body-sm font-bold text-label-emphasis", children: "\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u3092\u7DE8\u96C6" })
              }
            ),
            showNotification && /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                className: "beamerTrigger box-border block rounded-full p-sm pc:border pc:border-solid pc:border-border-tertiary",
                type: "button",
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "img",
                  {
                    className: "block align-middle",
                    width: 24,
                    height: 24,
                    src: NotificationSVG
                  }
                )
              }
            ),
            showViewSiteIcon(uiState) && /* @__PURE__ */ jsxRuntimeExports.jsx(
              ViewSitePopover,
              {
                onClickViewSiteIcon: () => onClickViewSiteIcon({
                  uiState,
                  viewSite,
                  showViewSiteIcon: true
                }),
                isOpen: viewSite?.isOpen ?? false,
                onClickMobileOrderViewSite: () => {
                  if (uiState.mobileOrderViewSite?.href) {
                    openWindow(uiState.mobileOrderViewSite?.href);
                  }
                },
                mobileOrderViewSiteName: uiState.mobileOrderViewSite?.name,
                onClickNetshopViewSite: () => {
                  if (uiState.netshopViewSite?.href) {
                    openWindow(uiState.netshopViewSite?.href);
                  }
                },
                netshopViewSiteName: uiState.netshopViewSite?.name,
                onClickReserveViewSite: () => {
                  if (uiState.reserveViewSite?.href) {
                    openWindow(uiState.reserveViewSite?.href);
                  }
                },
                reserveViewSiteName: uiState.reserveViewSite?.name
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              UserPopover,
              {
                onClickUserSettings: onClickUserSettings ?? (() => {
                }),
                onClickUser: onClickUser ?? (() => {
                }),
                onClickLogout,
                userName: uiState.employee?.name ?? "",
                userId: uiState.employee?.storesUser?.id ?? "",
                userEmail: uiState.employee?.storesUser?.email ?? "",
                businessEntityId: uiState.employee?.businessEntity?.id ?? "",
                businessEntityName: uiState.employee?.businessEntity?.name ?? "",
                isOpen: isUserOpen
              }
            )
          ] }) })
        ] })
      ]
    }
  );
};

const serviceOrigins = {
  reserve: {
    production: "https://coubic.com",
    staging: "https://staging.coubic.com",
    dev01: "https://sandbox001.coubic.com",
    local: "https://rsv.lo.stin.cc"
  },
  retail: {
    production: "https://dashboard.stores.jp",
    staging: "https://dashboard.stores.cm",
    dev01: "https://dashboard.stores-staging.net",
    local: "https://dashboard.lo.stin.cc"
  },
  organization: {
    production: "https://organization.stores.app",
    staging: "https://organization.maja-stg.com",
    dev01: "https://organization.maja-dev01.com",
    local: "https://maja.lo.stin.cc"
  }
};
const getServiceOrigin = (serviceType, stageEnv) => {
  return serviceOrigins[serviceType][stageEnv];
};
const getServiceOrigins = (serviceType) => serviceOrigins[serviceType];

const CalendarSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M4.48529%2018.8085C4.48529%2017.8696%205.24641%2017.1085%206.18529%2017.1085H41.8332C42.7721%2017.1085%2043.5332%2017.8696%2043.5332%2018.8085C43.5332%2019.7474%2042.7721%2020.5085%2041.8332%2020.5085H6.18529C5.24641%2020.5085%204.48529%2019.7474%204.48529%2018.8085Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M31.1841%2026.6194C31.1841%2025.6805%2031.9453%2024.9194%2032.8841%2024.9194H32.9027C33.8416%2024.9194%2034.6027%2025.6805%2034.6027%2026.6194C34.6027%2027.5583%2033.8416%2028.3194%2032.9027%2028.3194H32.8841C31.9453%2028.3194%2031.1841%2027.5583%2031.1841%2026.6194Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M22.3092%2026.6194C22.3092%2025.6805%2023.0703%2024.9194%2024.0092%2024.9194H24.0277C24.9666%2024.9194%2025.7277%2025.6805%2025.7277%2026.6194C25.7277%2027.5583%2024.9666%2028.3194%2024.0277%2028.3194H24.0092C23.0703%2028.3194%2022.3092%2027.5583%2022.3092%2026.6194Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M13.4158%2026.6194C13.4158%2025.6805%2014.1769%2024.9194%2015.1158%2024.9194H15.1343C16.0732%2024.9194%2016.8343%2025.6805%2016.8343%2026.6194C16.8343%2027.5583%2016.0732%2028.3194%2015.1343%2028.3194H15.1158C14.1769%2028.3194%2013.4158%2027.5583%2013.4158%2026.6194Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M31.1841%2034.3925C31.1841%2033.4536%2031.9453%2032.6925%2032.8841%2032.6925H32.9027C33.8416%2032.6925%2034.6027%2033.4536%2034.6027%2034.3925C34.6027%2035.3314%2033.8416%2036.0925%2032.9027%2036.0925H32.8841C31.9453%2036.0925%2031.1841%2035.3314%2031.1841%2034.3925Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M22.3092%2034.3925C22.3092%2033.4536%2023.0703%2032.6925%2024.0092%2032.6925H24.0277C24.9666%2032.6925%2025.7277%2033.4536%2025.7277%2034.3925C25.7277%2035.3314%2024.9666%2036.0925%2024.0277%2036.0925H24.0092C23.0703%2036.0925%2022.3092%2035.3314%2022.3092%2034.3925Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M13.4158%2034.3925C13.4158%2033.4536%2014.1769%2032.6925%2015.1158%2032.6925H15.1343C16.0732%2032.6925%2016.8343%2033.4536%2016.8343%2034.3925C16.8343%2035.3314%2016.0732%2036.0925%2015.1343%2036.0925H15.1158C14.1769%2036.0925%2013.4158%2035.3314%2013.4158%2034.3925Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M32.0875%202.30005C33.0263%202.30005%2033.7875%203.06116%2033.7875%204.00005V10.5816C33.7875%2011.5205%2033.0263%2012.2816%2032.0875%2012.2816C31.1486%2012.2816%2030.3875%2011.5205%2030.3875%2010.5816V4.00005C30.3875%203.06116%2031.1486%202.30005%2032.0875%202.30005Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M15.931%202.30005C16.8699%202.30005%2017.631%203.06116%2017.631%204.00005V10.5816C17.631%2011.5205%2016.8699%2012.2816%2015.931%2012.2816C14.9921%2012.2816%2014.231%2011.5205%2014.231%2010.5816V4.00005C14.231%203.06116%2014.9921%202.30005%2015.931%202.30005Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.39717%208.31408C9.44741%206.36511%2012.299%205.4585%2015.5419%205.4585H32.4765C35.7272%205.4585%2038.5806%206.36434%2040.6276%208.31572C42.6874%2010.2792%2043.7098%2013.0906%2043.7%2016.4472V34.6951C43.7%2038.0516%2042.6725%2040.8656%2040.6124%2042.8325C38.5644%2044.788%2035.7115%2045.7001%2032.458%2045.7001H15.5419C12.2888%2045.7001%209.43354%2044.7687%207.38529%2042.7835C5.32858%2040.7901%204.29999%2037.9421%204.29999%2034.5438V16.4445C4.29999%2013.0855%205.33379%2010.2755%207.39717%208.31408ZM9.7397%2010.7783C8.50046%2011.9564%207.69999%2013.7894%207.69999%2016.4445V34.5438C7.69999%2037.2543%208.50567%2039.1345%209.75158%2040.342C11.0059%2041.5578%2012.9217%2042.3001%2015.5419%2042.3001H32.458C35.0964%2042.3001%2037.0145%2041.5669%2038.2645%2040.3734C39.5025%2039.1914%2040.3%2037.3529%2040.3%2034.6951V16.4445L40.3%2016.4393C40.3081%2013.7829%2039.5147%2011.9521%2038.2817%2010.7767C37.0353%209.58858%2035.1178%208.8585%2032.4765%208.8585H15.5419C12.9115%208.8585%2010.9921%209.58781%209.7397%2010.7783Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const MessageSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20d%3D%22M30.3%2043.7C28.8%2043.7%2027.5%2043%2026.7%2041.7L19%2029.2L6.3%2021.3C4.9%2020.4%204.1%2018.8%204.3%2017.1C4.5%2015.4%205.7%2014.1%207.3%2013.6L38.2%204.49999C39.7%204.09999%2041.3%204.49999%2042.4%205.59999C43.5%206.69999%2043.9%208.29999%2043.5%209.79999L34.4%2040.7C33.9%2042.3%2032.6%2043.5%2030.9%2043.7C30.7%2043.7%2030.5%2043.7%2030.3%2043.7ZM22.4%2028.2L29.6%2039.9C29.9%2040.3%2030.3%2040.3%2030.4%2040.3C30.6%2040.3%2031%2040.2%2031.1%2039.7L40.2%208.79999C40.3%208.39999%2040.1%208.09999%2040%207.89999C39.9%207.79999%2039.6%207.59999%2039.2%207.69999L8.3%2016.8C7.8%2016.9%207.7%2017.3%207.7%2017.5C7.7%2017.7%207.7%2018.1%208.1%2018.3L20%2025.7L30.5%2015.1C31.2%2014.4%2032.2%2014.4%2032.9%2015.1C33.6%2015.8%2033.6%2016.8%2032.9%2017.5L22.4%2028.1V28.2Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const StaffSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20d%3D%22M24%2045.61C20.03%2045.61%207.95996%2045.61%207.95996%2038.01C7.95996%2030.41%2020.03%2030.46%2024%2030.46C27.97%2030.46%2040.04%2030.46%2040.04%2038.06C40.04%2045.66%2027.97%2045.61%2024%2045.61ZM24%2033.86C18.23%2033.86%2011.36%2034.58%2011.36%2038.01C11.36%2041.44%2018.23%2042.2%2024%2042.2C29.77%2042.2%2036.64%2041.48%2036.64%2038.05C36.64%2034.62%2029.77%2033.86%2024%2033.86Z%22%3E%3C%2Fpath%3E%3Cpath%20d%3D%22M24.0004%2027.1798C18.2804%2027.1598%2013.5404%2022.7298%2013.1404%2017.0998C13.1204%2016.8298%2013.1104%2016.5598%2013.1104%2016.2798C13.1104%2015.3398%2013.8704%2014.5898%2014.8104%2014.5898C15.7504%2014.5898%2016.5104%2015.3598%2016.5004%2016.2998C16.5004%2016.4898%2016.5004%2016.6798%2016.5204%2016.8598C16.8004%2020.7298%2020.0504%2023.7698%2023.9404%2023.7798C27.9004%2023.7798%2031.1804%2020.7398%2031.4704%2016.8498C31.4804%2016.6598%2031.4904%2016.4798%2031.4904%2016.2898C31.4904%2015.3498%2032.2503%2014.5898%2033.1903%2014.5898C34.1304%2014.5898%2034.8904%2015.3498%2034.8904%2016.2898C34.8904%2016.5598%2034.8804%2016.8398%2034.8604%2017.0998C34.4404%2022.7498%2029.6704%2027.1798%2024.0004%2027.1798Z%22%3E%3C%2Fpath%3E%3Cpath%20d%3D%22M33.17%2013.1799H14.83C14.07%2013.1799%2013.39%2012.8399%2012.96%2012.2599C12.23%2011.2499%2012.55%209.95991%2012.72%209.44991C12.76%209.32991%2012.81%209.21991%2012.88%209.10991C13.17%208.62991%2013.36%208.10991%2013.56%207.56991C14.65%204.57991%2016.02%202.45991%2023.8%202.40991H24.21C32%202.45991%2033.38%204.57991%2034.46%207.56991C34.66%208.11991%2034.85%208.63991%2035.14%209.10991C35.21%209.21991%2035.26%209.32991%2035.3%209.44991C35.47%209.95991%2035.79%2011.2499%2035.06%2012.2599C34.64%2012.8499%2033.96%2013.1799%2033.19%2013.1799H33.17ZM16.33%209.77991H31.67C31.51%209.40991%2031.38%209.04991%2031.26%208.71991C30.63%206.97991%2030.21%205.82991%2024.19%205.79991H23.8C17.79%205.83991%2017.37%206.97991%2016.74%208.71991C16.62%209.04991%2016.49%209.40991%2016.33%209.77991Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const ChartSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M14.7428%2018.7034C15.6817%2018.7034%2016.4428%2019.4645%2016.4428%2020.4034V34.1236C16.4428%2035.0625%2015.6817%2035.8236%2014.7428%2035.8236C13.804%2035.8236%2013.0428%2035.0625%2013.0428%2034.1236V20.4034C13.0428%2019.4645%2013.804%2018.7034%2014.7428%2018.7034Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M24.0762%2012.1382C25.015%2012.1382%2025.7762%2012.8993%2025.7762%2013.8382V34.1236C25.7762%2035.0625%2025.015%2035.8236%2024.0762%2035.8236C23.1373%2035.8236%2022.3762%2035.0625%2022.3762%2034.1236V13.8382C22.3762%2012.8993%2023.1373%2012.1382%2024.0762%2012.1382Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M33.2571%2025.9536C34.196%2025.9536%2034.9571%2026.7147%2034.9571%2027.6536V34.1236C34.9571%2035.0625%2034.196%2035.8236%2033.2571%2035.8236C32.3182%2035.8236%2031.5571%2035.0625%2031.5571%2034.1236V27.6536C31.5571%2026.7147%2032.3182%2025.9536%2033.2571%2025.9536Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M5.62078%205.9712C7.81577%203.6166%2010.9409%202.30005%2014.6286%202.30005H33.3714C37.0675%202.30005%2040.1936%203.61592%2042.3871%205.97201C44.5678%208.31436%2045.7%2011.5464%2045.7%2015.1704V32.8297C45.7%2036.4537%2044.5678%2039.6857%2042.3871%2042.0281C40.1936%2044.3842%2037.0675%2045.7001%2033.3714%2045.7001H14.6286C10.9325%2045.7001%207.80642%2044.3842%205.61289%2042.0281C3.43215%2039.6857%202.29999%2036.4537%202.29999%2032.8297V15.1704C2.29999%2011.5444%203.43815%208.31256%205.62078%205.9712ZM8.10776%208.2896C6.60945%209.89686%205.69999%2012.2502%205.69999%2015.1704V32.8297C5.69999%2035.752%206.60593%2038.105%208.10137%2039.7113C9.58403%2041.3038%2011.7722%2042.3%2014.6286%2042.3H33.3714C36.2277%2042.3%2038.416%2041.3038%2039.8986%2039.7113C41.3941%2038.105%2042.3%2035.752%2042.3%2032.8297V15.1704C42.3%2012.2481%2041.3941%209.89506%2039.8986%208.28879C38.416%206.69626%2036.2277%205.70005%2033.3714%205.70005H14.6286C11.7828%205.70005%209.59373%206.69558%208.10776%208.2896Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const DiscoverySVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M31.886%2016.1181C32.3333%2016.5654%2032.4952%2017.2241%2032.3063%2017.8279L29.1209%2028.0064C28.9545%2028.5382%2028.538%2028.9546%2028.0063%2029.1211L17.8278%2032.3064C17.224%2032.4954%2016.5653%2032.3334%2016.118%2031.8861C15.6706%2031.4388%2015.5087%2030.78%2015.6976%2030.1763L18.883%2019.9978C19.0494%2019.466%2019.4659%2019.0495%2019.9977%2018.8831L30.1762%2015.6978C30.7799%2015.5088%2031.4386%2015.6707%2031.886%2016.1181ZM21.8621%2021.8622L19.9127%2028.0913L26.1418%2026.1419L28.0912%2019.9128L21.8621%2021.8622Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M24.002%206.48008C14.3249%206.48008%206.48002%2014.3249%206.48002%2024.002C6.48002%2033.6792%2014.3249%2041.524%2024.002%2041.524C33.6791%2041.524%2041.524%2033.6792%2041.524%2024.002C41.524%2014.3249%2033.6791%206.48008%2024.002%206.48008ZM3.08002%2024.002C3.08002%2012.4472%2012.4471%203.08008%2024.002%203.08008C35.5569%203.08008%2044.924%2012.4472%2044.924%2024.002C44.924%2035.5569%2035.5569%2044.924%2024.002%2044.924C12.4471%2044.924%203.08002%2035.5569%203.08002%2024.002Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const TicketSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M27.6994%206.80054C28.6383%206.80054%2029.3994%207.56165%2029.3994%208.50054V13.3405C29.3994%2014.2794%2028.6383%2015.0405%2027.6994%2015.0405C26.7605%2015.0405%2025.9994%2014.2794%2025.9994%2013.3405V8.50054C25.9994%207.56165%2026.7605%206.80054%2027.6994%206.80054Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M27.6994%2033.8201C28.6383%2033.8201%2029.3994%2034.5812%2029.3994%2035.5201V39.5681C29.3994%2040.507%2028.6383%2041.2681%2027.6994%2041.2681C26.7605%2041.2681%2025.9994%2040.507%2025.9994%2039.5681V35.5201C25.9994%2034.5812%2026.7605%2033.8201%2027.6994%2033.8201Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M27.6994%2017.3071C28.6383%2017.3071%2029.3994%2018.0682%2029.3994%2019.0071V28.6491C29.3994%2029.588%2028.6383%2030.3491%2027.6994%2030.3491C26.7605%2030.3491%2025.9994%2029.588%2025.9994%2028.6491V19.0071C25.9994%2018.0682%2026.7605%2017.3071%2027.6994%2017.3071Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M2.30207%2014.5131C2.30244%209.95536%206.03758%206.30005%2010.5978%206.30005H37.4022C41.9624%206.30005%2045.6975%209.95535%2045.6979%2014.5131C45.6979%2014.5128%2045.6979%2014.5133%2045.6979%2014.5131L45.7%2019.7002C45.7002%2020.1511%2045.5211%2020.5837%2045.2023%2020.9027C44.8835%2021.2216%2044.451%2021.4008%2044%2021.4008C42.5085%2021.4008%2041.3466%2022.5786%2041.3466%2024.0021C41.3466%2025.4246%2042.5074%2026.6013%2044%2026.6013C44.9389%2026.6013%2045.7%2027.3624%2045.7%2028.3013V33.4863C45.7%2038.044%2041.9671%2041.7001%2037.4042%2041.7001H10.5957C6.03283%2041.7001%202.29999%2038.044%202.29999%2033.4863V28.3013C2.29999%2027.3624%203.0611%2026.6013%203.99999%2026.6013C5.49257%2026.6013%206.65335%2025.4246%206.65335%2024.0021C6.65335%2022.6662%205.58267%2021.5698%203.99999%2021.5698C3.54901%2021.5698%203.1165%2021.3906%202.79767%2021.0716C2.47884%2020.7526%202.29981%2020.3201%202.29999%2019.8691L2.30207%2014.5131ZM10.5978%209.70005C7.87418%209.70005%205.70207%2011.8742%205.70207%2014.5138L5.70056%2018.3972C8.1649%2019.0725%2010.0533%2021.1946%2010.0533%2024.0021C10.0533%2026.7509%208.20905%2029.0384%205.69999%2029.7622V33.4863C5.69999%2036.1263%207.87036%2038.3%2010.5957%2038.3H37.4042C40.1296%2038.3%2042.3%2036.1263%2042.3%2033.4863V29.7622C39.7909%2029.0384%2037.9466%2026.7509%2037.9466%2024.0021C37.9466%2021.2542%2039.7901%2018.9648%2042.2994%2018.2402L42.2979%2014.5144C42.2979%2011.8749%2040.1258%209.70005%2037.4022%209.70005H10.5978Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const CogSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cg%20clip-path%3D%22url%28%23clip0_9015_1171%29%22%3E%3Cpath%20d%3D%22M25.24%2044.9201H22.73C19.68%2044.9201%2017.2%2042.4401%2017.2%2039.3901C17.2%2039.0601%2017.1%2038.7201%2016.93%2038.4301C16.64%2037.9201%2016.18%2037.5701%2015.64%2037.4201C15.11%2037.2801%2014.52%2037.3501%2014.05%2037.6301C12.75%2038.3601%2011.22%2038.5401%209.81002%2038.1401C8.41002%2037.7401%207.19002%2036.7801%206.49002%2035.5001L5.24002%2033.3501C3.72002%2030.7201%204.62002%2027.3501%207.25002%2025.8301C7.91002%2025.4501%208.31002%2024.7501%208.31002%2023.9901C8.31002%2023.2301%207.90002%2022.5301%207.25002%2022.1501C4.63002%2020.6301%203.73002%2017.2501%205.25002%2014.6201L6.61002%2012.3901C8.11002%209.79008%2011.49%208.88008%2014.12%2010.3901C14.44%2010.5801%2014.78%2010.6701%2015.12%2010.6801C16.26%2010.6801%2017.21%209.74008%2017.23%208.58008C17.23%207.16008%2017.81%205.73008%2018.83%204.70008C19.85%203.67008%2021.28%203.08008%2022.73%203.08008H25.24C26.72%203.08008%2028.17%203.69008%2029.2%204.75008C30.24%205.82008%2030.81%207.28008%2030.76%208.76008C30.76%209.04008%2030.86%209.38008%2031.04%209.67008C31.33%2010.1601%2031.79%2010.5101%2032.33%2010.6501C32.87%2010.7901%2033.45%2010.7101%2033.93%2010.4301C36.59%208.91008%2039.97%209.82008%2041.48%2012.4601L42.73%2014.6201C42.77%2014.6801%2042.8%2014.7501%2042.82%2014.8101C44.18%2017.4001%2043.27%2020.6601%2040.72%2022.1501C40.39%2022.3401%2040.13%2022.6001%2039.95%2022.9201C39.66%2023.4101%2039.58%2024.0001%2039.73%2024.5401C39.87%2025.0801%2040.23%2025.5501%2040.72%2025.8201C42%2026.5601%2042.92%2027.7501%2043.3%2029.1801C43.68%2030.5801%2043.47%2032.1101%2042.74%2033.3701L41.41%2035.5901C39.89%2038.1901%2036.51%2039.0901%2033.89%2037.5801C33.58%2037.4001%2033.22%2037.3001%2032.86%2037.2901C32.32%2037.2501%2031.8%2037.5101%2031.4%2037.9101C31%2038.3101%2030.78%2038.8401%2030.78%2039.4101C30.77%2042.4601%2028.29%2044.9301%2025.25%2044.9301L25.24%2044.9201ZM15.11%2033.9601C15.59%2033.9601%2016.06%2034.0201%2016.53%2034.1501C17.93%2034.5301%2019.15%2035.4701%2019.88%2036.7301C20.35%2037.5201%2020.61%2038.4401%2020.62%2039.3901C20.62%2040.5801%2021.57%2041.5301%2022.75%2041.5301H25.26C26.43%2041.5301%2027.38%2040.5801%2027.39%2039.4101C27.39%2037.9701%2027.97%2036.5401%2029%2035.5001C30.03%2034.4601%2031.44%2033.8901%2032.9%2033.8901H32.93C33.89%2033.9201%2034.8%2034.1701%2035.6%2034.6301C36.61%2035.2101%2037.92%2034.8701%2038.5%2033.8601L39.83%2031.6401C40.1%2031.1801%2040.18%2030.5901%2040.03%2030.0601C39.88%2029.5101%2039.53%2029.0601%2039.04%2028.7801C37.78%2028.0601%2036.84%2026.8301%2036.46%2025.4301C36.08%2024.0201%2036.29%2022.4901%2037.02%2021.2401C37.49%2020.4101%2038.19%2019.7101%2039.03%2019.2301C40.02%2018.6501%2040.36%2017.3601%2039.79%2016.3501C39.76%2016.3001%2039.74%2016.2501%2039.71%2016.2001L38.55%2014.1801C37.97%2013.1701%2036.67%2012.8101%2035.65%2013.4001C34.42%2014.1301%2032.89%2014.3401%2031.49%2013.9801C30.07%2013.6101%2028.87%2012.7101%2028.12%2011.4401C27.64%2010.6401%2027.38%209.71008%2027.37%208.77008C27.39%208.13008%2027.17%207.57008%2026.77%207.16008C26.37%206.75008%2025.82%206.52008%2025.25%206.52008H22.74C22.18%206.52008%2021.64%206.75008%2021.25%207.14008C20.85%207.54008%2020.63%208.07008%2020.64%208.64008C20.6%2011.6801%2018.12%2014.1201%2015.11%2014.1201C14.15%2014.1101%2013.22%2013.8501%2012.41%2013.3701C11.42%2012.8001%2010.12%2013.1501%209.53002%2014.1701L8.17002%2016.4001C7.61002%2017.3801%207.95002%2018.6801%208.96002%2019.2601C10.66%2020.2401%2011.72%2022.0701%2011.72%2024.0401C11.72%2026.0101%2010.66%2027.8401%208.96002%2028.8301C7.96002%2029.4101%207.61002%2030.7001%208.19002%2031.7101L9.45002%2033.8801C9.74002%2034.4001%2010.2%2034.7701%2010.74%2034.9201C11.28%2035.0701%2011.87%2035.0001%2012.36%2034.7301C13.18%2034.2501%2014.14%2034.0001%2015.1%2034.0001L15.11%2033.9601Z%22%3E%3C%2Fpath%3E%3Cpath%20d%3D%22M24%2030.98C20.16%2030.98%2017.03%2027.85%2017.03%2024.01C17.03%2020.17%2020.16%2017.04%2024%2017.04C27.84%2017.04%2030.97%2020.17%2030.97%2024.01C30.97%2027.85%2027.84%2030.98%2024%2030.98ZM24%2020.43C22.03%2020.43%2020.43%2022.03%2020.43%2024C20.43%2025.97%2022.03%2027.57%2024%2027.57C25.97%2027.57%2027.57%2025.97%2027.57%2024C27.57%2022.03%2025.97%2020.43%2024%2020.43Z%22%3E%3C%2Fpath%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_9015_1171%22%3E%3Crect%20width%3D%2238.97%22%20height%3D%2241.84%22%20transform%3D%22translate%284.51001%203.08008%29%22%3E%3C%2Frect%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

const CustomerSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.82326%2034.4476C7.4164%2034.8739%207.19901%2035.3658%207.19901%2036.0376C7.19901%2036.7055%207.41603%2037.1918%207.82283%2037.6135C8.27016%2038.0773%209.00874%2038.5197%2010.1126%2038.8889C12.3377%2039.6329%2015.5283%2039.9136%2019.183%2039.9136C22.8547%2039.9136%2026.0435%2039.6227%2028.2615%2038.8705C29.3615%2038.4973%2030.0973%2038.0514%2030.5433%2037.5847C30.9498%2037.1593%2031.167%2036.6685%2031.167%2035.9976C31.167%2035.3305%2030.9501%2034.8436%2030.5425%2034.4209C30.0946%2033.9563%2029.3554%2033.5128%2028.2514%2033.1427C26.0263%2032.3967%2022.8357%2032.1136%2019.183%2032.1136C15.5108%2032.1136%2012.3223%2032.406%2010.1049%2033.1597C9.00511%2033.5335%208.26933%2033.9802%207.82326%2034.4476ZM9.01065%2029.9406C11.7798%2028.9993%2015.4332%2028.7136%2019.183%2028.7136C22.9083%2028.7136%2026.5598%2028.9896%2029.3322%2029.919C30.7269%2030.3867%2032.0253%2031.0601%2032.9903%2032.0612C33.9957%2033.1041%2034.567%2034.4318%2034.567%2035.9976C34.567%2037.5598%2034.0012%2038.8875%2033.0014%2039.9337C32.0409%2040.9387%2030.747%2041.6177%2029.3536%2042.0903C26.5845%2043.0295%2022.9313%2043.3136%2019.183%2043.3136C15.4577%2043.3136%2011.8064%2043.0403%209.03438%2042.1134C7.63978%2041.647%206.34111%2040.9747%205.37582%2039.9741C4.36999%2038.9314%203.79901%2037.6037%203.79901%2036.0376C3.79901%2034.4754%204.36437%2033.1473%205.36357%2032.1003C6.32357%2031.0943%207.61717%2030.4142%209.01065%2029.9406Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M19.183%208.19956C15.2774%208.19956%2012.111%2011.3649%2012.111%2015.2696C12.111%2019.1742%2015.2774%2022.3396%2019.183%2022.3396H19.2416C23.1282%2022.3235%2026.2675%2019.1612%2026.2531%2015.2759L26.2531%2015.2696C26.2531%2011.3647%2023.0864%208.19956%2019.183%208.19956ZM8.711%2015.2696C8.711%209.48617%2013.4006%204.79956%2019.183%204.79956C24.9627%204.79956%2029.6516%209.48497%2029.6531%2015.2669C29.6725%2021.0309%2025.0142%2025.7181%2019.2513%2025.7395L19.245%2025.7396H19.183C13.4006%2025.7396%208.711%2021.0529%208.711%2015.2696Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M31.4386%208.45198C31.5906%207.52547%2032.4648%206.89757%2033.3913%207.04953C37.3336%207.69609%2040.3402%2011.1149%2040.3402%2015.2391L40.3402%2015.2422C40.3327%2019.4264%2037.231%2022.8805%2033.2028%2023.4466C32.273%2023.5772%2031.4134%2022.9295%2031.2827%2021.9997C31.1521%2021.07%2031.7999%2020.2103%2032.7296%2020.0797C35.1049%2019.7458%2036.935%2017.7047%2036.9402%2015.2376C36.9395%2012.8065%2035.1663%2010.7861%2032.8411%2010.4047C31.9146%2010.2527%2031.2867%209.37848%2031.4386%208.45198Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M35.5094%2029.214C35.6477%2028.2853%2036.5126%2027.6446%2037.4413%2027.7829C39.0844%2028.0277%2040.6876%2028.4621%2041.9207%2029.2713C43.2392%2030.1365%2044.1588%2031.462%2044.1588%2033.2544C44.1588%2034.4403%2043.7521%2035.4765%2043.016%2036.3084C42.3114%2037.1047%2041.3729%2037.6399%2040.3945%2038.0116C39.5168%2038.345%2038.535%2037.9038%2038.2016%2037.0261C37.8682%2036.1484%2038.3095%2035.1666%2039.1872%2034.8332C39.8567%2034.5788%2040.2522%2034.3011%2040.4697%2034.0554C40.6556%2033.8453%2040.7588%2033.6105%2040.7588%2033.2544C40.7588%2032.8068%2040.5955%2032.4683%2040.0554%2032.114C39.4301%2031.7036%2038.3992%2031.3631%2036.9404%2031.1458C36.0118%2031.0075%2035.3711%2030.1426%2035.5094%2029.214Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const InfoCircleSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M6.90586%207.23692C8.96253%205.03043%2011.888%203.80029%2015.3302%203.80029H32.6682C36.1182%203.80029%2039.045%205.0297%2041.1008%207.23756C43.1439%209.43173%2044.2002%2012.4542%2044.2002%2015.8323V32.1683C44.2002%2035.5464%2043.1439%2038.5689%2041.1005%2040.7631C39.0443%2042.971%2036.117%2044.2003%2032.6662%2044.2003H15.3302C11.8801%2044.2003%208.95371%2042.9709%206.89835%2040.7628C4.85579%2038.5686%203.80017%2035.5461%203.80017%2032.1683V15.8323C3.80017%2012.4523%204.86155%209.43015%206.90586%207.23692ZM9.39298%209.55517C8.03279%2011.0144%207.20017%2013.1583%207.20017%2015.8323V32.1683C7.20017%2034.8444%208.02956%2036.988%209.38699%2038.4462C10.7316%2039.8907%2012.7202%2040.8003%2015.3302%2040.8003H32.6662C35.2773%2040.8003%2037.267%2039.8906%2038.6124%2038.446C39.9704%2036.9877%2040.8002%2034.8442%2040.8002%2032.1683V15.8323C40.8002%2013.1564%2039.9704%2011.0129%2038.6125%209.55453C37.2673%208.10989%2035.2782%207.20029%2032.6682%207.20029H15.3302C12.7303%207.20029%2010.7408%208.10915%209.39298%209.55517Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M23.9894%2022.3003C24.9283%2022.3003%2025.6894%2023.0614%2025.6894%2024.0003V32.0003C25.6894%2032.9392%2024.9283%2033.7003%2023.9894%2033.7003C23.0505%2033.7003%2022.2894%2032.9392%2022.2894%2032.0003V24.0003C22.2894%2023.0614%2023.0505%2022.3003%2023.9894%2022.3003Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M22.2798%2016.4087C22.2798%2015.4699%2023.0409%2014.7087%2023.9798%2014.7087H23.9998C24.9387%2014.7087%2025.6998%2015.4699%2025.6998%2016.4087C25.6998%2017.3476%2024.9387%2018.1087%2023.9998%2018.1087H23.9798C23.0409%2018.1087%2022.2798%2017.3476%2022.2798%2016.4087Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const HomeSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M18.9708%204.0384C21.895%201.7206%2026.0472%201.7206%2028.9714%204.0384L28.9754%204.04155L42.123%2014.5268C43.7203%2015.754%2044.6722%2017.6393%2044.6998%2019.6524L44.7%2019.6757V37.1237C44.7%2041.8764%2040.813%2045.7001%2036.0542%2045.7001H32.2061C32.1929%2045.7001%2032.1798%2045.6999%2032.1666%2045.6996C29.9214%2045.6475%2028.1006%2043.8255%2028.101%2041.5619C28.101%2041.5617%2028.101%2041.5621%2028.101%2041.5619V35.4094C28.101%2034.7969%2027.5947%2034.2712%2026.9342%2034.2712H21.1688C20.5137%2034.278%2020.0144%2034.8011%2020.0144%2035.4094V41.5429C20.0144%2041.7038%2019.9921%2041.8595%2019.9503%2042.0071C19.7175%2044.097%2017.9317%2045.7001%2015.7939%2045.7001H11.9458C7.18701%2045.7001%203.29999%2041.8764%203.29999%2037.1237V19.6948L3.30007%2019.678C3.32%2017.6609%204.27352%2015.7704%205.87714%2014.5456L18.9708%204.0384ZM16.6144%2041.1815V35.4094C16.6144%2035.4094%2016.6144%2035.4094%2016.6144%2035.4094C16.6144%2032.899%2018.6565%2030.8878%2021.1507%2030.8713L21.162%2030.8712L26.9342%2030.8712C29.4402%2030.8712%2031.501%2032.887%2031.501%2035.4094V41.5619C31.5009%2041.9429%2031.8088%2042.2829%2032.2312%2042.3H36.0542C38.9675%2042.3%2041.3%2039.9664%2041.3%2037.1237V19.6886C41.2836%2018.724%2040.8248%2017.8134%2040.0441%2017.2172C40.0347%2017.21%2040.0253%2017.2026%2040.016%2017.1952L26.8594%206.7029C26.8588%206.70241%2026.8582%206.70192%2026.8576%206.70143C25.1719%205.36671%2022.7726%205.36626%2021.0864%206.70006L7.98801%2017.211C7.97572%2017.2209%207.96329%2017.2306%207.95074%2017.2401C7.1695%2017.8321%206.71181%2018.7416%206.69999%2019.7041V37.1237C6.69999%2039.9664%209.03247%2042.3%2011.9458%2042.3H15.7939C16.242%2042.3%2016.5759%2041.945%2016.5759%2041.5429C16.5759%2041.4189%2016.5892%2041.298%2016.6144%2041.1815Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const CatalogSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20d%3D%22M24%2043.72C22.86%2043.72%2021.71%2043.43%2020.7%2042.83C18.12%2041.33%2014.08%2039.48%209.46999%2039.15C5.94999%2038.9%203.29999%2036.1%203.29999%2032.64V10.81C3.29999%208.96%204.08999%207.2%205.46999%205.96C6.85999%204.71%208.72999%204.11%2010.6%204.32C15.51%204.86%2019.73%206.82%2022.4%208.37C23.4%208.95%2024.6%208.95%2025.6%208.37C28.27%206.82%2032.49%204.86%2037.4%204.32C39.26%204.11%2041.14%204.72%2042.53%205.97C43.91%207.2%2044.7%208.97%2044.7%2010.82V32.65C44.7%2036.11%2042.05%2038.9%2038.53%2039.16C33.93%2039.49%2029.88%2041.34%2027.3%2042.84C26.28%2043.43%2025.14%2043.73%2024%2043.73V43.72ZM9.87999%207.68C9.08999%207.68%208.32999%207.97%207.73999%208.49C7.06999%209.09%206.69999%209.91%206.69999%2010.81V32.64C6.69999%2034.29%207.98999%2035.63%209.70999%2035.75C14.96%2036.13%2019.51%2038.2%2022.4%2039.88C23.4%2040.46%2024.6%2040.46%2025.6%2039.88C28.49%2038.21%2033.04%2036.13%2038.29%2035.75C40.01%2035.63%2041.3%2034.29%2041.3%2032.64V10.81C41.3%209.92%2040.93%209.09%2040.26%208.49C39.59%207.88%2038.67%207.6%2037.77%207.69C33.45%208.16%2029.69%209.92%2027.3%2011.3C25.26%2012.48%2022.73%2012.48%2020.69%2011.3C18.3%209.91%2014.54%208.16%2010.22%207.69C10.1%207.68%209.97999%207.67%209.86999%207.67L9.87999%207.68Z%22%3E%3C%2Fpath%3E%3Cpath%20d%3D%22M24%2034.9901C23.06%2034.9901%2022.3%2034.2301%2022.3%2033.2901V19.0401C22.3%2018.1001%2023.06%2017.3401%2024%2017.3401C24.94%2017.3401%2025.7%2018.1001%2025.7%2019.0401V33.2901C25.7%2034.2301%2024.94%2034.9901%2024%2034.9901Z%22%3E%3C%2Fpath%3E%3Cpath%20d%3D%22M16.36%2030.59C16.15%2030.59%2015.94%2030.55%2015.73%2030.47L11.06%2028.62C10.19%2028.27%209.75998%2027.29%2010.11%2026.41C10.46%2025.54%2011.44%2025.11%2012.32%2025.46L16.99%2027.31C17.86%2027.66%2018.29%2028.64%2017.94%2029.52C17.68%2030.19%2017.04%2030.59%2016.36%2030.59ZM16.36%2020.98C16.15%2020.98%2015.94%2020.94%2015.73%2020.86L11.06%2019.01C10.19%2018.66%209.75998%2017.68%2010.11%2016.8C10.46%2015.93%2011.44%2015.5%2012.32%2015.85L16.99%2017.7C17.86%2018.05%2018.29%2019.03%2017.94%2019.91C17.68%2020.58%2017.04%2020.98%2016.36%2020.98Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const ShopSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M14%2019.3C14.9389%2019.3%2015.7%2020.0612%2015.7%2021C15.7%2022.9167%2017.143%2024.3%2018.7178%2024.3H19.2821C20.857%2024.3%2022.3%2022.9167%2022.3%2021C22.3%2020.0612%2023.0611%2019.3%2024%2019.3C24.9389%2019.3%2025.7%2020.0612%2025.7%2021C25.7%2024.6057%2022.9181%2027.7%2019.2821%2027.7H18.7178C15.0818%2027.7%2012.3%2024.6057%2012.3%2021C12.3%2020.0612%2013.0611%2019.3%2014%2019.3Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M24%2019.3C24.9389%2019.3%2025.7%2020.0612%2025.7%2021C25.7%2022.9168%2027.143%2024.3%2028.7178%2024.3H29.2822C30.857%2024.3%2032.3%2022.9168%2032.3%2021C32.3%2020.0612%2033.0611%2019.3%2034%2019.3C34.9389%2019.3%2035.7%2020.0612%2035.7%2021C35.7%2024.6057%2032.9181%2027.7%2029.2822%2027.7H28.7178C25.0818%2027.7%2022.3%2024.6057%2022.3%2021C22.3%2020.0612%2023.0611%2019.3%2024%2019.3Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M9.11783%2014.7C7.20313%2014.7%205.69999%2016.2184%205.69999%2018.0316V21.3598C5.69999%2022.957%207.0246%2024.3%208.71783%2024.3H9.28214C10.976%2024.3%2012.3%2022.9577%2012.3%2021.3611C12.3%2020.4223%2013.0611%2019.6611%2014%2019.6611C14.9389%2019.6611%2015.7%2020.4223%2015.7%2021.3611C15.7%2024.8896%2012.7991%2027.7%209.28214%2027.7H8.71783C5.20022%2027.7%202.29999%2024.8877%202.29999%2021.3598V18.0316C2.29999%2014.2858%205.38062%2011.3%209.11783%2011.3H38.8822C42.6192%2011.3%2045.7%2014.2858%2045.7%2018.0316V21.3598C45.7%2024.8877%2042.7998%2027.7%2039.2822%2027.7H38.7178C35.2009%2027.7%2032.3%2024.8896%2032.3%2021.3611C32.3%2020.4223%2033.0611%2019.6611%2034%2019.6611C34.9389%2019.6611%2035.7%2020.4223%2035.7%2021.3611C35.7%2022.9577%2037.024%2024.3%2038.7178%2024.3H39.2822C40.9753%2024.3%2042.3%2022.957%2042.3%2021.3598V18.0316C42.3%2016.2184%2040.7967%2014.7%2038.8822%2014.7H9.11783Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M40%2024.3C40.9389%2024.3%2041.7%2025.0612%2041.7%2026V39.2102C41.7%2042.2559%2039.2124%2044.7001%2036.1756%2044.7001H11.8222C8.78682%2044.7001%206.29999%2042.2553%206.29999%2039.2102V26.0042C6.29999%2025.0653%207.0611%2024.3042%207.99999%2024.3042C8.93887%2024.3042%209.69999%2025.0653%209.69999%2026.0042V39.2102C9.69999%2040.3502%2010.6372%2041.3%2011.8222%2041.3H36.1756C37.3634%2041.3%2038.3%2040.3495%2038.3%2039.2102V26C38.3%2025.0612%2039.0611%2024.3%2040%2024.3Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M17.3%2037.5354C17.3%2033.9397%2020.4596%2031.3%2024%2031.3C27.5403%2031.3%2030.7%2033.9397%2030.7%2037.5354V43C30.7%2043.9389%2029.9389%2044.7%2029%2044.7C28.0611%2044.7%2027.3%2043.9389%2027.3%2043V37.5354C27.3%2036.1219%2025.9821%2034.7%2024%2034.7C22.0177%2034.7%2020.7%2036.1219%2020.7%2037.5354V43C20.7%2043.9389%2019.9389%2044.7%2019%2044.7C18.0611%2044.7%2017.3%2043.9389%2017.3%2043V37.5354Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M11.8222%207.70005C10.8188%207.70005%209.69999%208.66884%209.69999%2010.2579V13C9.69999%2013.9389%208.93887%2014.7%207.99999%2014.7C7.0611%2014.7%206.29999%2013.9389%206.29999%2013V10.2579C6.29999%207.14555%208.60516%204.30005%2011.8222%204.30005H36.1756C39.3941%204.30005%2041.7%207.14486%2041.7%2010.2579V13C41.7%2013.9389%2040.9389%2014.7%2040%2014.7C39.0611%2014.7%2038.3%2013.9389%2038.3%2013V10.2579C38.3%208.66953%2037.1817%207.70005%2036.1756%207.70005H11.8222Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const MoneySVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M13.723%205.66293L17.7358%2012.7335C22.0389%2013.58%2026.3341%2013.5557%2030.6376%2012.6605L33.744%205.9189C31.8979%206.05333%2029.6279%206.20005%2028.5%206.20005C27.7297%206.20005%2026.8326%205.97466%2026.0394%205.73905C25.2997%205.51935%2024.4802%205.23615%2023.6852%204.96142C23.5841%204.92649%2023.4834%204.89169%2023.3833%204.85718C22.4736%204.54351%2021.5994%204.2479%2020.8067%204.02973C19.99%203.80495%2019.3887%203.70005%2019%203.70005C18.3628%203.70005%2017.1838%204.06403%2015.793%204.66997C15.0432%204.99662%2014.3198%205.35328%2013.723%205.66293ZM31.0962%2016.0371C26.4655%2016.9695%2021.8298%2016.9881%2017.1987%2016.0929C15.9879%2018.0281%2013.547%2021.8971%2011.7956%2024.4594C10.7182%2026.0356%209.64723%2028.3485%209.05562%2030.7235C8.45275%2033.1437%208.42027%2035.3321%209.06239%2036.8304C9.85526%2038.6804%2010.9087%2040.4667%2012.967%2041.834C15.0462%2043.2152%2018.3522%2044.3%2023.8922%2044.3C29.4699%2044.3%2032.8941%2043.326%2035.052%2041.9916C37.1571%2040.69%2038.2281%2038.9397%2038.8871%2036.9625C39.5007%2035.1218%2039.4276%2032.9752%2038.8531%2030.7348C38.2808%2028.5026%2037.2378%2026.2883%2036.0583%2024.401C34.2591%2021.5224%2032.1546%2017.8851%2031.0962%2016.0371ZM14.5224%2013.9599L10.1568%206.26756C9.57192%205.23697%209.89911%203.88222%2010.9888%203.27368C11.6498%202.90454%2012.9842%202.18499%2014.435%201.55292C15.8%200.958283%2017.5734%200.300049%2019%200.300049C19.8613%200.300049%2020.8225%200.507645%2021.7089%200.751621C22.6193%201.0022%2023.5888%201.33159%2024.4917%201.64291C24.5932%201.67793%2024.6938%201.71268%2024.7935%201.7471C25.6015%202.02621%2026.3448%202.28295%2027.0075%202.47979C27.7924%202.71294%2028.2703%202.80005%2028.5%202.80005C29.9491%202.80005%2033.7513%202.51403%2035.5136%202.37425C37.2014%202.24039%2038.3845%203.97251%2037.6851%205.49021L33.8015%2013.9186C34.7378%2015.5589%2037.0239%2019.5309%2038.9415%2022.5991C40.262%2024.7118%2041.469%2027.2475%2042.1466%2029.8903C42.8221%2032.5249%2042.9991%2035.3783%2042.1127%2038.0376C41.2718%2040.5604%2039.7889%2043.0601%2036.8401%2044.8835C33.9441%2046.6741%2029.8144%2047.7001%2023.8922%2047.7001C17.9321%2047.7001%2013.8991%2046.5349%2011.0857%2044.6661C8.25141%2042.7834%206.8587%2040.3197%205.9373%2038.1697C4.86515%2035.668%205.08267%2032.6064%205.75644%2029.9016C6.44148%2027.1516%207.67377%2024.4645%208.98868%2022.5407C10.8066%2019.8811%2013.4104%2015.7407%2014.5224%2013.9599Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M19.7021%2023.498C20.366%2022.8341%2021.4424%2022.8341%2022.1062%2023.498L23.9447%2025.3364C24.01%2025.4017%2024.0689%2025.471%2024.1213%2025.5435C24.1738%2025.471%2024.2326%2025.4018%2024.2979%2025.3365L26.1364%2023.498C26.8003%2022.8341%2027.8767%2022.8341%2028.5406%2023.498C29.2044%2024.1619%2029.2044%2025.2383%2028.5406%2025.9022L26.5%2027.5L27.8%2027.3C28.7389%2027.3%2029.5%2028.0612%2029.5%2029C29.5%2029.9389%2028.7389%2030.7%2027.8%2030.7L25.7%2030.5L25.9%2031.3H27.8C28.7389%2031.3%2029.5%2032.0612%2029.5%2033C29.5%2033.9389%2028.7389%2034.7%2027.8%2034.7L25.7%2034.6107L25.9%2037C25.9%2037.9389%2025.1389%2038.7001%2024.2%2038.7001C23.2611%2038.7001%2022.5%2037.9389%2022.5%2037L22.7%2034.6107L20.2%2034.7001C19.2611%2034.7001%2018.5%2033.9389%2018.5%2033C18.5%2032.0612%2019.2611%2031.3%2020.2%2031.3H22.5L22.7%2030.5L20.2%2030.7C19.2611%2030.7%2018.5%2029.9389%2018.5%2029C18.5%2028.0612%2019.2611%2027.3%2020.2%2027.3L21.5%2027.5L19.7021%2025.9021C19.0382%2025.2382%2019.0382%2024.1619%2019.7021%2023.498Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const OrganizationSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.07735%2010.4803C7.07735%207.17228%209.75809%204.48755%2013.0681%204.48755H34.9368C38.2466%204.48755%2040.9276%207.17223%2040.9276%2010.4803V40.1125H42C42.9389%2040.1125%2043.7%2040.8737%2043.7%2041.8125C43.7%2042.7514%2042.9389%2043.5126%2042%2043.5126H28.7049C28.6813%2043.5135%2028.6576%2043.514%2028.6338%2043.514C28.61%2043.514%2028.5863%2043.5135%2028.5627%2043.5126H19.4383C19.4147%2043.5135%2019.391%2043.514%2019.3672%2043.514C19.3434%2043.514%2019.3197%2043.5135%2019.2961%2043.5126H6C5.06112%2043.5126%204.3%2042.7514%204.3%2041.8125C4.3%2040.8737%205.06112%2040.1125%206%2040.1125H7.07735V10.4803ZM10.4773%2040.1125H17.6672V31.1172C17.6672%2028.9941%2019.3887%2027.2766%2021.5078%2027.2766H26.4914C28.6113%2027.2766%2030.3338%2028.9932%2030.3338%2031.1172V40.1125H37.5276V10.4803C37.5276%209.04806%2036.3669%207.88755%2034.9368%207.88755H13.0681C11.6379%207.88755%2010.4773%209.04802%2010.4773%2010.4803V40.1125ZM26.9338%2040.1125V31.1172C26.9338%2030.8749%2026.7375%2030.6766%2026.4914%2030.6766H21.5078C21.2644%2030.6766%2021.0672%2030.8739%2021.0672%2031.1172V40.1125H26.9338ZM17.2883%2017.1854C17.2883%2016.0371%2018.2189%2015.1047%2019.3688%2015.1047C20.5179%2015.1047%2021.4496%2016.0361%2021.4496%2017.1854C21.4496%2018.3347%2020.5179%2019.2661%2019.3688%2019.2661C18.2189%2019.2661%2017.2883%2018.3337%2017.2883%2017.1854ZM26.552%2017.1854C26.552%2016.0366%2027.4832%2015.1047%2028.6326%2015.1047C29.7809%2015.1047%2030.7134%2016.0355%2030.7134%2017.1854C30.7134%2018.3353%2029.7809%2019.2661%2028.6326%2019.2661C27.4831%2019.2661%2026.552%2018.3342%2026.552%2017.1854Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const ItemsetSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20d%3D%22M15.6148%203.51598C16.5068%203.44281%2017.2177%203.91189%2017.6078%204.44842C18.9455%206.28851%2021.3819%207.32735%2024.0003%207.32735C26.6187%207.32735%2029.0551%206.28851%2030.3927%204.44842C30.7825%203.91226%2031.4937%203.44232%2032.3868%203.51613C33.4122%203.60089%2034.4971%203.96671%2035.5096%204.41866C36.5429%204.87989%2037.6064%205.47908%2038.6139%206.11838C40.6213%207.39211%2042.5232%208.89998%2043.673%209.9909C44.2604%2010.5482%2044.4827%2011.3547%2044.3229%2012.1008L42.7818%2019.2922C42.5576%2020.3386%2041.6329%2021.0861%2040.5627%2021.0861H38.1846H36.79C36.79%2021.0861%2034.9983%2021.0861%2034.9983%2019.2922C34.9983%2017.4982%2036.79%2017.6819%2037.0498%2017.6819H39.6454L40.8568%2012.0285C39.8478%2011.1374%2038.3602%209.98914%2036.79%208.99276C35.8747%208.41193%2034.9606%207.90156%2034.1221%207.52727C33.5738%207.28254%2033.0979%207.1143%2032.7019%207.01438C30.536%209.55693%2027.1888%2010.7316%2024.0003%2010.7316C20.8108%2010.7316%2017.4626%209.55628%2015.2969%207.01229C14.8864%207.11311%2014.3902%207.28447%2013.8187%207.5339C12.9557%207.91053%2012.0156%208.42301%2011.0856%209.00307C9.48569%2010.001%208.0292%2011.1271%207.13176%2011.9725L8.3552%2017.6819H10.9508C12.2042%2017.6819%2013.2203%2018.698%2013.2203%2019.9514V40.9441H20.5765C20.5765%2040.9441%2021.9052%2041.2062%2021.9052%2042.7774C21.9052%2044.3486%2020.3341%2044.3486%2020.3341%2044.3486C15.681%2044.3486%2012.0855%2044.3483%2012.0855%2044.3483C10.8321%2044.3483%209.81604%2043.3322%209.81604%2042.0788V21.0861H7.43786C6.36771%2021.0861%205.44298%2020.3386%205.21875%2019.2922L3.67191%2012.0736C3.52584%2011.3919%203.69513%2010.6326%204.22261%2010.0688C5.30122%208.91584%207.25043%207.38306%209.284%206.11466C10.3129%205.47288%2011.4026%204.87405%2012.457%204.41386C13.4894%203.9633%2014.59%203.60005%2015.6148%203.51598Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M27.6941%2023.4778C28.4446%2022.858%2029.3997%2022.5797%2030.3405%2022.5797H39.8929C40.8338%2022.5797%2041.7888%2022.858%2042.5394%2023.4778C43.3177%2024.1206%2043.7918%2025.0681%2043.7918%2026.1719L43.7908%2027.828C43.7908%2027.8276%2043.7908%2027.8283%2043.7908%2027.828C43.7905%2028.9314%2043.3163%2029.8795%2042.5382%2030.5221C42.4737%2030.5754%2042.4076%2030.6261%2042.3402%2030.6744V38.3607C42.3402%2040.1295%2041.4325%2041.7746%2039.9357%2042.7175C39.9356%2042.7175%2039.9357%2042.7175%2039.9357%2042.7175L33.6836%2046.6564C30.8941%2048.4138%2027.251%2047.9519%2024.9883%2045.5542C21.8672%2042.2465%2022.744%2036.8767%2026.7552%2034.7338L28.2657%2033.9269V30.9102C28.065%2030.7999%2027.8731%2030.6708%2027.6929%2030.5221C26.9146%2029.8793%2026.4404%2028.9318%2026.4404%2027.828L26.4416%2026.1719C26.4416%2026.1717%2026.4416%2026.1721%2026.4416%2026.1719C26.4416%2026.1717%2026.4416%2026.171%2026.4416%2026.1708C26.4419%2025.0674%2026.916%2024.1204%2027.6941%2023.4778ZM31.4081%2031.4201V34.8032C31.4081%2035.4236%2031.0663%2035.9933%2030.5195%2036.2855L28.2358%2037.5055C28.2358%2037.5055%2028.2359%2037.5055%2028.2358%2037.5055C26.0516%2038.6723%2025.5741%2041.5964%2027.2737%2043.3975C28.5059%2044.7032%2030.4896%2044.9547%2032.0086%2043.9977L33.8505%2042.8373C33.5308%2042.0088%2033.3555%2041.1088%2033.3555%2040.1698C33.3555%2036.6151%2035.8583%2033.645%2039.1979%2032.9255V31.4201H31.4081ZM39.1979%2036.1988C37.6165%2036.8239%2036.4979%2038.3662%2036.4979%2040.1698C36.4979%2040.4916%2036.5332%2040.8044%2036.6002%2041.1049L38.2607%2040.0588C38.8439%2039.6914%2039.1979%2039.0503%2039.1979%2038.3607V36.1988ZM29.6154%2025.998C29.6022%2026.0259%2029.5839%2026.0783%2029.5839%2026.1719L29.5828%2027.828C29.5828%2027.8279%2029.5828%2027.8281%2029.5828%2027.828C29.5828%2027.9214%2029.601%2027.974%2029.6142%2028.0019C29.628%2028.0308%2029.6506%2028.0634%2029.6939%2028.0991C29.7858%2028.1751%2029.9947%2028.2778%2030.3394%2028.2778H39.8918C40.2364%2028.2778%2040.4453%2028.1751%2040.5373%2028.0991C40.5805%2028.0634%2040.6032%2028.0308%2040.6169%2028.0018C40.6301%2027.974%2040.6484%2027.9215%2040.6484%2027.828L40.6495%2026.1719C40.6495%2026.1717%2040.6495%2026.1721%2040.6495%2026.1719C40.6494%2026.0787%2040.6312%2026.0258%2040.618%2025.998C40.6043%2025.969%2040.5816%2025.9364%2040.5384%2025.9007C40.4465%2025.8248%2040.2376%2025.722%2039.8929%2025.722H30.3405C29.9958%2025.722%2029.787%2025.8248%2029.695%2025.9007C29.6518%2025.9364%2029.6291%2025.9691%2029.6154%2025.998Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const ItemSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M15.5843%203.51735C16.4796%203.44391%2017.1931%203.91472%2017.5846%204.45322C18.9272%206.30007%2021.3725%207.34272%2024.0006%207.34272C26.6286%207.34272%2029.0739%206.30007%2030.4165%204.45322C30.8077%203.91509%2031.5215%203.44342%2032.4179%203.5175C33.4471%203.60257%2034.5359%203.96974%2035.5522%204.42335C36.5893%204.88627%2037.6567%205.48766%2038.6679%206.12931C40.6826%207.40773%2042.5916%208.92114%2043.7456%2010.0161C44.3352%2010.5754%2044.5583%2011.3849%2044.3978%2012.1337L42.8512%2019.3515C42.6261%2020.4018%2041.698%2021.1521%2040.6239%2021.1521H38.237V42.2219C38.237%2043.4799%2037.2172%2044.4998%2035.9592%2044.4998H12.042C10.784%2044.4998%209.7642%2043.48%209.7642%2042.2219V21.1521H7.37728C6.3032%2021.1521%205.37507%2020.4018%205.15002%2019.3515L3.5975%2012.1064C3.45089%2011.4223%203.6208%2010.6602%204.15021%2010.0943C5.2328%208.93705%207.18917%207.39864%209.23021%206.12558C10.2629%205.48144%2011.3566%204.88041%2012.4149%204.41854C13.4511%203.96631%2014.5557%203.60172%2015.5843%203.51735ZM15.2652%207.02651C14.8532%207.1277%2014.3552%207.2997%2013.7816%207.55003C12.9154%207.92805%2011.9718%208.44242%2011.0384%209.02461C9.43264%2010.0262%207.9708%2011.1564%207.07006%2012.005L8.29799%2017.7354H10.9031C12.1611%2017.7354%2013.1809%2018.7552%2013.1809%2020.0132V41.083H34.8202V20.0132C34.8202%2018.7552%2035.8401%2017.7354%2037.0981%2017.7354H39.7032L40.9191%2012.0611C39.9064%2011.1668%2038.4133%2010.0143%2036.8373%209.01426C35.9186%208.43129%2035.0012%207.91905%2034.1596%207.54339C33.6093%207.29776%2033.1316%207.1289%2032.7342%207.02861C30.5604%209.5805%2027.2009%2010.7595%2024.0006%2010.7595C20.7994%2010.7595%2017.4389%209.57985%2015.2652%207.02651Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const CartSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M0.149994%204.99991C0.149994%203.97818%200.978268%203.1499%202%203.1499H6.65864C7.51653%203.1499%208.26187%203.73968%208.45909%204.57459L9.8995%2010.6722L41.3683%2010.4172C41.3687%2010.4172%2041.3692%2010.4172%2041.3696%2010.4172C41.3694%2010.4172%2041.3698%2010.4172%2041.3696%2010.4172C44.3691%2010.3911%2046.532%2013.2881%2045.6539%2016.1562C45.6537%2016.1569%2045.6535%2016.1575%2045.6533%2016.1582L41.3795%2030.1646C40.4749%2033.1364%2037.8626%2035.2624%2034.7727%2035.5498L18.5854%2037.0504C18.5853%2037.0504%2018.5855%2037.0504%2018.5854%2037.0504C15.0729%2037.3765%2011.8607%2035.0635%2011.0494%2031.6339L5.19474%206.84991H2C0.978268%206.84991%200.149994%206.02163%200.149994%204.99991ZM10.7719%2014.3652L14.6501%2030.7822C14.65%2030.7821%2014.6501%2030.7824%2014.6501%2030.7822C15.0377%2032.4198%2016.5705%2033.5216%2018.2432%2033.3663L34.43%2031.8657C36.0259%2031.7173%2037.3734%2030.6196%2037.8398%2029.0871L42.1158%2015.0734C42.2622%2014.5963%2041.9013%2014.1125%2041.4019%2014.117L10.7719%2014.3652ZM13.2549%2041.4044C13.2549%2039.8367%2014.5252%2038.5645%2016.0944%2038.5645C17.6621%2038.5645%2018.9346%2039.8352%2018.9346%2041.4044C18.9346%2042.9736%2017.6619%2044.2442%2016.0944%2044.2442C14.5255%2044.2442%2013.2549%2042.9722%2013.2549%2041.4044ZM34.1884%2041.4044C34.1884%2039.8367%2035.4589%2038.5645%2037.028%2038.5645C38.5955%2038.5645%2039.8682%2039.8351%2039.8682%2041.4044C39.8682%2042.9737%2038.5953%2044.2442%2037.028%2044.2442C35.4592%2044.2442%2034.1884%2042.9722%2034.1884%2041.4044Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const StockSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M5.58721%207.39997C6.99896%204.29412%2010.0957%202.30005%2013.5074%202.30005H34.8005C38.3332%202.30005%2041.5152%204.43627%2042.8528%207.70594L45.0523%2013.0824C45.48%2014.128%2045.7%2015.2468%2045.7%2016.3765V37C45.7%2041.8049%2041.8049%2045.7001%2037%2045.7001H11C6.19513%2045.7001%202.3%2041.8049%202.3%2037V16.5163C2.3%2015.2744%202.5659%2014.0468%203.07981%2012.9162L5.58721%207.39997ZM13.5074%205.70005C11.429%205.70005%209.54248%206.91483%208.68245%208.8069L6.5827%2013.4263H22.3V5.70005H13.5074ZM25.7%205.70005V13.4263H41.5195L39.7059%208.99329C38.8911%207.00142%2036.9526%205.70005%2034.8005%205.70005H25.7ZM42.3%2016.8263H24.032C24.0213%2016.8265%2024.0107%2016.8266%2024%2016.8266C23.9893%2016.8266%2023.9787%2016.8265%2023.968%2016.8263H5.7V37C5.7%2039.9272%208.07289%2042.3%2011%2042.3H37C39.9271%2042.3%2042.3%2039.9272%2042.3%2037V16.8263ZM26.7749%2024.2432C26.7749%2022.3249%2028.3294%2020.7701%2030.2478%2020.7701H34.8293C36.745%2020.7701%2038.3047%2022.322%2038.3047%2024.2432V28.8248C38.3047%2030.7467%2036.7462%2032.2999%2034.8293%2032.2999H30.2478C28.3282%2032.2999%2026.7749%2030.7438%2026.7749%2028.8248V24.2432ZM30.2478%2024.1701C30.2075%2024.1701%2030.1749%2024.2024%2030.1749%2024.2432V28.8248C30.1749%2028.8688%2030.2087%2028.8999%2030.2478%2028.8999H34.8293C34.8715%2028.8999%2034.9047%2028.8659%2034.9047%2028.8248V24.2432C34.9047%2024.2053%2034.8728%2024.1701%2034.8293%2024.1701H30.2478ZM11.4189%2027.6439C11.4189%2026.705%2012.18%2025.9439%2013.1189%2025.9439H15.7784C16.7172%2025.9439%2017.4784%2026.705%2017.4784%2027.6439C17.4784%2028.5828%2016.7172%2029.3439%2015.7784%2029.3439H13.1189C12.18%2029.3439%2011.4189%2028.5828%2011.4189%2027.6439ZM11.4189%2033.951C11.4189%2033.0121%2012.18%2032.251%2013.1189%2032.251H19.7762C20.7151%2032.251%2021.4762%2033.0121%2021.4762%2033.951C21.4762%2034.8899%2020.7151%2035.651%2019.7762%2035.651H13.1189C12.18%2035.651%2011.4189%2034.8899%2011.4189%2033.951Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const getNaviSchema = ({
  rootLinks,
  nestedLinks
}) => {
  return [
    ...rootLinks,
    {
      path: "",
      origin: "",
      params: void 0,
      name: "\u3059\u3079\u3066",
      children: [...nestedLinks]
    }
  ];
};
const rewriteExternalOrigins = ({
  rootLinks,
  nestedLinks,
  options
}) => {
  if (!options?.externalOrigins)
    return;
  options.externalOrigins.forEach((externalOrigin) => {
    const { serviceType, stageEnv } = externalOrigin;
    return externalOrigin.paths.forEach((target) => {
      const r = rootLinks.flatMap((s) => s.path.match(target) ? s : []);
      if (r) {
        r.forEach((s) => s.origin = getServiceOrigin(serviceType, stageEnv));
      }
      const n = nestedLinks.flatMap((s) => s.path.match(target) ? s : []);
      if (n) {
        n.forEach((s) => s.origin = getServiceOrigin(serviceType, stageEnv));
      }
    });
  });
};
const setRelatedPaths = ({
  rootLinks,
  nestedLinks,
  options
}) => {
  if (!options?.relatedPaths)
    return;
  options.relatedPaths.forEach((r) => {
    const { path, relatedTargets } = r;
    rootLinks.forEach((s) => {
      if (s.path.match(path)) {
        s.relatedPaths = relatedTargets;
      }
    });
    nestedLinks.forEach((s) => {
      if (s.path.match(path)) {
        s.relatedPaths = relatedTargets;
      }
    });
  });
};
const runOptions = ({
  rootLinks,
  nestedLinks,
  options
}) => {
  rewriteExternalOrigins({
    rootLinks,
    nestedLinks,
    options
  });
  setRelatedPaths({
    rootLinks,
    nestedLinks,
    options
  });
};
const getDefaultSettings = ({
  serviceType,
  stageEnv,
  params,
  businessEntity,
  options,
  serviceSiteOrigin
}) => {
  const currentSiteOrigin = getServiceOrigin(serviceType, stageEnv);
  switch (serviceType) {
    case "reserve": {
      const rootLinks = defaultReserveRootLinks({
        origin: currentSiteOrigin,
        params
      });
      const nestedLinks = defaultReserveNestedLinks({
        origin: currentSiteOrigin,
        params,
        serviceSiteOrigin
      });
      runOptions({
        rootLinks,
        nestedLinks,
        options
      });
      return {
        rootLinks,
        nestedLinks
      };
    }
    case "retail": {
      const rootLinks = defaultRetailRootLinks({
        origin: currentSiteOrigin,
        params,
        businessEntity,
        serviceSiteOrigin
      });
      const nestedLinks = defaultRetailNestedLinks({
        origin: currentSiteOrigin,
        params,
        businessEntity,
        serviceSiteOrigin
      });
      runOptions({
        rootLinks,
        nestedLinks,
        options
      });
      return {
        rootLinks,
        nestedLinks
      };
    }
    default:
      throw new Error("Invalid service type");
  }
};
const defaultReserveRootLinks = ({
  origin,
  params
}) => {
  return [
    {
      name: "\u30DB\u30FC\u30E0",
      path: "/m",
      origin,
      params
    },
    {
      name: "\u30AB\u30EC\u30F3\u30C0\u30FC",
      path: "/dashboard/calendar",
      origin,
      params
    },
    {
      name: "\u4E88\u7D04\u30DA\u30FC\u30B8",
      path: "/dashboard/resources",
      origin,
      params
    },
    {
      name: "\u56DE\u6570\u5238\u30FB\u6708\u8B1D",
      path: "/m/products",
      origin,
      params
    },
    {
      name: "\u9867\u5BA2",
      path: "/dashboard/customers",
      origin,
      params
    },
    {
      name: "\u30E1\u30C3\u30BB\u30FC\u30B8\u914D\u4FE1",
      path: "/m/mail/sent",
      origin,
      params
    },
    {
      name: "\u30B9\u30BF\u30C3\u30D5",
      path: `/dashboard/staff`,
      origin,
      params,
      iconPath: CustomerSVG
    },
    {
      name: "\u5206\u6790",
      path: "/dashboard/analytics/reservation",
      origin,
      params
    },
    {
      name: "\u4E88\u7D04\u30B5\u30A4\u30C8\u8A2D\u5B9A",
      path: "/dashboard/site",
      origin,
      params
    },
    {
      name: "\u8A2D\u5B9A",
      path: "/dashboard/settings",
      origin,
      params
    }
  ];
};
const defaultReserveNestedLinks = ({
  origin,
  params,
  serviceSiteOrigin
}) => {
  return [
    {
      name: "\u30DB\u30FC\u30E0",
      path: "/m",
      origin,
      params,
      iconPath: HomeSVG
    },
    {
      name: "\u30AB\u30EC\u30F3\u30C0\u30FC",
      path: "/dashboard/calendar",
      origin,
      params,
      iconPath: CalendarSVG
    },
    {
      name: "\u4E88\u7D04\u30DA\u30FC\u30B8",
      path: "/dashboard/resources",
      origin,
      iconPath: CatalogSVG
    },
    {
      name: "\u56DE\u6570\u5238\u30FB\u6708\u8B1D",
      path: "/m/products",
      origin,
      params,
      iconPath: TicketSVG
    },
    {
      name: "\u9867\u5BA2",
      path: "/dashboard/customers",
      origin,
      params,
      iconPath: CustomerSVG
    },
    {
      name: "\u30E1\u30C3\u30BB\u30FC\u30B8\u914D\u4FE1",
      path: "/m/mail/sent",
      origin,
      params,
      iconPath: MessageSVG
    },
    {
      name: "\u30B9\u30BF\u30C3\u30D5",
      path: `/dashboard/staff`,
      origin,
      params,
      iconPath: StaffSVG
    },
    {
      name: "\u5206\u6790",
      path: "/dashboard/analytics/reservation",
      origin,
      params,
      iconPath: ChartSVG
    },
    {
      name: "\u4E88\u7D04\u30B5\u30A4\u30C8\u8A2D\u5B9A",
      path: "/dashboard/site",
      origin,
      params,
      iconPath: DiscoverySVG
    },
    {
      name: "\u8A2D\u5B9A",
      path: "/dashboard/settings",
      origin,
      params,
      iconPath: CogSVG
    },
    {
      name: "\u3088\u304F\u3042\u308B\u8CEA\u554F",
      path: "/hc/ja",
      origin: "https://reserve-faq.stores.jp",
      iconPath: InfoCircleSVG,
      externalIcon: true,
      targetBlank: true
    },
    {
      name: "\u81EA\u5206\u306E\u30B5\u30A4\u30C8\u3092\u898B\u308B",
      path: "",
      origin: serviceSiteOrigin,
      iconPath: BrowserSVG,
      externalIcon: true,
      targetBlank: true
    }
  ];
};
const defaultRetailRootLinks = ({
  origin,
  businessEntity,
  params
}) => {
  return [
    {
      name: "\u30DB\u30FC\u30E0",
      path: "/mobile_order",
      origin,
      params
    },
    {
      name: "\u30AA\u30FC\u30C0\u30FC",
      path: "/orders",
      origin,
      params
    },
    {
      name: "\u30AB\u30BF\u30ED\u30B0",
      path: "/catalogs",
      origin,
      params
    },
    {
      name: "\u30A2\u30A4\u30C6\u30E0\u30BB\u30C3\u30C8",
      path: "/mobile_order/item_sets",
      origin,
      params
    },
    {
      name: "\u30A2\u30A4\u30C6\u30E0",
      path: "/pos/items",
      origin,
      params
    },
    {
      name: "\u5728\u5EAB",
      path: "/pos/inventories",
      origin,
      params
    },
    {
      name: "\u9867\u5BA2",
      path: "/customers",
      origin,
      params
    },
    {
      name: "\u30E1\u30FC\u30EB\u30DE\u30AC\u30B8\u30F3",
      path: "/emails",
      origin,
      params
    },
    {
      name: "\u30AF\u30FC\u30DD\u30F3",
      path: "/coupons",
      origin,
      params
    },
    {
      name: "\u30B5\u30A4\u30C8\u8A2D\u5B9A",
      path: "/mobile_order/store",
      origin,
      params
    },
    {
      name: "\u4E8B\u696D\u8005",
      path: `/account`,
      origin,
      params
    },
    {
      name: "\u5E97\u8217",
      path: `/business_entities/${businessEntity.organizationId}/shops`,
      origin,
      params
    },
    {
      name: "\u5F93\u696D\u54E1",
      path: `/business_entities/${businessEntity.organizationId}/employees`,
      origin,
      params
    },
    {
      name: "\u5165\u91D1",
      path: "/mobile_order/remittances",
      origin,
      params
    }
  ];
};
const defaultRetailNestedLinks = ({
  origin,
  businessEntity,
  params,
  serviceSiteOrigin
}) => {
  return [
    {
      name: "\u30DB\u30FC\u30E0",
      path: "/mobile_order",
      origin,
      params,
      iconPath: HomeSVG
    },
    {
      name: "\u30AA\u30FC\u30C0\u30FC",
      path: "/orders",
      origin,
      params,
      iconPath: CartSVG
    },
    {
      name: "\u30AB\u30BF\u30ED\u30B0",
      path: "/catalogs",
      origin,
      params,
      iconPath: CatalogSVG
    },
    {
      name: "\u30A2\u30A4\u30C6\u30E0\u30BB\u30C3\u30C8",
      path: "/mobile_order/item_sets",
      origin,
      params,
      iconPath: ItemsetSVG
    },
    {
      name: "\u30A2\u30A4\u30C6\u30E0",
      path: "/pos/items",
      origin,
      params,
      iconPath: ItemSVG
    },
    {
      name: "\u5728\u5EAB",
      path: "/pos/inventories",
      origin,
      params,
      iconPath: StockSVG
    },
    {
      name: "\u9867\u5BA2",
      path: "/customers",
      origin,
      params,
      iconPath: CustomerSVG
    },
    {
      name: "\u30E1\u30FC\u30EB\u30DE\u30AC\u30B8\u30F3",
      path: "/emails",
      origin,
      params,
      iconPath: MessageSVG
    },
    {
      name: "\u30AF\u30FC\u30DD\u30F3",
      path: "/coupons",
      origin,
      params,
      iconPath: TicketSVG
    },
    {
      name: "\u30B5\u30A4\u30C8\u8A2D\u5B9A",
      path: "/mobile_order/store",
      origin,
      params,
      iconPath: DiscoverySVG
    },
    {
      name: "\u4E8B\u696D\u8005",
      path: `/account`,
      origin,
      params,
      iconPath: OrganizationSVG
    },
    {
      name: "\u5E97\u8217",
      path: `/business_entities/${businessEntity.organizationId}/shops`,
      origin,
      params,
      iconPath: ShopSVG
    },
    {
      name: "\u5F93\u696D\u54E1",
      path: `/business_entities/${businessEntity.organizationId}/employees`,
      origin,
      params,
      iconPath: ProfileSVG
    },
    {
      name: "\u5165\u91D1",
      path: "/mobile_order/remittances",
      origin,
      params,
      iconPath: MoneySVG
    },
    {
      name: "\u81EA\u5206\u306E\u30B5\u30A4\u30C8\u3092\u898B\u308B",
      path: "",
      origin: serviceSiteOrigin,
      iconPath: BrowserSVG,
      externalIcon: true,
      targetBlank: true
    },
    {
      name: "\u3088\u304F\u3042\u308B\u8CEA\u554F",
      path: "/hc/ja",
      origin: "https://faq.stores.jp",
      iconPath: InfoCircleSVG,
      externalIcon: true,
      targetBlank: true
    }
  ];
};

const BarsSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M6.29999%2038C6.29999%2037.0612%207.0611%2036.3%207.99999%2036.3H40C40.9389%2036.3%2041.7%2037.0612%2041.7%2038C41.7%2038.9389%2040.9389%2039.7%2040%2039.7H7.99999C7.0611%2039.7%206.29999%2038.9389%206.29999%2038Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M6.29999%2010C6.29999%209.06116%207.0611%208.30005%207.99999%208.30005H40C40.9389%208.30005%2041.7%209.06116%2041.7%2010C41.7%2010.9389%2040.9389%2011.7%2040%2011.7H7.99999C7.0611%2011.7%206.29999%2010.9389%206.29999%2010Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M6.29999%2024C6.29999%2023.0612%207.0611%2022.3%207.99999%2022.3H40C40.9389%2022.3%2041.7%2023.0612%2041.7%2024C41.7%2024.9389%2040.9389%2025.7%2040%2025.7H7.99999C7.0611%2025.7%206.29999%2024.9389%206.29999%2024Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const ExternalIconSVG = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%230A0A0A%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.3478%2010.0451C9.17442%208.08553%2011.7677%207%2014.8013%207H20.7622C21.7011%207%2022.4622%207.76112%2022.4622%208.7C22.4622%209.63888%2021.7011%2010.4%2020.7622%2010.4H14.8013C12.61%2010.4%2010.9526%2011.1643%209.83482%2012.3634C8.70466%2013.5758%207.99998%2015.3704%207.99998%2017.6351V31.7648C7.99998%2034.0317%208.70196%2035.8261%209.82961%2037.0374C10.9445%2038.235%2012.6009%2039%2014.8013%2039H29.7952C31.9967%2039%2033.654%2038.2349%2034.7695%2037.0372C35.8977%2035.8258%2036.6%2034.0315%2036.6%2031.7648V26.6698C36.6%2025.7309%2037.3611%2024.9698%2038.3%2024.9698C39.2389%2024.9698%2040%2025.7309%2040%2026.6698V31.7648C40%2034.7337%2039.0711%2037.4071%2037.2576%2039.3544C35.4313%2041.3153%2032.8363%2042.4%2029.7952%2042.4H14.8013C11.7609%2042.4%209.1666%2041.3152%207.34101%2039.3541C5.52821%2037.4067%204.59998%2034.7335%204.59998%2031.7648V17.6351C4.59998%2014.6643%205.53351%2011.9913%207.3478%2010.0451Z%22%3E%3C%2Fpath%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M32.0368%206.4C31.0979%206.4%2030.3368%205.63888%2030.3368%204.7C30.3368%203.76112%2031.0979%203%2032.0368%203H42.3C43.2389%203%2044%203.76112%2044%204.7V14.9633C44%2015.9022%2043.2389%2016.6633%2042.3%2016.6633C41.3611%2016.6633%2040.6%2015.9022%2040.6%2014.9633V8.80416L27.5021%2021.9021C26.8382%2022.566%2025.7618%2022.566%2025.0979%2021.9021C24.434%2021.2382%2024.434%2020.1618%2025.0979%2019.4979L38.1958%206.4H32.0368Z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const normalizePath = (path) => {
  return path.replace(/\/+$/, "").split("?")[0];
};
const StandLegacyNavi$1 = ({
  schema,
  renderRightContentsEl,
  renderLeftContentsEl,
  serviceType,
  pageTitle,
  currentPathname,
  businessEntity,
  info: { onClick: onInfoClick, overrideEl: overrideElNotice },
  user: { onClick: onUserClick, overrideEl: overrideElUser },
  CustomLink
}) => {
  const { displayName } = businessEntity;
  const normalizedCurrentPathname = normalizePath(currentPathname || "");
  const hasChildren = (item) => item.children && item.children.length > 0;
  const isNavigationItem = (item) => !hasChildren(item) && item.path;
  const isHoverMenuItem = (item) => hasChildren(item) && !item.path;
  const isCurrentPathname = (item) => {
    if (!normalizedCurrentPathname)
      return false;
    if (normalizedCurrentPathname === item.path) {
      return true;
    }
    return item.relatedPaths && item.relatedPaths.some((p) => normalizedCurrentPathname.includes(p));
  };
  const currentServiceOrigins = getServiceOrigins(serviceType);
  const isCurrentSiteOrigin = (origin) => {
    return Object.entries(currentServiceOrigins).some(([, v]) => v === origin);
  };
  const handleAllClick = () => {
    const root = document.getElementById("stand-navi-root");
    if (root) {
      root.classList.toggle("show-nested-routes");
    }
  };
  const handleBarsClick = () => {
    const body = document.body;
    const root = document.getElementById("stand-navi-root");
    if (body) {
      body.style.overflow = body.style.overflow === "hidden" ? "" : "hidden";
    }
    if (root) {
      root.classList.toggle("show-navigation");
    }
  };
  const handleCustomLinkClick = () => {
    const root = document.getElementById("stand-navi-root");
    if (root) {
      root.classList.remove("show-navigation");
      root.classList.remove("show-nested-routes");
    }
  };
  schema = schema || getNaviSchema({ rootLinks: [], nestedLinks: [] });
  const RootRoutesList = () => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex max-h-64 list-none flex-wrap justify-evenly overflow-hidden p-none text-heading-md", children: schema.filter(isNavigationItem).map((item) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    "li",
    {
      className: "box-border flex h-64 shrink items-center justify-center",
      "data-stand-navi-list-item": true,
      children: CustomLink && isCurrentSiteOrigin(item.origin) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        CustomLink,
        {
          href: `${item.path}${item.params ? `?${item.params}` : ""}`,
          target: item.targetBlank ? "_blank" : "",
          className: `block px-sm py-xs font-bold text-label-primary no-underline ${isCurrentPathname(item) ? "rounded-lg bg-surface-quaternary" : ""}`,
          children: item.name
        }
      ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          href: isCurrentSiteOrigin(item.origin) ? `${item.path}${item.params ? `?${item.params}` : ""}` : `${item.origin}${item.path}${item.params ? `?${item.params}` : ""}`,
          target: item.targetBlank ? "_blank" : "",
          className: `block px-sm py-xs font-bold text-label-primary no-underline ${isCurrentPathname(item) ? "rounded-lg bg-surface-quaternary" : ""}`,
          children: item.name
        }
      )
    },
    item.path
  )) }) });
  const NestedRoutesList = () => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex h-auto flex-none items-center justify-center text-body-lg pc:text-heading-md", children: schema.filter(isHoverMenuItem).map((item) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "li",
    {
      className: "box-border flex h-64 shrink items-center justify-center",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "button",
          {
            type: "button",
            onClick: handleAllClick,
            className: "flex items-center justify-center rounded-lg py-xs pl-sm pr-xs font-bold hover:cursor-pointer hover:bg-surface-quaternary group-[.show-navigation]/sp:hidden group-[.show-nested-routes]/pc:bg-surface-quaternary",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "", children: item.name }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center px-0.5", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                "img",
                {
                  className: "block align-middle",
                  width: 16,
                  src: ChevronSVG
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "hidden w-full bg-surface-primary group-[.show-nested-routes]/pc:absolute group-[.show-nested-routes]/pc:left-none group-[.show-nested-routes]/pc:top-4xl group-[.show-nested-routes]/pc:block group-[.show-navigation]/sp:grid", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute z-1 hidden h-screen w-full bg-[black] opacity-[0.2] pc:block" }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative z-5 hidden bg-white py-md pl-lg pc:flex", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "basis-3/4 text-13 text-label-secondary", children: serviceType === "reserve" ? "\u4E88\u7D04\u306E\u6A5F\u80FD" : serviceType === "retail" ? "\u30E2\u30D0\u30A4\u30EB\u30AA\u30FC\u30C0\u30FC\u306E\u6A5F\u80FD" : "" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "basis-1/4 text-13 text-label-secondary", children: serviceType === "retail" ? "\u4ED6\u306E\u30D7\u30ED\u30C0\u30AF\u30C8" : "" })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "ul",
            {
              className: `z-5 box-border w-full gap-x-lg bg-white px-lg pb-[300px] group-[.show-navigation]/sp:absolute group-[.show-nested-routes]/pc:relative group-[.show-navigation]/sp:left-none group-[.show-navigation]/sp:top-4xl group-[.show-navigation]/sp:mt-[-1px] group-[.show-navigation]/sp:grid group-[.show-nested-routes]/pc:grid group-[.show-navigation]/sp:h-[100svh] group-[.show-nested-routes]/pc:grid-flow-col group-[.show-nested-routes]/pc:items-center group-[.show-nested-routes]/pc:justify-center group-[.show-navigation]/sp:overflow-y-auto group-[.show-navigation]/sp:px-md pc:pb-[108px] ${serviceType === "retail" ? "group-[.show-nested-routes]/pc:grid-cols-4 group-[.show-nested-routes]/pc:grid-rows-6" : "group-[.show-nested-routes]/pc:grid-cols-3 group-[.show-nested-routes]/pc:grid-rows-5"}`,
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "box-border block pb-md pt-[12px] pc:hidden", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "max-w-[320px] truncate font-bold", children: displayName }) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "block pc:hidden", children: renderLeftContentsEl() }),
                item.children.map((child, index) => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: (() => {
                  const children = /* @__PURE__ */ jsxRuntimeExports.jsxs(
                    "li",
                    {
                      className: "box-border flex size-full items-center justify-start p-md",
                      children: [
                        child.iconPath && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mr-sm", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                          "img",
                          {
                            className: "block align-middle",
                            width: 28,
                            src: child.iconPath
                          }
                        ) }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: child.name }),
                        child.externalIcon && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ml-md", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                          "img",
                          {
                            className: "block align-middle",
                            width: 20,
                            src: ExternalIconSVG
                          }
                        ) })
                      ]
                    },
                    child.path
                  );
                  if (CustomLink && isCurrentSiteOrigin(child.origin)) {
                    return /* @__PURE__ */ jsxRuntimeExports.jsx(
                      CustomLink,
                      {
                        "data-id": index + 1,
                        href: `${child.path}${child.params ? `?${child.params}` : ""}`,
                        target: child.targetBlank ? "_blank" : "",
                        onClick: handleCustomLinkClick,
                        className: `box-border h-full border-x-0 border-b border-t-0 border-solid border-border-tertiary text-label-primary no-underline hover:bg-surface-quaternary first-of-type:pc:border-t ${isCurrentPathname(child) ? "bg-surface-quaternary" : ""} ${serviceType === "retail" ? "pc:data-[id=13]:border-t pc:data-[id=17]:border-b-0 pc:data-[id=18]:border-b-0 pc:data-[id=19]:border-t pc:data-[id=7]:border-t" : "pc:data-[id=11]:border-t pc:data-[id=16]:border-t pc:data-[id=6]:border-t"}`,
                        children
                      }
                    );
                  }
                  return /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "a",
                    {
                      "data-id": index + 1,
                      href: isCurrentSiteOrigin(child.origin) ? `${child.path}${child.params ? `?${child.params}` : ""}` : `${child.origin}${child.path}${child.params ? `?${child.params}` : ""}`,
                      target: child.targetBlank ? "_blank" : "",
                      className: `box-border h-full border-x-0 border-b border-t-0 border-solid border-border-tertiary text-label-primary no-underline hover:bg-surface-quaternary first-of-type:pc:border-t ${isCurrentPathname(child) ? "bg-surface-quaternary" : ""} ${serviceType === "retail" ? "pc:data-[id=13]:border-t pc:data-[id=17]:border-b-0 pc:data-[id=18]:border-b-0 pc:data-[id=19]:border-t pc:data-[id=7]:border-t" : "pc:data-[id=11]:border-t pc:data-[id=16]:border-t pc:data-[id=6]:border-t"}`,
                      children
                    }
                  );
                })() })),
                serviceType === "retail" && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: (() => {
                  if (CustomLink) {
                    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "block pb-xs pl-md pt-lg pc:hidden", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-13 text-label-secondary", children: "\u4ED6\u306E\u30D7\u30ED\u30C0\u30AF\u30C8" }) }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        CustomLink,
                        {
                          href: "/pos",
                          className: `box-border h-full border-x-0 border-b border-t-0 border-solid border-border-tertiary font-bold text-label-primary no-underline hover:bg-surface-quaternary pc:col-start-4 pc:col-end-4 pc:row-start-1 pc:row-end-1 pc:border-t ${isCurrentPathname({ path: "/pos" }) ? "bg-surface-quaternary" : ""}`,
                          children: /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "box-border flex size-full items-center justify-start p-md", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "font-bold", children: "\u30EC\u30B8" }) }),
                          target: ""
                        }
                      ),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        CustomLink,
                        {
                          href: "/",
                          className: `box-border h-full border-x-0 border-b border-t-0 border-solid border-border-tertiary font-bold text-label-primary no-underline hover:bg-surface-quaternary pc:col-start-4 pc:col-end-4 pc:row-start-2 pc:row-end-2 ${isCurrentPathname({ path: "/" }) ? "bg-surface-quaternary" : ""}`,
                          children: /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "box-border flex size-full items-center justify-start p-md", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "font-bold", children: "\u30CD\u30C3\u30C8\u30B7\u30E7\u30C3\u30D7" }) }),
                          target: ""
                        }
                      )
                    ] });
                  }
                  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "block pb-xs pl-md pt-lg pc:hidden", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-13 text-label-secondary", children: "\u4ED6\u306E\u30D7\u30ED\u30C0\u30AF\u30C8" }) }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "a",
                      {
                        href: "/pos",
                        className: `box-border h-full border-x-0 border-b border-t-0 border-solid border-border-tertiary font-bold text-label-primary no-underline hover:bg-surface-quaternary pc:col-start-4 pc:col-end-4 pc:row-start-1 pc:row-end-1 pc:border-t ${isCurrentPathname({ path: "/pos" }) ? "bg-surface-quaternary" : ""}`,
                        children: /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "box-border flex size-full items-center justify-start p-md", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "font-bold", children: "\u30EC\u30B8" }) })
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "a",
                      {
                        href: "/",
                        className: `box-border h-full border-x-0 border-b border-t-0 border-solid border-border-tertiary font-bold text-label-primary no-underline hover:bg-surface-quaternary pc:col-start-4 pc:col-end-4 pc:row-start-2 pc:row-end-2 ${isCurrentPathname({ path: "/" }) ? "bg-surface-quaternary" : ""}`,
                        children: /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "box-border flex size-full items-center justify-start p-md", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "font-bold", children: "\u30CD\u30C3\u30C8\u30B7\u30E7\u30C3\u30D7" }) })
                      }
                    )
                  ] });
                })() })
              ]
            }
          )
        ] })
      ]
    },
    item.path
  )) }) });
  const HamburgerToggleButton = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("button", { onClick: handleBarsClick, className: "mr-xs h-[40px] w-40", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex h-[40px] w-40 items-center justify-center transition-all group-[.show-navigation]/sp:hidden", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "block align-middle", width: 24, src: BarsSVG }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "hidden h-[40px] w-40 items-center justify-center transition-all group-[.show-navigation]/sp:flex", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "block align-middle", width: 24, src: CloseSVG }) })
  ] });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "nav",
    {
      id: "stand-navi-root",
      className: "group/pc group/sp relative box-border flex h-64 w-full items-center justify-between border-x-0 border-b border-t-0 border-solid border-b-border-tertiary bg-surface-primary px-md text-label-primary antialiased pc:px-lg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "hidden max-w-[200px] shrink-0 items-center pc:flex", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: renderLeftContentsEl() }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "w-full", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "box-border flex grow pc:hidden", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex shrink-0 items-center", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(HamburgerToggleButton, {}),
            /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "text-body-lg font-bold group-[.show-navigation]/sp:hidden", children: pageTitle }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "hidden group-[.show-navigation]/sp:flex", children: /* @__PURE__ */ jsxRuntimeExports.jsx(NestedRoutesList, {}) })
          ] }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { className: "box-border hidden pc:flex pc:grow pc:justify-center", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-[64px] shrink" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(RootRoutesList, {}),
            /* @__PURE__ */ jsxRuntimeExports.jsx(NestedRoutesList, {}),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-[64px] shrink" })
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex shrink-0 items-center justify-end", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: renderRightContentsEl() }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ml-xs", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-xs", children: [
            overrideElNotice ? overrideElNotice() : /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                className: "box-border hidden rounded-full border border-solid border-border-tertiary p-xs group-[.show-navigation]/sp:block pc:block",
                onClick: onInfoClick,
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "img",
                  {
                    className: "block align-middle",
                    width: 22,
                    height: 22,
                    src: InfoCircleSVG
                  }
                )
              }
            ),
            overrideElUser ? overrideElUser() : /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                className: "box-border rounded-full border border-solid border-border-tertiary p-xs",
                onClick: onUserClick,
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "img",
                  {
                    className: "block align-middle",
                    width: 22,
                    height: 22,
                    src: ProfileSVG
                  }
                )
              }
            )
          ] }) })
        ] })
      ]
    }
  );
};

function useFocusWindow(cb) {
  const focusOutOnce = useRef(false);
  const throttle = useRef(false);
  const onFocus = useCallback(() => {
    if (focusOutOnce.current && !throttle.current) {
      cb();
      throttle.current = true;
      setTimeout(() => {
        throttle.current = false;
      }, 5e3);
    }
  }, [cb]);
  const onBlur = () => {
    focusOutOnce.current = true;
  };
  useEffect(() => {
    window.addEventListener("blur", onBlur);
    return () => {
      window.removeEventListener("blur", onBlur);
    };
  }, []);
  useEffect(() => {
    window.addEventListener("focus", onFocus);
    return () => {
      window.removeEventListener("focus", onFocus);
    };
  }, [onFocus]);
}

const cleanupObservers = (intersectionObserverRef, resizeObserverRef) => {
  if (intersectionObserverRef.current) {
    intersectionObserverRef.current.disconnect();
    intersectionObserverRef.current = null;
  }
  if (resizeObserverRef.current) {
    resizeObserverRef.current.disconnect();
    resizeObserverRef.current = null;
  }
};
let beamerInitialized = false;
const useStandNavi = ({
  getDashboardMetaUrl,
  putNavigationUrl,
  currentPath,
  relatedPathMap,
  renderRightContentsEl,
  isHome,
  currentService,
  onClickLogout,
  onFetchError,
  fetchHeaders,
  fetchOptions,
  onAuthenticateRequired
}) => {
  const [state, setState] = useState(initialState);
  const [isUserOpen, setIsUserOpen] = useState(false);
  const [isCollapsedAppsOpen, setIsCollapsedAppsOpen] = useState(false);
  const [collapsedAppsState, setCollapsedAppsState] = useState({ count: 0, position: { left: 0 } });
  const [isViewSiteOpen, setIsViewSiteOpen] = useState(false);
  const intersectionObserverRef = useRef(null);
  const resizeObserverRef = useRef(null);
  const breakpointRef = useRef(null);
  const observeContainerRef = useRef(null);
  const observerListItemsRef = useRef([]);
  const [inAsyncPhase, setInAsyncPhase] = useState(false);
  const inLifecycleRef = useRef(false);
  useEffect(() => {
    const setupObserver = async () => {
      const config = {
        onNavChange: (data) => setCollapsedAppsState((prev) => {
          if (prev.count !== data.count || prev.position.left !== data.position.left) {
            return {
              count: data.count,
              position: { left: data.position.left }
            };
          }
          return prev;
        }),
        getContainer: () => observeContainerRef.current,
        getListItems: () => observerListItemsRef.current,
        clearListItems: () => {
          observerListItemsRef.current = [];
        },
        setListItems: (newValue) => {
          observerListItemsRef.current = newValue;
        },
        getBreakpoint: () => breakpointRef.current ?? "pc",
        setBreakpoint: (newValue) => {
          breakpointRef.current = newValue;
        },
        getIntersectionObserver: () => intersectionObserverRef.current
      };
      const { intersectionObserver, resizeObserver } = await createCollapsedAppsObserver(config);
      cleanupObservers(intersectionObserverRef, resizeObserverRef);
      intersectionObserverRef.current = intersectionObserver;
      resizeObserverRef.current = resizeObserver;
    };
    setupObserver();
    return () => {
      cleanupObservers(intersectionObserverRef, resizeObserverRef);
    };
  }, []);
  const appId = useMemo(() => {
    return currentPath ? detectAppId(currentPath, relatedPathMap) : null;
  }, [currentPath, relatedPathMap]);
  useFocusWindow(() => {
    if (!currentPath) {
      return;
    }
    setState((prevState) => {
      const newState = StartNavigationLifecycle(
        prevState,
        "revalidate",
        appId,
        inLifecycleRef.current,
        () => {
          inLifecycleRef.current = true;
        }
      );
      return newState;
    });
  });
  useEffect(() => {
    if (!currentPath) {
      return;
    }
    setState((prevState) => {
      const newState = StartNavigationLifecycle(
        prevState,
        "pageOpen",
        appId,
        inLifecycleRef.current,
        () => {
          inLifecycleRef.current = true;
        }
      );
      return newState;
    });
  }, [currentPath, appId]);
  useEffect(() => {
    if (beamerInitialized) {
      return;
    }
    if (!state.beamerConfig) {
      return;
    }
    initBeamer(state.beamerConfig);
    beamerInitialized = true;
  }, [state.beamerConfig]);
  useEffect(() => {
    const shouldBlockPhaseExecution = inAsyncPhase || !inLifecycleRef.current;
    if (shouldBlockPhaseExecution) {
      return;
    }
    setInAsyncPhase(true);
    const fn = async () => {
      switch (state.phase) {
        case "initialized": {
          break;
        }
        case "optimisticUI": {
          const { state: newState } = await Phase_OptimisticUI(state);
          setState(newState);
          break;
        }
        case "fetch": {
          const { getDashboardMeta, putNavigation } = createUniversalDashboardFetchers({
            getDashboardMetaUrl,
            putNavigationUrl,
            overrideHeaders: fetchHeaders,
            overrideFetchOptions: fetchOptions
          });
          const { state: newState } = await Phase_Fetch(state, {
            getDashboardMetaFetcher: getDashboardMeta,
            putNavigationFetcher: putNavigation,
            onError: (error) => {
              if (onAuthenticateRequired && error.error === "auth_required") {
                onAuthenticateRequired();
                return;
              }
              onFetchError?.(error);
            }
          });
          setState(newState);
          break;
        }
        case "persist": {
          const { getDashboardMeta, putNavigation } = createUniversalDashboardFetchers({
            getDashboardMetaUrl,
            putNavigationUrl,
            overrideHeaders: fetchHeaders,
            overrideFetchOptions: fetchOptions
          });
          const { state: newState } = await Phase_Persist(state, {
            getDashboardMetaFetcher: getDashboardMeta,
            putNavigationFetcher: putNavigation,
            onError: (error) => {
              if (onAuthenticateRequired && error.error === "auth_required") {
                onAuthenticateRequired();
                return;
              }
              onFetchError?.(error);
            }
          });
          setState(newState);
          break;
        }
        case "transition": {
          break;
        }
        case "completed": {
          inLifecycleRef.current = false;
          break;
        }
      }
    };
    fn().then(() => {
      setInAsyncPhase(false);
    });
  }, [
    getDashboardMetaUrl,
    putNavigationUrl,
    state,
    onFetchError,
    fetchHeaders,
    fetchOptions,
    onAuthenticateRequired,
    inAsyncPhase
  ]);
  const notifyAppClosed = async (appId2) => {
    const newState = StartNavigationLifecycle(
      state,
      "appRemove",
      appId2,
      inLifecycleRef.current,
      () => {
        inLifecycleRef.current = true;
      }
    );
    setState(newState);
  };
  const Navi = /* @__PURE__ */ jsx(
    StandNavi$1,
    {
      isHome,
      uiState: state.uiState,
      currentPath: currentPath ?? "/",
      onClickLogout,
      onClickUserSettings: () => {
        if (state.uiState.userSetting) {
          window.location.href = state.uiState.userSetting.href;
        }
      },
      showNotification: !!state.beamerConfig || state.phase !== "completed",
      user: {
        onClick: () => setIsUserOpen(!isUserOpen),
        isOpen: isUserOpen
      },
      currentService,
      relatedPathMap,
      renderRightContentsEl: renderRightContentsEl ?? (() => /* @__PURE__ */ jsx(Fragment, {})),
      onAppClosed: async (appId2) => {
        notifyAppClosed(appId2);
      },
      collapsedApps: {
        onClick: () => setIsCollapsedAppsOpen(!isCollapsedAppsOpen),
        collapsedAppsState,
        isOpen: isCollapsedAppsOpen
      },
      viewSite: {
        onOpenStateChange: (isOpen) => setIsViewSiteOpen(isOpen),
        isOpen: isViewSiteOpen
      },
      observeContainerRef
    }
  );
  const enabled = inferEnabled(state);
  const block = shouldBlockRendering(state);
  return {
    state,
    shouldBlockRendering: block,
    enabled,
    component: Navi
  };
};

const SvgAddSquare = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M14 24a1.5 1.5 0 0 1 1.5-1.5h7v-7a1.5 1.5 0 0 1 3 0v7h7a1.5 1.5 0 0 1 0 3h-7v7a1.5 1.5 0 0 1-3 0v-7h-7A1.5 1.5 0 0 1 14 24" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M12 6a6 6 0 0 0-6 6v24a6 6 0 0 0 6 6h24a6 6 0 0 0 6-6V12a6 6 0 0 0-6-6zm24 3H12a3 3 0 0 0-3 3v24a3 3 0 0 0 3 3h24a3 3 0 0 0 3-3V12a3 3 0 0 0-3-3",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgAddSquare$1 = SvgAddSquare;

const SvgAnnounce = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M33.48 9.764c-1.01 2.247-1.678 5.47-1.678 9.122 0 3.65.669 6.874 1.678 9.122 1.082 2.408 2.226 3.064 2.86 3.064.636 0 1.78-.656 2.861-3.064 1.01-2.248 1.678-5.471 1.678-9.122s-.668-6.875-1.678-9.122C38.12 7.356 36.976 6.7 36.341 6.7s-1.779.656-2.86 3.064m1.738-6.328A4.7 4.7 0 0 1 36.34 3.3c2.81 0 4.785 2.453 5.962 5.07 1.248 2.78 1.976 6.499 1.976 10.516s-.728 7.736-1.977 10.515c-1.176 2.618-3.151 5.07-5.961 5.07q-.348 0-.678-.048a2 2 0 0 1-.2-.03v-.004.005l-.938-.193a6163 6163 0 0 1-10.773-2.233v6.015a6.717 6.717 0 0 1-13.434 0v-8.96c-1.556-.585-3.071-1.78-4.236-3.296C4.715 23.946 3.72 21.58 3.72 18.89s.995-5.056 2.362-6.837c1.344-1.751 3.155-3.073 4.957-3.524m1.174 17.505q-.21-.048-.35-.083c-.878-.22-2.083-.99-3.084-2.295-.978-1.274-1.659-2.928-1.659-4.766s.681-3.492 1.66-4.767c1-1.305 2.205-2.075 3.083-2.295 1.297-.324 7.31-1.591 13.064-2.79 2.013-.419 3.984-.828 5.695-1.182q-.126.255-.243.515c-1.248 2.778-1.977 6.497-1.977 10.515 0 4.017.729 7.736 1.977 10.515q.118.263.247.523l-5.647-1.173c-5.042-1.05-10.282-2.153-12.398-2.632a1.7 1.7 0 0 0-.368-.085m1.505 3.816c1.752.38 4.116.88 6.634 1.408v6.726a3.317 3.317 0 0 1-6.634 0zm21.5-26.414-.793.163A5147 5147 0 0 0 24.234 5.71c-5.7 1.187-11.813 2.474-13.195 2.82",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgAnnounce$1 = SvgAnnounce;

const SvgArrowDown = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M39.086 25.98a2.1 2.1 0 0 0-2.964 0L26.102 36V6.922c0-1.164-.936-2.1-2.1-2.1s-2.1.936-2.1 2.1V36l-10.02-10.02a2.1 2.1 0 0 0-2.964 0 2.115 2.115 0 0 0 0 2.977L22.514 42.55c.408.408.948.612 1.488.612s1.08-.204 1.488-.612l13.596-13.596a2.115 2.115 0 0 0 0-2.975" })
  }
);
const SvgArrowDown$1 = SvgArrowDown;

const SvgArrowLeft = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M41.075 21.9H11.999l10.02-10.02a2.115 2.115 0 0 0 0-2.976 2.1 2.1 0 0 0-2.964 0L5.459 22.5a2.09 2.09 0 0 0-.612 1.488c0 .564.216 1.092.612 1.488l13.596 13.596c.408.408.948.612 1.488.612s1.08-.204 1.488-.612a2.115 2.115 0 0 0 0-2.976l-10.02-10.02h29.076c1.164 0 2.1-.936 2.1-2.1s-.936-2.1-2.1-2.1z" })
  }
);
const SvgArrowLeft$1 = SvgArrowLeft;

const SvgArrowRight = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M42.552 22.512 28.955 8.916a2.1 2.1 0 0 0-2.965 0 2.115 2.115 0 0 0 0 2.976l10.02 10.02H6.923c-1.164 0-2.1.936-2.1 2.1s.936 2.1 2.1 2.1H36l-10.02 10.02a2.115 2.115 0 0 0 0 2.976c.409.408.948.612 1.489.612.54 0 1.08-.204 1.488-.612L42.55 25.512c.396-.396.612-.924.612-1.488s-.215-1.092-.611-1.488z" })
  }
);
const SvgArrowRight$1 = SvgArrowRight;

const SvgArrowUp = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M39.084 19.044 25.488 5.448a2.1 2.1 0 0 0-2.964 0L8.928 19.044a2.1 2.1 0 0 0 0 2.964 2.1 2.1 0 0 0 2.964 0l10.02-10.02v29.076c0 1.164.936 2.1 2.1 2.1s2.1-.936 2.1-2.1V11.988l10.02 10.02c.408.408.948.612 1.488.612s1.08-.204 1.488-.612a2.1 2.1 0 0 0 0-2.964z" })
  }
);
const SvgArrowUp$1 = SvgArrowUp;

const SvgArrowsH = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M32.94 17.06a1.5 1.5 0 0 0 2.12-2.12l-10-10a1.5 1.5 0 0 0-2.12 0l-10 10a1.5 1.5 0 0 0 2.12 2.12l7.44-7.439V38.38l-7.44-7.44a1.5 1.5 0 0 0-2.12 2.122l10 10a1.5 1.5 0 0 0 2.12 0l10-10a1.5 1.5 0 0 0-2.12-2.122l-7.44 7.44V9.62z" })
  }
);
const SvgArrowsH$1 = SvgArrowsH;

const SvgArrowsV = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M17.06 12.94a1.5 1.5 0 0 1 0 2.12L9.622 22.5H38.38l-7.44-7.44a1.5 1.5 0 0 1 2.122-2.12l10 10a1.5 1.5 0 0 1 0 2.12l-10 10a1.5 1.5 0 0 1-2.122-2.12l7.44-7.44H9.62l7.44 7.44a1.5 1.5 0 0 1-2.122 2.12l-10-10a1.5 1.5 0 0 1 0-2.12l10-10a1.5 1.5 0 0 1 2.122 0" })
  }
);
const SvgArrowsV$1 = SvgArrowsV;

const SvgAscendingOrder = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M18.56 16.56a1.5 1.5 0 0 1-2.12 0L13 13.122V38.5a1.5 1.5 0 0 1-3 0V13.121l-3.44 3.44a1.5 1.5 0 0 1-2.12-2.122l6-6a1.5 1.5 0 0 1 2.12 0l6 6a1.5 1.5 0 0 1 0 2.122M25.5 11a1.5 1.5 0 0 0 0 3h17a1.5 1.5 0 0 0 0-3zM24 24.5a1.5 1.5 0 0 1 1.5-1.5h13a1.5 1.5 0 0 1 0 3h-13a1.5 1.5 0 0 1-1.5-1.5M25.5 35a1.5 1.5 0 0 0 0 3h7a1.5 1.5 0 0 0 0-3z" })
  }
);
const SvgAscendingOrder$1 = SvgAscendingOrder;

const SvgBadge = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M22.788 6.766a2 2 0 0 1 2.924 0l2.302 2.466a2 2 0 0 0 1.842.598l3.312-.642a2 2 0 0 1 2.365 1.72l.413 3.347a2 2 0 0 0 1.139 1.567l3.056 1.428a2 2 0 0 1 .904 2.78l-1.634 2.951a2 2 0 0 0 0 1.938l1.634 2.95a2 2 0 0 1-.904 2.782l-3.056 1.427a2 2 0 0 0-1.139 1.567l-.413 3.348a2 2 0 0 1-2.365 1.718l-3.312-.641a2 2 0 0 0-1.842.598l-2.302 2.466a2 2 0 0 1-2.924 0l-2.302-2.466a2 2 0 0 0-1.842-.598l-3.312.642a2 2 0 0 1-2.365-1.72l-.413-3.347a2 2 0 0 0-1.139-1.567L8.359 30.65a2 2 0 0 1-.904-2.78l1.634-2.951a2 2 0 0 0 0-1.938l-1.634-2.95a2 2 0 0 1 .904-2.781l3.056-1.428a2 2 0 0 0 1.139-1.567l.413-3.348a2 2 0 0 1 2.365-1.719l3.312.642a2 2 0 0 0 1.842-.598z" })
  }
);
const SvgBadge$1 = SvgBadge;

const SvgBan = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#ban_svg__a)", children: [
        /* @__PURE__ */ jsx("path", { d: "M9.858 36.02a1.5 1.5 0 1 0 2.121 2.122L38.142 11.98a1.5 1.5 0 1 0-2.121-2.121z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M38.142 9.858c7.81 7.81 7.81 20.474 0 28.284s-20.474 7.81-28.284 0-7.81-20.474 0-28.284 20.474-7.81 28.284 0m-2.121 2.121c6.639 6.64 6.639 17.403 0 24.042s-17.403 6.639-24.042 0-6.639-17.403 0-24.042 17.403-6.639 24.042 0",
            clipRule: "evenodd"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "ban_svg__a", children: /* @__PURE__ */ jsx("path", { d: "M0 0h48v48H0z" }) }) })
    ]
  }
);
const SvgBan$1 = SvgBan;

const SvgBarcode = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M15 16h-3v16h3zM23 16h2v16h-2zM36 16h-3v16h3zM17 16h4v16h-4zM31 16h-4v16h4z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M4 14a6 6 0 0 1 6-6h28a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H10a6 6 0 0 1-6-6zm6-3h28a3 3 0 0 1 3 3v20a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V14a3 3 0 0 1 3-3",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgBarcode$1 = SvgBarcode;

const SvgBarcodeScan = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M30.5 42a1.5 1.5 0 0 1 0-3H36a3 3 0 0 0 3-3v-5.5a1.5 1.5 0 0 1 3 0V36a6 6 0 0 1-6 6zM30.5 9a1.5 1.5 0 0 1 0-3H36a6 6 0 0 1 6 6v5.5a1.5 1.5 0 0 1-3 0V12a3 3 0 0 0-3-3zM19 7.5A1.5 1.5 0 0 0 17.5 6H12a6 6 0 0 0-6 6v5.5a1.5 1.5 0 0 0 3 0V12a3 3 0 0 1 3-3h5.5A1.5 1.5 0 0 0 19 7.5M19 40.5a1.5 1.5 0 0 0-1.5-1.5H12a3 3 0 0 1-3-3v-5.5a1.5 1.5 0 0 0-3 0V36a6 6 0 0 0 6 6h5.5a1.5 1.5 0 0 0 1.5-1.5M15 16h-2v16h2zM23 16h2v16h-2zM35 16h-2v16h2zM17 16h4v16h-4zM31 16h-4v16h4z" })
  }
);
const SvgBarcodeScan$1 = SvgBarcodeScan;

const SvgBarcodeScanner = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M12 7h24a3 3 0 0 1 3 3v13a3 3 0 0 1-3 3 1.5 1.5 0 0 0 0 3 6 6 0 0 0 6-6V10a6 6 0 0 0-6-6H12a6 6 0 0 0-6 6v13a6 6 0 0 0 6 6 1.5 1.5 0 0 0 0-3 3 3 0 0 1-3-3V10a3 3 0 0 1 3-3" }),
      /* @__PURE__ */ jsx("path", { d: "M15 10h2v6h-2zM27 10h2v6h-2zM22 10h-3v6h3zM30 10h3v6h-3zM25 10h-1v6h1z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M16.368 18A2.37 2.37 0 0 0 14 20.368V23c0 2.882 1.22 5.48 3.17 7.304l.412 8.004A6 6 0 0 0 23.574 44h.852a6 6 0 0 0 5.992-5.692l.412-8.004A9.97 9.97 0 0 0 34 23v-2.632A2.37 2.37 0 0 0 31.632 18zm3.798 12.15a3 3 0 0 0-.947-2.037A6.97 6.97 0 0 1 17 23v-2h14v2c0 2.018-.85 3.832-2.22 5.113a3 3 0 0 0-.946 2.037l-.412 8.004A3 3 0 0 1 24.426 41h-.852a3 3 0 0 1-2.996-2.846z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgBarcodeScanner$1 = SvgBarcodeScanner;

const SvgBarcodeScannerOffline = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M12 7h24a3 3 0 0 1 3 3v13c0 .468-.107.911-.298 1.306.971.224 1.92.57 2.823 1.038.306-.72.475-1.512.475-2.344V10a6 6 0 0 0-6-6H12a6 6 0 0 0-6 6v13a6 6 0 0 0 6 6 1.5 1.5 0 0 0 0-3 3 3 0 0 1-3-3V10a3 3 0 0 1 3-3" }),
      /* @__PURE__ */ jsx("path", { d: "M33.931 24.179A10 10 0 0 0 34 23v-2.632A2.37 2.37 0 0 0 31.632 18H16.368A2.37 2.37 0 0 0 14 20.368V23c0 2.882 1.22 5.48 3.17 7.304l.412 8.004A6 6 0 0 0 23.574 44h.852c.796 0 1.558-.156 2.255-.438a12 12 0 0 1-1.623-2.629 3 3 0 0 1-.632.067h-.852a3 3 0 0 1-2.996-2.846l-.412-8.004a3 3 0 0 0-.947-2.037A6.97 6.97 0 0 1 17 23v-2h14v2c0 .794-.131 1.556-.375 2.267a12 12 0 0 1 3.306-1.088M17 10h-2v6h2zM29 10h-2v6h2zM19 10h3v6h-3zM33 10h-3v6h3zM24 10h1v6h-1z" }),
      /* @__PURE__ */ jsx("path", { d: "M41.657 41.657a8 8 0 1 1-11.314-11.315 8 8 0 0 1 11.314 11.315" })
    ]
  }
);
const SvgBarcodeScannerOffline$1 = SvgBarcodeScannerOffline;

const SvgBars = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M6.3 38A1.7 1.7 0 0 1 8 36.3h32a1.7 1.7 0 0 1 0 3.4H8A1.7 1.7 0 0 1 6.3 38M6.3 10A1.7 1.7 0 0 1 8 8.3h32a1.7 1.7 0 1 1 0 3.4H8A1.7 1.7 0 0 1 6.3 10M6.3 24A1.7 1.7 0 0 1 8 22.3h32a1.7 1.7 0 0 1 0 3.4H8A1.7 1.7 0 0 1 6.3 24",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgBars$1 = SvgBars;

const SvgBluetooth = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M23.39 4.63a1.5 1.5 0 0 1 1.613.255l10 9a1.5 1.5 0 0 1 0 2.23L26.243 24l8.76 7.885a1.5 1.5 0 0 1 0 2.23l-10 9A1.5 1.5 0 0 1 22.5 42V27.368l-7.497 6.747a1.5 1.5 0 1 1-2.006-2.23L21.757 24l-8.76-7.885a1.5 1.5 0 1 1 2.006-2.23l7.497 6.747V6a1.5 1.5 0 0 1 .89-1.37m2.11 22.738L31.758 33 25.5 38.632zm0-6.736V9.368L31.758 15z",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgBluetooth$1 = SvgBluetooth;

const SvgBoxOpen = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M25.5 9.5a1.5 1.5 0 0 0-3 0v4a1.5 1.5 0 0 0 3 0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M36.5 19h-25a1.5 1.5 0 0 0-1.102.483l-6 6.5a1.5 1.5 0 1 0 2.204 2.034L10 24.337V36a4 4 0 0 0 4 4h20a4 4 0 0 0 4-4V24.337l3.398 3.68a1.5 1.5 0 1 0 2.204-2.034l-6-6.5A1.5 1.5 0 0 0 36.5 19M13 36V22h22v14a1 1 0 0 1-1 1H14a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M13.128 8.78a1.5 1.5 0 0 0-.349 2.092l2.5 3.5a1.5 1.5 0 0 0 2.442-1.744l-2.5-3.5a1.5 1.5 0 0 0-2.093-.349M35.22 10.872a1.5 1.5 0 0 0-2.44-1.744l-2.5 3.5a1.5 1.5 0 0 0 2.44 1.744z" })
    ]
  }
);
const SvgBoxOpen$1 = SvgBoxOpen;

const SvgBrandFacebook = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M44 24c0-11.046-8.954-20-20-20S4 12.954 4 24c0 9.982 7.314 18.257 16.875 19.757V29.781h-5.078V24h5.078v-4.406c0-5.013 2.986-7.782 7.554-7.782 2.188 0 4.477.391 4.477.391v4.922h-2.522c-2.484 0-3.259 1.542-3.259 3.125V24h5.547l-.887 5.781h-4.66v13.976C36.686 42.257 44 33.982 44 24" })
  }
);
const SvgBrandFacebook$1 = SvgBrandFacebook;

const SvgBrandInstagram = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 14.76a9.242 9.242 0 1 0 0 18.484 9.242 9.242 0 0 0 0-18.485M24 30a6.001 6.001 0 1 1 0-12.003A6.001 6.001 0 0 1 24 30",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M35.768 14.394a2.16 2.16 0 1 1-4.32 0 2.16 2.16 0 0 1 4.32 0" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24.003 6c-4.888 0-5.5.02-7.42.109-1.92.087-3.226.394-4.371.839a8.8 8.8 0 0 0-3.188 2.075 8.8 8.8 0 0 0-2.072 3.188c-.448 1.145-.753 2.453-.84 4.368s-.108 2.533-.108 7.42.02 5.501.108 7.42c.088 1.92.392 3.224.837 4.37a8.8 8.8 0 0 0 2.075 3.187 8.8 8.8 0 0 0 3.188 2.076c1.143.444 2.453.749 4.368.836 1.915.088 2.533.108 7.42.108s5.501-.02 7.42-.108c1.92-.087 3.224-.392 4.37-.836a9.2 9.2 0 0 0 5.263-5.264c.444-1.143.748-2.453.836-4.368s.108-2.533.108-7.42-.02-5.501-.108-7.42c-.087-1.92-.392-3.224-.836-4.37a8.8 8.8 0 0 0-2.076-3.187 8.8 8.8 0 0 0-3.188-2.071c-1.145-.45-2.453-.753-4.368-.84-1.916-.088-2.533-.11-7.42-.11zM24 9.245c4.806 0 5.375.019 7.273.105 1.754.08 2.707.373 3.342.62.782.288 1.49.748 2.071 1.346a5.6 5.6 0 0 1 1.347 2.072c.246.635.54 1.588.62 3.342.086 1.898.104 2.467.104 7.272 0 4.806-.018 5.375-.105 7.273-.08 1.754-.373 2.707-.62 3.342a5.97 5.97 0 0 1-3.414 3.415c-.635.247-1.588.54-3.342.62-1.898.086-2.467.105-7.273.105s-5.375-.02-7.272-.105c-1.755-.08-2.708-.373-3.342-.62a5.6 5.6 0 0 1-2.072-1.346 5.6 5.6 0 0 1-1.346-2.072c-.247-.635-.54-1.588-.62-3.342-.086-1.898-.105-2.467-.105-7.272 0-4.806.019-5.375.105-7.273.08-1.754.373-2.707.62-3.342a5.6 5.6 0 0 1 1.346-2.071 5.6 5.6 0 0 1 2.072-1.347c.634-.247 1.587-.54 3.342-.62 1.898-.086 2.467-.104 7.272-.104z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgBrandInstagram$1 = SvgBrandInstagram;

const SvgBrandLine = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M14.116 6h19.768A8.116 8.116 0 0 1 42 14.116v19.768A8.116 8.116 0 0 1 33.884 42H14.116A8.116 8.116 0 0 1 6 33.884V14.116A8.116 8.116 0 0 1 14.116 6m14.518 19.405h3.371v.003a.23.23 0 0 0 .23-.23v-.85a.23.23 0 0 0-.23-.23h-2.291v-.884h2.291a.23.23 0 0 0 .23-.23v-.852a.23.23 0 0 0-.23-.23h-2.291v-.883h2.291c.128 0 .23-.103.23-.23v-.852a.23.23 0 0 0-.23-.229h-3.371a.23.23 0 0 0-.23.23v5.238c0 .127.103.229.23.229m-9.101 0a.23.23 0 0 0 .23-.23v-.851a.23.23 0 0 0-.23-.23H17.24v-4.158a.23.23 0 0 0-.23-.229h-.851a.23.23 0 0 0-.23.23v5.239c0 .127.103.23.23.23h3.372m1.179-5.697h.85a.23.23 0 0 1 .23.23v5.238a.23.23 0 0 1-.23.229h-.85a.23.23 0 0 1-.23-.23v-5.238a.23.23 0 0 1 .23-.229m6.645 0h-.852a.23.23 0 0 0-.23.23v3.11l-2.395-3.236-.018-.024-.002-.001-.006-.008-.007-.007-.005-.003-.012-.01-.002-.002h-.001l-.004-.003-.012-.008-.003-.002-.004-.002-.006-.004-.006-.003-.007-.003q-.006-.005-.013-.006h-.003l-.005-.002-.004-.001-.003-.002h-.003l-.004-.002-.008-.002-.009-.002-.004-.001h-.005l-.005-.002h-.879a.23.23 0 0 0-.23.229v5.238c0 .126.103.23.23.23h.852a.23.23 0 0 0 .23-.23v-3.11l2.399 3.24a.2.2 0 0 0 .062.06l.01.006.004.003.007.003.004.003q.004 0 .007.003l.01.004h.002l.006.003.016.004h.003q.03.008.06.008h.846a.23.23 0 0 0 .23-.23V19.94a.23.23 0 0 0-.23-.23zm-3.36-7.145c6.618 0 12.002 4.37 12.002 9.74H36c0 2.15-.833 4.085-2.572 5.993-2.518 2.898-8.149 6.429-9.43 6.969-1.247.526-1.101-.298-1.044-.622l.004-.025.171-1.027c.04-.308.082-.782-.04-1.086-.134-.334-.666-.507-1.057-.592-5.767-.762-10.038-4.794-10.038-9.61 0-5.37 5.384-9.74 12.003-9.74",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgBrandLine$1 = SvgBrandLine;

const SvgBrandPinterest = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M24 4C12.955 4 4 12.955 4 24c0 8.477 5.267 15.72 12.708 18.634-.181-1.58-.33-4.017.066-5.745.362-1.564 2.337-9.943 2.337-9.943s-.593-1.201-.593-2.963c0-2.781 1.614-4.855 3.622-4.855 1.712 0 2.535 1.284 2.535 2.814 0 1.712-1.087 4.28-1.663 6.667-.477 1.992 1.005 3.621 2.963 3.621 3.556 0 6.288-3.753 6.288-9.152 0-4.79-3.44-8.131-8.362-8.131-5.695 0-9.037 4.263-9.037 8.674 0 1.712.659 3.556 1.482 4.56a.6.6 0 0 1 .131.576c-.148.626-.494 1.992-.56 2.272-.082.362-.296.444-.674.263-2.502-1.169-4.066-4.806-4.066-7.753 0-6.304 4.576-12.099 13.218-12.099 6.93 0 12.33 4.939 12.33 11.556 0 6.897-4.346 12.444-10.371 12.444-2.025 0-3.934-1.053-4.576-2.304l-1.251 4.757c-.445 1.745-1.663 3.918-2.486 5.251 1.877.576 3.852.889 5.926.889 11.045 0 20-8.955 20-20C44 12.955 35.045 4 24 4" })
  }
);
const SvgBrandPinterest$1 = SvgBrandPinterest;

const SvgBrandTwitter = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M43 12.04c-1.5.504-2.997 1.007-4.5 1.26 1.503-1.008 2.753-2.52 3.503-4.283-1.503 1.007-3.25 1.511-5 2.015-1.503-1.512-3.503-2.52-5.75-2.52-4.25-.251-7.753 3.276-7.753 7.559 0 .503 0 1.26.25 1.763-6.5-.252-12.25-3.275-16-8.062-.748 1.008-1.25 2.52-1.25 3.78 0 2.77 1.5 5.038 3.5 6.55-1.25 0-2.5-.504-3.5-1.008 0 3.779 2.75 7.054 6.25 7.81-.5.252-1.25.503-1.998.503-.503 0-1.002 0-1.503-.252 1 3.024 3.75 5.291 7.25 5.543-2.75 2.015-6 3.275-9.75 3.275H5C8.5 38.24 12.5 39.5 17.002 39.5c14.25 0 22.248-12.093 22.248-22.422v-1.007c1.503-1.26 2.753-2.52 3.75-4.031",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgBrandTwitter$1 = SvgBrandTwitter;

const SvgBrandWechat = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M16 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4M26 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4M27.5 29a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M36 27.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M35.662 20.906c.22-.845.338-1.736.338-2.669C36 10.797 28.507 6 21 6S6 10.796 6 18.237c0 2.941 1.245 5.531 3.15 7.53l-.412 1.162c-1.076 3.037 2.282 5.728 5.011 4.016l1.978-1.24c1.365.414 2.819.67 4.324.746C20.618 35.7 25.84 39 31 39q.633 0 1.252-.06l1.53 1.146c2.35 1.762 5.633-.307 5.057-3.188l-.123-.615c1.938-1.646 3.284-4 3.284-6.783 0-4.107-2.777-7.161-6.338-8.594m-23.241 3.79-.005-.004C10.302 23.027 9 20.749 9 18.237 9 13.136 14.373 9 21 9s12 4.136 12 9.237a7.2 7.2 0 0 1-.25 1.888A12.4 12.4 0 0 0 31 20c-4.79 0-9.638 2.846-10.759 7.456a14.8 14.8 0 0 1-4.69-.986.41.41 0 0 0-.365.032l-3.03 1.902a.4.4 0 0 1-.59-.473l.985-2.782a.41.41 0 0 0-.13-.453m11.06 2.581a5.4 5.4 0 0 0-.413 3.077C23.584 33.54 26.939 36 31 36a10 10 0 0 0 1.958-.196.2.2 0 0 1 .162.036l2.461 1.846a.2.2 0 0 0 .316-.2l-.48-2.404a.2.2 0 0 1 .1-.217 8 8 0 0 0 .71-.444C37.925 33.229 39 31.466 39 29.5c0-2.57-1.835-4.79-4.498-5.846A9.5 9.5 0 0 0 31 23c-3.457 0-6.402 1.782-7.52 4.277",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgBrandWechat$1 = SvgBrandWechat;

const SvgBrandWechatRefund = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M18 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0M28 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M35.662 20.906c.22-.845.338-1.736.338-2.669C36 10.797 28.507 6 21 6S6 10.796 6 18.237c0 2.941 1.245 5.531 3.15 7.53l-.412 1.162c-1.076 3.037 2.282 5.728 5.011 4.016l1.978-1.24c1.365.414 2.819.67 4.324.746.34 3.158 2.368 5.611 5.053 7.064a11.1 11.1 0 0 1 .084-3.549c-1.13-.97-1.895-2.221-2.12-3.612a5.412 5.412 0 0 1 .412-3.077C24.598 24.782 27.543 23 31 23q.141 0 .281.004a9.5 9.5 0 0 1 3.221.65 8.2 8.2 0 0 1 2.305 1.375c1.677.122 3.25.62 4.634 1.409-.985-2.565-3.172-4.483-5.78-5.532m-23.241 3.79-.005-.004C10.302 23.027 9 20.749 9 18.237 9 13.136 14.373 9 21 9s12 4.136 12 9.237a7.2 7.2 0 0 1-.25 1.888A12.4 12.4 0 0 0 31 20c-4.79 0-9.638 2.846-10.759 7.456a14.8 14.8 0 0 1-4.69-.986.41.41 0 0 0-.365.032l-3.03 1.902a.4.4 0 0 1-.59-.473l.985-2.782a.41.41 0 0 0-.13-.453",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M27.514 29c.447-.541.945-1.039 1.486-1.486V27.5a1.5 1.5 0 1 0-1.5 1.5z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M44 36a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-8.293-2.293a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L34.414 37H40a1 1 0 1 0 0-2h-5.586z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgBrandWechatRefund$1 = SvgBrandWechatRefund;

const SvgBrandX = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M26.85 21.626 38.008 8.5h-2.644l-9.686 11.398L17.94 8.5H9.017l11.699 17.235L9.016 39.5h2.644l10.23-12.036L30.06 39.5h8.923zm-3.62 4.26-1.185-1.715-9.432-13.656h4.06l7.612 11.02 1.185 1.717 9.894 14.325h-4.06l-8.074-11.69" })
  }
);
const SvgBrandX$1 = SvgBrandX;

const SvgBrandYoutube = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M43.164 14.372a5 5 0 0 0-1.293-2.238 5.03 5.03 0 0 0-2.244-1.299C36.5 10 24 10 24 10s-12.5 0-15.627.835c-.85.23-1.624.678-2.244 1.299a5 5 0 0 0-1.293 2.238C4 17.492 4 24 4 24s0 6.508.836 9.628a5 5 0 0 0 1.293 2.238 5.03 5.03 0 0 0 2.244 1.298C11.5 38 24 38 24 38s12.5 0 15.627-.836a5.03 5.03 0 0 0 2.244-1.298 5 5 0 0 0 1.293-2.238C44 30.508 44 24 44 24s0-6.508-.836-9.628M19.909 29.909V18.091L30.364 24z" })
  }
);
const SvgBrandYoutube$1 = SvgBrandYoutube;

const SvgBrowser = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M9.822 9.978C8.507 11.388 7.7 13.46 7.7 16.053v15.894c0 2.594.804 4.667 2.116 6.076 1.3 1.395 3.222 2.276 5.75 2.276h16.866c2.53 0 4.452-.88 5.75-2.276 1.312-1.408 2.116-3.482 2.116-6.076V16.053c0-2.594-.804-4.667-2.115-6.076-1.299-1.395-3.22-2.276-5.749-2.276H15.566c-2.518 0-4.442.88-5.744 2.277M7.335 7.659c2.011-2.157 4.87-3.358 8.23-3.358h16.87c3.367 0 6.227 1.2 8.237 3.359 1.996 2.145 3.026 5.097 3.026 8.393v15.894c0 3.296-1.03 6.248-3.027 8.393-2.01 2.159-4.87 3.359-8.239 3.359H15.566c-3.368 0-6.228-1.2-8.238-3.359C5.33 38.196 4.3 35.243 4.3 31.947V16.053c0-3.298 1.036-6.25 3.035-8.394",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M10.878 13.1a1.7 1.7 0 0 1 1.7-1.7h.111a1.7 1.7 0 1 1 0 3.4h-.11a1.7 1.7 0 0 1-1.7-1.7m4.971 0a1.7 1.7 0 0 1 1.7-1.7h.111a1.7 1.7 0 0 1 0 3.4h-.11a1.7 1.7 0 0 1-1.7-1.7m4.973 0a1.7 1.7 0 0 1 1.7-1.7h.111a1.7 1.7 0 1 1 0 3.4h-.111a1.7 1.7 0 0 1-1.7-1.7M4.3 18.983a1.7 1.7 0 0 1 1.7-1.7h35.998a1.7 1.7 0 0 1 0 3.4H6a1.7 1.7 0 0 1-1.7-1.7",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgBrowser$1 = SvgBrowser;

const SvgBrowserEdit = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M5.714 5.97c2.194-2.353 5.317-3.67 9-3.67h10.89a1.7 1.7 0 1 1 0 3.4h-10.89c-2.84 0-5.027.995-6.512 2.589-1.498 1.607-2.407 3.96-2.407 6.88v2.007h13.03a1.7 1.7 0 1 1 0 3.4H5.796v12.253c0 2.922.906 5.276 2.4 6.882 1.482 1.593 3.668 2.589 6.52 2.589h18.742c2.856 0 5.042-.996 6.523-2.588 1.493-1.607 2.397-3.96 2.397-6.883v-9.73a1.7 1.7 0 1 1 3.4 0v9.73c0 3.623-1.129 6.855-3.308 9.198-2.191 2.357-5.315 3.673-9.012 3.673H14.715c-3.693 0-6.817-1.317-9.009-3.673-2.18-2.342-3.311-5.574-3.311-9.198v-17.66c0-3.626 1.138-6.857 3.32-9.198m36.07-.787 1.98 1.833a4.656 4.656 0 0 1 .256 6.58l-.003.003-9.273 10.119a6.86 6.86 0 0 1-3.977 2.189l-2.155.36c-2.69.45-5.06-1.79-4.77-4.498v-.001l.24-2.222a6.87 6.87 0 0 1 1.71-3.839l.012-.014L35.2 5.434a4.66 4.66 0 0 1 6.584-.25m-4.088 2.56-.003.004-9.374 10.234a3.47 3.47 0 0 0-.857 1.93l-.24 2.22v.002c-.05.473.363.859.828.782m9.646-15.172a1.26 1.26 0 0 1 1.778-.065l1.98 1.832c.512.475.54 1.27.07 1.777L32.23 21.428l-.015.018a3.46 3.46 0 0 1-2.01 1.108l-2.154.36M9.572 12.455a1.7 1.7 0 0 1 1.7-1.7h.124a1.7 1.7 0 1 1 0 3.4h-.124a1.7 1.7 0 0 1-1.7-1.7m5.429 0a1.7 1.7 0 0 1 1.7-1.7h.123a1.7 1.7 0 1 1 0 3.4h-.123a1.7 1.7 0 0 1-1.7-1.7",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgBrowserEdit$1 = SvgBrowserEdit;

const SvgCalculator = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M34.546 13.768a1.5 1.5 0 0 1 0 2.121l-1.768 1.768 1.768 1.768a1.5 1.5 0 0 1-2.121 2.121l-1.768-1.768-1.768 1.768a1.5 1.5 0 0 1-2.121-2.121l1.768-1.768-1.768-1.768a1.5 1.5 0 1 1 2.121-2.121l1.768 1.768 1.768-1.768a1.5 1.5 0 0 1 2.121 0M18.5 27a1.5 1.5 0 0 0-3 0v2.5H13a1.5 1.5 0 0 0 0 3h2.5V35a1.5 1.5 0 0 0 3 0v-2.5H21a1.5 1.5 0 0 0 0-3h-2.5zM35.5 33.5A1.5 1.5 0 0 1 34 35h-7a1.5 1.5 0 0 1 0-3h7a1.5 1.5 0 0 1 1.5 1.5M34 30.5a1.5 1.5 0 0 0 0-3h-7a1.5 1.5 0 0 0 0 3zM22.5 17.5A1.5 1.5 0 0 1 21 19h-8a1.5 1.5 0 0 1 0-3h8a1.5 1.5 0 0 1 1.5 1.5" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M6 12a6 6 0 0 1 6-6h24a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6zm6-3h24a3 3 0 0 1 3 3v24a3 3 0 0 1-3 3H12a3 3 0 0 1-3-3V12a3 3 0 0 1 3-3",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgCalculator$1 = SvgCalculator;

const SvgCalculatorSolid = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#000E2B",
        strokeWidth: 3,
        d: "M12 7.5h24a4.5 4.5 0 0 1 4.5 4.5v24a4.5 4.5 0 0 1-4.5 4.5H12A4.5 4.5 0 0 1 7.5 36V12A4.5 4.5 0 0 1 12 7.5ZM17 24a3 3 0 0 0-3 3v1h-1a3 3 0 1 0 0 6h1v1a3 3 0 1 0 6 0v-1h1a3 3 0 1 0 0-6h-1v-1a3 3 0 0 0-3-3Zm10 2a3 3 0 0 0-1.98 5.25A3 3 0 0 0 27 36.5h7a3 3 0 0 0 3-3c0-.897-.396-1.7-1.02-2.25A3 3 0 0 0 37 29a3 3 0 0 0-3-3zm8.606-13.293a3 3 0 0 0-4.242 0l-.707.707-.707-.707a3 3 0 0 0-4.243 4.243l.707.707-.707.707a3 3 0 1 0 4.243 4.242l.707-.707.707.707a3 3 0 1 0 4.242-4.242l-.707-.707.707-.707a3 3 0 0 0 0-4.243ZM13 14.5a3 3 0 0 0 0 6h8a3 3 0 1 0 0-6z"
      }
    )
  }
);
const SvgCalculatorSolid$1 = SvgCalculatorSolid;

const SvgCalendar = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M4.485 18.809a1.7 1.7 0 0 1 1.7-1.7h35.648a1.7 1.7 0 1 1 0 3.4H6.185a1.7 1.7 0 0 1-1.7-1.7M31.184 26.62a1.7 1.7 0 0 1 1.7-1.7h.019a1.7 1.7 0 1 1 0 3.4h-.019a1.7 1.7 0 0 1-1.7-1.7M22.31 26.62a1.7 1.7 0 0 1 1.7-1.7h.018a1.7 1.7 0 1 1 0 3.4h-.019a1.7 1.7 0 0 1-1.7-1.7M13.416 26.62a1.7 1.7 0 0 1 1.7-1.7h.018a1.7 1.7 0 1 1 0 3.4h-.018a1.7 1.7 0 0 1-1.7-1.7M31.184 34.393a1.7 1.7 0 0 1 1.7-1.7h.019a1.7 1.7 0 1 1 0 3.4h-.019a1.7 1.7 0 0 1-1.7-1.7M22.31 34.393a1.7 1.7 0 0 1 1.7-1.7h.018a1.7 1.7 0 1 1 0 3.4h-.019a1.7 1.7 0 0 1-1.7-1.7M13.416 34.393a1.7 1.7 0 0 1 1.7-1.7h.018a1.7 1.7 0 1 1 0 3.4h-.018a1.7 1.7 0 0 1-1.7-1.7M32.088 2.3a1.7 1.7 0 0 1 1.7 1.7v6.582a1.7 1.7 0 0 1-3.4 0V4a1.7 1.7 0 0 1 1.7-1.7M15.931 2.3a1.7 1.7 0 0 1 1.7 1.7v6.582a1.7 1.7 0 1 1-3.4 0V4a1.7 1.7 0 0 1 1.7-1.7",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M7.397 8.314C9.447 6.365 12.3 5.46 15.542 5.46h16.935c3.25 0 6.104.905 8.15 2.857 2.06 1.963 3.083 4.775 3.073 8.131v18.248c0 3.357-1.028 6.17-3.088 8.138-2.048 1.955-4.9 2.867-8.154 2.867H15.542c-3.253 0-6.108-.931-8.157-2.917C5.33 40.79 4.3 37.944 4.3 34.543V16.446c0-3.36 1.034-6.17 3.097-8.13m2.343 2.464C8.5 11.956 7.7 13.79 7.7 16.445v18.099c0 2.71.806 4.59 2.052 5.798 1.254 1.216 3.17 1.958 5.79 1.958h16.916c2.638 0 4.557-.733 5.807-1.927 1.237-1.182 2.035-3.02 2.035-5.678V16.44c.008-2.656-.785-4.487-2.018-5.662-1.247-1.188-3.164-1.918-5.805-1.918H15.542c-2.63 0-4.55.729-5.802 1.92",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgCalendar$1 = SvgCalendar;

const SvgCamera = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M32 26a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-3 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M19.338 8a4 4 0 0 0-3.776 2.679L14.4 14H10a6 6 0 0 0-6 6v14a6 6 0 0 0 6 6h28a6 6 0 0 0 6-6V20a6 6 0 0 0-6-6h-4.4l-1.163-3.321A4 4 0 0 0 28.663 8zM14.4 17a3 3 0 0 0 2.832-2.009l1.162-3.321a1 1 0 0 1 .944-.67h9.324a1 1 0 0 1 .944.67l1.162 3.321A3 3 0 0 0 33.6 17H38a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V20a3 3 0 0 1 3-3z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgCamera$1 = SvgCamera;

const SvgCameraRotate = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M19.46 21.07c.384.221.861.169 1.23-.076a6 6 0 0 1 9.294 4.576l-.277-.277a1 1 0 0 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l2.122-2.12a1 1 0 0 0-1.414-1.415l-.538.537a8 8 0 0 0-12.684-6.314c-.554.4-.445 1.212.146 1.554M18.536 26.828l-.529-.528a6 6 0 0 0 9.302 4.706c.37-.245.847-.297 1.23-.076.592.342.701 1.154.147 1.554a8 8 0 0 1-12.67-5.965l-.309.31a1 1 0 1 1-1.414-1.415l2.121-2.121a1 1 0 0 1 1.414 0l2.122 2.121a1 1 0 1 1-1.415 1.414M31.004 29.87a8 8 0 0 1-.144.247zM16.994 22.136l.149-.259a8 8 0 0 0-.15.259" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M19.338 8a4 4 0 0 0-3.776 2.679L14.4 14H10a6 6 0 0 0-6 6v14a6 6 0 0 0 6 6h28a6 6 0 0 0 6-6V20a6 6 0 0 0-6-6h-4.4l-1.163-3.321A4 4 0 0 0 28.663 8zM14.4 17a3 3 0 0 0 2.832-2.009l1.162-3.321a1 1 0 0 1 .944-.67h9.324a1 1 0 0 1 .944.67l1.162 3.321A3 3 0 0 0 33.6 17H38a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V20a3 3 0 0 1 3-3z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgCameraRotate$1 = SvgCameraRotate;

const SvgCardIc = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M6.893 10.254c1.727-1.853 4.177-2.876 7.035-2.876H34.07c2.864 0 5.316 1.023 7.042 2.877 1.714 1.84 2.588 4.363 2.588 7.156v13.176c0 2.793-.874 5.316-2.588 7.156-1.727 1.855-4.18 2.876-7.044 2.876h-20.14c-2.864 0-5.315-1.022-7.041-2.876-1.714-1.84-2.587-4.364-2.587-7.156V17.41c0-2.795.878-5.317 2.593-7.157m2.487 2.319c-1.03 1.106-1.68 2.75-1.68 4.838v13.176c0 2.091.647 3.735 1.675 4.84 1.015 1.09 2.528 1.792 4.553 1.792h20.14c2.026 0 3.54-.702 4.556-1.793 1.029-1.105 1.676-2.748 1.676-4.84V17.412c0-2.09-.647-3.734-1.676-4.839-1.016-1.091-2.53-1.794-4.554-1.794H13.928c-2.015 0-3.53.702-4.548 1.795",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M12.202 19.028a1.7 1.7 0 0 1 1.7-1.7h20.195a1.7 1.7 0 0 1 0 3.4H13.902a1.7 1.7 0 0 1-1.7-1.7",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgCardIc$1 = SvgCardIc;

const SvgCardIcRefund = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M10 12h28a3 3 0 0 1 3 3v11.2c1.126.575 2.14 1.34 3 2.25V15a6 6 0 0 0-6-6H10a6 6 0 0 0-6 6v18a6 6 0 0 0 6 6h15.414c-.27-.954-.414-1.96-.414-3H10a3 3 0 0 1-3-3V15a3 3 0 0 1 3-3" }),
      /* @__PURE__ */ jsx("path", { d: "M15 17a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M44 36a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-8.293-2.293a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L34.414 37H40a1 1 0 1 0 0-2h-5.586z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgCardIcRefund$1 = SvgCardIcRefund;

const SvgCaretDown = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "m36.338 20.486-9.472 13.061c-1.405 1.937-4.327 1.937-5.732 0l-9.472-13.061C9.997 18.19 11.664 15 14.528 15h18.944c2.864 0 4.53 3.19 2.866 5.486" })
  }
);
const SvgCaretDown$1 = SvgCaretDown;

const SvgCaretLeft = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "m27.514 36.338-13.061-9.472c-1.937-1.405-1.937-4.327 0-5.732l13.061-9.472C29.81 9.997 33 11.664 33 14.528v18.944c0 2.864-3.19 4.53-5.486 2.866" })
  }
);
const SvgCaretLeft$1 = SvgCaretLeft;

const SvgCaretRight = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "m20.486 11.662 13.061 9.472c1.937 1.405 1.937 4.327 0 5.732l-13.061 9.472C18.19 38.003 15 36.336 15 33.472V14.528c0-2.864 3.19-4.53 5.486-2.866" })
  }
);
const SvgCaretRight$1 = SvgCaretRight;

const SvgCaretUp = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "m11.662 27.514 9.472-13.061c1.405-1.937 4.327-1.937 5.732 0l9.472 13.061C38.003 29.81 36.336 33 33.472 33H14.528c-2.864 0-4.53-3.19-2.866-5.486" })
  }
);
const SvgCaretUp$1 = SvgCaretUp;

const SvgCaretUpDown = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "m16.14 15.248 6.034-8.322c.895-1.234 2.757-1.234 3.652 0l6.035 8.322c1.06 1.463-.001 3.495-1.826 3.495h-12.07c-1.825 0-2.887-2.032-1.826-3.495M31.861 32.753l-6.035 8.322c-.895 1.234-2.757 1.234-3.652 0l-6.035-8.322c-1.06-1.463.001-3.496 1.826-3.496h12.07c1.825 0 2.887 2.032 1.826 3.496" })
  }
);
const SvgCaretUpDown$1 = SvgCaretUpDown;

const SvgCart = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M.15 5A1.85 1.85 0 0 1 2 3.15h4.659c.858 0 1.603.59 1.8 1.425l1.44 6.097 31.47-.255c3-.026 5.163 2.871 4.285 5.74v.001l-4.275 14.007a7.645 7.645 0 0 1-6.606 5.385l-16.188 1.5a7.07 7.07 0 0 1-7.536-5.416L5.195 6.85H2A1.85 1.85 0 0 1 .15 5m10.622 9.365 3.878 16.417a3.374 3.374 0 0 0 3.593 2.584l16.187-1.5a3.945 3.945 0 0 0 3.41-2.779l4.276-14.014a.74.74 0 0 0-.714-.956zm2.483 27.04a2.84 2.84 0 1 1 5.679-.001 2.84 2.84 0 0 1-5.68 0m20.933 0a2.84 2.84 0 1 1 5.68-.001 2.84 2.84 0 0 1-5.68 0",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgCart$1 = SvgCart;

const SvgCartCheck = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M6 7.5A1.5 1.5 0 0 1 7.5 6H11a1.5 1.5 0 0 1 1.488 1.314l2.672 21.372A1.5 1.5 0 0 0 16.648 30h10.866a11 11 0 0 0-1.764 3h-9.102a4.5 4.5 0 0 1-4.465-3.942L9.676 9H7.5A1.5 1.5 0 0 1 6 7.5m34.148 19.309 1.532-11.34a3.5 3.5 0 0 0-3.468-3.969H18.2a1.5 1.5 0 0 0 0 3h20.012a.5.5 0 0 1 .495.567l-1.486 11c1.024.113 2.007.367 2.927.742M17 42a3 3 0 1 0 0-6 3 3 0 0 0 0 6m19 3a8 8 0 1 0 0-16 8 8 0 0 0 0 16m3.918-11.068a.915.915 0 0 0-1.228.12l-3.833 4.38-1.6-1.528a.916.916 0 0 0-1.234-.016.81.81 0 0 0-.017 1.197l1.844 1.76c.6.573 1.596.533 2.141-.09l4.055-4.633a.81.81 0 0 0-.128-1.19",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgCartCheck$1 = SvgCartCheck;

const SvgCartTimer = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M7.5 6a1.5 1.5 0 1 0 0 3h2.176l2.507 20.058A4.5 4.5 0 0 0 16.648 33h9.102a11 11 0 0 1 1.764-3H16.648a1.5 1.5 0 0 1-1.488-1.314L12.488 7.314A1.5 1.5 0 0 0 11 6z" }),
      /* @__PURE__ */ jsx("path", { d: "m41.68 15.469-1.532 11.34a11 11 0 0 0-2.927-.742l1.486-11a.5.5 0 0 0-.495-.567H18.2a1.5 1.5 0 0 1 0-3h20.012a3.5 3.5 0 0 1 3.468 3.969M17 42a3 3 0 1 0 0-6 3 3 0 0 0 0 6" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M44 37a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-8-4.6a1 1 0 0 1 1 1v3.986l1.707 1.707a1 1 0 0 1-1.414 1.414l-2-2A1 1 0 0 1 35 37.8v-4.4a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgCartTimer$1 = SvgCartTimer;

const SvgCash = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M30 24a6 6 0 1 1-12 0 6 6 0 0 1 12 0m-3 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M4 16.5A5.5 5.5 0 0 1 9.5 11h29a5.5 5.5 0 0 1 5.5 5.5v15a5.5 5.5 0 0 1-5.5 5.5h-29A5.5 5.5 0 0 1 4 31.5zM9.5 14h29a2.5 2.5 0 0 1 2.5 2.5v15a2.5 2.5 0 0 1-2.5 2.5h-29A2.5 2.5 0 0 1 7 31.5v-15A2.5 2.5 0 0 1 9.5 14",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgCash$1 = SvgCash;

const SvgCatalog = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M24 43.72c-1.14 0-2.29-.29-3.3-.89-2.58-1.5-6.62-3.35-11.23-3.68-3.52-.25-6.17-3.05-6.17-6.51V10.81c0-1.85.79-3.61 2.17-4.85a6.58 6.58 0 0 1 5.13-1.64c4.91.54 9.13 2.5 11.8 4.05 1 .58 2.2.58 3.2 0 2.67-1.55 6.89-3.51 11.8-4.05 1.86-.21 3.74.4 5.13 1.65 1.38 1.23 2.17 3 2.17 4.85v21.83c0 3.46-2.65 6.25-6.17 6.51-4.6.33-8.65 2.18-11.23 3.68-1.02.59-2.16.89-3.3.89zM9.88 7.68c-.79 0-1.55.29-2.14.81-.67.6-1.04 1.42-1.04 2.32v21.83c0 1.65 1.29 2.99 3.01 3.11 5.25.38 9.8 2.45 12.69 4.13 1 .58 2.2.58 3.2 0 2.89-1.67 7.44-3.75 12.69-4.13 1.72-.12 3.01-1.46 3.01-3.11V10.81c0-.89-.37-1.72-1.04-2.32-.67-.61-1.59-.89-2.49-.8-4.32.47-8.08 2.23-10.47 3.61a6.61 6.61 0 0 1-6.61 0c-2.39-1.39-6.15-3.14-10.47-3.61-.12-.01-.24-.02-.35-.02z" }),
      /* @__PURE__ */ jsx("path", { d: "M24 34.99c-.94 0-1.7-.76-1.7-1.7V19.04c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7v14.25c0 .94-.76 1.7-1.7 1.7M16.36 30.59q-.315 0-.63-.12l-4.67-1.85a1.7 1.7 0 0 1-.95-2.21 1.7 1.7 0 0 1 2.21-.95l4.67 1.85a1.7 1.7 0 0 1 .95 2.21c-.26.67-.9 1.07-1.58 1.07m0-9.61q-.315 0-.63-.12l-4.67-1.85a1.7 1.7 0 0 1-.95-2.21 1.7 1.7 0 0 1 2.21-.95l4.67 1.85a1.7 1.7 0 0 1 .95 2.21c-.26.67-.9 1.07-1.58 1.07" })
    ]
  }
);
const SvgCatalog$1 = SvgCatalog;

const SvgChart = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M14.743 18.703a1.7 1.7 0 0 1 1.7 1.7v13.72a1.7 1.7 0 1 1-3.4 0v-13.72a1.7 1.7 0 0 1 1.7-1.7M24.076 12.138a1.7 1.7 0 0 1 1.7 1.7v20.286a1.7 1.7 0 0 1-3.4 0V13.838a1.7 1.7 0 0 1 1.7-1.7M33.257 25.954a1.7 1.7 0 0 1 1.7 1.7v6.47a1.7 1.7 0 1 1-3.4 0v-6.47a1.7 1.7 0 0 1 1.7-1.7",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M5.62 5.971C7.817 3.617 10.94 2.3 14.63 2.3H33.37c3.697 0 6.823 1.316 9.016 3.672 2.18 2.342 3.313 5.574 3.313 9.198v17.66c0 3.624-1.132 6.856-3.313 9.198-2.193 2.356-5.32 3.672-9.016 3.672H14.63c-3.697 0-6.823-1.316-9.016-3.672C3.433 39.686 2.3 36.454 2.3 32.83V15.17c0-3.626 1.138-6.857 3.32-9.199M8.109 8.29C6.609 9.897 5.7 12.25 5.7 15.17v17.66c0 2.922.906 5.275 2.401 6.881 1.483 1.593 3.671 2.589 6.528 2.589H33.37c2.857 0 5.045-.996 6.528-2.589 1.495-1.606 2.401-3.959 2.401-6.881V15.17c0-2.922-.906-5.275-2.401-6.881C38.416 6.696 36.228 5.7 33.37 5.7H14.63c-2.846 0-5.035.996-6.521 2.59",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgChart$1 = SvgChart;

const SvgCheck = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M39.202 13.173a1.7 1.7 0 0 1 0 2.404l-19.25 19.25a1.7 1.7 0 0 1-2.404 0l-8.75-8.75a1.7 1.7 0 1 1 2.404-2.404l7.548 7.548 18.048-18.048a1.7 1.7 0 0 1 2.404 0",
        clipRule: "evenodd"
      }
    )
  }
);
const CheckIcon = SvgCheck;

const SvgCheckCircle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M4.3 24C4.3 13.12 13.12 4.3 24 4.3S43.7 13.12 43.7 24 34.88 43.7 24 43.7 4.3 34.88 4.3 24M24 7.7C14.997 7.7 7.7 14.997 7.7 24c0 9.001 7.297 16.3 16.3 16.3S40.3 33.001 40.3 24c0-9.003-7.297-16.3-16.3-16.3",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M32.127 18.18a1.7 1.7 0 0 1 0 2.405l-9.235 9.235a1.7 1.7 0 0 1-2.404 0l-4.62-4.617a1.7 1.7 0 0 1 2.404-2.405l3.418 3.416 8.033-8.033a1.7 1.7 0 0 1 2.404 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgCheckCircle$1 = SvgCheckCircle;

const SvgCheckCircleSolid = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M24 3.744c-11.088 0-20.1 9.144-20.1 20.388S12.912 44.52 24 44.52s20.1-9.144 20.1-20.388S35.088 3.744 24 3.744m10.032 16.188L23.016 32.964c-.384.444-.924.72-1.512.744h-.084a2.1 2.1 0 0 1-1.488-.612l-6.24-6.24a2.115 2.115 0 0 1 0-2.976 2.09 2.09 0 0 1 2.964 0l4.62 4.62 9.54-11.28a2.11 2.11 0 0 1 2.964-.252c.888.744.996 2.076.252 2.964" })
  }
);
const SvgCheckCircleSolid$1 = SvgCheckCircleSolid;

const SvgChevronDoubleLeft = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M22.933 42.096c-.54 0-1.08-.204-1.488-.612L5.45 25.488A2.09 2.09 0 0 1 4.837 24c0-.564.216-1.092.612-1.488L21.445 6.516a2.1 2.1 0 0 1 2.964 0 2.115 2.115 0 0 1 0 2.976L9.89 24.012l14.52 14.52a2.115 2.115 0 0 1 0 2.976 2.1 2.1 0 0 1-1.488.612z" }),
      /* @__PURE__ */ jsx("path", { d: "M39.734 42.096c-.54 0-1.08-.204-1.489-.612L22.25 25.488A2.09 2.09 0 0 1 21.638 24c0-.564.215-1.092.611-1.488L38.245 6.516a2.1 2.1 0 0 1 2.964 0 2.115 2.115 0 0 1 0 2.976l-14.52 14.52 14.52 14.52a2.115 2.115 0 0 1 0 2.976 2.1 2.1 0 0 1-1.488.612z" })
    ]
  }
);
const SvgChevronDoubleLeft$1 = SvgChevronDoubleLeft;

const SvgChevronDoubleRight = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M25.055 42.096c-.54 0-1.08-.204-1.488-.612a2.115 2.115 0 0 1 0-2.976l14.52-14.52-14.52-14.52a2.115 2.115 0 0 1 0-2.976 2.1 2.1 0 0 1 2.964 0l15.996 15.996a2.115 2.115 0 0 1 0 2.976L26.53 41.46a2.1 2.1 0 0 1-1.488.612z" }),
      /* @__PURE__ */ jsx("path", { d: "M8.255 42.096c-.54 0-1.08-.204-1.488-.612a2.115 2.115 0 0 1 0-2.976l14.52-14.52-14.52-14.52a2.115 2.115 0 0 1 0-2.976 2.1 2.1 0 0 1 2.964 0l15.996 15.996a2.115 2.115 0 0 1 0 2.976L9.73 41.46a2.1 2.1 0 0 1-1.488.612z" })
    ]
  }
);
const SvgChevronDoubleRight$1 = SvgChevronDoubleRight;

const SvgCircle = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M24 43.26c-10.416 0-18.9-8.604-18.9-19.176S13.584 4.908 24 4.908s18.9 8.604 18.9 19.176S34.416 43.26 24 43.26m0-34.14c-8.1 0-14.7 6.72-14.7 14.976S15.9 39.072 24 39.072s14.7-6.72 14.7-14.976S32.1 9.12 24 9.12" })
  }
);
const SvgCircle$1 = SvgCircle;

const SvgClock = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 7.201c-9.28 0-16.8 7.52-16.8 16.8s7.52 16.8 16.8 16.8c9.279 0 16.8-7.52 16.8-16.8s-7.521-16.8-16.8-16.8m-20.2 16.8c0-11.157 9.043-20.2 20.2-20.2s20.2 9.043 20.2 20.2-9.044 20.2-20.2 20.2c-11.157 0-20.2-9.043-20.2-20.2",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M23.323 13.994a1.7 1.7 0 0 1 1.7 1.7v8.728l6.71 4.004a1.7 1.7 0 1 1-1.741 2.92l-7.54-4.498a1.7 1.7 0 0 1-.83-1.46v-9.694a1.7 1.7 0 0 1 1.7-1.7",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgClock$1 = SvgClock;

const SvgClose = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M10.798 10.798a1.7 1.7 0 0 1 2.404 0l24 24a1.7 1.7 0 1 1-2.404 2.404l-24-24a1.7 1.7 0 0 1 0-2.404",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M37.202 10.798a1.7 1.7 0 0 1 0 2.404l-24 24a1.7 1.7 0 0 1-2.404-2.404l24-24a1.7 1.7 0 0 1 2.404 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgClose$1 = SvgClose;

const SvgCloudUpload = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "m35.593 21.741.33-1.857q.076-.428.077-.884a5 5 0 0 0-5.316-4.99l-1.529.094-.973-1.182a8.001 8.001 0 0 0-14.143 4.281l-.164 1.666-1.504.736A6 6 0 0 0 15 31h.499a1.5 1.5 0 0 1 0 3H15a9 9 0 0 1-3.947-17.09C11.601 11.345 16.293 7 22 7c3.423 0 6.481 1.564 8.498 4.015Q30.747 11 31 11a8 8 0 0 1 7.876 9.409A7.5 7.5 0 0 1 34.5 34h-2a1.5 1.5 0 0 1 0-3h2a4.5 4.5 0 0 0 2.624-8.157z" }),
      /* @__PURE__ */ jsx("path", { d: "M30.06 26.06a1.5 1.5 0 0 1-2.12 0l-2.44-2.439V40.5a1.5 1.5 0 0 1-3 0V23.621l-2.44 2.44a1.5 1.5 0 0 1-2.12-2.122l5-5a1.5 1.5 0 0 1 2.12 0l5 5a1.5 1.5 0 0 1 0 2.122" })
    ]
  }
);
const SvgCloudUpload$1 = SvgCloudUpload;

const SvgCog = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#cog_svg__a)", children: [
        /* @__PURE__ */ jsx("path", { d: "M25.24 44.92h-2.51c-3.05 0-5.53-2.48-5.53-5.53 0-.33-.1-.67-.27-.96-.29-.51-.75-.86-1.29-1.01a2.1 2.1 0 0 0-1.59.21c-1.3.73-2.83.91-4.24.51-1.4-.4-2.62-1.36-3.32-2.64l-1.25-2.15c-1.52-2.63-.62-6 2.01-7.52.66-.38 1.06-1.08 1.06-1.84s-.41-1.46-1.06-1.84c-2.62-1.52-3.52-4.9-2-7.53l1.36-2.23c1.5-2.6 4.88-3.51 7.51-2 .32.19.66.28 1 .29 1.14 0 2.09-.94 2.11-2.1 0-1.42.58-2.85 1.6-3.88a5.54 5.54 0 0 1 3.9-1.62h2.51c1.48 0 2.93.61 3.96 1.67a5.52 5.52 0 0 1 1.56 4.01c0 .28.1.62.28.91.29.49.75.84 1.29.98s1.12.06 1.6-.22c2.66-1.52 6.04-.61 7.55 2.03l1.25 2.16c.04.06.07.13.09.19 1.36 2.59.45 5.85-2.1 7.34-.33.19-.59.45-.77.77-.29.49-.37 1.08-.22 1.62.14.54.5 1.01.99 1.28 1.28.74 2.2 1.93 2.58 3.36.38 1.4.17 2.93-.56 4.19l-1.33 2.22c-1.52 2.6-4.9 3.5-7.52 1.99-.31-.18-.67-.28-1.03-.29-.54-.04-1.06.22-1.46.62s-.62.93-.62 1.5a5.54 5.54 0 0 1-5.53 5.52zM15.11 33.96c.48 0 .95.06 1.42.19 1.4.38 2.62 1.32 3.35 2.58.47.79.73 1.71.74 2.66 0 1.19.95 2.14 2.13 2.14h2.51c1.17 0 2.12-.95 2.13-2.12 0-1.44.58-2.87 1.61-3.91a5.48 5.48 0 0 1 3.9-1.61h.03c.96.03 1.87.28 2.67.74 1.01.58 2.32.24 2.9-.77l1.33-2.22c.27-.46.35-1.05.2-1.58-.15-.55-.5-1-.99-1.28a5.57 5.57 0 0 1-2.58-3.35c-.38-1.41-.17-2.94.56-4.19.47-.83 1.17-1.53 2.01-2.01.99-.58 1.33-1.87.76-2.88-.03-.05-.05-.1-.08-.15l-1.16-2.02a2.123 2.123 0 0 0-2.9-.78c-1.23.73-2.76.94-4.16.58a5.5 5.5 0 0 1-3.37-2.54 5.3 5.3 0 0 1-.75-2.67c.02-.64-.2-1.2-.6-1.61s-.95-.64-1.52-.64h-2.51c-.56 0-1.1.23-1.49.62-.4.4-.62.93-.61 1.5-.04 3.04-2.52 5.48-5.53 5.48-.96-.01-1.89-.27-2.7-.75-.99-.57-2.29-.22-2.88.8L8.17 16.4c-.56.98-.22 2.28.79 2.86 1.7.98 2.76 2.81 2.76 4.78s-1.06 3.8-2.76 4.79c-1 .58-1.35 1.87-.77 2.88l1.26 2.17c.29.52.75.89 1.29 1.04s1.13.08 1.62-.19c.82-.48 1.78-.73 2.74-.73z" }),
        /* @__PURE__ */ jsx("path", { d: "M24 30.98c-3.84 0-6.97-3.13-6.97-6.97s3.13-6.97 6.97-6.97 6.97 3.13 6.97 6.97-3.13 6.97-6.97 6.97m0-10.55c-1.97 0-3.57 1.6-3.57 3.57s1.6 3.57 3.57 3.57 3.57-1.6 3.57-3.57-1.6-3.57-3.57-3.57" })
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "cog_svg__a", children: /* @__PURE__ */ jsx("path", { d: "M4.51 3.08h38.97v41.84H4.51z" }) }) })
    ]
  }
);
const SvgCog$1 = SvgCog;

const SvgComment = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M24 43.73c-1.27 0-2.47-.5-3.36-1.4l-2.94-2.95c-.52-.52-1.21-.81-1.95-.81h-2.21c-5.43 0-9.84-4.43-9.84-9.87V14.36c0-5.44 4.41-9.86 9.84-9.86h20.91c5.42 0 9.84 4.43 9.84 9.86V28.7c0 5.44-4.41 9.87-9.84 9.87h-2.21c-.74 0-1.43.29-1.95.81l-2.94 2.95c-.9.9-2.09 1.4-3.36 1.4zM13.55 7.91c-3.55 0-6.44 2.9-6.44 6.46v14.34c0 3.57 2.89 6.47 6.44 6.47h2.21c1.65 0 3.19.64 4.36 1.81l2.94 2.95c.26.26.6.4.96.4s.7-.14.95-.4l2.94-2.95a6.1 6.1 0 0 1 4.36-1.81h2.21c3.55 0 6.44-2.9 6.44-6.47V14.37c0-3.56-2.89-6.46-6.44-6.46z" }),
      /* @__PURE__ */ jsx("path", { d: "M24.97 26.74H17.4c-.94 0-1.7-.76-1.7-1.7s.76-1.7 1.7-1.7h7.57c.94 0 1.7.76 1.7 1.7s-.76 1.7-1.7 1.7M30.59 18.84H17.4c-.94 0-1.7-.76-1.7-1.7s.76-1.7 1.7-1.7h13.19c.94 0 1.7.76 1.7 1.7s-.76 1.7-1.7 1.7" })
    ]
  }
);
const SvgComment$1 = SvgComment;

const SvgContactLine = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M14.28 7.7c-4.893 0-8.38 3.988-8.38 9.328v13.599c0 5.347 3.486 9.325 8.375 9.313h19.449c4.89.012 8.376-3.966 8.376-9.313V17.028c0-5.34-3.487-9.328-8.38-9.328zM2.5 17.028C2.5 10.214 7.13 4.3 14.28 4.3h19.44c7.15 0 11.78 5.914 11.78 12.728v13.599c0 6.82-4.63 12.73-11.782 12.713H14.282C7.13 43.357 2.5 37.447 2.5 30.627z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M11.017 16.518a1.7 1.7 0 0 1 2.39-.257l8.867 7.15c1.035.819 2.5.82 3.536.002l8.79-7.147a1.7 1.7 0 0 1 2.144 2.638l-8.797 7.153-.015.012a6.25 6.25 0 0 1-7.777 0l-.01-.007-8.872-7.154a1.7 1.7 0 0 1-.256-2.39",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgContactLine$1 = SvgContactLine;

const SvgContactSolid = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("mask", { id: "contact-solid_svg__a", children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M10 8a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h28a6 6 0 0 0 6-6V14a6 6 0 0 0-6-6zm4.9 8.8a1.5 1.5 0 0 0-1.8 2.4l10 7.5a1.5 1.5 0 0 0 1.8 0l10-7.5a1.5 1.5 0 0 0-1.8-2.4L24 23.625z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M10 8a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h28a6 6 0 0 0 6-6V14a6 6 0 0 0-6-6zm4.9 8.8a1.5 1.5 0 0 0-1.8 2.4l10 7.5a1.5 1.5 0 0 0 1.8 0l10-7.5a1.5 1.5 0 0 0-1.8-2.4L24 23.625z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "m14.9 16.8 1.8-2.4zm-2.1.3 2.4 1.8zm.3 2.1 1.8-2.4zm10 7.5-1.8 2.4zm1.8 0 1.8 2.4zm10-7.5-1.8-2.4zm.3-2.1 2.4-1.8zm-2.1-.3 1.8 2.4zM24 23.625l-1.8 2.4a3 3 0 0 0 3.6 0zM10 5a9 9 0 0 0-9 9h6a3 3 0 0 1 3-3zm-9 9v20h6V14zm0 20a9 9 0 0 0 9 9v-6a3 3 0 0 1-3-3zm9 9h28v-6H10zm28 0a9 9 0 0 0 9-9h-6a3 3 0 0 1-3 3zm9-9V14h-6v20zm0-20a9 9 0 0 0-9-9v6a3 3 0 0 1 3 3zm-9-9H10v6h28zm-21.3 9.4a4.5 4.5 0 0 0-6.3.9l4.8 3.6a1.5 1.5 0 0 1-2.1.3zm-6.3.9a4.5 4.5 0 0 0 .9 6.3l3.6-4.8a1.5 1.5 0 0 1 .3 2.1zm.9 6.3 10 7.5 3.6-4.8-10-7.5zm10 7.5a4.5 4.5 0 0 0 5.4 0l-3.6-4.8a1.5 1.5 0 0 1 1.8 0zm5.4 0 10-7.5-3.6-4.8-10 7.5zm10-7.5a4.5 4.5 0 0 0 .9-6.3l-4.8 3.6a1.5 1.5 0 0 1 .3-2.1zm.9-6.3a4.5 4.5 0 0 0-6.3-.9l3.6 4.8a1.5 1.5 0 0 1-2.1-.3zm-6.3-.9-9.1 6.825 3.6 4.8 9.1-6.825zm-5.5 6.825L16.7 14.4l-3.6 4.8 9.1 6.825z",
          mask: "url(#contact-solid_svg__a)"
        }
      )
    ]
  }
);
const SvgContactSolid$1 = SvgContactSolid;

const SvgCopy = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M34 7h-9a3 3 0 0 0-3 3v2.5a1.5 1.5 0 0 1-3 0V10a6 6 0 0 1 6-6h9a6 6 0 0 1 6 6v16a6 6 0 0 1-6 6h-.5a1.5 1.5 0 0 1 0-3h.5a3 3 0 0 0 3-3V10a3 3 0 0 0-3-3" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M8 22a6 6 0 0 1 6-6h9a6 6 0 0 1 6 6v16a6 6 0 0 1-6 6h-9a6 6 0 0 1-6-6zm6-3h9a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3V22a3 3 0 0 1 3-3",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgCopy$1 = SvgCopy;

const SvgCounterClockwiseUndo = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M29.31 8.6c-7.569-2.612-15.7.651-19.515 7.37a1.7 1.7 0 1 1-2.957-1.678c4.605-8.112 14.43-12.065 23.581-8.905h.001C40.685 8.94 46.148 20.15 42.596 30.417 39.06 40.707 27.85 46.17 17.564 42.616a19.61 19.61 0 0 1-12.55-13.34 1.7 1.7 0 0 1 3.277-.906A16.21 16.21 0 0 0 18.672 39.4h.002c8.512 2.942 17.784-1.578 20.707-10.089v-.003C42.32 20.818 37.805 11.54 29.31 8.6",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M7.832 6.843a1.7 1.7 0 0 1 1.7 1.7v4.898h4.862a1.7 1.7 0 1 1 0 3.4H7.832a1.7 1.7 0 0 1-1.7-1.7V8.543a1.7 1.7 0 0 1 1.7-1.7M24.317 15.449a1.7 1.7 0 0 1 1.7 1.7v8.195a1.7 1.7 0 0 1-.828 1.46l-6.348 3.794a1.7 1.7 0 0 1-1.744-2.919l5.52-3.299v-7.232a1.7 1.7 0 0 1 1.7-1.7",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgCounterClockwiseUndo$1 = SvgCounterClockwiseUndo;

const SvgCustomer = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M7.823 34.448c-.407.426-.624.918-.624 1.59 0 .668.217 1.154.624 1.576.447.463 1.186.906 2.29 1.275 2.225.744 5.415 1.025 9.07 1.025 3.672 0 6.86-.291 9.079-1.044 1.1-.373 1.835-.819 2.281-1.285.407-.426.624-.916.624-1.587 0-.667-.217-1.154-.625-1.577-.447-.465-1.187-.908-2.29-1.278-2.226-.746-5.416-1.03-9.069-1.03-3.672 0-6.86.293-9.078 1.047-1.1.373-1.836.82-2.282 1.288m1.188-4.507c2.769-.942 6.422-1.227 10.172-1.227 3.725 0 7.377.276 10.15 1.205 1.394.468 2.692 1.141 3.657 2.142 1.006 1.043 1.577 2.37 1.577 3.937 0 1.562-.566 2.89-1.566 3.936-.96 1.005-2.254 1.684-3.647 2.156-2.77.94-6.423 1.224-10.171 1.224-3.725 0-7.377-.274-10.149-1.2-1.394-.467-2.693-1.14-3.658-2.14-1.006-1.043-1.577-2.37-1.577-3.936 0-1.563.565-2.89 1.565-3.938.96-1.006 2.253-1.686 3.647-2.16M19.183 8.2a7.071 7.071 0 1 0 0 14.14h.059a7.04 7.04 0 0 0 7.011-7.064v-.006a7.07 7.07 0 0 0-7.07-7.07M8.711 15.27c0-5.784 4.69-10.47 10.472-10.47 5.78 0 10.469 4.685 10.47 10.467.02 5.764-4.639 10.451-10.402 10.473h-.068c-5.782 0-10.472-4.687-10.472-10.47M31.439 8.452A1.7 1.7 0 0 1 33.39 7.05a8.3 8.3 0 0 1 6.95 8.19v.002a8.3 8.3 0 0 1-7.138 8.205 1.7 1.7 0 0 1-.473-3.367 4.9 4.9 0 0 0 4.21-4.842 4.9 4.9 0 0 0-4.099-4.833 1.7 1.7 0 0 1-1.402-1.953M35.51 29.214a1.7 1.7 0 0 1 1.931-1.431c1.643.245 3.247.68 4.48 1.488 1.318.866 2.238 2.191 2.238 3.983 0 1.186-.407 2.223-1.143 3.054-.705.797-1.643 1.332-2.621 1.704a1.7 1.7 0 1 1-1.208-3.179c.67-.254 1.065-.532 1.283-.778.186-.21.289-.444.289-.8 0-.448-.163-.787-.704-1.141-.625-.41-1.656-.75-3.115-.968a1.7 1.7 0 0 1-1.43-1.932",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgCustomer$1 = SvgCustomer;

const SvgCustomerDisplay = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M27.331 14.257a1 1 0 0 1 1.412.074l2.793 3.103 2.792-3.103a1 1 0 0 1 1.487 1.338l-2.741 3.045h1.997a1 1 0 1 1 0 2h-2.535v1.143h2.535a1 1 0 1 1 0 2h-2.535V26a1 1 0 1 1-2 0v-2.143H28a1 1 0 0 1 0-2h2.536v-1.143H28a1 1 0 1 1 0-2h1.997l-2.74-3.045a1 1 0 0 1 .074-1.412" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M10 8a6 6 0 0 0-6 6v13a6 6 0 0 0 6 6h12.5v4H17a1.5 1.5 0 0 0 0 3h14a1.5 1.5 0 0 0 0-3h-5.5v-4H38a6 6 0 0 0 6-6V14a6 6 0 0 0-6-6zm28 3H10a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h28a3 3 0 0 0 3-3V14a3 3 0 0 0-3-3",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgCustomerDisplay$1 = SvgCustomerDisplay;

const SvgCustomerDisplayOffline = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M4 14a6 6 0 0 1 6-6h28a6 6 0 0 1 6 6v13q-.001.672-.142 1.303A11 11 0 0 0 41 26.199V14a3 3 0 0 0-3-3H10a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h16.779A10.95 10.95 0 0 0 25 36c0 1.411.266 2.76.75 4H17a1.5 1.5 0 0 1 0-3h5.5v-4H10a6 6 0 0 1-6-6z" }),
      /* @__PURE__ */ jsx("path", { d: "M32.536 25.557q-1.006.335-1.916.846a1 1 0 0 1-.084-.403v-2.143H28a1 1 0 0 1 0-2h2.536v-1.143H28a1 1 0 1 1 0-2h1.997l-2.74-3.045a1 1 0 1 1 1.486-1.338l2.793 3.103 2.792-3.103a1 1 0 0 1 1.487 1.338l-2.741 3.045h1.997a1 1 0 1 1 0 2h-2.535v1.143h2.535a1 1 0 1 1 0 2h-2.535z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M30.343 30.343a8 8 0 1 0 11.315 11.314 8 8 0 0 0-11.315-11.314",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgCustomerDisplayOffline$1 = SvgCustomerDisplayOffline;

const SvgDescendingOrder = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M16.44 31.44 13 34.878V9.5a1.5 1.5 0 0 0-3 0v25.379l-3.44-3.44a1.5 1.5 0 0 0-2.12 2.122l6 6a1.5 1.5 0 0 0 2.12 0l6-6a1.5 1.5 0 0 0-2.12-2.122M25.5 11a1.5 1.5 0 0 0 0 3h17a1.5 1.5 0 0 0 0-3zM24 24.5a1.5 1.5 0 0 1 1.5-1.5h13a1.5 1.5 0 0 1 0 3h-13a1.5 1.5 0 0 1-1.5-1.5M25.5 35a1.5 1.5 0 0 0 0 3h7a1.5 1.5 0 0 0 0-3z" })
  }
);
const SvgDescendingOrder$1 = SvgDescendingOrder;

const SvgDiscovery = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M31.886 16.118a1.7 1.7 0 0 1 .42 1.71l-3.185 10.178a1.7 1.7 0 0 1-1.115 1.115l-10.178 3.185a1.7 1.7 0 0 1-2.13-2.13l3.185-10.178a1.7 1.7 0 0 1 1.115-1.115l10.178-3.185a1.7 1.7 0 0 1 1.71.42m-10.024 5.744-1.95 6.23 6.23-1.95 1.95-6.23z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24.002 6.48c-9.677 0-17.522 7.845-17.522 17.522s7.845 17.522 17.522 17.522 17.522-7.845 17.522-17.522S33.679 6.48 24.002 6.48M3.08 24.002c0-11.555 9.367-20.922 20.922-20.922s20.922 9.367 20.922 20.922-9.367 20.922-20.922 20.922S3.08 35.557 3.08 24.002",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgDiscovery$1 = SvgDiscovery;

const SvgDocument = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M17.5 14a1.5 1.5 0 0 0 0 3h5a1.5 1.5 0 0 0 0-3zM16 24.5a1.5 1.5 0 0 1 1.5-1.5h13a1.5 1.5 0 0 1 0 3h-13a1.5 1.5 0 0 1-1.5-1.5M16 33.5a1.5 1.5 0 0 1 1.5-1.5h13a1.5 1.5 0 0 1 0 3h-13a1.5 1.5 0 0 1-1.5-1.5" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M8 38a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V16.405a4.5 4.5 0 0 0-1.267-3.13L31.08 5.37A4.5 4.5 0 0 0 27.847 4H14a6 6 0 0 0-6 6zm6 3a3 3 0 0 1-3-3V10a3 3 0 0 1 3-3h13v8.5a1.5 1.5 0 0 0 1.5 1.5H37v21a3 3 0 0 1-3 3zm21.26-27L30 8.568V14z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgDocument$1 = SvgDocument;

const SvgDocumentCircle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M14 31.5a4.5 4.5 0 0 0 4.5 4.5h11a4.5 4.5 0 0 0 4.5-4.5V20.243a4.5 4.5 0 0 0-1.318-3.182l-3.743-3.743A4.5 4.5 0 0 0 25.757 12H18.5a4.5 4.5 0 0 0-4.5 4.5zm4.5 1.5a1.5 1.5 0 0 1-1.5-1.5v-15a1.5 1.5 0 0 1 1.5-1.5H24v5.5a1.5 1.5 0 0 0 1.5 1.5H31v9.5a1.5 1.5 0 0 1-1.5 1.5zm11.879-14L27 15.621V19z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M44 24c0 11.046-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4s20 8.954 20 20m-3 0c0 9.389-7.611 17-17 17S7 33.389 7 24 14.611 7 24 7s17 7.611 17 17",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgDocumentCircle$1 = SvgDocumentCircle;

const SvgDownload = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M24 6a1.5 1.5 0 0 1 1.5 1.5v19.879l5.44-5.44a1.5 1.5 0 0 1 2.12 2.122l-8 8a1.5 1.5 0 0 1-2.12 0l-8-8a1.5 1.5 0 0 1 2.12-2.122l5.44 5.44V7.5A1.5 1.5 0 0 1 24 6" }),
      /* @__PURE__ */ jsx("path", { d: "M9 28.5a1.5 1.5 0 0 0-3 0V36a6 6 0 0 0 6 6h24a6 6 0 0 0 6-6v-7.5a1.5 1.5 0 0 0-3 0V36a3 3 0 0 1-3 3H12a3 3 0 0 1-3-3z" })
    ]
  }
);
const SvgDownload$1 = SvgDownload;

const SvgEMoney = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M16 20a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2zM14 16.5a1.5 1.5 0 0 1 1.5-1.5h2a1.5 1.5 0 0 1 0 3h-2a1.5 1.5 0 0 1-1.5-1.5M33 20a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-5a1.5 1.5 0 0 0 0 3h5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-5.5a6.5 6.5 0 1 1 0-13z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M4 15a6 6 0 0 1 6-6h28a6 6 0 0 1 6 6v18a6 6 0 0 1-6 6H10a6 6 0 0 1-6-6zm6-3h28a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V15a3 3 0 0 1 3-3",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgEMoney$1 = SvgEMoney;

const SvgEdit = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M26.56 21.33c-.34 0-.68-.1-.97-.31-.77-.54-.96-1.6-.42-2.37l3.08-4.4a1.701 1.701 0 1 1 2.79 1.95l-3.08 4.4c-.33.47-.86.73-1.39.73z" }),
      /* @__PURE__ */ jsx("path", { d: "M14.46 41.69c-1.07 0-2.02-.18-2.7-.64-1.89-1.29-2.38-5.2-2.45-8.25-.05-2.13.55-4.19 1.75-5.95l11.73-16.81a8.64 8.64 0 0 1 5.64-3.6c2.3-.41 4.62.11 6.54 1.45 3.94 2.76 4.9 8.21 2.15 12.16L25.51 36.69a10.15 10.15 0 0 1-5.39 3.97c-1.75.54-3.87 1.04-5.65 1.04zm-.77-3.46c.54.18 2.56.05 5.42-.84a6.77 6.77 0 0 0 3.59-2.65l11.62-16.65A5.336 5.336 0 0 0 33 10.67a5.3 5.3 0 0 0-3.99-.88 5.27 5.27 0 0 0-3.44 2.2L13.85 28.78a6.74 6.74 0 0 0-1.15 3.94c.07 2.92.6 5.03.98 5.52z" })
    ]
  }
);
const SvgEdit$1 = SvgEdit;

const SvgExchange = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M40.777 23.59a1.7 1.7 0 0 1 1.7 1.7v2.581a9.44 9.44 0 0 1-9.442 9.442H13.912l4.84 4.84a1.7 1.7 0 0 1-2.404 2.405l-7.742-7.743a1.7 1.7 0 0 1 0-2.404l7.742-7.742a1.7 1.7 0 1 1 2.404 2.404l-4.84 4.84h19.123a6.04 6.04 0 0 0 6.042-6.042v-2.58a1.7 1.7 0 0 1 1.7-1.7M29.251 3.443a1.7 1.7 0 0 1 2.404 0l7.743 7.742a1.7 1.7 0 0 1 0 2.404l-7.743 7.742a1.7 1.7 0 1 1-2.404-2.404l4.84-4.84H14.97a6.04 6.04 0 0 0-6.042 6.042v2.58a1.7 1.7 0 1 1-3.4 0v-2.58a9.44 9.44 0 0 1 9.442-9.442H34.09l-4.84-4.84a1.7 1.7 0 0 1 0-2.405",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgExchange$1 = SvgExchange;

const SvgExternalLink = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M7.348 10.045C9.174 8.085 11.768 7 14.8 7h5.961a1.7 1.7 0 1 1 0 3.4h-5.96c-2.192 0-3.85.764-4.967 1.963C8.705 13.576 8 15.37 8 17.635v14.13c0 2.267.702 4.061 1.83 5.272C10.944 38.235 12.6 39 14.8 39h14.994c2.202 0 3.859-.765 4.974-1.963 1.129-1.211 1.831-3.005 1.831-5.272V26.67a1.7 1.7 0 1 1 3.4 0v5.095c0 2.969-.929 5.642-2.742 7.59-1.827 1.96-4.422 3.045-7.463 3.045H14.801c-3.04 0-5.634-1.085-7.46-3.046-1.813-1.947-2.741-4.62-2.741-7.59V17.636c0-2.97.934-5.644 2.748-7.59",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M32.037 6.4a1.7 1.7 0 1 1 0-3.4H42.3A1.7 1.7 0 0 1 44 4.7v10.263a1.7 1.7 0 1 1-3.4 0V8.804L27.502 21.902a1.7 1.7 0 0 1-2.404-2.404L38.196 6.4z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgExternalLink$1 = SvgExternalLink;

const SvgEye = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M24 40.55h-.01c-8.6 0-16.32-5.94-20.65-15.87-.19-.43-.19-.93 0-1.36C7.68 13.38 15.4 7.45 24 7.45s16.32 5.93 20.66 15.87c.19.43.19.93 0 1.36-4.33 9.93-12.05 15.87-20.65 15.87zM6.77 24C10.59 32.25 16.99 37.15 24 37.15S37.41 32.25 41.23 24c-3.82-8.25-10.22-13.15-17.24-13.15S10.58 15.75 6.76 24z" }),
      /* @__PURE__ */ jsx("path", { d: "M24.01 32.14c-4.54 0-8.23-3.65-8.23-8.13s3.69-8.13 8.23-8.13 8.23 3.65 8.23 8.13-3.69 8.13-8.23 8.13m0-12.86c-2.66 0-4.83 2.12-4.83 4.73s2.17 4.73 4.83 4.73 4.83-2.12 4.83-4.73-2.17-4.73-4.83-4.73" })
    ]
  }
);
const SvgEye$1 = SvgEye;

const SvgEyeSlash = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M9.182 8.94a1.5 1.5 0 1 0-2.121 2.12l3.797 3.798c-2.466 1.964-4.392 4.202-5.78 6.067a5.15 5.15 0 0 0 0 6.15C8.363 31.491 14.67 38 24 38c3.06 0 5.794-.7 8.203-1.797l4.556 4.556a1.5 1.5 0 1 0 2.121-2.121zM7.485 22.715c1.378-1.853 3.217-3.951 5.509-5.722l3.713 3.713a8 8 0 0 0 10.586 10.586l2.616 2.615A16.5 16.5 0 0 1 24 35c-7.847 0-13.374-5.494-16.515-9.716a2.15 2.15 0 0 1 0-2.568M19 24q0-.47.084-.916l5.832 5.832A5 5 0 0 1 19 24",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "m21.048 16.562 2.461 2.462a5 5 0 0 1 5.467 5.467l2.462 2.461a8 8 0 0 0-10.39-10.39" }),
      /* @__PURE__ */ jsx("path", { d: "M35.278 30.793c2.166-1.725 3.913-3.73 5.237-5.509a2.15 2.15 0 0 0 0-2.568C37.375 18.494 31.847 13 24 13c-2.003 0-3.854.358-5.553.961l-2.314-2.314A19.6 19.6 0 0 1 24 10c9.33 0 15.637 6.51 18.922 10.925a5.15 5.15 0 0 1 0 6.15c-1.337 1.797-3.174 3.94-5.511 5.85z" })
    ]
  }
);
const SvgEyeSlash$1 = SvgEyeSlash;

const SvgFaceRecognition = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M13.786 7.7A6.085 6.085 0 0 0 7.7 13.784v3.154a1.7 1.7 0 1 1-3.4 0v-3.154C4.3 8.546 8.547 4.3 13.786 4.3h2.578a1.7 1.7 0 1 1 0 3.4zM6 29.362a1.7 1.7 0 0 1 1.7 1.7v3.155a6.085 6.085 0 0 0 6.086 6.084H16.3a1.7 1.7 0 1 1 0 3.4h-2.514c-5.24 0-9.486-4.246-9.486-9.484v-3.155a1.7 1.7 0 0 1 1.7-1.7M42 29.362a1.7 1.7 0 0 1 1.7 1.7v3.155c0 5.238-4.246 9.484-9.485 9.484h-2.578a1.7 1.7 0 1 1 0-3.4h2.578a6.085 6.085 0 0 0 6.086-6.084v-3.155a1.7 1.7 0 0 1 1.7-1.7M30 6a1.7 1.7 0 0 1 1.7-1.7h2.513c5.24 0 9.486 4.246 9.486 9.484v3.154a1.7 1.7 0 1 1-3.4 0v-3.154A6.084 6.084 0 0 0 34.213 7.7H31.7A1.7 1.7 0 0 1 30 6M11.019 24c0-7.17 5.81-12.981 12.98-12.981s12.98 5.81 12.98 12.98S31.17 36.98 24 36.98 11.02 31.17 11.02 24m12.98-9.581a9.58 9.58 0 0 0-9.58 9.58 9.58 9.58 0 0 0 9.58 9.58A9.58 9.58 0 0 0 33.58 24 9.58 9.58 0 0 0 24 14.42",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M21.12 19.054a1.7 1.7 0 0 1 1.7 1.7v.117a1.7 1.7 0 0 1-3.4 0v-.117a1.7 1.7 0 0 1 1.7-1.7m5.868 0a1.7 1.7 0 0 1 1.7 1.7v.117a1.7 1.7 0 0 1-3.4 0v-.117a1.7 1.7 0 0 1 1.7-1.7M19.649 25.484a1.7 1.7 0 0 1 2.371.395c.4.56 1.114.961 1.984.961s1.584-.402 1.983-.961a1.7 1.7 0 0 1 2.767 1.976c-1.06 1.485-2.822 2.386-4.75 2.386-1.929 0-3.69-.901-4.75-2.386a1.7 1.7 0 0 1 .395-2.371",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgFaceRecognition$1 = SvgFaceRecognition;

const SvgFilter = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M6 10a1.5 1.5 0 0 0 0 3h36a1.5 1.5 0 0 0 0-3zM10.5 24a1.5 1.5 0 0 1 1.5-1.5h24a1.5 1.5 0 0 1 0 3H12a1.5 1.5 0 0 1-1.5-1.5M16.5 36.5A1.5 1.5 0 0 1 18 35h12a1.5 1.5 0 0 1 0 3H18a1.5 1.5 0 0 1-1.5-1.5" })
  }
);
const SvgFilter$1 = SvgFilter;

const SvgGift = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M38.5 12H35a6 6 0 0 0-10.5-3.969A6 6 0 0 0 14 12H9.5A3.5 3.5 0 0 0 6 15.5v8a3.5 3.5 0 0 0 2 3.163V37.5a4.5 4.5 0 0 0 4.5 4.5h23a4.5 4.5 0 0 0 4.5-4.5V26.663a3.5 3.5 0 0 0 2-3.163v-8a3.5 3.5 0 0 0-3.5-3.5M29 9a3 3 0 0 1 3 3h-6a3 3 0 0 1 3-3m-6 3h-6a3 3 0 1 1 6 0M11 37.5V27h11.5v12h-10a1.5 1.5 0 0 1-1.5-1.5M25.5 39h10a1.5 1.5 0 0 0 1.5-1.5V27H25.5zm0-15h13a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-13zm-3-9h-13a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h13z",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgGift$1 = SvgGift;

const SvgGiftCertificates = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M10.5 20.29c0-2.752 2.373-4.79 5.053-4.79 1.552 0 3.002.684 3.947 1.795.945-1.11 2.395-1.795 3.947-1.795 2.68 0 5.053 2.038 5.053 4.79 0 2.748-2.367 4.784-5.043 4.79l2.667 2.711a1.5 1.5 0 0 1-2.14 2.104l-4.536-4.615-4.537 4.615a1.5 1.5 0 1 1-2.14-2.104l2.668-2.713c-2.633-.056-4.939-2.075-4.939-4.788m5.053-1.79c-1.245 0-2.053.908-2.053 1.79s.808 1.79 2.053 1.79 2.052-.908 2.052-1.79-.808-1.79-2.052-1.79m7.894 0c-1.244 0-2.052.908-2.052 1.79s.808 1.79 2.052 1.79c1.245 0 2.053-.908 2.053-1.79s-.808-1.79-2.053-1.79",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M4 15a6 6 0 0 1 6-6h28a6 6 0 0 1 6 6v18a6 6 0 0 1-6 6H10a6 6 0 0 1-6-6zm6-3h28a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V15a3 3 0 0 1 3-3",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgGiftCertificates$1 = SvgGiftCertificates;

const SvgGlobe = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M24 4c11.046 0 20 8.954 20 20s-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4m17 20c0 1.378-.164 2.717-.473 4H32.82c.118-1.292.18-2.63.18-4s-.062-2.707-.18-4h7.707c.31 1.283.473 2.622.473 4m-11.193-4c.125 1.279.193 2.617.193 4s-.068 2.721-.193 4H18.193A41 41 0 0 1 18 24c0-1.383.068-2.721.193-4zm2.626-3h7.064a17.05 17.05 0 0 0-10.19-9.155c1.408 2.288 2.506 5.463 3.126 9.155M24 7c.57 0 2.084.657 3.628 4.089.733 1.629 1.342 3.635 1.76 5.911H18.612c.418-2.276 1.027-4.282 1.76-5.911C21.916 7.657 23.43 7 24 7m5.307 33.155A17.05 17.05 0 0 0 39.497 31h-7.064c-.62 3.692-1.718 6.867-3.126 9.155m.08-9.155c-.417 2.276-1.026 4.282-1.759 5.911C26.084 40.343 24.57 41 24 41c-.57 0-2.084-.657-3.628-4.089-.733-1.629-1.342-3.635-1.76-5.911zm-13.82 0c.62 3.692 1.718 6.867 3.127 9.155A17.05 17.05 0 0 1 8.504 31zm-.387-3H7.473A17 17 0 0 1 7 24c0-1.378.164-2.717.473-4h7.707a44 44 0 0 0-.18 4c0 1.37.062 2.708.18 4m.387-11H8.503a17.05 17.05 0 0 1 10.19-9.155c-1.408 2.288-2.506 5.463-3.126 9.155",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgGlobe$1 = SvgGlobe;

const SvgGridMultiItems = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M10.396 7.7A2.696 2.696 0 0 0 7.7 10.396v5.208a2.696 2.696 0 0 0 2.696 2.696h5.208a2.696 2.696 0 0 0 2.696-2.696v-5.208A2.696 2.696 0 0 0 15.604 7.7zM4.3 10.396A6.096 6.096 0 0 1 10.396 4.3h5.208a6.096 6.096 0 0 1 6.096 6.096v5.208a6.096 6.096 0 0 1-6.096 6.096h-5.208A6.096 6.096 0 0 1 4.3 15.604zM32.396 29.7a2.696 2.696 0 0 0-2.696 2.696v5.208a2.696 2.696 0 0 0 2.696 2.696h5.208a2.696 2.696 0 0 0 2.696-2.696v-5.208a2.696 2.696 0 0 0-2.696-2.696zM26.3 32.396a6.096 6.096 0 0 1 6.096-6.096h5.208a6.096 6.096 0 0 1 6.096 6.096v5.208a6.096 6.096 0 0 1-6.096 6.096h-5.208a6.096 6.096 0 0 1-6.096-6.096zM10.396 29.7A2.696 2.696 0 0 0 7.7 32.396v5.208a2.696 2.696 0 0 0 2.696 2.696h5.208a2.696 2.696 0 0 0 2.696-2.696v-5.208a2.696 2.696 0 0 0-2.696-2.696zM4.3 32.396a6.096 6.096 0 0 1 6.096-6.096h5.208a6.096 6.096 0 0 1 6.096 6.096v5.208a6.096 6.096 0 0 1-6.096 6.096h-5.208A6.096 6.096 0 0 1 4.3 37.604zM32.396 7.7a2.696 2.696 0 0 0-2.696 2.696v5.208a2.696 2.696 0 0 0 2.696 2.696h5.208a2.696 2.696 0 0 0 2.696-2.696v-5.208A2.696 2.696 0 0 0 37.604 7.7zM26.3 10.396A6.096 6.096 0 0 1 32.396 4.3h5.208a6.096 6.096 0 0 1 6.096 6.096v5.208a6.096 6.096 0 0 1-6.096 6.096h-5.208a6.096 6.096 0 0 1-6.096-6.096z",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgGridMultiItems$1 = SvgGridMultiItems;

const SvgHandle = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M17.747 33.05c1.072.107 2.004.99 2.004 2.19 0 1.28-1.06 2.201-2.22 2.201-1.089 0-2.089-.81-2.21-1.964l-.011-.237.011-.234c.12-1.157 1.122-1.965 2.21-1.965zm12.942 0c1.071.107 2.003.99 2.003 2.19 0 1.28-1.06 2.201-2.22 2.201-1.09 0-2.088-.81-2.21-1.964l-.011-.237.012-.234c.12-1.157 1.12-1.965 2.209-1.965zm-12.942-11.4c1.072.106 2.004.99 2.004 2.19 0 1.279-1.059 2.201-2.22 2.201-1.09 0-2.089-.81-2.21-1.965l-.011-.236.011-.235c.12-1.156 1.121-1.964 2.21-1.964zm12.942 0c1.071.106 2.003.99 2.003 2.19 0 1.279-1.059 2.201-2.22 2.201-1.09 0-2.088-.81-2.21-1.965l-.011-.236.012-.235c.12-1.156 1.12-1.964 2.209-1.964zm-12.942-11.4c1.072.106 2.004.99 2.004 2.19 0 1.279-1.06 2.2-2.22 2.2-1.09 0-2.089-.81-2.21-1.964l-.011-.236.011-.235c.12-1.156 1.121-1.964 2.21-1.965zm12.942 0c1.071.106 2.003.99 2.003 2.19 0 1.279-1.06 2.2-2.22 2.2-1.09 0-2.088-.81-2.21-1.964l-.011-.236.012-.235c.12-1.156 1.12-1.965 2.209-1.965z" })
  }
);
const SvgHandle$1 = SvgHandle;

const SvgHeart = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M24.017 17.48a3 3 0 0 1-2.488-1.3c-2.337-3.395-5.56-4.157-8.057-3.512C10.929 13.324 9 15.423 9 18.452c0 1.071.451 2.515 1.504 4.305 1.03 1.751 2.495 3.596 4.171 5.406 3.288 3.55 7.13 6.692 9.339 8.4 2.209-1.685 6.042-4.785 9.32-8.316 1.672-1.8 3.132-3.641 4.16-5.4C38.54 21.053 39 19.58 39 18.451c0-3.184-1.974-5.305-4.472-5.95-2.455-.634-5.678.136-8.037 3.65a3 3 0 0 1-2.474 1.328m-2.048-5.324c.725.648 1.409 1.42 2.031 2.324a13.3 13.3 0 0 1 1.998-2.355C32.36 6.245 42 10.118 42 18.452c0 7.509-11.813 17.19-16.3 20.596a2.78 2.78 0 0 1-3.392-.013C17.828 35.587 6 25.787 6 18.452c0-8.121 9.608-11.976 15.969-6.296",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgHeart$1 = SvgHeart;

const SvgHeartSolid = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M22.87 39.465c.675.51 1.588.513 2.266.008C29.09 36.526 42 26.303 42 18.453c0-9.27-11.925-13.021-18-3.973-6.075-8.827-18-5.076-18 3.972 0 7.668 12.926 18.029 16.87 21.013",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgHeartSolid$1 = SvgHeartSolid;

const SvgHierarchy = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M32 28.572V32H16V16h3.43v12.572z" })
  }
);
const SvgHierarchy$1 = SvgHierarchy;

const SvgHome = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M18.97 4.038a8.06 8.06 0 0 1 10.001 0l.004.004 13.148 10.485a6.58 6.58 0 0 1 2.577 5.125v17.472c0 4.752-3.887 8.576-8.646 8.576h-3.888c-2.245-.053-4.065-1.875-4.065-4.138v-6.153c0-.612-.506-1.138-1.167-1.138H21.17a1.153 1.153 0 0 0-1.155 1.138v6.134q0 .241-.064.464c-.232 2.09-2.018 3.693-4.156 3.693h-3.848c-4.759 0-8.646-3.824-8.646-8.576V19.678a6.54 6.54 0 0 1 2.577-5.132zm-2.356 37.143V35.41c0-2.51 2.043-4.521 4.537-4.538h5.783c2.506 0 4.567 2.016 4.567 4.538v6.153a.75.75 0 0 0 .73.738h3.823c2.913 0 5.246-2.334 5.246-5.176V19.689a3.18 3.18 0 0 0-1.284-2.494L26.859 6.703l-.001-.002a4.66 4.66 0 0 0-5.772 0L7.988 17.21l-.037.03A3.14 3.14 0 0 0 6.7 19.703v17.42c0 2.842 2.332 5.176 5.246 5.176h3.848a.77.77 0 0 0 .782-.757q0-.187.038-.361",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgHome$1 = SvgHome;

const SvgHorizontalRule = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M4.5 24A1.5 1.5 0 0 1 6 22.5h36a1.5 1.5 0 0 1 0 3H6A1.5 1.5 0 0 1 4.5 24",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgHorizontalRule$1 = SvgHorizontalRule;

const SvgIdCard = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M10.106 39.22h15.885q6.043.001 12.086-.002.521-.001 1.039-.07c2.846-.376 5.135-2.926 5.144-5.796.018-5.954.01-11.909.002-17.863v-.524c-.001-.418-.053-.847-.148-1.255C43.456 10.882 41.063 9 38.137 9q-13.997-.003-27.992.003a6.2 6.2 0 0 0-1.239.109c-2.937.6-4.905 3.026-4.905 6.027q-.003 8.978.004 17.957c0 .367.024.74.089 1.1.532 2.957 3.011 5.024 6.012 5.024m9.327-27.2h4.692-.001 14.035c1.578 0 2.796 1.024 3.06 2.577.025.148.027.3.027.45v18.119a3.01 3.01 0 0 1-2.98 3.033q-.23.002-.46.002H27.348l-17.175.001c-1.178 0-2.094-.475-2.722-1.476a2.87 2.87 0 0 1-.43-1.557V15.05a3.007 3.007 0 0 1 3.026-3.028zm-6.134 5.445c-1.938 2.03-1.605 5.528 1.031 7.068v.001l-.07.032-.027.012c-2.163.936-3.626 2.556-4.562 4.686-.278.633-.218 1.26.186 1.825.528.738 1.282 1.066 2.169 1.069q3.285.007 6.57.004h2.554q.82 0 1.51-.441c.863-.552 1.234-1.512.868-2.384-.832-1.986-2.162-3.532-4.092-4.529a11 11 0 0 0-.401-.193l-.188-.088c2.578-1.526 2.973-4.915 1.084-7.007-1.742-1.93-4.814-1.959-6.632-.055m19.61 1.61q1.401-.004 2.803.002c.9.005 1.587.758 1.507 1.627-.076.823-.726 1.389-1.61 1.39q-1.646.003-3.292.002h-2.312q-1.125 0-2.25-.003c-.772-.003-1.348-.419-1.544-1.099-.27-.943.419-1.903 1.4-1.914.945-.01 1.889-.007 2.833-.005l1.239.002v-.002zm2.762 7.051h-7.978c-.863 0-1.532.651-1.542 1.496a1.51 1.51 0 0 0 1.52 1.522q4.01.006 8.02 0c.869 0 1.538-.678 1.531-1.53-.006-.836-.684-1.488-1.55-1.488",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgIdCard$1 = SvgIdCard;

const SvgImage = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M19 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M4 34a6 6 0 0 0 .25 1.72A6.005 6.005 0 0 0 10 40h28a6 6 0 0 0 6-6V14a6 6 0 0 0-6-6H10a6 6 0 0 0-6 6zm34-23H10a3 3 0 0 0-3 3v18l5.586-5.586a2 2 0 0 1 2.828 0l2.672 2.672a2 2 0 0 0 2.828 0l9.672-9.672a2 2 0 0 1 2.828 0L41 27V14a3 3 0 0 0-3-3",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgImage$1 = SvgImage;

const SvgImageAdd = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M4.071 34.929A6 6 0 0 1 4 34V14a6 6 0 0 1 6-6h28a6 6 0 0 1 6 6v14.45a11 11 0 0 0-3-2.25V14a3 3 0 0 0-3-3H10a3 3 0 0 0-3 3v18l5.586-5.586a2 2 0 0 1 2.828 0l2.672 2.672a2 2 0 0 0 2.828 0l9.672-9.672a2 2 0 0 1 2.828 0l6.19 6.19A11 11 0 0 0 36 25c-6.075 0-11 4.925-11 11 0 1.411.266 2.76.75 4H10q-.311 0-.613-.031a6.005 6.005 0 0 1-5.316-5.04" }),
      /* @__PURE__ */ jsx("path", { d: "M22 19a3 3 0 1 1-6 0 3 3 0 0 1 6 0" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M44 36a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-9-4a1 1 0 1 1 2 0v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3h-3a1 1 0 1 1 0-2h3z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgImageAdd$1 = SvgImageAdd;

const SvgImageCaption = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M32 22a2 2 0 1 1-4 0 2 2 0 0 1 4 0" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M20.025 29.975A5 5 0 0 1 20 29.5v-11a4.5 4.5 0 0 1 4.5-4.5h15a4.5 4.5 0 0 1 4.5 4.5v11a4.5 4.5 0 0 1-4.484 4.5H24.471a4.5 4.5 0 0 1-4.446-4.025M24.5 17h15a1.5 1.5 0 0 1 1.5 1.5V25l-3.293-3.293a1 1 0 0 0-1.414 0l-5.586 5.586a1 1 0 0 1-1.414 0l-2.586-2.586a1 1 0 0 0-1.414 0L23 27v-8.5a1.5 1.5 0 0 1 1.5-1.5",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M5.5 16a1.5 1.5 0 0 0 0 3h10a1.5 1.5 0 0 0 0-3zM4 30.5A1.5 1.5 0 0 1 5.5 29h4a1.5 1.5 0 0 1 0 3h-4A1.5 1.5 0 0 1 4 30.5M5.5 22.5a1.5 1.5 0 0 0 0 3h7a1.5 1.5 0 0 0 0-3z" })
    ]
  }
);
const SvgImageCaption$1 = SvgImageCaption;

const SvgImageCircle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M22.5 24a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M16.5 15a4.5 4.5 0 0 0-4.5 4.5v10a4.5 4.5 0 0 0 4.5 4.5h15.037A4.5 4.5 0 0 0 36 29.5v-10a4.5 4.5 0 0 0-4.5-4.5zm12.407 7.707L33 26.8v-7.3a1.5 1.5 0 0 0-1.5-1.5h-15a1.5 1.5 0 0 0-1.5 1.5V29l3.293-3.293a1 1 0 0 1 1.414 0l1.686 1.686a1 1 0 0 0 1.414 0l4.686-4.686a1 1 0 0 1 1.414 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M44 24c0 11.046-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4s20 8.954 20 20m-3 0c0 9.389-7.611 17-17 17S7 33.389 7 24 14.611 7 24 7s17 7.611 17 17",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgImageCircle$1 = SvgImageCircle;

const SvgInbox = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "m3.415 21.174 7.078-12.387A3.15 3.15 0 0 1 13.228 7.2h21.544a3.15 3.15 0 0 1 2.735 1.587l7.078 12.387c.272.476.415 1.014.415 1.563V34.5a6.3 6.3 0 0 1-6.3 6.3H9.3A6.3 6.3 0 0 1 3 34.5V22.737c0-.549.143-1.087.415-1.563m2.913 1.251 6.9-12.075h21.544l6.9 12.075H33.45c-2.102 0-3.462 1.686-3.908 3.204a5.778 5.778 0 0 1-11.085 0c-.445-1.518-1.805-3.204-3.907-3.204zm-.178 3.15V34.5a3.15 3.15 0 0 0 3.15 3.15h29.4a3.15 3.15 0 0 0 3.15-3.15v-8.925h-8.4c-.122 0-.273.046-.446.205a1.64 1.64 0 0 0-.439.736 8.928 8.928 0 0 1-17.13 0 1.64 1.64 0 0 0-.439-.736c-.173-.16-.324-.205-.446-.205z",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgInbox$1 = SvgInbox;

const SvgInfinity = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M4 24c0-5.328 4.172-9.5 9.5-9.5a13.25 13.25 0 0 1 6.817 1.91 9 9 0 0 1 .538.357l.037.027.013.01.005.003.002.002c.001 0 .001.001-.912 1.191l.913-1.19a1.5 1.5 0 0 1-1.82 2.384l-.009-.006-.058-.041a6 6 0 0 0-.28-.181A10.254 10.254 0 0 0 13.5 17.5c-3.67-.001-6.499 2.827-6.499 6.499s2.828 6.5 6.5 6.5c4.318 0 6.526-3.178 9.246-7.323l.144-.22c2.502-3.815 5.545-8.457 11.61-8.457 5.328 0 9.5 4.172 9.5 9.5s-4.172 9.5-9.5 9.5a13.25 13.25 0 0 1-6.817-1.91 9 9 0 0 1-.538-.357l-.037-.027-.013-.01-.005-.003-.003-.003L28 30l-.913 1.19a1.5 1.5 0 0 1 1.82-2.384l.006.003-.003-.001-.002-.002.008.006.058.041c.058.04.152.103.28.181A10.254 10.254 0 0 0 34.5 30.5c3.67.001 6.499-2.827 6.499-6.499s-2.828-6.5-6.5-6.5c-4.318 0-6.526 3.178-9.246 7.323l-.144.22C22.608 28.858 19.565 33.5 13.5 33.5 8.172 33.5 4 29.328 4 24",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgInfinity$1 = SvgInfinity;

const SvgInfo = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M23.988 34.356c-1.164 0-2.1-.936-2.1-2.1v-8.688c0-1.164.936-2.1 2.1-2.1s2.1.936 2.1 2.1v8.688c0 1.164-.936 2.1-2.1 2.1M24 18.504a2.37 2.37 0 0 1-1.656-.684 2.35 2.35 0 0 1-.684-1.656c0-.624.252-1.224.684-1.656.864-.876 2.436-.876 3.312 0 .432.432.684 1.032.684 1.656s-.252 1.224-.684 1.656a2.37 2.37 0 0 1-1.656.684" }),
      /* @__PURE__ */ jsx("path", { d: "M24 44.388C12.912 44.388 3.9 35.244 3.9 24S12.912 3.612 24 3.612 44.1 12.756 44.1 24 35.088 44.388 24 44.388M24 7.8c-8.772 0-15.9 7.26-15.9 16.188S15.228 40.176 24 40.176s15.9-7.26 15.9-16.188S32.772 7.8 24 7.8" })
    ]
  }
);
const SvgInfo$1 = SvgInfo;

const SvgInfoCircle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M6.906 7.237C8.963 5.03 11.888 3.8 15.33 3.8h17.338c3.45 0 6.377 1.23 8.433 3.438 2.043 2.194 3.1 5.216 3.1 8.594v16.336c0 3.378-1.057 6.4-3.1 8.595-2.057 2.208-4.984 3.437-8.435 3.437H15.33c-3.45 0-6.376-1.23-8.432-3.437C4.856 38.569 3.8 35.546 3.8 32.168V15.832c0-3.38 1.062-6.402 3.106-8.595m2.487 2.318c-1.36 1.46-2.193 3.603-2.193 6.277v16.336c0 2.676.83 4.82 2.187 6.278 1.345 1.445 3.333 2.354 5.943 2.354h17.336c2.611 0 4.601-.91 5.946-2.354 1.358-1.458 2.188-3.602 2.188-6.278V15.832c0-2.676-.83-4.82-2.187-6.277C37.266 8.11 35.277 7.2 32.667 7.2H15.33c-2.6 0-4.59.91-5.937 2.355",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M23.99 22.3a1.7 1.7 0 0 1 1.7 1.7v8a1.7 1.7 0 1 1-3.4 0v-8a1.7 1.7 0 0 1 1.7-1.7M22.28 16.409a1.7 1.7 0 0 1 1.7-1.7H24a1.7 1.7 0 0 1 0 3.4h-.02a1.7 1.7 0 0 1-1.7-1.7",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgInfoCircle$1 = SvgInfoCircle;

const SvgInfoSolid = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M24 3.612C12.912 3.612 3.9 12.756 3.9 24S12.912 44.388 24 44.388 44.1 35.244 44.1 24 35.088 3.612 24 3.612m2.1 30.084c0 1.164-.936 2.1-2.1 2.1s-2.1-.936-2.1-2.1V22.44c0-1.164.936-2.1 2.1-2.1s2.1.936 2.1 2.1zm-.444-17.448a2.37 2.37 0 0 1-1.656.684 2.4 2.4 0 0 1-1.656-.684 2.37 2.37 0 0 1-.684-1.656c0-.156.012-.3.048-.456.036-.144.072-.3.132-.444s.132-.276.216-.408q.126-.198.288-.36c.876-.876 2.436-.876 3.312 0q.162.162.288.36c.084.132.156.264.216.408s.108.288.132.444.048.3.048.456c0 .612-.252 1.224-.684 1.656" })
  }
);
const SvgInfoSolid$1 = SvgInfoSolid;

const SvgInquiry = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M8.11 8.298c-1.5 1.614-2.41 3.978-2.41 6.91v8.155h7.837c2.621 0 5.01 1.489 6.171 3.84a4.79 4.79 0 0 0 4.296 2.675 4.79 4.79 0 0 0 4.297-2.676 6.88 6.88 0 0 1 6.17-3.839H42.3v-8.155c0-2.935-.907-5.298-2.403-6.91-1.483-1.6-3.67-2.598-6.524-2.598H14.629c-2.843 0-5.032.998-6.519 2.598M42.3 26.764h-7.829c-1.323 0-2.532.75-3.122 1.945a8.19 8.19 0 0 1-7.345 4.57 8.19 8.19 0 0 1-7.344-4.57 3.48 3.48 0 0 0-3.123-1.945H5.7v6.164c0 2.934.907 5.297 2.404 6.91 1.484 1.599 3.671 2.597 6.525 2.597h18.742c2.855 0 5.042-.999 6.526-2.597 1.496-1.613 2.403-3.976 2.403-6.91zM5.62 5.983C7.814 3.622 10.94 2.3 14.63 2.3h18.743c3.698 0 6.824 1.321 9.017 3.685 2.179 2.35 3.31 5.59 3.31 9.222v17.72c0 3.634-1.131 6.874-3.31 9.224-2.194 2.363-5.32 3.684-9.02 3.684H14.63c-3.698 0-6.825-1.321-9.018-3.684C3.432 39.8 2.3 36.56 2.3 32.928v-17.72c0-3.636 1.138-6.876 3.32-9.224m9.922 8.92a1.7 1.7 0 0 1 1.7-1.7h13.522a1.7 1.7 0 1 1 0 3.4H17.242a1.7 1.7 0 0 1-1.7-1.7",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgInquiry$1 = SvgInquiry;

const SvgInvoice = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M19.62 12.01c.68-.68 1.77-.68 2.45 0l1.87 1.87q.105.105.18.21.075-.105.18-.21l1.87-1.87c.68-.68 1.77-.68 2.45 0s.68 1.77 0 2.45l-2.08 1.63 1.32-.2c.96 0 1.73.78 1.73 1.73s-.78 1.73-1.73 1.73l-2.14-.2.2.82h1.94c.96 0 1.73.78 1.73 1.73s-.78 1.73-1.73 1.73l-2.14-.09.2 2.43c0 .96-.78 1.73-1.73 1.73s-1.73-.78-1.73-1.73l.2-2.43-2.55.09c-.96 0-1.73-.78-1.73-1.73s.78-1.73 1.73-1.73h2.34l.2-.82-2.55.2c-.96 0-1.73-.78-1.73-1.73s.78-1.73 1.73-1.73l1.32.2-1.83-1.63c-.68-.68-.68-1.77 0-2.45z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M24 44.71a9.2 9.2 0 0 1-3.49-.69l-4.53-1.85c-.54-.22-1.15-.2-1.67.05l-1.6.77c-1.32.63-2.85.54-4.09-.24a4.21 4.21 0 0 1-1.98-3.59l.02-25.88c0-6.16 3.7-9.99 9.66-9.99h15.42c5.93 0 9.61 3.83 9.61 9.99l.04 25.88c0 1.47-.74 2.81-1.98 3.59s-2.77.87-4.09.24l-1.59-.76c-.52-.25-1.13-.27-1.67-.05l-4.54 1.85c-1.13.46-2.31.69-3.49.69zm-8.8-6.09c.7 0 1.41.14 2.07.41l4.52 1.85c1.42.58 2.99.58 4.42 0l4.53-1.85a5.47 5.47 0 0 1 4.43.13l1.59.76c.36.17.67.05.81-.05.12-.07.39-.29.39-.71l-.04-25.88c0-3.01-1.08-6.59-6.21-6.59H16.29c-5.17 0-6.25 3.58-6.25 6.59l-.02 25.89c0 .41.25.62.39.71.15.09.45.22.81.05l1.6-.77c.74-.36 1.55-.53 2.36-.53z" }),
      /* @__PURE__ */ jsx("path", { d: "M29.53 34.44H18.22c-.94 0-1.7-.76-1.7-1.7s.76-1.7 1.7-1.7h11.31c.94 0 1.7.76 1.7 1.7s-.76 1.7-1.7 1.7" })
    ]
  }
);
const SvgInvoice$1 = SvgInvoice;

const SvgItem = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M15.584 3.517c.896-.073 1.61.398 2 .936 1.343 1.847 3.788 2.89 6.417 2.89s5.073-1.043 6.415-2.89c.392-.538 1.105-1.01 2.002-.936 1.03.086 2.118.453 3.134.906 1.037.463 2.105 1.065 3.116 1.706 2.015 1.279 3.924 2.792 5.078 3.887.59.56.812 1.369.652 2.118l-1.547 7.218a2.28 2.28 0 0 1-2.227 1.8h-2.387v21.07a2.28 2.28 0 0 1-2.278 2.278H12.042a2.28 2.28 0 0 1-2.278-2.278v-21.07H7.377a2.28 2.28 0 0 1-2.227-1.8l-1.553-7.246a2.25 2.25 0 0 1 .553-2.012C5.233 8.937 7.19 7.4 9.23 6.126c1.033-.645 2.127-1.246 3.185-1.707 1.036-.453 2.14-.817 3.17-.902m-.319 3.51c-.412.1-.91.273-1.483.523-.867.378-1.81.892-2.744 1.475-1.605 1.001-3.067 2.131-3.968 2.98l1.228 5.73h2.605a2.28 2.28 0 0 1 2.278 2.278v21.07h21.64v-21.07a2.28 2.28 0 0 1 2.277-2.278h2.605l1.216-5.674a34 34 0 0 0-4.082-3.047c-.918-.583-1.836-1.095-2.677-1.47a9 9 0 0 0-1.426-.515c-2.174 2.552-5.533 3.73-8.733 3.73-3.202 0-6.562-1.18-8.736-3.732",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgItem$1 = SvgItem;

const SvgItemAdd = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M16.61 6.016c.786-.064 1.413.35 1.756.822C19.547 8.46 21.693 9.375 24 9.375c2.307 0 4.454-.915 5.633-2.537.344-.472.97-.886 1.758-.821.903.074 1.86.397 2.752.795.91.406 1.847.934 2.735 1.498 1.77 1.122 3.446 2.451 4.459 3.412.517.492.713 1.202.572 1.86l-1.358 6.337a2 2 0 0 1-1.955 1.581H36.5v4.511a11 11 0 0 0-3 .274V20.5a2 2 0 0 1 2-2h2.287l1.068-4.982a30 30 0 0 0-3.584-2.675A19 19 0 0 0 32.92 9.55a8 8 0 0 0-1.252-.452C29.76 11.34 26.81 12.375 24 12.375s-5.761-1.036-7.67-3.277a8.3 8.3 0 0 0-1.303.46c-.76.331-1.589.783-2.408 1.294-1.41.88-2.694 1.872-3.485 2.617l1.079 5.031H12.5a2 2 0 0 1 2 2V39h10.681a11 11 0 0 0 1.019 3H13.5a2 2 0 0 1-2-2V21.5H9.404a2 2 0 0 1-1.955-1.58l-1.364-6.362c-.128-.6.02-1.27.486-1.767.95-1.016 2.668-2.367 4.46-3.484a22 22 0 0 1 2.796-1.5c.91-.396 1.88-.716 2.783-.79" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M44 37a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-8-5a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgItemAdd$1 = SvgItemAdd;

const SvgItemset = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M15.615 3.516c.892-.073 1.603.396 1.993.932 1.337 1.84 3.774 2.88 6.392 2.88s5.055-1.04 6.393-2.88c.39-.536 1.1-1.006 1.994-.932 1.025.085 2.11.45 3.123.903 1.033.46 2.096 1.06 3.104 1.7 2.007 1.273 3.91 2.781 5.059 3.872.587.557.81 1.364.65 2.11l-1.541 7.191a2.27 2.27 0 0 1-2.22 1.794H36.79s-1.792 0-1.792-1.794 1.792-1.61 2.052-1.61h2.595l1.212-5.653a34 34 0 0 0-4.067-3.036c-.915-.581-1.83-1.091-2.668-1.466a9 9 0 0 0-1.42-.513c-2.166 2.543-5.513 3.718-8.702 3.718s-6.537-1.176-8.703-3.72c-.41.101-.907.272-1.478.522-.863.377-1.803.889-2.733 1.47-1.6.997-3.057 2.123-3.954 2.969l1.223 5.709h2.596a2.27 2.27 0 0 1 2.27 2.27v20.992h7.355s1.33.262 1.33 1.833c0 1.572-1.572 1.572-1.572 1.572h-8.248a2.27 2.27 0 0 1-2.27-2.27V21.086H7.438a2.27 2.27 0 0 1-2.22-1.794l-1.546-7.218a2.24 2.24 0 0 1 .55-2.005c1.08-1.153 3.028-2.686 5.062-3.954 1.029-.642 2.119-1.24 3.173-1.701 1.032-.45 2.133-.814 3.158-.898" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M27.694 23.478c.75-.62 1.706-.898 2.646-.898h9.553c.94 0 1.896.278 2.646.898a3.44 3.44 0 0 1 1.253 2.694l-.001 1.656a3.44 3.44 0 0 1-1.45 2.846v7.687a5.15 5.15 0 0 1-2.405 4.357l-6.252 3.938a6.9 6.9 0 0 1-8.696-1.102c-3.12-3.308-2.244-8.677 1.767-10.82l1.51-.807V30.91q-.301-.165-.572-.388a3.44 3.44 0 0 1-1.253-2.694l.002-1.656v-.001c0-1.104.474-2.05 1.252-2.693m3.714 7.942v3.383c0 .62-.342 1.19-.889 1.483l-2.283 1.22c-2.184 1.166-2.662 4.09-.962 5.892a3.76 3.76 0 0 0 4.735.6l1.841-1.16a7.413 7.413 0 0 1 5.347-9.912V31.42zm7.79 4.779a4.27 4.27 0 0 0-2.598 4.906l1.66-1.046a2 2 0 0 0 .938-1.698zm-9.583-10.201a.4.4 0 0 0-.031.174l-.001 1.656c0 .093.018.146.031.174a.3.3 0 0 0 .08.097c.092.076.3.179.645.179h9.553c.344 0 .553-.103.645-.179a.3.3 0 0 0 .08-.097.4.4 0 0 0 .031-.174l.002-1.656a.4.4 0 0 0-.032-.174.3.3 0 0 0-.08-.097c-.091-.076-.3-.179-.645-.179H30.34c-.344 0-.553.103-.645.179a.3.3 0 0 0-.08.097",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgItemset$1 = SvgItemset;

const SvgKey = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M23.95 25c-.501 5.053-4.765 9-9.95 9-5.523 0-10-4.477-10-10s4.477-10 10-10c4.838 0 8.873 3.436 9.8 8h18.7a1.5 1.5 0 0 1 0 3H39v5.5a1.5 1.5 0 0 1-3 0V25h-5v3.5a1.5 1.5 0 0 1-3 0V25zM21 24a7 7 0 1 1-14 0 7 7 0 0 1 14 0",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgKey$1 = SvgKey;

const SvgKeypad = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M6 12a6 6 0 0 1 6-6h24a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6zm6-3.2h5.114q-.015.098-.014.2v5.6H9q-.102 0-.2.014V12A3.2 3.2 0 0 1 12 8.8m7.9.2q0-.102-.014-.2h8.228q-.014.098-.014.2v5.6h-8.2zm8.2 8.4h-8.2v5.2h8.2zm2.8 5.2v-5.2h8.3v5.2zm-2.8 2.8h-8.2v5.2h8.2zm2.8 5.2v-5.2h8.3v5.2zM9 33.4q-.102 0-.2-.014V36a3.2 3.2 0 0 0 3.2 3.2h24a3.2 3.2 0 0 0 3.2-3.2v-2.6zm21.9-18.8V9q0-.102-.014-.2H36a3.2 3.2 0 0 1 3.2 3.2v2.6zM9 17.4h8.1v5.2H9q-.102 0-.2.014v-5.228q.098.015.2.014m0 8h8.1v5.2H9q-.102 0-.2.014v-5.228q.098.014.2.014",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgKeypad$1 = SvgKeypad;

const SvgKnifeAndFork = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M35.36 43.7c-.29 0-.58-.04-.88-.14-1.71-.54-7.96-5.69-7.22-21.03.16-2.05 1.03-3.58 2.68-4.72.47-.33.67-.63.6-1.55-.09-1.07-.17-1.92-.24-2.7-.14-1.47-.26-2.75-.38-4.82-.07-1.25.36-2.41 1.2-3.25.83-.83 1.96-1.25 3.19-1.19 2.23.12 3.86 1.95 3.86 4.34V40.5c0 1.13-.46 2.11-1.24 2.68-.46.34-1.01.51-1.58.51zm-1.29-36c-.22 0-.41.07-.54.2-.15.15-.22.38-.21.65.11 2.01.22 3.19.37 4.69.07.79.16 1.65.25 2.73.17 2.04-.5 3.56-2.05 4.63-.8.55-1.15 1.17-1.22 2.13-.51 10.54 2.53 15.17 4.12 16.85V8.64c0-.21-.05-.92-.65-.95h-.06zM17.73 43.7c-1.34 0-2.67-.59-3.63-1.62-.93-1-1.4-2.28-1.3-3.59.25-3.54.51-5.93.84-8.96.1-.95.21-1.97.33-3.09.23-2.23-.24-3.69-1.59-4.88-1.77-1.57-2.66-3.69-2.56-6.11.08-2 .17-4 .26-6l.13-2.77c.04-.94.85-1.65 1.77-1.62.94.04 1.66.84 1.62 1.77l-.13 2.78c-.09 1.99-.18 3.98-.26 5.98-.06 1.41.41 2.54 1.42 3.43 2.17 1.92 3.06 4.47 2.72 7.78-.12 1.13-.23 2.14-.33 3.1-.32 3-.58 5.36-.83 8.84-.03.49.24.85.4 1.03.62.67 1.66.67 2.28 0 .16-.18.43-.54.4-1.03-.25-3.46-.5-5.82-.82-8.8-.1-.97-.22-2-.34-3.14-.35-3.31.54-5.86 2.72-7.78 1.01-.89 1.47-2.02 1.42-3.43-.08-1.99-.17-3.98-.26-5.98l-.13-2.78c-.04-.94.68-1.73 1.62-1.77.93-.03 1.73.68 1.77 1.62l.13 2.77c.09 2 .18 4 .26 6 .1 2.43-.79 4.54-2.56 6.11-1.35 1.19-1.82 2.65-1.59 4.88.12 1.14.23 2.16.33 3.13.33 3.02.59 5.4.84 8.92.09 1.31-.37 2.59-1.3 3.59-.96 1.03-2.28 1.62-3.63 1.62" }),
      /* @__PURE__ */ jsx("path", { d: "M15.77 14.68c-.94 0-1.7-.77-1.69-1.71l.02-6.08c0-.94.74-1.68 1.71-1.69.94 0 1.7.77 1.69 1.71l-.02 6.08c0 .94-.76 1.69-1.7 1.69zM19.67 14.68c-.94 0-1.7-.77-1.69-1.71L18 6.89c0-.94.76-1.69 1.7-1.69s1.7.77 1.69 1.71l-.02 6.08c0 .94-.76 1.69-1.7 1.69" })
    ]
  }
);
const SvgKnifeAndFork$1 = SvgKnifeAndFork;

const SvgLamp = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M26.731 6.977c-8.377-1.696-15.734 4.64-15.734 12.703 0 5.36 3.249 9.95 7.884 11.905a1.7 1.7 0 0 1 1.04 1.566v4.885c0 2.24 1.84 4.08 4.08 4.08 2.237 0 4.078-1.84 4.078-4.08v-4.86a1.7 1.7 0 0 1 1.038-1.565c5.393-2.28 8.918-8.233 7.573-14.717-1.03-4.928-5.032-8.908-9.959-9.917M7.597 19.68c0-10.183 9.298-18.164 19.81-16.035l.004.001c6.255 1.28 11.3 6.295 12.607 12.553v.002c1.602 7.712-2.301 14.874-8.539 18.058v3.777c0 4.117-3.362 7.48-7.478 7.48-4.117 0-7.48-3.362-7.48-7.48v-3.8A16.3 16.3 0 0 1 7.596 19.68",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M22.832 33.186a1.7 1.7 0 0 1 1.7-1.7h5.258a1.7 1.7 0 1 1 0 3.4h-5.258a1.7 1.7 0 0 1-1.7-1.7M22.728 15.586c-1.706-.346-3.18.932-3.18 2.553a1.7 1.7 0 1 1-3.4 0 6.02 6.02 0 0 1 7.255-5.885 1.7 1.7 0 1 1-.675 3.332",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgLamp$1 = SvgLamp;

const SvgLgChevronDown = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M8.798 16.798a1.7 1.7 0 0 1 2.404 0L24 29.596l12.798-12.798a1.7 1.7 0 0 1 2.404 2.404l-14 14a1.7 1.7 0 0 1-2.404 0l-14-14a1.7 1.7 0 0 1 0-2.404",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgLgChevronDown$1 = SvgLgChevronDown;

const SvgLgChevronLeft = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M31.202 8.798a1.7 1.7 0 0 1 0 2.404L18.404 24l12.798 12.798a1.7 1.7 0 1 1-2.404 2.404l-14-14a1.7 1.7 0 0 1 0-2.404l14-14a1.7 1.7 0 0 1 2.404 0",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgLgChevronLeft$1 = SvgLgChevronLeft;

const SvgLgChevronRight = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M16.798 8.798a1.7 1.7 0 0 1 2.404 0l14 14a1.7 1.7 0 0 1 0 2.404l-14 14a1.7 1.7 0 0 1-2.404-2.404L29.596 24 16.798 11.202a1.7 1.7 0 0 1 0-2.404",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgLgChevronRight$1 = SvgLgChevronRight;

const SvgLgChevronUp = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M22.798 16.798a1.7 1.7 0 0 1 2.404 0l14 14a1.7 1.7 0 1 1-2.404 2.404L24 20.404 11.202 33.202a1.7 1.7 0 0 1-2.404-2.404z",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgLgChevronUp$1 = SvgLgChevronUp;

const SvgListBullet = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M13.827 37.203a1.7 1.7 0 0 1 1.7-1.7h26.399a1.7 1.7 0 1 1 0 3.4H15.527a1.7 1.7 0 0 1-1.7-1.7M13.827 24.004a1.7 1.7 0 0 1 1.7-1.7h26.399a1.7 1.7 0 0 1 0 3.4H15.527a1.7 1.7 0 0 1-1.7-1.7M13.827 10.806a1.7 1.7 0 0 1 1.7-1.7h26.399a1.7 1.7 0 1 1 0 3.4H15.527a1.7 1.7 0 0 1-1.7-1.7M4.476 10.804a2.274 2.274 0 1 1 4.547 0 2.274 2.274 0 0 1-4.547 0M4.476 24.003a2.274 2.274 0 1 1 4.547 0 2.274 2.274 0 0 1-4.547 0M4.476 37.201a2.273 2.273 0 1 1 4.547 0 2.273 2.273 0 0 1-4.547 0",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgListBullet$1 = SvgListBullet;

const SvgListNumber = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("g", { clipPath: "url(#list-number_svg__a)", children: /* @__PURE__ */ jsx("path", { d: "M15.092 11.46a1.5 1.5 0 0 1 1.5-1.5h24a1.5 1.5 0 0 1 0 3h-24a1.5 1.5 0 0 1-1.5-1.5M15.092 23.96a1.5 1.5 0 0 1 1.5-1.5h24a1.5 1.5 0 1 1 0 3h-24a1.5 1.5 0 0 1-1.5-1.5M15.092 36.46a1.5 1.5 0 0 1 1.5-1.5h24a1.5 1.5 0 1 1 0 3h-24a1.5 1.5 0 0 1-1.5-1.5M9.44 21.385c-.671 0-1.131-.453-1.131-1.14V12.45h-.046l-1.592 1.11c-.211.15-.37.203-.604.203-.46 0-.8-.332-.8-.815 0-.347.136-.604.491-.853l2.158-1.494c.528-.362.89-.43 1.359-.43.807 0 1.29.49 1.29 1.275v8.8c0 .686-.453 1.139-1.124 1.139M5.894 37.686c-.717 0-1.072-.4-1.072-.974 0-.43.166-.717.626-1.14l3.245-3.1c1.343-1.291 1.69-1.82 1.69-2.604 0-.898-.694-1.54-1.667-1.54-.875 0-1.48.438-1.872 1.314-.256.452-.52.664-1.01.664-.612 0-.974-.363-.974-.929 0-.173.03-.332.083-.49.37-1.207 1.735-2.332 3.795-2.332 2.31 0 3.864 1.298 3.864 3.17 0 1.328-.649 2.158-2.43 3.84L7.818 35.83v.046h4.105c.589 0 .943.354.943.905 0 .536-.354.906-.943.906z" }) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "list-number_svg__a", children: /* @__PURE__ */ jsx("path", { d: "M0 0h48v48H0z" }) }) })
    ]
  }
);
const SvgListNumber$1 = SvgListNumber;

const SvgLock = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M14.5 13.714V18H14a6 6 0 0 0-6 6v14a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V24a6 6 0 0 0-6-6h-.5v-4.286c0-5.14-4.305-9.214-9.5-9.214s-9.5 4.074-9.5 9.214M24 7.5c-3.642 0-6.5 2.833-6.5 6.214V18h13v-4.286c0-3.38-2.858-6.214-6.5-6.214M14 21a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h20a3 3 0 0 0 3-3V24a3 3 0 0 0-3-3zm13 8a3 3 0 0 1-1.4 2.538V35.5a1.5 1.5 0 0 1-3 0v-3.846A3 3 0 1 1 27 29",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgLock$1 = SvgLock;

const SvgLockCheck = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M30.997 29.121a1.5 1.5 0 1 0-1.994-2.242l-6.711 5.966-3.289-2.96a1.5 1.5 0 1 0-2.006 2.23l3.953 3.558a2 2 0 0 0 2.666.008z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M14.5 13.714V18H14a6 6 0 0 0-6 6v14a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V24a6 6 0 0 0-6-6h-.5v-4.286c0-5.14-4.305-9.214-9.5-9.214s-9.5 4.074-9.5 9.214M24 7.5c-3.642 0-6.5 2.833-6.5 6.214V18h13v-4.286c0-3.38-2.858-6.214-6.5-6.214M14 21a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h20a3 3 0 0 0 3-3V24a3 3 0 0 0-3-3z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgLockCheck$1 = SvgLockCheck;

const SvgLogoStores = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M28.813 3.163A34.15 34.15 0 0 0 13 14.764C3.325 26.53 5.914 36.882 24.766 34.701c9.674-.968 5.804-12.55-2.513-6.492-11.243 8.23-7.125 22.24 6.9 14.247 14.336-8.105 18.015-29.224-6.424-24.578-6.197 1.276-5.326 9.005.842 7.794 4.262-.915 9.763-7.454 9.763-12.32 0-3.035-1.83-4.374-3.32-3.571-1.154.614-1.094 2.327 0 2.876 1.633.81-.785 6.16-5.677 9.559-2.244 1.339-3.4-.852-.688-1.224 10.78-1.971 14.708 1.525 13.09 7.18-1.682 5.326-5.693 9.74-10.765 12.08-8.712 4.01-8.747-3.862-2.218-9.507 2.924-2.528 4.566.026 1.872.523-5.697 1.046-19.96 2.146-12.477-10.893C17.523 12.733 24.8 7.87 30.222 6.285c2.014-.588 1.404-4.071-1.409-3.122" })
  }
);
const SvgLogoStores$1 = SvgLogoStores;

const SvgLogout = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M15.118 7.795c-1.129.092-1.794.266-2.306.526a5.7 5.7 0 0 0-2.49 2.491c-.262.512-.435 1.177-.527 2.306-.094 1.149-.095 2.622-.095 4.722v12.32c0 2.1.001 3.573.095 4.722.092 1.129.265 1.794.526 2.306a5.7 5.7 0 0 0 2.491 2.49c.512.262 1.177.435 2.306.527 1.149.094 2.622.095 4.722.095H20a1.7 1.7 0 0 1 0 3.4h-.233c-2.01 0-3.622 0-4.926-.106-1.339-.11-2.501-.34-3.572-.886a9.1 9.1 0 0 1-3.977-3.977c-.546-1.07-.776-2.233-.886-3.572-.106-1.304-.106-2.916-.106-4.925V17.767c0-2.01 0-3.622.106-4.926.11-1.339.34-2.501.886-3.572a9.1 9.1 0 0 1 3.977-3.977c1.07-.546 2.233-.776 3.572-.885 1.304-.107 2.916-.107 4.926-.107H20a1.7 1.7 0 1 1 0 3.4h-.16c-2.1 0-3.573.001-4.722.095",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M34.092 14.378a1.7 1.7 0 0 1 2.404-.035l8.688 8.437a1.7 1.7 0 0 1 0 2.44l-8.688 8.436a1.7 1.7 0 1 1-2.369-2.44L39.81 25.7H18.9a1.7 1.7 0 0 1 0-3.4h20.91l-5.682-5.517a1.7 1.7 0 0 1-.035-2.404",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgLogout$1 = SvgLogout;

const SvgMapMarker = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M8.247 21.054C8.247 11.8 15.747 4.3 25 4.3s16.752 7.5 16.752 16.754c0 5.977-3.49 11.608-7.051 15.618-1.807 2.034-3.7 3.729-5.322 4.928-.81.599-1.577 1.093-2.254 1.446-.594.31-1.376.654-2.125.654-.748 0-1.53-.343-2.125-.654-.677-.353-1.444-.847-2.254-1.446-1.622-1.2-3.515-2.894-5.321-4.928-3.562-4.01-7.052-9.641-7.052-15.618M25 7.7c-7.374 0-13.352 5.978-13.352 13.354 0 4.734 2.832 9.575 6.194 13.36 1.656 1.865 3.375 3.398 4.8 4.453.715.528 1.33.917 1.806 1.165.293.153.47.219.552.248a4 4 0 0 0 .552-.248c.476-.248 1.09-.637 1.806-1.165 1.425-1.055 3.145-2.588 4.8-4.453 3.362-3.785 6.194-8.626 6.194-13.36 0-7.376-5.978-13.354-13.352-13.354",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M18.28 20.93A6.717 6.717 0 0 1 25 14.215a6.718 6.718 0 1 1-6.718 6.717M25 17.615a3.318 3.318 0 1 0 0 6.635 3.318 3.318 0 0 0 0-6.635",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgMapMarker$1 = SvgMapMarker;

const SvgMessage = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M30.3 43.7c-1.5 0-2.8-.7-3.6-2L19 29.2 6.3 21.3c-1.4-.9-2.2-2.5-2-4.2s1.4-3 3-3.5l30.9-9.1c1.5-.4 3.1 0 4.2 1.1s1.5 2.7 1.1 4.2l-9.1 30.9c-.5 1.6-1.8 2.8-3.5 3zm-7.9-15.5 7.2 11.7c.3.4.7.4.8.4.2 0 .6-.1.7-.6l9.1-30.9c.1-.4-.1-.7-.2-.9-.1-.1-.4-.3-.8-.2L8.3 16.8c-.5.1-.6.5-.6.7s0 .6.4.8L20 25.7l10.5-10.6c.7-.7 1.7-.7 2.4 0s.7 1.7 0 2.4L22.4 28.1z" })
  }
);
const SvgMessage$1 = SvgMessage;

const SvgMinus = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M10.3 24a1.7 1.7 0 0 1 1.7-1.7h24a1.7 1.7 0 0 1 0 3.4H12a1.7 1.7 0 0 1-1.7-1.7",
        clipRule: "evenodd"
      }
    )
  }
);
const MinusIcon = SvgMinus;

const SvgMinusCircle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M24 44.388C12.912 44.388 3.9 35.244 3.9 24S12.912 3.612 24 3.612 44.1 12.756 44.1 24 35.088 44.388 24 44.388M24 7.8c-8.772 0-15.9 7.26-15.9 16.188S15.228 40.176 24 40.176s15.9-7.26 15.9-16.188S32.772 7.8 24 7.8" }),
      /* @__PURE__ */ jsx("path", { d: "M31.872 26.1H16.128c-1.164 0-2.1-.936-2.1-2.1s.936-2.1 2.1-2.1h15.756c1.164 0 2.1.936 2.1 2.1s-.936 2.1-2.1 2.1z" })
    ]
  }
);
const SvgMinusCircle$1 = SvgMinusCircle;

const SvgMinusCircleSolid = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M24 3.744c-11.088 0-20.1 9.144-20.1 20.388S12.912 44.52 24 44.52s20.1-9.144 20.1-20.388S35.088 3.744 24 3.744m9.084 22.176H14.928a1.926 1.926 0 0 1-1.92-1.92c0-1.056.864-1.92 1.92-1.92h18.156c1.056 0 1.92.864 1.92 1.92s-.864 1.92-1.92 1.92" })
  }
);
const SvgMinusCircleSolid$1 = SvgMinusCircleSolid;

const SvgMoney = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "m13.723 5.663 4.013 7.07c4.303.847 8.598.823 12.902-.072l3.106-6.742c-1.846.134-4.116.281-5.244.281-.77 0-1.667-.225-2.46-.461-.74-.22-1.56-.503-2.355-.778l-.302-.104c-.91-.313-1.784-.61-2.576-.827-.817-.225-1.418-.33-1.807-.33-.637 0-1.816.364-3.207.97-.75.327-1.473.683-2.07.993m17.373 10.374a35.6 35.6 0 0 1-13.897.056c-1.211 1.935-3.652 5.804-5.403 8.366-1.078 1.577-2.149 3.89-2.74 6.265-.603 2.42-.636 4.608.006 6.106.793 1.85 1.847 3.637 3.905 5.004 2.08 1.381 5.385 2.466 10.925 2.466 5.578 0 9.002-.974 11.16-2.308 2.105-1.302 3.176-3.052 3.835-5.03.614-1.84.54-3.987-.034-6.227-.572-2.232-1.615-4.447-2.795-6.334-1.799-2.879-3.903-6.516-4.962-8.364M14.522 13.96l-4.365-7.692a2.19 2.19 0 0 1 .832-2.994 41 41 0 0 1 3.446-1.721C15.8.958 17.573.3 19 .3c.861 0 1.823.208 2.709.452.91.25 1.88.58 2.783.89l.302.105c.808.28 1.55.536 2.214.733.784.233 1.262.32 1.492.32 1.45 0 5.251-.286 7.014-.426 1.687-.134 2.87 1.599 2.171 3.116l-3.884 8.429c.937 1.64 3.223 5.612 5.14 8.68 1.321 2.113 2.528 4.648 3.206 7.291.675 2.635.852 5.488-.034 8.148-.841 2.522-2.324 5.022-5.273 6.846-2.896 1.79-7.026 2.816-12.948 2.816-5.96 0-9.993-1.165-12.806-3.034-2.835-1.883-4.227-4.346-5.149-6.496-1.072-2.502-.854-5.564-.18-8.268.684-2.75 1.917-5.437 3.232-7.361 1.818-2.66 4.421-6.8 5.533-8.581",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M19.702 23.498a1.7 1.7 0 0 1 2.404 0l1.839 1.838q.098.099.176.208.08-.11.177-.207l1.838-1.839a1.7 1.7 0 0 1 2.405 2.404L26.5 27.5l1.3-.2a1.7 1.7 0 0 1 0 3.4l-2.1-.2.2.8h1.9a1.7 1.7 0 0 1 0 3.4l-2.1-.09.2 2.39a1.7 1.7 0 1 1-3.4 0l.2-2.39-2.5.09a1.7 1.7 0 0 1 0-3.4h2.3l.2-.8-2.5.2a1.7 1.7 0 1 1 0-3.4l1.3.2-1.798-1.598a1.7 1.7 0 0 1 0-2.404",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgMoney$1 = SvgMoney;

const SvgMoneyReceived = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M6.893 9.91c1.728-1.853 4.178-2.876 7.036-2.876h20.14c2.864 0 5.315 1.023 7.042 2.877 1.714 1.84 2.587 4.363 2.587 7.156v6.15a1.7 1.7 0 1 1-3.4 0v-6.15c0-2.09-.647-3.734-1.676-4.839-1.016-1.09-2.53-1.794-4.553-1.794h-20.14c-2.016 0-3.53.702-4.549 1.795-1.03 1.106-1.68 2.75-1.68 4.838v13.175c0 2.09.647 3.733 1.676 4.838 1.016 1.091 2.53 1.794 4.553 1.794h7.846a1.7 1.7 0 0 1 0 3.4h-7.846c-2.864 0-5.315-1.022-7.041-2.877-1.714-1.84-2.588-4.363-2.588-7.155V17.067c0-2.794.878-5.317 2.593-7.157",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M12.2 18.692a1.7 1.7 0 0 1 1.7-1.7h20.194a1.7 1.7 0 1 1 0 3.4H13.9a1.7 1.7 0 0 1-1.7-1.7M35.681 43.187a1.7 1.7 0 0 1-1.7-1.7V28.844a1.7 1.7 0 0 1 3.4 0v12.642a1.7 1.7 0 0 1-1.7 1.7",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M30.384 36.17a1.7 1.7 0 0 1 2.404.005l2.89 2.903 2.891-2.903a1.7 1.7 0 1 1 2.409 2.4l-4.096 4.111a1.7 1.7 0 0 1-2.41 0l-4.093-4.112a1.7 1.7 0 0 1 .005-2.404",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgMoneyReceived$1 = SvgMoneyReceived;

const SvgMoreHoriz = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M12 20a4 4 0 1 1 0 8 4 4 0 0 1 0-8M24 20a4 4 0 1 1 0 8 4 4 0 0 1 0-8M40 24a4 4 0 1 0-8 0 4 4 0 0 0 8 0" })
  }
);
const SvgMoreHoriz$1 = SvgMoreHoriz;

const SvgMoreSquareHoriz = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M6.906 7.237C8.963 5.03 11.888 3.8 15.33 3.8h17.338c3.45 0 6.377 1.23 8.433 3.438 2.043 2.194 3.1 5.216 3.1 8.594v16.336c0 3.378-1.057 6.4-3.1 8.595-2.056 2.208-4.984 3.437-8.435 3.437H15.33c-3.45 0-6.377-1.23-8.432-3.437C4.855 38.568 3.8 35.546 3.8 32.168V15.832c0-3.38 1.062-6.402 3.106-8.595m2.487 2.318c-1.36 1.46-2.193 3.603-2.193 6.277v16.336c0 2.677.83 4.82 2.187 6.278 1.344 1.445 3.332 2.354 5.943 2.354h17.336c2.612 0 4.601-.91 5.947-2.354 1.358-1.458 2.187-3.602 2.187-6.278V15.832c0-2.676-.83-4.82-2.187-6.277C37.268 8.11 35.278 7.2 32.668 7.2H15.33c-2.6 0-4.589.91-5.937 2.355m4.75 14.471a1.7 1.7 0 0 1 1.7-1.7h.018a1.7 1.7 0 1 1 0 3.4h-.018a1.7 1.7 0 0 1-1.7-1.7m8.018 0a1.7 1.7 0 0 1 1.7-1.7h.018a1.7 1.7 0 1 1 0 3.4h-.018a1.7 1.7 0 0 1-1.7-1.7m8.018 0a1.7 1.7 0 0 1 1.7-1.7h.018a1.7 1.7 0 1 1 0 3.4h-.018a1.7 1.7 0 0 1-1.7-1.7",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgMoreSquareHoriz$1 = SvgMoreSquareHoriz;

const SvgMoreVert = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M28 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0M28 24a4 4 0 1 1-8 0 4 4 0 0 1 8 0M24 40a4 4 0 1 0 0-8 4 4 0 0 0 0 8" })
  }
);
const SvgMoreVert$1 = SvgMoreVert;

const SvgMovie = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M19 19.618v8.764a1 1 0 0 0 1.447.894l8.764-4.381a1 1 0 0 0 0-1.79l-8.764-4.381a1 1 0 0 0-1.447.894" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M4 15a6 6 0 0 1 6-6h28a6 6 0 0 1 6 6v18a6 6 0 0 1-6 6H10a6 6 0 0 1-6-6zm6-3h28a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V15a3 3 0 0 1 3-3",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgMovie$1 = SvgMovie;

const SvgNewsletter = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M16.5 9a1.5 1.5 0 0 0-1.5 1.5v13a1.5 1.5 0 0 1-3 0v-13A4.5 4.5 0 0 1 16.5 6h15a4.5 4.5 0 0 1 4.5 4.5v13a1.5 1.5 0 0 1-3 0v-13A1.5 1.5 0 0 0 31.5 9z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M10.243 19.84a1.5 1.5 0 0 0-2.486-1.68l-.473.702A7.5 7.5 0 0 0 6 23.058V34.5a7.5 7.5 0 0 0 7.5 7.5h21a7.5 7.5 0 0 0 7.5-7.5V23.058a7.5 7.5 0 0 0-1.284-4.196l-.473-.701a1.5 1.5 0 0 0-2.486 1.678l.473.701a4.5 4.5 0 0 1 .77 2.518v1.765l-14.33 7.165a1.5 1.5 0 0 1-1.34 0L9 24.823v-1.765a4.5 4.5 0 0 1 .77-2.518zM9 28.176V34.5a4.5 4.5 0 0 0 4.5 4.5h21a4.5 4.5 0 0 0 4.5-4.5v-6.323l-12.987 6.494a4.5 4.5 0 0 1-4.026 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M19.5 11.5a1.5 1.5 0 0 0 0 3h9a1.5 1.5 0 0 0 0-3zM18 19a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 0 3h-9A1.5 1.5 0 0 1 18 19M19.5 23.5a1.5 1.5 0 0 0 0 3h9a1.5 1.5 0 0 0 0-3z" })
    ]
  }
);
const SvgNewsletter$1 = SvgNewsletter;

const SvgNoteShield = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M15.904 8.266a6.54 6.54 0 0 0-6.538 6.538v19.523a6.54 6.54 0 0 0 6.538 6.54h5.185a1.7 1.7 0 1 1 0 3.4h-5.185c-5.488 0-9.938-4.45-9.938-9.94V14.804c0-5.486 4.45-9.938 9.938-9.938H30.1c5.488 0 9.938 4.452 9.938 9.938v6.73a1.7 1.7 0 0 1-3.4 0v-6.73A6.54 6.54 0 0 0 30.1 8.266z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M33.997 27.859c.189-.042.49-.102.78-.102s.59.06.779.101c.23.05.487.118.753.194a32 32 0 0 1 1.772.57c.609.215 1.223.449 1.727.665.25.108.494.22.704.33.147.077.479.253.741.518l.018.018c.115.115.423.422.598.91.152.424.16.858.163 1.145.002.252-.005.589-.013 1.01l-.008.4a136 136 0 0 0-.024 2.611c0 3.072-1.862 5.087-3.461 6.24a12.3 12.3 0 0 1-3.22 1.646l-.022.007-.008.002-.005.002-.494-1.627c-.493 1.627-.494 1.627-.495 1.627l-.004-.002-.008-.002-.022-.007a5 5 0 0 1-.288-.099 12.35 12.35 0 0 1-2.933-1.548c-1.598-1.152-3.46-3.167-3.46-6.239a135 135 0 0 0-.033-3.018 39 39 0 0 1-.013-1.005c.003-.286.01-.722.164-1.147.177-.492.49-.8.606-.914l.018-.018 1.2 1.204-1.206-1.199c.262-.263.594-.438.74-.515.21-.11.454-.221.703-.328.503-.216 1.117-.45 1.726-.665.61-.215 1.237-.418 1.771-.571.266-.076.525-.144.754-.194m.78 14.64-.493 1.627a1.7 1.7 0 0 0 .986 0zm.499-1.625h-.002zm-.5-.188a9.2 9.2 0 0 1-1.76-.976c-1.157-.833-2.05-1.953-2.05-3.48a138 138 0 0 0-.034-3.134l-.01-.61.165-.073c.413-.177.952-.384 1.515-.582a29 29 0 0 1 1.576-.509 10 10 0 0 1 .6-.153l.051.011q.205.045.548.142c.452.129 1.013.31 1.575.508a26 26 0 0 1 1.68.654c-.003.163-.006.364-.012.62l-.008.451c-.012.648-.025 1.511-.025 2.674 0 1.528-.893 2.648-2.049 3.48a9 9 0 0 1-1.761.977M16.219 19.856a1.7 1.7 0 0 1 1.7-1.7h10.165a1.7 1.7 0 1 1 0 3.4H17.919a1.7 1.7 0 0 1-1.7-1.7m-.003 8.874a1.7 1.7 0 0 1 1.7-1.7h5.307a1.7 1.7 0 1 1 0 3.4h-5.307a1.7 1.7 0 0 1-1.7-1.7",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgNoteShield$1 = SvgNoteShield;

const SvgNotification = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M8.938 15.89C8.938 9.354 15.007 2.3 24 2.3s15.062 7.054 15.062 13.59c0 1.63.208 2.763.487 3.627.28.868.653 1.536 1.092 2.27q.066.114.138.23c.401.668.877 1.46 1.24 2.41.42 1.099.681 2.37.681 4.014q0 .074-.006.147c-.148 1.706-.657 3.215-1.632 4.476-.97 1.256-2.307 2.14-3.902 2.765-3.108 1.217-7.527 1.566-13.16 1.566-5.63 0-10.05-.343-13.157-1.557-1.596-.624-2.933-1.508-3.904-2.765-.976-1.263-1.484-2.775-1.633-4.485a2 2 0 0 1-.006-.147c0-1.643.26-2.915.68-4.015.363-.95.84-1.741 1.241-2.408l.138-.23c.44-.735.812-1.403 1.092-2.27.28-.865.487-1.998.487-3.628M24 5.7c-7.188 0-11.662 5.603-11.662 10.19 0 1.93-.248 3.422-.65 4.671-.403 1.247-.94 2.183-1.41 2.97l-.135.226c-.416.695-.737 1.229-.987 1.883-.256.671-.448 1.508-.456 2.726.112 1.167.442 1.998.93 2.628.5.65 1.268 1.215 2.45 1.677 2.446.955 6.274 1.324 11.92 1.324 5.645 0 9.474-.374 11.92-1.332 1.183-.463 1.95-1.03 2.452-1.678.487-.63.817-1.458.928-2.619-.008-1.218-.2-2.055-.456-2.726-.25-.654-.57-1.188-.987-1.883q-.067-.11-.135-.226c-.47-.787-1.007-1.723-1.41-2.97-.402-1.25-.65-2.74-.65-4.67C35.662 11.302 31.188 5.7 24 5.7M17.903 40.45a1.7 1.7 0 0 1 2.4.128c2.073 2.307 5.152 2.286 7.211-.001a1.7 1.7 0 1 1 2.527 2.275c-3.397 3.772-8.83 3.823-12.267-.001a1.7 1.7 0 0 1 .129-2.401",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgNotification$1 = SvgNotification;

const SvgNumberCircle0 = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 41c9.389 0 17-7.611 17-17S33.389 7 24 7 7 14.611 7 24s7.611 17 17 17m0 3c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M24.013 33.528c4.506 0 7.185-3.694 7.185-9.56 0-5.865-2.704-9.496-7.185-9.496-4.494 0-7.211 3.656-7.211 9.509 0 5.878 2.691 9.547 7.21 9.547m0-2.679c-2.489 0-3.91-2.539-3.91-6.88 0-4.266 1.447-6.818 3.91-6.818 2.45 0 3.884 2.539 3.884 6.83 0 4.342-1.409 6.868-3.884 6.868" })
    ]
  }
);
const SvgNumberCircle0$1 = SvgNumberCircle0;

const SvgNumberCircle1 = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 41c9.389 0 17-7.611 17-17S33.389 7 24 7 7 14.611 7 24s7.611 17 17 17m0 3c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M25.041 33.327c.952 0 1.613-.66 1.613-1.65V16.328c0-1.13-.699-1.828-1.854-1.828-.686 0-1.193.114-2.006.685l-3.745 2.629c-.546.38-.749.761-.749 1.269 0 .724.495 1.219 1.18 1.219.356 0 .61-.09.927-.318l2.958-2.056h.064v13.749c0 .99.66 1.65 1.612 1.65" })
    ]
  }
);
const SvgNumberCircle1$1 = SvgNumberCircle1;

const SvgNumberCircle2 = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 41c9.389 0 17-7.611 17-17S33.389 7 24 7 7 14.611 7 24s7.611 17 17 17m0 3c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M19.049 33.088h10.13c.864 0 1.397-.534 1.397-1.334 0-.812-.533-1.345-1.396-1.345h-7.313v-.064l4.202-4.138c3.035-2.971 4.063-4.418 4.063-6.564 0-3.072-2.527-5.243-6.196-5.243-3.567 0-5.763 2.095-6.258 4.075a2.4 2.4 0 0 0-.102.686c0 .812.533 1.358 1.422 1.358.75 0 1.13-.343 1.46-1.003.648-1.65 1.803-2.488 3.453-2.488 1.765 0 3.022 1.18 3.022 2.818 0 1.397-.584 2.323-2.92 4.634l-5.599 5.548c-.698.66-.914 1.04-.914 1.676 0 .825.533 1.383 1.549 1.383" })
    ]
  }
);
const SvgNumberCircle2$1 = SvgNumberCircle2;

const SvgNumberCircle3 = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 41c9.389 0 17-7.611 17-17S33.389 7 24 7 7 14.611 7 24s7.611 17 17 17m0 3c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M23.924 33.368c4.012 0 6.855-2.209 6.855-5.459 0-2.552-1.79-4.177-4.494-4.43v-.064c2.21-.457 3.847-1.993 3.847-4.291 0-2.831-2.438-4.811-6.234-4.811-2.983 0-5.014 1.332-5.878 3.148-.228.444-.317.85-.317 1.308 0 .837.483 1.37 1.397 1.37.761 0 1.117-.291 1.472-1.078.61-1.435 1.613-2.146 3.34-2.146 2.03 0 3.071 1.066 3.071 2.653 0 1.625-1.345 2.78-3.364 2.78h-.965c-.812 0-1.295.496-1.295 1.22 0 .723.483 1.218 1.295 1.218h1.041c2.349 0 3.77 1.092 3.758 3.047 0 1.663-1.41 2.857-3.491 2.857-2.006 0-3.11-.826-3.745-2.21-.343-.672-.75-.964-1.422-.964-.914 0-1.46.546-1.46 1.409 0 .431.101.85.343 1.295.952 1.84 3.034 3.148 6.246 3.148" })
    ]
  }
);
const SvgNumberCircle3$1 = SvgNumberCircle3;

const SvgNumberCircle4 = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 41c9.389 0 17-7.611 17-17S33.389 7 24 7 7 14.611 7 24s7.611 17 17 17m0 3c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M26.44 33.254c.914 0 1.562-.584 1.562-1.612v-2.159h1.27c.875 0 1.396-.546 1.396-1.345 0-.787-.52-1.346-1.384-1.346h-1.282v-9.953c0-1.524-1.003-2.412-2.692-2.412-1.345 0-2.145.558-3.338 2.336-2.197 3.224-4.279 6.36-5.561 8.658-.508.914-.711 1.51-.711 2.222 0 1.091.774 1.84 1.955 1.84h7.224v2.159c0 1.028.66 1.612 1.561 1.612m-1.51-6.386h-6.26v-.089c1.486-2.704 3.301-5.446 6.209-9.61h.05z" })
    ]
  }
);
const SvgNumberCircle4$1 = SvgNumberCircle4;

const SvgNumberCircle5 = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 41c9.389 0 17-7.611 17-17S33.389 7 24 7 7 14.611 7 24s7.611 17 17 17m0 3c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M23.784 33.888c4.063 0 6.881-2.628 6.881-6.462 0-3.504-2.5-5.98-6.005-5.98-1.84 0-3.351.711-4.126 1.854h-.063l.482-5.421h7.402c.837 0 1.383-.534 1.383-1.346 0-.8-.546-1.333-1.383-1.333h-7.897c-1.435 0-2.17.584-2.285 2.031l-.584 6.92c-.013.075-.013.126-.013.202-.025.889.495 1.638 1.549 1.638.749 0 1.066-.165 1.828-.927a4.07 4.07 0 0 1 2.857-1.155c2.158 0 3.694 1.498 3.694 3.606 0 2.17-1.536 3.706-3.707 3.706-1.765 0-2.983-.875-3.606-2.36-.342-.674-.761-.94-1.447-.94-.863 0-1.409.533-1.409 1.384 0 .47.114.85.292 1.244.901 1.993 3.339 3.339 6.157 3.339" })
    ]
  }
);
const SvgNumberCircle5$1 = SvgNumberCircle5;

const SvgNumberCircle6 = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 41c9.389 0 17-7.611 17-17S33.389 7 24 7 7 14.611 7 24s7.611 17 17 17m0 3c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M24.33 33.868c3.961 0 6.843-2.679 6.843-6.398 0-3.466-2.476-6.005-6.005-6.005-2.488 0-4.316 1.27-5.04 2.958h-.064v-.19c.064-4.215 1.537-6.767 4.304-6.767 1.359 0 2.336.533 3.187 1.701.508.647.914.952 1.561.952.864 0 1.397-.571 1.397-1.32 0-.356-.09-.673-.292-1.041-.914-1.74-3.047-2.958-5.84-2.958-4.66 0-7.452 3.643-7.452 9.75 0 2.082.343 3.834 1.015 5.243 1.27 2.679 3.53 4.075 6.386 4.075m-.05-2.666c-2.045 0-3.657-1.612-3.657-3.669 0-2.044 1.587-3.542 3.694-3.542s3.644 1.498 3.631 3.606c0 2.005-1.625 3.605-3.669 3.605" })
    ]
  }
);
const SvgNumberCircle6$1 = SvgNumberCircle6;

const SvgNumberCircle7 = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 41c9.389 0 17-7.611 17-17S33.389 7 24 7 7 14.611 7 24s7.611 17 17 17m0 3c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M21.458 34.073c.71 0 1.117-.254 1.472-.952l7.122-13.812c.445-.864.635-1.372.635-1.968 0-1.155-.8-1.841-1.968-1.841h-9.623c-.812 0-1.396.52-1.396 1.333s.584 1.346 1.396 1.346h8.265v.063L20.24 31.7c-.19.381-.28.66-.28 1.041 0 .775.585 1.333 1.499 1.333" })
    ]
  }
);
const SvgNumberCircle7$1 = SvgNumberCircle7;

const SvgNumberCircle8 = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 41c9.389 0 17-7.611 17-17S33.389 7 24 7 7 14.611 7 24s7.611 17 17 17m0 3c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M23.994 33.656c4.19 0 7.147-2.184 7.147-5.32 0-2.361-1.701-4.176-4.151-4.684v-.076c2.107-.584 3.466-2.133 3.466-4.076 0-2.843-2.68-4.9-6.462-4.9-3.784 0-6.475 2.07-6.475 4.888 0 1.968 1.371 3.529 3.479 4.088v.076c-2.45.495-4.14 2.31-4.14 4.684 0 3.123 2.933 5.32 7.136 5.32m0-11.121c-1.905 0-3.238-1.118-3.238-2.717 0-1.613 1.333-2.742 3.238-2.742 1.891 0 3.237 1.117 3.237 2.742 0 1.6-1.346 2.717-3.237 2.717m0 8.62c-2.197 0-3.745-1.283-3.745-3.06s1.548-3.06 3.745-3.06 3.745 1.27 3.745 3.06c0 1.777-1.55 3.06-3.745 3.06" })
    ]
  }
);
const SvgNumberCircle8$1 = SvgNumberCircle8;

const SvgNumberCircle9 = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 41c9.389 0 17-7.611 17-17S33.389 7 24 7 7 14.611 7 24s7.611 17 17 17m0 3c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M24.043 33.368c4.723 0 7.528-3.618 7.528-9.737 0-2.095-.355-3.847-1.015-5.256-1.257-2.666-3.53-4.075-6.386-4.075-3.961 0-6.843 2.678-6.843 6.41 0 3.543 2.653 6.006 6.081 6.006 2.374 0 4.266-1.194 4.964-2.97h.05v.202c-.037 4.152-1.446 6.767-4.277 6.767-1.524 0-2.4-.559-3.263-1.714-.508-.648-.914-.952-1.574-.952-.876 0-1.384.558-1.384 1.32 0 .33.089.635.266 1.003.762 1.536 2.857 2.996 5.853 2.996m.127-9.191c-2.082 0-3.63-1.498-3.63-3.593 0-2.006 1.624-3.593 3.668-3.593 2.07 0 3.669 1.6 3.669 3.657 0 2.043-1.587 3.529-3.707 3.529" })
    ]
  }
);
const SvgNumberCircle9$1 = SvgNumberCircle9;

const SvgOldBars = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M38.4 26.1H9.6c-1.164 0-2.1-.936-2.1-2.1s.936-2.1 2.1-2.1h28.8c1.164 0 2.1.936 2.1 2.1s-.936 2.1-2.1 2.1M38.4 38.7H9.6c-1.164 0-2.1-.936-2.1-2.1s.936-2.1 2.1-2.1h28.8c1.164 0 2.1.936 2.1 2.1s-.936 2.1-2.1 2.1M38.4 13.5H9.6c-1.164 0-2.1-.936-2.1-2.1s.936-2.1 2.1-2.1h28.8c1.164 0 2.1.936 2.1 2.1s-.936 2.1-2.1 2.1" })
  }
);
const SvgOldBars$1 = SvgOldBars;

const SvgOldBrowser = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M10.5 8A4.5 4.5 0 0 0 6 12.5v22a4.5 4.5 0 0 0 4.5 4.5h15a1.5 1.5 0 0 0 0-3h-15A1.5 1.5 0 0 1 9 34.5v-22a1.5 1.5 0 0 1 1.5-1.5h27a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 0 3 0v-5A4.5 4.5 0 0 0 37.5 8z" }),
      /* @__PURE__ */ jsx("path", { d: "M35.5 27a1.5 1.5 0 0 0 0 3h2a1.5 1.5 0 0 0 0-3z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M29 24a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v15a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3zm3 0h9v15h-9z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M12 16.5a1.5 1.5 0 0 1 1.5-1.5h21a1.5 1.5 0 0 1 0 3h-21a1.5 1.5 0 0 1-1.5-1.5" })
    ]
  }
);
const SvgOldBrowser$1 = SvgOldBrowser;

const SvgOldCalendar = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M16 7.5a1.5 1.5 0 0 1 3 0V9h10V7.5a1.5 1.5 0 0 1 3 0V9h4.5a3.5 3.5 0 0 1 3.5 3.5V14a1.5 1.5 0 0 1-3 0v-1.5a.5.5 0 0 0-.5-.5H32v1.5a1.5 1.5 0 0 1-3 0V12H19v1.5a1.5 1.5 0 0 1-3 0V12h-4.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h25a3.5 3.5 0 0 1 3.5 3.5v17a3.5 3.5 0 0 1-3.5 3.5h-25A3.5 3.5 0 0 1 8 38.5V25a1.5 1.5 0 0 1 3 0v13.5a.5.5 0 0 0 .5.5h25a.5.5 0 0 0 .5-.5v-17a.5.5 0 0 0-.5-.5h-25A3.5 3.5 0 0 1 8 17.5v-5A3.5 3.5 0 0 1 11.5 9H16z" }),
      /* @__PURE__ */ jsx("path", { d: "M17 25a2 2 0 1 0 0 4 2 2 0 0 0 0-4M15 33a2 2 0 1 1 4 0 2 2 0 0 1-4 0M22 27a2 2 0 1 1 4 0 2 2 0 0 1-4 0M24 31a2 2 0 1 0 0 4 2 2 0 0 0 0-4M29 27a2 2 0 1 1 4 0 2 2 0 0 1-4 0M31 31a2 2 0 1 0 0 4 2 2 0 0 0 0-4" })
    ]
  }
);
const SvgOldCalendar$1 = SvgOldCalendar;

const SvgOldCardIc = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M15 17a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M4 15a6 6 0 0 1 6-6h28a6 6 0 0 1 6 6v18a6 6 0 0 1-6 6H10a6 6 0 0 1-6-6zm6-3h28a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V15a3 3 0 0 1 3-3",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgOldCardIc$1 = SvgOldCardIc;

const SvgOldCart = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M6 7.5A1.5 1.5 0 0 1 7.5 6H11a1.5 1.5 0 0 1 1.488 1.314l2.672 21.372A1.5 1.5 0 0 0 16.648 30h18.73a1.5 1.5 0 0 0 1.487-1.3l1.842-13.633a.5.5 0 0 0-.495-.567H18.2a1.5 1.5 0 0 1 0-3h20.012a3.5 3.5 0 0 1 3.468 3.969l-1.842 13.634A4.5 4.5 0 0 1 35.378 33h-18.73a4.5 4.5 0 0 1-4.465-3.942L9.676 9H7.5A1.5 1.5 0 0 1 6 7.5M20 39a3 3 0 1 1-6 0 3 3 0 0 1 6 0M35 42a3 3 0 1 0 0-6 3 3 0 0 0 0 6" })
  }
);
const SvgOldCart$1 = SvgOldCart;

const SvgOldCheck = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M19.38 38.424a2.1 2.1 0 0 1-1.488-.612L6.096 26.016a2.1 2.1 0 0 1 0-2.964 2.1 2.1 0 0 1 2.964 0l10.176 10.176 19.356-22.896a2.11 2.11 0 0 1 2.964-.252c.888.744.996 2.076.252 2.964l-20.82 24.648c-.384.444-.924.72-1.512.744h-.084z" })
  }
);
const SvgOldCheck$1 = SvgOldCheck;

const SvgOldCheckCircle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M21.888 32.52a2.1 2.1 0 0 1-1.488-.612L14.892 26.4a2.1 2.1 0 0 1 0-2.964 2.1 2.1 0 0 1 2.964 0l3.9 3.9 8.256-9.768a2.11 2.11 0 0 1 2.964-.252c.888.744.996 2.076.252 2.964l-9.732 11.508c-.384.444-.924.72-1.512.744H21.9z" }),
      /* @__PURE__ */ jsx("path", { d: "M24 44.388C12.912 44.388 3.9 35.244 3.9 24S12.912 3.612 24 3.612 44.1 12.756 44.1 24 35.088 44.388 24 44.388M24 7.8c-8.772 0-15.9 7.26-15.9 16.188S15.228 40.176 24 40.176s15.9-7.26 15.9-16.188S32.772 7.8 24 7.8" })
    ]
  }
);
const SvgOldCheckCircle$1 = SvgOldCheckCircle;

const SvgOldClock = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M25.5 15a1.5 1.5 0 0 0-3 0v11c0 .398.158.78.44 1.06l5 5a1.5 1.5 0 0 0 2.12-2.12l-4.56-4.561z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M44 24c0 11.046-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4s20 8.954 20 20m-3 0c0 9.389-7.611 17-17 17S7 33.389 7 24 14.611 7 24 7s17 7.611 17 17",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgOldClock$1 = SvgOldClock;

const SvgOldClose = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M38.4 40.5c-.54 0-1.08-.204-1.488-.612l-28.8-28.8a2.115 2.115 0 0 1 0-2.976 2.115 2.115 0 0 1 2.976 0l28.8 28.8a2.1 2.1 0 0 1 0 2.964 2.1 2.1 0 0 1-1.488.612z" }),
      /* @__PURE__ */ jsx("path", { d: "M9.6 40.5c-.54 0-1.08-.204-1.488-.612a2.1 2.1 0 0 1 0-2.964l28.8-28.812a2.1 2.1 0 0 1 2.964 0 2.1 2.1 0 0 1 0 2.964L11.088 39.888A2.1 2.1 0 0 1 9.6 40.5" })
    ]
  }
);
const SvgOldClose$1 = SvgOldClose;

const SvgOldCog = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M0 0h48v48H0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M15.737 39.615a4 4 0 0 0 .285-.256l.772-.772.569-.569a.8.8 0 0 1 .874-.165c.298.124.5.412.5.734v1.899a4 4 0 0 0 .02.38A3.514 3.514 0 0 0 22.251 44h3.498a3.514 3.514 0 0 0 3.514-3.514v-1.921c0-.31.193-.585.48-.703a.765.765 0 0 1 .835.158l.544.545.802.802a3.485 3.485 0 0 0 4.931 0l2.512-2.512a3.487 3.487 0 0 0 0-4.931l-.802-.803-.544-.544a.765.765 0 0 1-.16-.835.77.77 0 0 1 .704-.479h1.921a4 4 0 0 0 .436-.027A3.514 3.514 0 0 0 44 25.75v-3.498a3.514 3.514 0 0 0-3.514-3.514h-1.899a.8.8 0 0 1-.734-.5.8.8 0 0 1 .165-.874l.57-.57.771-.77a4 4 0 0 0 .256-.286 3.5 3.5 0 0 0-.256-4.662L36.884 8.6a3.53 3.53 0 0 0-4.989 0l-.858.858-.52.52a.73.73 0 0 1-.796.152.73.73 0 0 1-.458-.672V7.513a4 4 0 0 0-.034-.49A3.514 3.514 0 0 0 25.75 4h-3.498a3.514 3.514 0 0 0-3.514 3.514v1.921c0 .31-.193.585-.48.703a.76.76 0 0 1-.834-.159l-.544-.544-.828-.828a4 4 0 0 0-.314-.279 3.54 3.54 0 0 0-4.69.28l-2.44 2.438a3.54 3.54 0 0 0 0 5.005l.828.827.544.544c.22.22.278.55.16.836a.77.77 0 0 1-.704.479H7.514a4 4 0 0 0-.436.027A3.514 3.514 0 0 0 4 22.25v3.498a3.514 3.514 0 0 0 3.514 3.514h1.944c.295 0 .559.185.672.458a.73.73 0 0 1-.153.797l-.52.52-.857.857a4 4 0 0 0-.321.368 3.53 3.53 0 0 0 .32 4.62l2.476 2.476a3.5 3.5 0 0 0 4.662.256m6 .871v-1.899c0-1.599-.992-2.94-2.347-3.503a3.8 3.8 0 0 0-4.148.813l-1.341 1.34a.5.5 0 0 1-.705 0l-2.475-2.474a.527.527 0 0 1 0-.746l1.378-1.378a3.73 3.73 0 0 0 .804-4.063 3.73 3.73 0 0 0-3.445-2.313H7.514A.514.514 0 0 1 7 25.75v-3.498c0-.284.23-.514.514-.514h1.921a3.77 3.77 0 0 0 3.474-2.33 3.765 3.765 0 0 0-.808-4.106l-1.372-1.372a.54.54 0 0 1 0-.762l2.439-2.438c.21-.21.551-.21.762 0l1.372 1.372a3.765 3.765 0 0 0 4.105.808 3.77 3.77 0 0 0 2.33-3.474V7.514c0-.284.23-.514.514-.514h3.498c.284 0 .514.23.514.514v1.944c0 1.57.973 2.891 2.313 3.445a3.73 3.73 0 0 0 4.063-.804l1.378-1.378a.527.527 0 0 1 .745 0l2.476 2.475a.5.5 0 0 1 0 .705l-1.341 1.34a3.8 3.8 0 0 0-.813 4.15 3.8 3.8 0 0 0 3.503 2.346h1.9c.283 0 .513.23.513.514v3.498c0 .284-.23.514-.514.514h-1.921a3.77 3.77 0 0 0-3.474 2.33 3.76 3.76 0 0 0 .808 4.105l1.347 1.347c.19.19.19.498 0 .689l-2.512 2.512a.487.487 0 0 1-.689 0L32.7 35.899a3.765 3.765 0 0 0-4.106-.809 3.77 3.77 0 0 0-2.33 3.475v1.921c0 .284-.23.514-.514.514h-3.498a.514.514 0 0 1-.514-.514M29 24a5 5 0 1 1-10 0 5 5 0 0 1 10 0m3 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgOldCog$1 = SvgOldCog;

const SvgOldComment = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M15 34a3 3 0 0 1 3 3v1.227a1 1 0 0 0 1.581.814l6.275-4.482A3 3 0 0 1 27.6 34H36a3 3 0 0 0 3-3V12a3 3 0 0 0-3-3H12a3 3 0 0 0-3 3v19a3 3 0 0 0 3 3zm-3 3a6 6 0 0 1-6-6V12a6 6 0 0 1 6-6h24a6 6 0 0 1 6 6v19a6 6 0 0 1-6 6h-8.4l-6.275 4.482C18.677 43.373 15 41.481 15 38.227V37z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M12 21.5a1.5 1.5 0 0 1 1.5-1.5h16a1.5 1.5 0 0 1 0 3h-16a1.5 1.5 0 0 1-1.5-1.5M12 28.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 0 3h-9a1.5 1.5 0 0 1-1.5-1.5M12 14.5a1.5 1.5 0 0 1 1.5-1.5h21a1.5 1.5 0 0 1 0 3h-21a1.5 1.5 0 0 1-1.5-1.5",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgOldComment$1 = SvgOldComment;

const SvgOldContactLine = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M14.9 16.8a1.5 1.5 0 0 0-1.8 2.4l10 7.5a1.5 1.5 0 0 0 1.8 0l10-7.5a1.5 1.5 0 0 0-1.8-2.4L24 23.625z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M10 8a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h28a6 6 0 0 0 6-6V14a6 6 0 0 0-6-6zm28 3H10a3 3 0 0 0-3 3v20a3 3 0 0 0 3 3h28a3 3 0 0 0 3-3V14a3 3 0 0 0-3-3",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgOldContactLine$1 = SvgOldContactLine;

const SvgOldEdit = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M34.06 6.94a1.5 1.5 0 0 0-2.12 0l-22 22a1.5 1.5 0 0 0 0 2.12l7 7a1.5 1.5 0 0 0 2.12 0l22-22a1.5 1.5 0 0 0 0-2.12zM13.122 30 33 10.121 37.879 15 18 34.879z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "m8.56 32.94 6.5 6.499a1.5 1.5 0 0 1-1.06 2.56H7.5A1.5 1.5 0 0 1 6 40.5V34a1.5 1.5 0 0 1 2.56-1.06" })
    ]
  }
);
const SvgOldEdit$1 = SvgOldEdit;

const SvgOldExchange = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "m23.376 13.632-8.088-8.088a2.4 2.4 0 0 0-.324-.264c-.048-.036-.108-.06-.156-.084-.072-.036-.132-.072-.204-.108-.072-.024-.132-.048-.204-.06a1 1 0 0 0-.192-.06 2 2 0 0 0-.384-.036h-.072a2 2 0 0 0-.384.036 1 1 0 0 0-.192.06c-.072.024-.132.036-.204.06s-.132.072-.204.108c-.048.024-.108.048-.156.084a2 2 0 0 0-.312.252L4.212 13.62a2.1 2.1 0 0 0 0 2.964 2.1 2.1 0 0 0 2.964 0l4.5-4.5v25.272c0 1.164.936 2.1 2.1 2.1s2.1-.936 2.1-2.1V12.084l4.5 4.5c.408.408.948.612 1.488.612s1.08-.204 1.488-.612a2.1 2.1 0 0 0 0-2.964zM43.776 31.392a2.1 2.1 0 0 0-2.964 0l-4.5 4.5V10.62c0-1.164-.936-2.1-2.1-2.1s-2.1.936-2.1 2.1v25.272l-4.5-4.5a2.1 2.1 0 0 0-2.964 0 2.1 2.1 0 0 0 0 2.964l8.088 8.088.012.012c.096.096.192.18.3.252.048.036.108.06.156.084.072.036.132.072.204.108.072.024.144.048.204.06.06.024.12.036.18.048a2.3 2.3 0 0 0 .816 0c.06-.012.12-.036.18-.048.072-.024.144-.036.204-.06.072-.024.132-.072.204-.108.048-.024.108-.048.156-.084a2 2 0 0 0 .312-.252l8.088-8.088a2.1 2.1 0 0 0 0-2.964z" })
  }
);
const SvgOldExchange$1 = SvgOldExchange;

const SvgOldExternalLink = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M12 38.1c-.54 0-1.08-.204-1.488-.612a2.1 2.1 0 0 1 0-2.964l24-24.012a2.1 2.1 0 0 1 2.964 0 2.1 2.1 0 0 1 0 2.964L13.488 37.488A2.1 2.1 0 0 1 12 38.1" }),
      /* @__PURE__ */ jsx("path", { d: "M36 28.5c-1.164 0-2.1-.936-2.1-2.1V14.1H21.6c-1.164 0-2.1-.936-2.1-2.1s.936-2.1 2.1-2.1H36c1.164 0 2.1.936 2.1 2.1v14.4c0 1.164-.936 2.1-2.1 2.1" })
    ]
  }
);
const SvgOldExternalLink$1 = SvgOldExternalLink;

const SvgOldEye = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M32 24a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-3 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 10c-9.33 0-15.637 6.51-18.922 10.925a5.15 5.15 0 0 0 0 6.15C8.363 31.491 14.67 38 24 38s15.637-6.51 18.922-10.925a5.15 5.15 0 0 0 0-6.15C39.637 16.509 33.33 10 24 10M7.485 22.716C10.625 18.494 16.153 13 24 13s13.374 5.494 16.515 9.716a2.15 2.15 0 0 1 0 2.568C37.375 29.506 31.847 35 24 35s-13.374-5.494-16.515-9.716a2.15 2.15 0 0 1 0-2.568",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgOldEye$1 = SvgOldEye;

const SvgOldGridMultiitems = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M22 14a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-3 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0M42 34a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-3 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0M10 26a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-8a4 4 0 0 0-4-4zm0 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1zM26 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4zm4-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgOldGridMultiitems$1 = SvgOldGridMultiitems;

const SvgOldInvoice = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M15 10.5A1.5 1.5 0 0 1 16.5 9h15a1.5 1.5 0 0 1 1.5 1.5v13a1.5 1.5 0 0 0 3 0v-13A4.5 4.5 0 0 0 31.5 6h-15a4.5 4.5 0 0 0-4.5 4.5v13a1.5 1.5 0 0 0 3 0z" }),
      /* @__PURE__ */ jsx("path", { d: "M18.497 12.385a1.5 1.5 0 0 1 2.118.112L24 16.257l3.385-3.76a1.5 1.5 0 0 1 2.23 2.006L26.468 18H28.5a1.5 1.5 0 0 1 0 3h-3v1h3a1.5 1.5 0 0 1 0 3h-3v2.5a1.5 1.5 0 0 1-3 0V25h-3a1.5 1.5 0 0 1 0-3h3v-1h-3a1.5 1.5 0 0 1 0-3h2.032l-3.147-3.497a1.5 1.5 0 0 1 .112-2.118" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M10.243 19.84a1.5 1.5 0 0 0-2.486-1.68l-.473.702A7.5 7.5 0 0 0 6 23.058V34.5a7.5 7.5 0 0 0 7.5 7.5h21a7.5 7.5 0 0 0 7.5-7.5V23.058a7.5 7.5 0 0 0-1.284-4.196l-.473-.701a1.5 1.5 0 0 0-2.486 1.678l.473.701a4.5 4.5 0 0 1 .77 2.518v1.765l-14.33 7.165a1.5 1.5 0 0 1-1.34 0L9 24.823v-1.765a4.5 4.5 0 0 1 .77-2.518zm15.77 14.83L39 28.178V34.5a4.5 4.5 0 0 1-4.5 4.5h-21A4.5 4.5 0 0 1 9 34.5v-6.323l12.988 6.494a4.5 4.5 0 0 0 4.024 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgOldInvoice$1 = SvgOldInvoice;

const SvgOldItem = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M16.61 6.016c.786-.064 1.413.35 1.756.822C19.547 8.46 21.693 9.375 24 9.375s4.454-.916 5.633-2.537c.344-.473.97-.887 1.758-.822.903.075 1.86.397 2.752.796.91.406 1.847.934 2.735 1.498 1.77 1.122 3.446 2.45 4.459 3.412.517.491.713 1.202.572 1.86l-1.358 6.337a2 2 0 0 1-1.955 1.581H36.5V40a2 2 0 0 1-2 2h-21a2 2 0 0 1-2-2V21.5H9.404a2 2 0 0 1-1.955-1.58l-1.364-6.362c-.128-.601.02-1.27.486-1.767.95-1.016 2.668-2.367 4.46-3.485a22 22 0 0 1 2.796-1.499c.91-.397 1.88-.717 2.783-.79m-.28 3.081c-.362.09-.799.24-1.303.46-.76.332-1.589.784-2.408 1.295-1.41.88-2.694 1.871-3.485 2.617l1.079 5.031H12.5a2 2 0 0 1 2 2V39h19V20.5a2 2 0 0 1 2-2h2.287l1.068-4.982c-.89-.785-2.2-1.797-3.584-2.675A19 19 0 0 0 32.92 9.55a8 8 0 0 0-1.252-.452C29.76 11.34 26.81 12.375 24 12.375s-5.761-1.036-7.67-3.278",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgOldItem$1 = SvgOldItem;

const SvgOldLgChevronDown = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M24.002 35.104c-.54 0-1.08-.204-1.488-.612L6.518 18.495a2.1 2.1 0 0 1 0-2.964 2.1 2.1 0 0 1 2.964 0l14.52 14.52 14.52-14.52a2.1 2.1 0 0 1 2.964 0 2.1 2.1 0 0 1 0 2.964L25.49 34.492a2.1 2.1 0 0 1-1.488.611" })
  }
);
const SvgOldLgChevronDown$1 = SvgOldLgChevronDown;

const SvgOldLgChevronLeft = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M31.004 42.096c-.54 0-1.08-.204-1.488-.612L13.52 25.488A2.09 2.09 0 0 1 12.908 24c0-.564.216-1.092.612-1.488L29.516 6.516a2.1 2.1 0 0 1 2.964 0 2.115 2.115 0 0 1 0 2.976l-14.52 14.52 14.52 14.52a2.115 2.115 0 0 1 0 2.976 2.1 2.1 0 0 1-1.488.612z" })
  }
);
const SvgOldLgChevronLeft$1 = SvgOldLgChevronLeft;

const SvgOldLgChevronRight = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M16.994 42.096c-.54 0-1.08-.204-1.488-.612a2.115 2.115 0 0 1 0-2.976l14.52-14.52-14.52-14.52a2.115 2.115 0 0 1 0-2.976 2.1 2.1 0 0 1 2.964 0l15.996 15.996c.396.396.612.924.612 1.488s-.216 1.092-.612 1.488L18.47 41.46a2.1 2.1 0 0 1-1.488.612z" })
  }
);
const SvgOldLgChevronRight$1 = SvgOldLgChevronRight;

const SvgOldLgChevronUp = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M39.996 33.104c-.54 0-1.08-.204-1.488-.612l-14.52-14.52-14.52 14.52a2.1 2.1 0 0 1-2.964 0 2.1 2.1 0 0 1 0-2.965L22.5 13.531a2.1 2.1 0 0 1 2.964 0L41.46 29.527a2.1 2.1 0 0 1 0 2.965 2.1 2.1 0 0 1-1.488.611z" })
  }
);
const SvgOldLgChevronUp$1 = SvgOldLgChevronUp;

const SvgOldListBullet = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M8.75 14a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m8-4a1.5 1.5 0 0 0 0 3h24a1.5 1.5 0 0 0 0-3zm.056 12.5a1.556 1.556 0 1 0 0 3.111h23.888a1.555 1.555 0 1 0 0-3.111zm-1.556 14a1.5 1.5 0 0 1 1.5-1.5h24a1.5 1.5 0 0 1 0 3h-24a1.5 1.5 0 0 1-1.5-1.5m-4-12.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-2.5 15a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgOldListBullet$1 = SvgOldListBullet;

const SvgOldLogout = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M6 12a6 6 0 0 1 6-6h10a6 6 0 0 1 6 6v1.5a1.5 1.5 0 0 1-3 0V12a3 3 0 0 0-3-3H12a3 3 0 0 0-3 3v24a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1.5a1.5 1.5 0 0 1 3 0V36a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6z" }),
      /* @__PURE__ */ jsx("path", { d: "M19.5 24a1.5 1.5 0 0 1 1.5-1.5h15.879l-3.44-3.44a1.5 1.5 0 0 1 2.122-2.12l6 6a1.5 1.5 0 0 1 0 2.12l-6 6a1.5 1.5 0 0 1-2.122-2.12l3.44-3.44H21a1.5 1.5 0 0 1-1.5-1.5" })
    ]
  }
);
const SvgOldLogout$1 = SvgOldLogout;

const SvgOldMapMarker = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M24 24a5 5 0 1 0 0-10 5 5 0 0 0 0 10" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M38 19c0 7.848-7.127 17.733-11.21 22.753a3.56 3.56 0 0 1-5.58 0C17.128 36.733 10 26.848 10 19c0-7.18 5-14 14-14s14 6.82 14 14m-3 0c0 3.135-1.468 7.013-3.69 10.968-2.175 3.872-4.862 7.45-6.848 9.892-.15.185-.319.241-.462.241s-.311-.056-.462-.241c-1.986-2.442-4.673-6.02-6.849-9.892C14.468 26.013 13 22.135 13 19c0-5.787 3.91-11 11-11s11 5.213 11 11",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgOldMapMarker$1 = SvgOldMapMarker;

const SvgOldMinus = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M40.8 26.1H7.2c-1.164 0-2.1-.936-2.1-2.1s.936-2.1 2.1-2.1h33.6c1.164 0 2.1.936 2.1 2.1s-.936 2.1-2.1 2.1" })
  }
);
const SvgOldMinus$1 = SvgOldMinus;

const SvgOldNotification = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#000",
        d: "M23.5 4.5a1 1 0 0 1 1 1v3.001l.462.035C31.416 9.027 36.5 14.42 36.5 21v7.667a4.5 4.5 0 0 0 .9 2.7l.401.533c1.73 2.308.084 5.6-2.8 5.6h-4.504l-.062.43a6.502 6.502 0 0 1-12.868 0l-.062-.43H13c-2.883 0-4.53-3.292-2.8-5.6l.401-.534a4.5 4.5 0 0 0 .9-2.699V21c0-6.25 4.587-11.428 10.577-12.353l.422-.065V5.5a1 1 0 0 1 1-1Zm-3.858 33.625a4.501 4.501 0 0 0 8.716 0l.161-.625h-9.038zM24 10.5c-5.8 0-10.5 4.701-10.5 10.5v7.667a6.5 6.5 0 0 1-1.3 3.9l-.4.533c-.741.988-.036 2.4 1.2 2.4h22c1.236 0 1.941-1.411 1.2-2.4l-.4-.534a6.5 6.5 0 0 1-1.3-3.899V21c0-5.799-4.701-10.5-10.5-10.5Z"
      }
    )
  }
);
const SvgOldNotification$1 = SvgOldNotification;

const SvgOldOrganization = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M10 7h12a3 3 0 0 1 3 3v26.5a1.5 1.5 0 0 0 3 0v-11a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v11a1.5 1.5 0 0 0 3 0v-11a6 6 0 0 0-6-6h-6a6 6 0 0 0-3 .803V10a6 6 0 0 0-6-6H10a6 6 0 0 0-6 6v30a4 4 0 0 0 4 4h34.5a1.5 1.5 0 0 0 0-3H22v-7a3 3 0 0 0-3-3h-5a3 3 0 0 0-3 3v7H8a1 1 0 0 1-1-1V10a3 3 0 0 1 3-3m4 34h5v-6a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M11 13.5c0-.828.746-1.5 1.667-1.5h6.666c.92 0 1.667.672 1.667 1.5s-.746 1.5-1.667 1.5h-6.666c-.92 0-1.667-.672-1.667-1.5M11 19.5c0-.828.746-1.5 1.667-1.5h6.666c.92 0 1.667.672 1.667 1.5s-.746 1.5-1.667 1.5h-6.666c-.92 0-1.667-.672-1.667-1.5M11 25.5c0-.828.746-1.5 1.667-1.5h6.666c.92 0 1.667.672 1.667 1.5s-.746 1.5-1.667 1.5h-6.666c-.92 0-1.667-.672-1.667-1.5M35.5 27a1.5 1.5 0 0 1 0 3h-3a1.5 1.5 0 0 1 0-3zM37 34.5a1.5 1.5 0 0 0-1.5-1.5h-3a1.5 1.5 0 0 0 0 3h3a1.5 1.5 0 0 0 1.5-1.5" })
    ]
  }
);
const SvgOldOrganization$1 = SvgOldOrganization;

const SvgOldPlus = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M24 42.9c-1.164 0-2.1-.936-2.1-2.1V7.2c0-1.164.936-2.1 2.1-2.1s2.1.936 2.1 2.1v33.6c0 1.164-.936 2.1-2.1 2.1" }),
      /* @__PURE__ */ jsx("path", { d: "M40.8 26.1H7.2c-1.164 0-2.1-.936-2.1-2.1s.936-2.1 2.1-2.1h33.6c1.164 0 2.1.936 2.1 2.1s-.936 2.1-2.1 2.1" })
    ]
  }
);
const SvgOldPlus$1 = SvgOldPlus;

const SvgOldQuestionCircle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M24 35.076c-.54 0-1.068-.216-1.44-.6a2.06 2.06 0 0 1-.6-1.44c0-.528.216-1.068.6-1.44.756-.756 2.124-.756 2.88 0 .384.384.6.912.6 1.44s-.216 1.056-.6 1.44-.912.6-1.44.6" }),
      /* @__PURE__ */ jsx("path", { d: "M24 44.388C12.912 44.388 3.9 35.244 3.9 24S12.912 3.612 24 3.612 44.1 12.756 44.1 24 35.088 44.388 24 44.388M24 7.8c-8.772 0-15.9 7.26-15.9 16.188S15.228 40.176 24 40.176s15.9-7.26 15.9-16.188S32.772 7.8 24 7.8" }),
      /* @__PURE__ */ jsx("path", { d: "M24 28.284c-.996 0-1.8-.804-1.8-1.8v-.576c0-1.956.96-3.588 2.856-4.86.456-.312 1.224-.972 1.224-2.004 0-1.26-1.02-2.28-2.28-2.28s-2.28 1.02-2.28 2.268c0 .996-.804 1.8-1.8 1.8s-1.8-.804-1.8-1.8c0-3.24 2.64-5.868 5.88-5.868a5.89 5.89 0 0 1 5.88 5.88c0 1.968-1.02 3.792-2.808 4.992-1.116.744-1.272 1.344-1.272 1.872v.576c0 .996-.804 1.8-1.8 1.8" })
    ]
  }
);
const SvgOldQuestionCircle$1 = SvgOldQuestionCircle;

const SvgOldSearch = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M36 21c0 8.284-6.716 15-15 15S6 29.284 6 21 12.716 6 21 6s15 6.716 15 15m-3 0c0 6.627-5.373 12-12 12S9 27.627 9 21 14.373 9 21 9s12 5.373 12 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M35.631 33.369a1.6 1.6 0 0 0-2.262 2.262l4.596 4.597a1.6 1.6 0 0 0 2.263-2.263z" })
    ]
  }
);
const SvgOldSearch$1 = SvgOldSearch;

const SvgOldShop = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M6.338 8.81a4.5 4.5 0 0 1 4.34-3.31h26.644a4.5 4.5 0 0 1 4.34 3.31l2.744 10c.785 2.864-1.37 5.69-4.34 5.69H7.934c-2.97 0-5.126-2.826-4.34-5.69zm4.34-.31A1.5 1.5 0 0 0 9.23 9.603l-2.744 10A1.5 1.5 0 0 0 7.934 21.5h32.132a1.5 1.5 0 0 0 1.446-1.897l-2.743-10A1.5 1.5 0 0 0 37.322 8.5zM8.5 26.5A1.5 1.5 0 0 1 10 28v8.5a2.5 2.5 0 0 0 2.5 2.5H17v-8a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8h4.5a2.5 2.5 0 0 0 2.5-2.5V28a1.5 1.5 0 0 1 3 0v8.5a5.5 5.5 0 0 1-5.5 5.5h-23A5.5 5.5 0 0 1 7 36.5V28a1.5 1.5 0 0 1 1.5-1.5M28 39v-7a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v7z",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgOldShop$1 = SvgOldShop;

const SvgOldStar = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "m24 11.429-3.306 6.267a5 5 0 0 1-3.57 2.593l-6.982 1.208 4.938 5.081a5 5 0 0 1 1.364 4.197l-1.009 7.013 6.359-3.126a5 5 0 0 1 4.412 0l6.359 3.126-1.009-7.013a5 5 0 0 1 1.364-4.197l4.938-5.08-6.982-1.209a5 5 0 0 1-3.57-2.593zm1.769-3.076c-.75-1.423-2.787-1.423-3.538 0l-4.19 7.943a2 2 0 0 1-1.429 1.037l-8.849 1.531c-1.585.274-2.214 2.212-1.093 3.365l6.26 6.44a2 2 0 0 1 .545 1.679l-1.279 8.89c-.229 1.591 1.42 2.788 2.862 2.079l8.06-3.963a2 2 0 0 1 1.765 0l8.059 3.963c1.443.71 3.09-.488 2.862-2.08l-1.279-8.89a2 2 0 0 1 .546-1.678l6.26-6.44c1.12-1.153.49-3.09-1.094-3.365l-8.85-1.53a2 2 0 0 1-1.427-1.038z",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgOldStar$1 = SvgOldStar;

const SvgOldStock = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M26 5.155a4 4 0 0 0-4 0l-13.32 7.69a4 4 0 0 0-2 3.464v15.382a4 4 0 0 0 2 3.464L22 42.845a4 4 0 0 0 4 0l13.32-7.69a4 4 0 0 0 2-3.464V16.309a4 4 0 0 0-2-3.464zm-1.5 2.598 12.722 7.345-4.892 2.825-13.222-7.634L23.5 7.753a1 1 0 0 1 1 0m-7.995 4.497 12.825 7.405L24 22.732l-13.222-7.634 5.39-3.112q.146.152.337.264M22.5 25.33 9.68 17.928v13.763a1 1 0 0 0 .5.866L22.5 39.67zm3 14.34 12.32-7.113a1 1 0 0 0 .5-.866V17.928L25.5 25.33z",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgOldStock$1 = SvgOldStock;

const SvgOldTerminal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M20 14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M8 12a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8zm8-5h16a5 5 0 0 1 5 5v24a5 5 0 0 1-5 5H16a5 5 0 0 1-5-5V12a5 5 0 0 1 5-5",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgOldTerminal$1 = SvgOldTerminal;

const SvgOldTicket = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M31.5 18a1.5 1.5 0 0 0-1.5 1.5v2a1.5 1.5 0 0 0 3 0v-2a1.5 1.5 0 0 0-1.5-1.5M30 26.5a1.5 1.5 0 0 1 3 0v2a1.5 1.5 0 0 1-3 0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M38 38a6 6 0 0 0 6-6V16a6 6 0 0 0-6-6H10a6 6 0 0 0-6 6v16a6 6 0 0 0 6 6zm0-25h-5v.5a1.5 1.5 0 0 1-3 0V13H10a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h20v-.5a1.5 1.5 0 0 1 3 0v.5h5a3 3 0 0 0 3-3V16a3 3 0 0 0-3-3",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgOldTicket$1 = SvgOldTicket;

const SvgOldTrash = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M18 23.5a1.5 1.5 0 0 1 3 0v8a1.5 1.5 0 0 1-3 0zM28.5 22a1.5 1.5 0 0 0-1.5 1.5v8a1.5 1.5 0 0 0 3 0v-8a1.5 1.5 0 0 0-1.5-1.5" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M14.5 12.5v-1A5.5 5.5 0 0 1 20 6h8a5.5 5.5 0 0 1 5.5 5.5v1h7a1.5 1.5 0 0 1 0 3H37v21a5.5 5.5 0 0 1-5.5 5.5h-15a5.5 5.5 0 0 1-5.5-5.5v-21H7.5a1.5 1.5 0 0 1 0-3zm3-1A2.5 2.5 0 0 1 20 9h8a2.5 2.5 0 0 1 2.5 2.5v1h-13zm-3.5 4h20v21a2.5 2.5 0 0 1-2.5 2.5h-15a2.5 2.5 0 0 1-2.5-2.5z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgOldTrash$1 = SvgOldTrash;

const SvgOldUser = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M30.084 26.166A10.99 10.99 0 0 0 35 17c0-6.075-4.925-11-11-11s-11 4.925-11 11a10.99 10.99 0 0 0 4.916 9.166C13.122 28.038 9.27 31.94 7.343 36.198 5.977 39.217 8.686 42 12 42h24c3.314 0 6.023-2.783 4.657-5.802-1.928-4.257-5.78-8.16-10.573-10.032M32 17a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-8 11c-6.132 0-11.625 4.357-13.924 9.435-.107.239-.1.379-.088.453a.8.8 0 0 0 .205.39c.307.358.956.722 1.807.722h24c.851 0 1.5-.364 1.807-.722a.8.8 0 0 0 .205-.39c.012-.074.02-.214-.088-.453C35.624 32.357 30.132 28 24 28",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgOldUser$1 = SvgOldUser;

const SvgOldWarehouse = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M6 19.14V38a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V19.14a4 4 0 0 0-1.781-3.328l-14-9.333a4 4 0 0 0-4.438 0l-14 9.334A4 4 0 0 0 6 19.14M9 38V19.14a1 1 0 0 1 .445-.831l14-9.334a1 1 0 0 1 1.11 0l14 9.334a1 1 0 0 1 .445.832V38a1 1 0 0 1-1 1h-2v-6a3 3 0 0 0-3-3h-2v-6a3 3 0 0 0-3-3h-8a3 3 0 0 0-3 3v6h-2a3 3 0 0 0-3 3v6h-2a1 1 0 0 1-1-1m16.5-5H32a1 1 0 0 1 1 1v5h-7.5zm-3 0H16a1 1 0 0 0-1 1v5h7.5zm5.5-8v5h-8v-5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgOldWarehouse$1 = SvgOldWarehouse;

const SvgOldWarning = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M24 28.482c-1.164 0-2.1-.936-2.1-2.1v-8.1c0-1.164.936-2.1 2.1-2.1s2.1.936 2.1 2.1v8.1c0 1.164-.936 2.1-2.1 2.1M24 35.634a2.37 2.37 0 0 1-1.656-.684 2.37 2.37 0 0 1-.684-1.656c0-.612.252-1.224.684-1.656.876-.864 2.436-.876 3.312 0 .432.432.684 1.044.684 1.656s-.252 1.224-.684 1.656a2.37 2.37 0 0 1-1.656.684" }),
      /* @__PURE__ */ jsx("path", { d: "M36.264 43.518H11.748A8.04 8.04 0 0 1 4.8 39.582c-1.476-2.472-1.548-5.46-.18-7.992L16.86 8.754C18.3 6.078 20.964 4.482 24 4.482s5.7 1.596 7.14 4.272L43.392 31.59a8.05 8.05 0 0 1-.18 7.992c-1.476 2.472-4.08 3.936-6.948 3.936M20.568 10.734 8.304 33.57a3.87 3.87 0 0 0 .084 3.852 3.87 3.87 0 0 0 3.348 1.896h24.528c1.38 0 2.64-.708 3.348-1.896a3.87 3.87 0 0 0 .084-3.852L27.444 10.734a3.86 3.86 0 0 0-3.432-2.052 3.84 3.84 0 0 0-3.432 2.052z" })
    ]
  }
);
const SvgOldWarning$1 = SvgOldWarning;

const SvgOrganization = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M7.077 10.48a5.99 5.99 0 0 1 5.991-5.992h21.869c3.31 0 5.99 2.684 5.99 5.992v29.632H42a1.7 1.7 0 0 1 0 3.4H28.705a2 2 0 0 1-.142 0h-9.125a2 2 0 0 1-.142 0H6a1.7 1.7 0 0 1 0-3.4h1.077zm3.4 29.632h7.19v-8.995a3.84 3.84 0 0 1 3.84-3.84h4.984a3.84 3.84 0 0 1 3.843 3.84v8.995h7.194V10.48a2.59 2.59 0 0 0-2.591-2.592H13.068c-1.43 0-2.59 1.16-2.59 2.592zm16.457 0v-8.995a.44.44 0 0 0-.443-.44h-4.983a.44.44 0 0 0-.44.44v8.995zm-9.646-22.927a2.08 2.08 0 1 1 4.161 0 2.08 2.08 0 0 1-4.16 0m9.264 0a2.08 2.08 0 1 1 4.161 0 2.08 2.08 0 0 1-4.161 0",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgOrganization$1 = SvgOrganization;

const SvgOrganizationInfo = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M10 7h12a3 3 0 0 1 3 3v21.197c.695-1.59 1.725-3 3-4.141V25.5a3 3 0 0 1 3-3h6c1.358 0 2.505.902 2.875 2.14 1.126.383 2.177.93 3.125 1.612V25.5a6 6 0 0 0-6-6h-6a6 6 0 0 0-3 .803V10a6 6 0 0 0-6-6H10a6 6 0 0 0-6 6v30a4 4 0 0 0 4 4h19.056c-.797-.89-1.463-1.9-1.968-3H22v-7a3 3 0 0 0-3-3h-5a3 3 0 0 0-3 3v7H8a1 1 0 0 1-1-1V10a3 3 0 0 1 3-3m4 34h5v-6a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M11 13.5c0-.828.746-1.5 1.667-1.5h6.666c.92 0 1.667.672 1.667 1.5s-.746 1.5-1.667 1.5h-6.666c-.92 0-1.667-.672-1.667-1.5M12.667 18c-.92 0-1.667.672-1.667 1.5s.746 1.5 1.667 1.5h6.666c.92 0 1.667-.672 1.667-1.5s-.746-1.5-1.667-1.5zM11 25.5c0-.828.746-1.5 1.667-1.5h6.666c.92 0 1.667.672 1.667 1.5s-.746 1.5-1.667 1.5h-6.666c-.92 0-1.667-.672-1.667-1.5" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M36 44a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0-11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-1 2.5a1 1 0 1 1 2 0V40a1 1 0 1 1-2 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgOrganizationInfo$1 = SvgOrganizationInfo;

const SvgParagraphCenter = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M8 8a1.5 1.5 0 1 0 0 3h32a1.5 1.5 0 0 0 0-3zM12.5 24a1.5 1.5 0 0 1 1.5-1.5h20a1.5 1.5 0 0 1 0 3H14a1.5 1.5 0 0 1-1.5-1.5M16.5 38.5A1.5 1.5 0 0 1 18 37h12a1.5 1.5 0 0 1 0 3H18a1.5 1.5 0 0 1-1.5-1.5" })
  }
);
const SvgParagraphCenter$1 = SvgParagraphCenter;

const SvgParagraphLeft = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M8 8a1.5 1.5 0 1 0 0 3h32a1.5 1.5 0 0 0 0-3zM6.5 24A1.5 1.5 0 0 1 8 22.5h20a1.5 1.5 0 0 1 0 3H8A1.5 1.5 0 0 1 6.5 24M6.5 38.5A1.5 1.5 0 0 1 8 37h12a1.5 1.5 0 0 1 0 3H8a1.5 1.5 0 0 1-1.5-1.5" })
  }
);
const SvgParagraphLeft$1 = SvgParagraphLeft;

const SvgParagraphRight = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M8 8a1.5 1.5 0 1 0 0 3h32a1.5 1.5 0 0 0 0-3zM18.5 24a1.5 1.5 0 0 1 1.5-1.5h20a1.5 1.5 0 0 1 0 3H20a1.5 1.5 0 0 1-1.5-1.5M26.5 38.5A1.5 1.5 0 0 1 28 37h12a1.5 1.5 0 0 1 0 3H28a1.5 1.5 0 0 1-1.5-1.5" })
  }
);
const SvgParagraphRight$1 = SvgParagraphRight;

const SvgPennant = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M12 42.5a1.5 1.5 0 0 0 3 0V31.759l21.534-8.911c1.647-.681 1.647-3.014 0-3.696L15.43 10.42a3.5 3.5 0 1 0-3.43.243zm3-29.012v15.024L33.154 21z",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgPennant$1 = SvgPennant;

const SvgPercent = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M13.5 23c4.142 0 7.5-3.806 7.5-8.5S17.642 6 13.5 6 6 9.806 6 14.5 9.358 23 13.5 23m0-3c2.143 0 4.5-2.099 4.5-5.5S15.643 9 13.5 9 9 11.099 9 14.5s2.357 5.5 4.5 5.5M34.5 42c4.142 0 7.5-3.806 7.5-8.5S38.642 25 34.5 25 27 28.806 27 33.5s3.358 8.5 7.5 8.5m0-3c2.143 0 4.5-2.099 4.5-5.5S36.643 28 34.5 28 30 30.099 30 33.5s2.357 5.5 4.5 5.5",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M39.62 8.998a1.5 1.5 0 1 0-2.24-1.996l-28.5 32a1.5 1.5 0 1 0 2.24 1.996z" })
    ]
  }
);
const SvgPercent$1 = SvgPercent;

const SvgPhone = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("g", { clipPath: "url(#phone_svg__a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M32.701 41.958c1.501.131 2.93-.449 4.12-1.374l3.602-2.802a4 4 0 0 0 .373-5.986l-5.53-5.53a2 2 0 0 0-2.664-.148l-3.323 2.66a1.3 1.3 0 0 1-.626.294c-.899.128-3.457.125-6.653-3.072-3.197-3.197-3.2-5.754-3.073-6.653.034-.234.148-.441.296-.626l2.659-3.323a2 2 0 0 0-.148-2.664l-5.53-5.53a4 4 0 0 0-5.986.373l-2.802 3.602c-.925 1.19-1.505 2.619-1.374 4.12C6.351 18.827 7.913 25.913 15 33s14.174 8.649 17.701 8.958m1.076-12.938 4.898 4.897a1 1 0 0 1-.094 1.497l-3.603 2.802c-.778.605-1.475.8-2.015.753-2.98-.26-9.354-1.602-15.842-8.09-6.487-6.488-7.83-12.861-8.09-15.842-.048-.54.147-1.237.753-2.016l2.802-3.603a1 1 0 0 1 1.497-.093l4.897 4.898-2.1 2.624c-.343.43-.788 1.129-.923 2.078-.26 1.834.058 5.333 3.922 9.196 3.863 3.864 7.363 4.182 9.196 3.922l-.422-2.97.422 2.97c.949-.135 1.648-.58 2.078-.923z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "phone_svg__a", children: /* @__PURE__ */ jsx("path", { d: "M0 0h48v48H0z" }) }) })
    ]
  }
);
const SvgPhone$1 = SvgPhone;

const SvgPlay = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M24 44.7C12.6 44.7 3.3 35.4 3.3 24S12.6 3.3 24 3.3 44.7 12.6 44.7 24 35.4 44.7 24 44.7m0-38C14.5 6.7 6.7 14.5 6.7 24S14.5 41.3 24 41.3 41.3 33.5 41.3 24 33.5 6.7 24 6.7" }),
      /* @__PURE__ */ jsx("path", { d: "M21.2 31.7c-.6 0-1.1-.2-1.6-.6-.4-.4-1.2-1.2-1.2-6.9 0-6 .9-6.9 1.2-7.3 1.1-1.1 2.9-.4 3.7-.1.1 0 8.5 4 8.5 7.2 0 2.9-7.3 6.7-8.4 7.2-.5.2-1.4.5-2.2.5m.7-11.7c-.3 2-.3 6.2 0 8.1 1.7-.7 5.1-2.9 6.2-4.1-1.1-1.2-4.4-3.3-6.2-4" })
    ]
  }
);
const SvgPlay$1 = SvgPlay;

const SvgPlayCircle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M32 25.732c1.333-.77 1.333-2.694 0-3.464l-10.5-6.062c-1.333-.77-3 .192-3 1.732v12.124c0 1.54 1.667 2.502 3 1.732z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m0-3c9.389 0 17-7.611 17-17S33.389 7 24 7 7 14.611 7 24s7.611 17 17 17",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgPlayCircle$1 = SvgPlayCircle;

const SvgPlus = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M10.3 24a1.7 1.7 0 0 1 1.7-1.7h24a1.7 1.7 0 0 1 0 3.4H12a1.7 1.7 0 0 1-1.7-1.7",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 10.3a1.7 1.7 0 0 1 1.7 1.7v24a1.7 1.7 0 1 1-3.4 0V12a1.7 1.7 0 0 1 1.7-1.7",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgPlus$1 = SvgPlus;

const SvgPrinter = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M17 6a3 3 0 0 0-3 3v3h-2a6 6 0 0 0-6 6v14a3 3 0 0 0 3 3h1.5a1.5 1.5 0 0 0 0-3H10a1 1 0 0 1-1-1V18a3 3 0 0 1 3-3h24a3 3 0 0 1 3 3v13a1 1 0 0 1-1 1h-.5a1.5 1.5 0 0 0 0 3H39a3 3 0 0 0 3-3V18a6 6 0 0 0-6-6h-2V9a3 3 0 0 0-3-3zm14 6H17v-2a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M21 28.5a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 0 3h-3a1.5 1.5 0 0 1-1.5-1.5M22.5 33a1.5 1.5 0 0 0 0 3h3a1.5 1.5 0 0 0 0-3z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M14 22a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v17a3 3 0 0 1-3 3H17a3 3 0 0 1-3-3zm3 2h14v14a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgPrinter$1 = SvgPrinter;

const SvgPrinterOffline = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M14 9a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v3h2a6 6 0 0 1 6 6v8.093a11 11 0 0 0-3-1.365V18a3 3 0 0 0-3-3H12a3 3 0 0 0-3 3v13a1 1 0 0 0 1 1h.5a1.5 1.5 0 0 1 0 3H9a3 3 0 0 1-3-3V18a6 6 0 0 1 6-6h2zm20 15.496V22a1 1 0 0 0-1-1H15a1 1 0 0 0-1 1v17a3 3 0 0 0 3 3h10.264c-.69-.9-1.244-1.91-1.631-3H18a1 1 0 0 1-1-1V24h14v1.514a11 11 0 0 1 3-1.018M25.244 33H22.5a1.5 1.5 0 0 0 0 3h2.521a11.2 11.2 0 0 1 .223-3M17 12h14v-2a1 1 0 0 0-1-1H18a1 1 0 0 0-1 1zm5.5 15a1.5 1.5 0 0 0 0 3h3a1.5 1.5 0 0 0 0-3z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M41.657 40.97a8 8 0 1 1-11.314-11.313A8 8 0 0 1 41.657 40.97" })
    ]
  }
);
const SvgPrinterOffline$1 = SvgPrinterOffline;

const SvgQuestion = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M23.992 7.5c-5.074 0-8.992 4.081-8.992 9v.75a1.5 1.5 0 0 0 1.5 1.5h1.489a1.5 1.5 0 0 0 1.5-1.5v-.75c0-2.106 1.651-4.5 4.503-4.5 2.85 0 4.502 2.394 4.502 4.5 0 2.402-1.61 3.777-3.256 5.185-1.724 1.473-3.488 2.98-3.488 5.736v2.58a1.5 1.5 0 0 0 1.5 1.499h1.5a1.5 1.5 0 0 0 1.5-1.5v-1.745c0-1.616 1.244-2.761 2.663-4.068C30.801 22.45 33 20.426 33 16.627c0-5.518-3.935-9.127-9.008-9.127M24 40.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6" })
  }
);
const SvgQuestion$1 = SvgQuestion;

const SvgQuestionCircle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M4.3 24C4.3 13.12 13.12 4.3 24 4.3S43.7 13.12 43.7 24 34.88 43.7 24 43.7 4.3 34.88 4.3 24M24 7.7C14.997 7.7 7.7 14.997 7.7 24c0 9.001 7.297 16.3 16.3 16.3S40.3 33.001 40.3 24c0-9.003-7.297-16.3-16.3-16.3",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M23.895 30.693a1.7 1.7 0 0 1 1.7 1.7v.056a1.7 1.7 0 1 1-3.4 0v-.056a1.7 1.7 0 0 1 1.7-1.7M17.906 20.387a6.46 6.46 0 0 1 6.477-6.478 6.47 6.47 0 0 1 6.475 6.478c0 2.54-1.458 4.334-3.332 5.37l-.33.188c-.529.297-.912.512-1.226.795-.296.266-.381.463-.378.737a1.7 1.7 0 0 1-3.4.045c-.02-1.509.694-2.58 1.504-3.31.623-.56 1.398-.991 1.918-1.28l.238-.134.022-.012c1.06-.584 1.584-1.369 1.584-2.4a3.07 3.07 0 0 0-3.075-3.077 3.06 3.06 0 0 0-3.078 3.078 1.7 1.7 0 0 1-3.4 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgQuestionCircle$1 = SvgQuestionCircle;

const SvgQuestionCircleSolid = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M24 3.744c-11.088 0-20.1 9.144-20.1 20.388S12.912 44.52 24 44.52s20.1-9.144 20.1-20.388S35.088 3.744 24 3.744m1.524 31.344a2.143 2.143 0 0 1-3.048 0 2.22 2.22 0 0 1-.636-1.524c0-.564.228-1.128.636-1.524.804-.804 2.244-.804 3.06 0 .396.408.636.96.636 1.524s-.228 1.128-.636 1.524zm1.728-11.136c-1.2.804-1.332 1.56-1.332 2.064v.612c0 1.056-.864 1.92-1.92 1.92a1.926 1.926 0 0 1-1.92-1.92v-.612c0-1.464.528-3.564 3.036-5.244.852-.576 1.284-1.26 1.284-2.028 0-1.32-1.08-2.4-2.4-2.4s-2.4 1.068-2.4 2.388c0 1.056-.864 1.92-1.92 1.92a1.926 1.926 0 0 1-1.92-1.92c0-3.432 2.796-6.228 6.24-6.228a6.243 6.243 0 0 1 6.24 6.24c0 2.064-1.056 3.924-2.988 5.22z" })
  }
);
const SvgQuestionCircleSolid$1 = SvgQuestionCircleSolid;

const SvgReceipt = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M4.5 6c0-.828.728-1.5 1.625-1.5h35.75c.898 0 1.625.672 1.625 1.5s-.727 1.5-1.625 1.5H39.5V42a1.5 1.5 0 0 1-1.5 1.5c-1.687 0-2.617-.799-3.231-1.326l-.041-.035c-.302-.259-.47-.393-.658-.488-.156-.078-.37-.151-.737-.151-.559 0-.766.165-1.32.639l-.02.017c-.28.241-.695.597-1.236.87-.586.297-1.266.474-2.09.474-1.687 0-2.618-.799-3.232-1.326l-.04-.035c-.303-.259-.47-.393-.659-.488-.155-.078-.369-.151-.736-.151-.56 0-.767.165-1.32.639l-.02.017c-.281.241-.696.597-1.236.87-.587.297-1.266.474-2.09.474-1.687 0-2.618-.799-3.232-1.326l-.041-.035c-.302-.259-.47-.393-.658-.488-.155-.078-.37-.151-.736-.151-.367 0-.57.072-.711.145-.177.091-.333.22-.634.483l-.033.029c-.27.236-.673.59-1.201.863-.585.302-1.263.48-2.088.48A1.5 1.5 0 0 1 8.5 42V7.5H6.125C5.228 7.5 4.5 6.828 4.5 6m7 33.736a5.6 5.6 0 0 1 1.079-.756c.585-.302 1.263-.48 2.088-.48.824 0 1.504.177 2.09.474.54.273.955.629 1.236.87l.02.017c.554.474.761.639 1.32.639.367 0 .582-.073.737-.151.188-.095.356-.229.658-.488l.04-.035c.615-.527 1.545-1.326 3.232-1.326.825 0 1.504.177 2.09.474.541.273.956.629 1.237.87l.02.017c.553.474.76.639 1.32.639.367 0 .58-.073.736-.151.188-.095.356-.229.658-.488l.041-.035c.614-.527 1.545-1.326 3.231-1.326.825 0 1.504.177 2.09.474.447.226.807.507 1.077.734V7.5h-25zm6.997-24.35a1.5 1.5 0 0 1 2.118.11L24 19.259l3.385-3.761a1.5 1.5 0 1 1 2.23 2.006L26.468 21H28.5a1.5 1.5 0 0 1 0 3h-3v1h3a1.5 1.5 0 0 1 0 3h-3v2.5a1.5 1.5 0 0 1-3 0V28h-3a1.5 1.5 0 0 1 0-3h3v-1h-3a1.5 1.5 0 0 1 0-3h2.032l-3.147-3.497a1.5 1.5 0 0 1 .112-2.118",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgReceipt$1 = SvgReceipt;

const SvgRefresh = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("g", { clipPath: "url(#refresh_svg__a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M15.273 10.903a15.755 15.755 0 1 0 24.508 13.1 1.519 1.519 0 0 0-3.038 0 12.717 12.717 0 1 1-5.442-10.431l-2.527.677a1.5 1.5 0 0 0 .776 2.897l5.464-1.464a1.5 1.5 0 0 0 1.06-1.837l-1.463-5.464a1.5 1.5 0 1 0-2.898.777l.344 1.283q-.146-.083-.293-.163a15.75 15.75 0 0 0-16.49.625",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "refresh_svg__a", children: /* @__PURE__ */ jsx("path", { d: "M0 0h48v48H0z" }) }) })
    ]
  }
);
const SvgRefresh$1 = SvgRefresh;

const SvgReport = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsxs(
      "g",
      {
        style: {
          mixBlendMode: "multiply"
        },
        children: [
          /* @__PURE__ */ jsx("path", { d: "M19.522 14.58a1.375 1.375 0 1 0-2.044 1.84l4.536 5.04H18.5a1.375 1.375 0 1 0 0 2.75h4.125v2.14H18.5a1.375 1.375 0 0 0 0 2.75h4.125v3.513a1.375 1.375 0 1 0 2.75 0V29.1H29.5a1.375 1.375 0 1 0 0-2.75h-4.125v-2.14H29.5a1.375 1.375 0 1 0 0-2.75h-3.514l4.536-5.04a1.375 1.375 0 1 0-2.044-1.84L24 19.557z" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M24 41c9.389 0 17-7.611 17-17S33.389 7 24 7 7 14.611 7 24s7.611 17 17 17m0 3c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20",
              clipRule: "evenodd"
            }
          )
        ]
      }
    )
  }
);
const SvgReport$1 = SvgReport;

const SvgReturn = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M25.5 8a1.5 1.5 0 0 0 0 3h9a6.5 6.5 0 0 1 6.5 6.5v5a6.5 6.5 0 0 1-6.5 6.5H9.121l5.44-5.44a1.5 1.5 0 0 0-2.122-2.12l-8 8a1.5 1.5 0 0 0 0 2.12l8 8a1.5 1.5 0 0 0 2.122-2.12L9.12 32H34.5a9.5 9.5 0 0 0 9.5-9.5v-5A9.5 9.5 0 0 0 34.5 8z" })
  }
);
const SvgReturn$1 = SvgReturn;

const SvgRhombus = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "m36.728 22.97-12.02-12.02a1 1 0 0 0-1.415 0l-12.02 12.02a1 1 0 0 0 0 1.415l12.02 12.02a1 1 0 0 0 1.414 0l12.02-12.02a1 1 0 0 0 0-1.414m-9.9-14.142a4 4 0 0 0-5.656 0L9.15 20.85a4 4 0 0 0 0 5.657l12.02 12.02a4 4 0 0 0 5.657 0l12.021-12.02a4 4 0 0 0 0-5.657z",
        clipRule: "evenodd",
        style: {
          mixBlendMode: "multiply"
        }
      }
    )
  }
);
const SvgRhombus$1 = SvgRhombus;

const SvgRingnote = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M33.5 27a1.5 1.5 0 0 1-1.5 1.5H16a1.5 1.5 0 0 1 0-3h16a1.5 1.5 0 0 1 1.5 1.5M33.5 19a1.5 1.5 0 0 1-1.5 1.5H16a1.5 1.5 0 0 1 0-3h16a1.5 1.5 0 0 1 1.5 1.5M33.5 35a1.5 1.5 0 0 1-1.5 1.5H16a1.5 1.5 0 0 1 0-3h16a1.5 1.5 0 0 1 1.5 1.5" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 4a1.5 1.5 0 0 1 1.5 1.5V7H30V5.5a1.5 1.5 0 0 1 3 0V7h3a4 4 0 0 1 4 4v29a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4h3V5.5a1.5 1.5 0 0 1 3 0V7h4.5V5.5A1.5 1.5 0 0 1 24 4m-1.5 6H18v1.5a1.5 1.5 0 0 1-3 0V10h-3a1 1 0 0 0-1 1v29a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1h-3v1.5a1.5 1.5 0 0 1-3 0V10h-4.5v1.5a1.5 1.5 0 0 1-3 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgRingnote$1 = SvgRingnote;

const SvgRocket = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M20.169 14.402a1.7 1.7 0 0 1-1.564 1.825l-9.374.722-2.305 2.305a77 77 0 0 1 6.03 4.235l.004.003a71.6 71.6 0 0 1 12.345 12.344l.001.002a75 75 0 0 1 4.24 6.03l2.304-2.303.741-9.377a1.7 1.7 0 0 1 3.39.268l-.791 10.002a1.7 1.7 0 0 1-.493 1.068l-4.274 4.273a1.7 1.7 0 0 1-2.665-.336 71 71 0 0 0-5.133-7.534A68.2 68.2 0 0 0 10.87 26.173a74 74 0 0 0-7.537-5.136 1.7 1.7 0 0 1-.334-2.663L7.27 14.1a1.7 1.7 0 0 1 1.072-.493l10-.77a1.7 1.7 0 0 1 1.826 1.565",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M20.803 14.395a51.7 51.7 0 0 0-7.98 12.424 33 33 0 0 0-1.437 3.412l7.105 7.105c1.173-.351 2.31-.82 3.393-1.398q.045-.024.092-.046a52.3 52.3 0 0 0 12.378-7.953l.077-.077q.115-.116.339-.351a32.27 32.27 0 0 0 4.6-6.317c2.17-3.94 3.65-8.85 1.937-13.735-5.035-1.733-9.964-.24-13.862 1.925a31 31 0 0 0-6.219 4.59 18 18 0 0 0-.424.42M35.506 29.19c1.178 1.225 1.179 1.224 1.18 1.224v-.001l.004-.004.01-.01.032-.03.113-.114c.096-.096.232-.236.4-.415a35.656 35.656 0 0 0 5.102-7.007c2.484-4.506 4.526-10.85 1.846-17.347a1.7 1.7 0 0 0-.938-.93c-6.632-2.667-12.97-.638-17.46 1.855a34.5 34.5 0 0 0-6.925 5.11 21 21 0 0 0-.519.516l-.031.033-.01.01-.003.004h-.001c0 .001 0 .002 1.238 1.165l-1.239-1.163q-.023.024-.044.05a55.1 55.1 0 0 0-8.502 13.207 36 36 0 0 0-1.94 4.824 1.7 1.7 0 0 0 .416 1.721l8.548 8.547a1.7 1.7 0 0 0 1.604.45 21.8 21.8 0 0 0 5.053-1.925 55.7 55.7 0 0 0 13.244-8.545z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M23.038 21.028a4.863 4.863 0 1 1 9.725 0 4.863 4.863 0 0 1-9.725 0m4.862-1.462a1.462 1.462 0 1 0 0 2.924 1.462 1.462 0 0 0 0-2.924M27.784 6.278a1.7 1.7 0 0 1 2.404 0l12.35 12.351a1.7 1.7 0 0 1-2.404 2.404l-12.35-12.35a1.7 1.7 0 0 1 0-2.405M4.302 36.388a1.7 1.7 0 0 1 2.404-.005l5.15 5.128a1.7 1.7 0 1 1-2.4 2.41l-5.15-5.129a1.7 1.7 0 0 1-.004-2.404",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgRocket$1 = SvgRocket;

const SvgRss = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M10 6.5a1.5 1.5 0 1 0 0 3h2c14.636 0 26.5 11.865 26.5 26.5v2a1.5 1.5 0 0 0 3 0v-2C41.5 19.708 28.292 6.5 12 6.5z" }),
      /* @__PURE__ */ jsx("path", { d: "M8.5 16a1.5 1.5 0 0 1 1.5-1.5h1c12.426 0 22.5 10.074 22.5 22.5v1a1.5 1.5 0 0 1-3 0v-1c0-10.77-8.73-19.5-19.5-19.5h-1A1.5 1.5 0 0 1 8.5 16" }),
      /* @__PURE__ */ jsx("path", { d: "M10 22.5a1.5 1.5 0 0 0 0 3c6.904 0 12.5 5.596 12.5 12.5a1.5 1.5 0 0 0 3 0c0-8.56-6.94-15.5-15.5-15.5M12.5 40a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9" })
    ]
  }
);
const SvgRss$1 = SvgRss;

const SvgScaleDown = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M9.06 6.94a1.5 1.5 0 1 0-2.12 2.12L17.878 20H12.5a1.5 1.5 0 0 0 0 3h9a1.5 1.5 0 0 0 1.5-1.5v-9a1.5 1.5 0 0 0-3 0v5.379zM26.5 25a1.5 1.5 0 0 0-1.5 1.5v9a1.5 1.5 0 0 0 3 0v-5.379l10.94 10.94a1.5 1.5 0 0 0 2.12-2.122L30.122 28H35.5a1.5 1.5 0 0 0 0-3z" })
  }
);
const SvgScaleDown$1 = SvgScaleDown;

const SvgScaleUp = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M8.5 7A1.5 1.5 0 0 0 7 8.5v9a1.5 1.5 0 0 0 3 0v-5.379l9.94 9.94a1.5 1.5 0 0 0 2.12-2.122L12.122 10H17.5a1.5 1.5 0 0 0 0-3zM41 39.5a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1 0-3h5.379l-9.94-9.94a1.5 1.5 0 0 1 2.122-2.12L38 35.878V30.5a1.5 1.5 0 0 1 3 0z" })
  }
);
const SvgScaleUp$1 = SvgScaleUp;

const SvgSearch = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M23.265 7.7c-8.36 0-15.135 6.776-15.135 15.135s6.776 15.137 15.135 15.137S38.4 31.195 38.4 22.835 31.624 7.7 23.265 7.7M4.73 22.835C4.73 12.598 13.028 4.3 23.265 4.3S41.8 12.598 41.8 22.835s-8.298 18.537-18.535 18.537S4.73 33.072 4.73 22.835",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M33.519 33.968a1.7 1.7 0 0 1 2.404-.004l6.85 6.833a1.7 1.7 0 0 1-2.4 2.407l-6.851-6.832a1.7 1.7 0 0 1-.003-2.404",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgSearch$1 = SvgSearch;

const SvgShareAndroid = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("g", { clipPath: "url(#share-android_svg__a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M40.204 7.968a5.935 5.935 0 0 1-9.182 7.316l-13.3 7.679c.1.439.15.884.149 1.326 0 .442-.049.887-.15 1.325l13.301 7.68a5.935 5.935 0 1 1-1.6 2.503l-13.067-7.545q-.076.084-.156.167a5.9 5.9 0 0 1-1.896 1.312 5.9 5.9 0 0 1-2.275.493 5.9 5.9 0 0 1-2.603-.557 5.9 5.9 0 0 1-2.915-2.97A5.9 5.9 0 0 1 6 24.289c-.001-.811.164-1.631.51-2.408a5.9 5.9 0 0 1 2.915-2.97 5.9 5.9 0 0 1 2.602-.557c.768.011 1.54.172 2.277.493a5.9 5.9 0 0 1 2.05 1.479l13.068-7.545a5.937 5.937 0 0 1 10.781-4.813",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "share-android_svg__a", children: /* @__PURE__ */ jsx("path", { d: "M0 0h48v48H0z" }) }) })
    ]
  }
);
const SvgShareAndroid$1 = SvgShareAndroid;

const SvgShareIos = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M15 44a6 6 0 0 1-6-6V22a6 6 0 0 1 6-6h2.5a1.5 1.5 0 0 1 0 3H15a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V22a3 3 0 0 0-3-3h-2.5a1.5 1.5 0 0 1 0-3H33a6 6 0 0 1 6 6v16a6 6 0 0 1-6 6z" }),
      /* @__PURE__ */ jsx("path", { d: "M24 27.5a1.5 1.5 0 0 1-1.5-1.5V9.121l-2.44 2.44a1.5 1.5 0 0 1-2.12-2.122l5-5a1.5 1.5 0 0 1 2.12 0l5 5a1.5 1.5 0 0 1-2.12 2.122L25.5 9.12V26a1.5 1.5 0 0 1-1.5 1.5" })
    ]
  }
);
const SvgShareIos$1 = SvgShareIos;

const SvgShiftManagement = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M3.583 18.194a1.7 1.7 0 0 1 1.7-1.7h35.933a1.7 1.7 0 1 1 0 3.4H5.283a1.7 1.7 0 0 1-1.7-1.7M31.326 1.7a1.7 1.7 0 0 1 1.7 1.7v6.575a1.7 1.7 0 0 1-3.4 0V3.4a1.7 1.7 0 0 1 1.7-1.7M15.182 1.7a1.7 1.7 0 0 1 1.7 1.7v6.575a1.7 1.7 0 1 1-3.4 0V3.4a1.7 1.7 0 0 1 1.7-1.7",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M6.659 7.708c2.048-1.948 4.898-2.854 8.138-2.854h16.915c3.247 0 6.098.905 8.143 2.855 2.058 1.962 3.079 4.77 3.07 8.124v6.712a1.7 1.7 0 1 1-3.4 0v-6.72c.008-2.652-.785-4.481-2.016-5.655-1.245-1.187-3.16-1.916-5.797-1.916H14.797c-2.628 0-4.545.729-5.795 1.918-1.238 1.176-2.037 3.007-2.037 5.658v18.08c0 2.707.804 4.584 2.048 5.79 1.253 1.214 3.166 1.956 5.784 1.956h4.922a1.7 1.7 0 1 1 0 3.4h-4.922c-3.25 0-6.104-.931-8.15-2.915-2.055-1.991-3.082-4.837-3.082-8.23V15.83c0-3.356 1.032-6.164 3.094-8.123",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M34.336 28.62a7.142 7.142 0 1 0 .004 14.283 7.142 7.142 0 0 0-.004-14.283m-10.54 7.142c0-5.82 4.719-10.542 10.54-10.542 5.824 0 10.542 4.722 10.542 10.542 0 5.821-4.719 10.54-10.542 10.54-5.82 0-10.54-4.72-10.54-10.54",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M34.287 31.097a1.7 1.7 0 0 1 1.7 1.7v2.628l1.968 1.175a1.7 1.7 0 1 1-1.745 2.919l-2.795-1.67a1.7 1.7 0 0 1-.828-1.46v-3.592a1.7 1.7 0 0 1 1.7-1.7M12.6 26.156a1.7 1.7 0 0 1 1.7-1.7h.022a1.7 1.7 0 1 1 0 3.4H14.3a1.7 1.7 0 0 1-1.7-1.7M12.6 34.114a1.7 1.7 0 0 1 1.7-1.7h.022a1.7 1.7 0 1 1 0 3.4H14.3a1.7 1.7 0 0 1-1.7-1.7M20.996 26.156a1.7 1.7 0 0 1 1.7-1.7h.022a1.7 1.7 0 1 1 0 3.4h-.022a1.7 1.7 0 0 1-1.7-1.7",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgShiftManagement$1 = SvgShiftManagement;

const SvgShop = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M14 19.3a1.7 1.7 0 0 1 1.7 1.7c0 1.917 1.443 3.3 3.018 3.3h.564c1.575 0 3.018-1.383 3.018-3.3a1.7 1.7 0 0 1 3.4 0c0 3.606-2.782 6.7-6.418 6.7h-.564c-3.636 0-6.418-3.094-6.418-6.7a1.7 1.7 0 0 1 1.7-1.7",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 19.3a1.7 1.7 0 0 1 1.7 1.7c0 1.917 1.443 3.3 3.018 3.3h.564c1.575 0 3.018-1.383 3.018-3.3a1.7 1.7 0 0 1 3.4 0c0 3.606-2.782 6.7-6.418 6.7h-.564c-3.636 0-6.418-3.094-6.418-6.7a1.7 1.7 0 0 1 1.7-1.7",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M9.118 14.7c-1.915 0-3.418 1.518-3.418 3.332v3.328c0 1.597 1.325 2.94 3.018 2.94h.564c1.694 0 3.018-1.342 3.018-2.939a1.7 1.7 0 0 1 3.4 0c0 3.529-2.9 6.339-6.418 6.339h-.564C5.2 27.7 2.3 24.888 2.3 21.36v-3.328c0-3.746 3.08-6.732 6.818-6.732h29.764c3.737 0 6.818 2.986 6.818 6.732v3.328c0 3.528-2.9 6.34-6.418 6.34h-.564c-3.517 0-6.418-2.81-6.418-6.339a1.7 1.7 0 0 1 3.4 0c0 1.597 1.324 2.939 3.018 2.939h.564c1.693 0 3.018-1.343 3.018-2.94v-3.328c0-1.814-1.503-3.332-3.418-3.332z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M40 24.3a1.7 1.7 0 0 1 1.7 1.7v13.21c0 3.046-2.488 5.49-5.524 5.49H11.822c-3.035 0-5.522-2.445-5.522-5.49V26.004a1.7 1.7 0 1 1 3.4 0V39.21c0 1.14.937 2.09 2.122 2.09h24.354c1.187 0 2.124-.95 2.124-2.09V26a1.7 1.7 0 0 1 1.7-1.7",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M17.3 37.535c0-3.595 3.16-6.235 6.7-6.235s6.7 2.64 6.7 6.235V43a1.7 1.7 0 1 1-3.4 0v-5.465c0-1.413-1.318-2.835-3.3-2.835s-3.3 1.422-3.3 2.835V43a1.7 1.7 0 1 1-3.4 0zM11.822 7.7C10.82 7.7 9.7 8.67 9.7 10.258V13a1.7 1.7 0 1 1-3.4 0v-2.742C6.3 7.146 8.605 4.3 11.822 4.3h24.354c3.218 0 5.524 2.845 5.524 5.958V13a1.7 1.7 0 1 1-3.4 0v-2.742c0-1.588-1.118-2.558-2.124-2.558z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgShop$1 = SvgShop;

const SvgShopInfo = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M6.338 8.81a4.5 4.5 0 0 1 4.34-3.31h26.644a4.5 4.5 0 0 1 4.34 3.31l2.744 10c.785 2.864-1.37 5.69-4.34 5.69H7.934c-2.97 0-5.126-2.826-4.34-5.69zm4.34-.31A1.5 1.5 0 0 0 9.23 9.603l-2.744 10A1.5 1.5 0 0 0 7.934 21.5h32.132a1.5 1.5 0 0 0 1.446-1.897l-2.743-10A1.5 1.5 0 0 0 37.322 8.5z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M8.5 26.5A1.5 1.5 0 0 1 10 28v8.5a2.5 2.5 0 0 0 2.5 2.5H17v-8a3 3 0 0 1 3-3h8q.213 0 .42.03A11 11 0 0 0 26.2 31H21a1 1 0 0 0-1 1v7h5.414a11 11 0 0 0 1.365 3h-14.28A5.5 5.5 0 0 1 7 36.5V28a1.5 1.5 0 0 1 1.5-1.5" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M36 44a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0-11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-1 2.5a1 1 0 0 1 2 0V40a1 1 0 1 1-2 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgShopInfo$1 = SvgShopInfo;

const SvgSidebarLeft = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 56 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M13.41 14c-.967 0-1.75.672-1.75 1.5s.783 1.5 1.75 1.5h2.331c.966 0 1.75-.672 1.75-1.5s-.784-1.5-1.75-1.5zM11.66 21.5c0-.828.783-1.5 1.75-1.5h2.331c.966 0 1.75.672 1.75 1.5s-.784 1.5-1.75 1.5H13.41c-.966 0-1.749-.672-1.749-1.5M13.41 26c-.967 0-1.75.672-1.75 1.5s.783 1.5 1.75 1.5h2.331c.966 0 1.75-.672 1.75-1.5s-.784-1.5-1.75-1.5z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M11.66 8c-3.864 0-6.996 2.686-6.996 6v20c0 3.314 3.132 6 6.996 6H44.31c3.863 0 6.996-2.686 6.996-6V14c0-3.314-3.133-6-6.996-6zm32.649 3H24.486v26H44.31c1.931 0 3.498-1.343 3.498-3V14c0-1.657-1.567-3-3.498-3M11.66 11h9.328v26H11.66c-1.932 0-3.498-1.343-3.498-3V14c0-1.657 1.566-3 3.498-3",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgSidebarLeft$1 = SvgSidebarLeft;

const SvgSidebarRight = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 56 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M40.227 14c-.965 0-1.749.672-1.749 1.5s.783 1.5 1.75 1.5h2.331c.966 0 1.75-.672 1.75-1.5s-.784-1.5-1.75-1.5zM38.478 21.5c0-.828.783-1.5 1.75-1.5h2.331c.966 0 1.75.672 1.75 1.5s-.784 1.5-1.75 1.5h-2.332c-.965 0-1.749-.672-1.749-1.5M40.227 26c-.965 0-1.749.672-1.749 1.5s.783 1.5 1.75 1.5h2.331c.966 0 1.75-.672 1.75-1.5s-.784-1.5-1.75-1.5z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M11.66 8c-3.864 0-6.996 2.686-6.996 6v20c0 3.314 3.132 6 6.996 6H44.31c3.863 0 6.996-2.686 6.996-6V14c0-3.314-3.133-6-6.996-6zm32.649 3H34.98v26h9.329c1.931 0 3.498-1.343 3.498-3V14c0-1.657-1.567-3-3.498-3M11.66 11h19.822v26H11.66c-1.932 0-3.498-1.343-3.498-3V14c0-1.657 1.566-3 3.498-3",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgSidebarRight$1 = SvgSidebarRight;

const SvgSmChevronDown = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M33.202 18.798a1.7 1.7 0 0 1 0 2.404l-8 8a1.7 1.7 0 0 1-2.404 0l-8-8a1.7 1.7 0 1 1 2.404-2.404L24 25.596l6.798-6.798a1.7 1.7 0 0 1 2.404 0",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgSmChevronDown$1 = SvgSmChevronDown;

const SvgSmChevronLeft = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M29.202 33.202a1.7 1.7 0 0 1-2.404 0l-8-8a1.7 1.7 0 0 1 0-2.404l8-8a1.7 1.7 0 0 1 2.404 2.404L22.404 24l6.798 6.798a1.7 1.7 0 0 1 0 2.404",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgSmChevronLeft$1 = SvgSmChevronLeft;

const SvgSmChevronRight = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M18.798 14.798a1.7 1.7 0 0 1 2.404 0l8 8a1.7 1.7 0 0 1 0 2.404l-8 8a1.7 1.7 0 0 1-2.404-2.404L25.596 24l-6.798-6.798a1.7 1.7 0 0 1 0-2.404",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgSmChevronRight$1 = SvgSmChevronRight;

const SvgSmChevronUp = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M14.798 29.202a1.7 1.7 0 0 1 0-2.404l8-8a1.7 1.7 0 0 1 2.404 0l8 8a1.7 1.7 0 1 1-2.404 2.404L24 22.404l-6.798 6.798a1.7 1.7 0 0 1-2.404 0",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgSmChevronUp$1 = SvgSmChevronUp;

const SvgSoundCircle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M30.01 15.94a1.5 1.5 0 0 1 2.122 0c4.49 4.49 4.49 11.772 0 16.263a1.5 1.5 0 1 1-2.122-2.122 8.5 8.5 0 0 0 0-12.02 1.5 1.5 0 0 1 0-2.122M24.94 19.94a1.5 1.5 0 0 1 2.121 0 5.5 5.5 0 0 1 0 7.777 1.5 1.5 0 0 1-2.121-2.12 2.5 2.5 0 0 0 0-3.536 1.5 1.5 0 0 1 0-2.122M12 20a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3l4.36 3.633a1 1 0 0 0 1.64-.768v-13.73a1 1 0 0 0-1.64-.768L15 20z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M44 24c0 11.046-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4s20 8.954 20 20m-3 0c0 9.389-7.611 17-17 17S7 33.389 7 24 14.611 7 24 7s17 7.611 17 17",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgSoundCircle$1 = SvgSoundCircle;

const SvgSparkle = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M23.131 4.626c.279-.835 1.46-.835 1.738 0l2.888 8.666a10.99 10.99 0 0 0 6.951 6.95l8.666 2.89c.835.277.835 1.458 0 1.737l-8.666 2.888a10.99 10.99 0 0 0-6.95 6.951l-2.89 8.666c-.277.835-1.458.835-1.737 0l-2.888-8.666a10.99 10.99 0 0 0-6.951-6.95l-8.666-2.89c-.835-.277-.835-1.458 0-1.737l8.666-2.888a10.99 10.99 0 0 0 6.95-6.951z" })
  }
);
const SvgSparkle$1 = SvgSparkle;

const SvgSpinner = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M35.667 12.333c-.586.586-1.53.579-2.172.054A14.94 14.94 0 0 0 24 9C15.716 9 9 15.716 9 24c0 3.603 1.27 6.909 3.387 9.495.525.641.532 1.587-.054 2.172s-1.541.59-2.076-.042A17.93 17.93 0 0 1 6 24c0-9.941 8.059-18 18-18 4.431 0 8.488 1.601 11.625 4.257.632.535.628 1.49.042 2.076" })
  }
);
const SvgSpinner$1 = SvgSpinner;

const SvgStaff = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M24 45.61c-3.97 0-16.04 0-16.04-7.6S20.03 30.46 24 30.46s16.04 0 16.04 7.6S27.97 45.61 24 45.61m0-11.75c-5.77 0-12.64.72-12.64 4.15S18.23 42.2 24 42.2s12.64-.72 12.64-4.15-6.87-4.19-12.64-4.19M24 27.18c-5.72-.02-10.46-4.45-10.86-10.08-.02-.27-.03-.54-.03-.82 0-.94.76-1.69 1.7-1.69s1.7.77 1.69 1.71c0 .19 0 .38.02.56.28 3.87 3.53 6.91 7.42 6.92 3.96 0 7.24-3.04 7.53-6.93.01-.19.02-.37.02-.56 0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7c0 .27-.01.55-.03.81-.42 5.65-5.19 10.08-10.86 10.08M33.17 13.18H14.83c-.76 0-1.44-.34-1.87-.92-.73-1.01-.41-2.3-.24-2.81.04-.12.09-.23.16-.34.29-.48.48-1 .68-1.54 1.09-2.99 2.46-5.11 10.24-5.16h.41c7.79.05 9.17 2.17 10.25 5.16.2.55.39 1.07.68 1.54.07.11.12.22.16.34.17.51.49 1.8-.24 2.81-.42.59-1.1.92-1.87.92zm-16.84-3.4h15.34c-.16-.37-.29-.73-.41-1.06-.63-1.74-1.05-2.89-7.07-2.92h-.39c-6.01.04-6.43 1.18-7.06 2.92-.12.33-.25.69-.41 1.06" })
  }
);
const SvgStaff$1 = SvgStaff;

const SvgStandard = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M31 19a7 7 0 1 1-14 0 7 7 0 0 1 14 0m-3 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M21.937 4.648a3.5 3.5 0 0 1 4.126 0l1.97 1.437a.5.5 0 0 0 .295.096l2.44-.004A3.5 3.5 0 0 1 34.104 8.6l.749 2.321a.5.5 0 0 0 .182.252l1.976 1.43a3.5 3.5 0 0 1 1.275 3.923l-.758 2.318a.5.5 0 0 0 0 .31l.758 2.318a3.5 3.5 0 0 1-1.275 3.924l-1.976 1.43a.5.5 0 0 0-.182.25l-.75 2.322a3.5 3.5 0 0 1-3.337 2.424l-2.439-.004a.5.5 0 0 0-.295.096l-1.97 1.437a3.5 3.5 0 0 1-4.126 0l-1.97-1.437a.5.5 0 0 0-.295-.096l-2.44.005a3.5 3.5 0 0 1-3.337-2.425l-.749-2.321a.5.5 0 0 0-.183-.252l-1.975-1.43a3.5 3.5 0 0 1-1.275-3.923l.758-2.318a.5.5 0 0 0 0-.31l-.758-2.318a3.5 3.5 0 0 1 1.275-3.924l1.976-1.43a.5.5 0 0 0 .182-.25l.75-2.322a3.5 3.5 0 0 1 3.337-2.424l2.439.004a.5.5 0 0 0 .295-.096zm2.358 2.424a.5.5 0 0 0-.59 0l-1.97 1.437a3.5 3.5 0 0 1-2.07.672l-2.438-.004a.5.5 0 0 0-.477.346l-.749 2.32a3.5 3.5 0 0 1-1.279 1.761l-1.976 1.43a.5.5 0 0 0-.182.56l.758 2.318a3.5 3.5 0 0 1 0 2.176l-.758 2.318a.5.5 0 0 0 .182.56l1.976 1.43a3.5 3.5 0 0 1 1.28 1.76l.748 2.321a.5.5 0 0 0 .477.346l2.439-.004a3.5 3.5 0 0 1 2.07.672l1.97 1.437a.5.5 0 0 0 .589 0l1.97-1.437a3.5 3.5 0 0 1 2.07-.672l2.438.005a.5.5 0 0 0 .477-.347l.749-2.32a3.5 3.5 0 0 1 1.279-1.761l1.976-1.43a.5.5 0 0 0 .182-.56l-.758-2.318a3.5 3.5 0 0 1 0-2.176l.758-2.318a.5.5 0 0 0-.182-.56l-1.976-1.43a3.5 3.5 0 0 1-1.28-1.76l-.748-2.321a.5.5 0 0 0-.477-.346l-2.439.004a3.5 3.5 0 0 1-2.07-.672z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "m11.976 40.956 1.893-7.066c.994.599 2.152.936 3.37.933l1.62-.003 1.31.956q.61.443 1.282.728l-1.748 6.523a1 1 0 0 1-1.67.451l-1.642-1.628a1 1 0 0 0-.958-.257l-2.237.589a1 1 0 0 1-1.22-1.226M27.83 35.776a6.5 6.5 0 0 1-1.345.755l1.74 6.496a1 1 0 0 0 1.67.451l1.642-1.628a1 1 0 0 1 .959-.257l2.236.589a1 1 0 0 0 1.22-1.226l-1.883-7.03c-.98.577-2.115.9-3.308.897l-1.62-.003z" })
    ]
  }
);
const SvgStandard$1 = SvgStandard;

const SvgStar = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M14.294 42.7c-.9 0-1.7-.3-2.5-.8-1.3-.9-1.9-2.5-1.6-4l1.4-8c0-.2 0-.5-.2-.6l-5.9-5.7c-1.1-1.1-1.6-2.7-1.1-4.2s1.8-2.6 3.4-2.8l8.2-1.2c.3 0 .5-.2.6-.4l3.7-7.3c.7-1.4 2.1-2.3 3.7-2.3s3 .9 3.7 2.3l3.7 7.3c.1.2.3.4.6.4l8.2 1.2c1.6.2 2.9 1.3 3.4 2.8s0 3.1-1.1 4.2l-5.9 5.7c-.2.2-.3.4-.2.6l1.4 8c.3 1.5-.4 3.1-1.6 4-1.3.9-3 1.1-4.4.3l-7.3-3.8c-.2-.1-.5-.1-.7 0l-7.3 3.8c-.6.3-1.3.5-1.9.5zm9.6-34c-.1 0-.5 0-.7.4l-3.7 7.3c-.6 1.2-1.8 2.1-3.1 2.3l-8.2 1.2c-.4 0-.6.4-.6.5 0 .2 0 .5.2.7l5.9 5.7c1 1 1.4 2.3 1.2 3.7l-1.4 8c0 .4.2.6.3.7.1 0 .4.3.8 0l7.3-3.8c1.2-.6 2.7-.6 3.9 0l7.3 3.8c.4.2.7 0 .8 0s.4-.3.3-.7l-1.4-8c-.2-1.3.2-2.7 1.2-3.7l5.9-5.7c.3-.3.2-.6.2-.7s-.2-.4-.6-.5l-8.2-1.2c-1.4-.2-2.5-1-3.1-2.3l-3.7-7.3c-.2-.4-.5-.4-.7-.4z" })
  }
);
const SvgStar$1 = SvgStar;

const SvgStarSolid = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M22.231 8.353c.75-1.423 2.787-1.423 3.538 0l4.19 7.943a2 2 0 0 0 1.429 1.037l8.849 1.531c1.585.274 2.214 2.212 1.093 3.365l-6.26 6.44a2 2 0 0 0-.544 1.679l1.278 8.89c.229 1.591-1.42 2.788-2.862 2.079l-8.06-3.963a2 2 0 0 0-1.765 0l-8.059 3.963c-1.443.71-3.09-.488-2.862-2.08l1.279-8.89a2 2 0 0 0-.546-1.678l-6.26-6.44c-1.12-1.153-.49-3.09 1.094-3.365l8.85-1.53a2 2 0 0 0 1.427-1.038z" })
  }
);
const SvgStarSolid$1 = SvgStarSolid;

const SvgStock = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M5.587 7.4a8.7 8.7 0 0 1 7.92-5.1h21.294a8.7 8.7 0 0 1 8.052 5.406l2.2 5.376a8.7 8.7 0 0 1 .647 3.294V37a8.7 8.7 0 0 1-8.7 8.7H11A8.7 8.7 0 0 1 2.3 37V16.516a8.7 8.7 0 0 1 .78-3.6zm7.92-1.7a5.3 5.3 0 0 0-4.825 3.107l-2.1 4.62H22.3V5.7zm12.193 0v7.726h15.82l-1.814-4.433A5.3 5.3 0 0 0 34.8 5.7zm16.6 11.126H5.7V37a5.3 5.3 0 0 0 5.3 5.3h26a5.3 5.3 0 0 0 5.3-5.3zm-15.525 7.417a3.473 3.473 0 0 1 3.473-3.473h4.581a3.475 3.475 0 0 1 3.476 3.473v4.582a3.475 3.475 0 0 1-3.476 3.475h-4.581a3.473 3.473 0 0 1-3.473-3.475zm3.473-.073a.073.073 0 0 0-.073.073v4.582c0 .044.034.075.073.075h4.581a.075.075 0 0 0 .076-.075v-4.582a.075.075 0 0 0-.076-.073zm-18.83 3.474a1.7 1.7 0 0 1 1.7-1.7h2.66a1.7 1.7 0 0 1 0 3.4h-2.66a1.7 1.7 0 0 1-1.7-1.7m0 6.307a1.7 1.7 0 0 1 1.7-1.7h6.658a1.7 1.7 0 1 1 0 3.4H13.12a1.7 1.7 0 0 1-1.7-1.7",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgStock$1 = SvgStock;

const SvgStockLink = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "m25.425 12.697-3.182 3.182-.013-.013a1.75 1.75 0 0 1-2.45-2.45l-.012-.012 3.182-3.182c4.296-4.296 11.26-4.296 15.556 0s4.296 11.26 0 15.556l-3.182 3.182-.012-.012a1.75 1.75 0 0 1-2.45-2.45l-.013-.013 3.182-3.182a7.5 7.5 0 1 0-10.606-10.606M13.404 19.768l.012.012q.075-.099.165-.189a1.75 1.75 0 1 1 2.285 2.64l.013.012-3.182 3.182A7.5 7.5 0 0 0 23.303 36.03l3.182-3.182.013.013q.075-.1.164-.19a1.75 1.75 0 1 1 2.286 2.64l.012.012-3.182 3.182c-4.296 4.296-11.26 4.296-15.556 0s-4.296-11.26 0-15.556z" }),
      /* @__PURE__ */ jsx("path", { d: "M18.707 27.546a1.75 1.75 0 0 0 2.475 2.475l8.839-8.839a1.75 1.75 0 0 0-2.475-2.475z" })
    ]
  }
);
const SvgStockLink$1 = SvgStockLink;

const SvgStockMove = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M19.685 5.495c-4.03-.703-7.118.978-8.736 4.12a1.7 1.7 0 0 1-1.511.921H4.024a1.7 1.7 0 1 1 0-3.4H8.45c2.44-3.89 6.743-5.876 11.821-4.99l.005.001 14.617 2.597.007.001 2.82.49c3.469.615 6.19 2.367 7.86 4.945 1.66 2.563 2.18 5.782 1.575 9.175v.001l-2.903 16.46c-.592 3.393-2.187 6.242-4.626 8.081-2.455 1.851-5.614 2.566-9.085 1.95L13.103 42.76h-.002c-5.398-.94-8.845-4.626-9.55-9.533a1.7 1.7 0 1 1 3.366-.484c.49 3.416 2.786 5.975 6.769 6.667l.005.001L31.135 42.5c2.645.47 4.824-.095 6.445-1.316 1.635-1.233 2.852-3.252 3.323-5.952l2.906-16.47c.481-2.703.03-5.016-1.082-6.732-1.101-1.7-2.952-2.976-5.597-3.446h-.003l-.25-.044-2.521 14.251a1.7 1.7 0 0 1-2.478 1.202l-5.033-2.698-5.696.81a1.7 1.7 0 0 1-1.913-1.98l2.537-14.258-2.086-.37zm5.435.966-2.126 11.946 3.924-.558a1.7 1.7 0 0 1 1.043.185l3.456 1.853 2.11-11.932zM5.642 17.158a1.7 1.7 0 0 1 1.7-1.7h6.971a1.7 1.7 0 1 1 0 3.4H7.342a1.7 1.7 0 0 1-1.7-1.7M2 25.442a1.7 1.7 0 0 1 1.7-1.7h7.516a1.7 1.7 0 1 1 0 3.4H3.7a1.7 1.7 0 0 1-1.7-1.7",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgStockMove$1 = SvgStockMove;

const SvgStocks = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M18 8a4.5 4.5 0 0 0-4.5 4.5v10h-5A4.5 4.5 0 0 0 4 27v11.5A1.5 1.5 0 0 0 5.5 40h37a1.5 1.5 0 0 0 1.5-1.5V27a4.5 4.5 0 0 0-4.5-4.5h-5v-10A4.5 4.5 0 0 0 30 8zm13.5 14.5v-10A1.5 1.5 0 0 0 30 11h-3v3.416c0 .471-.546.748-.944.477l-1.712-1.163a.615.615 0 0 0-.688 0l-1.712 1.163c-.398.27-.944-.006-.944-.477V11h-3a1.5 1.5 0 0 0-1.5 1.5v10zm-19.5 3H8.5A1.5 1.5 0 0 0 7 27v10h15.5V25.5H18v3.416c0 .471-.546.748-.944.477l-1.712-1.163a.615.615 0 0 0-.688 0l-1.712 1.163c-.398.27-.944-.006-.944-.477zM41 37H25.5V25.5H30v3.416c0 .471.546.748.944.477l1.712-1.163a.615.615 0 0 1 .688 0l1.712 1.163c.398.27.944-.006.944-.477V25.5h3.5A1.5 1.5 0 0 1 41 27z",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgStocks$1 = SvgStocks;

const SvgStores = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 120 32",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M16.297.137A26.78 26.78 0 0 0 4.126 9.133c-7.346 8.922-5.232 16.922 9.162 15.258 7.572-.777 4.614-9.961-1.998-5.18-8.719 6.357-5.159 17.024 5.399 11.015 10.68-6.249 13.725-22.67-4.876-19.015-4.52.893-4.178 7.026.727 6.176 3.328-.582 7.542-5.69 7.542-9.38 0-2.108-1.453-3.38-2.87-2.95-1.417.428-1.38 2.412-.247 2.833 1.65.603-.21 4.236-3.916 6.62-1.454.915-2.18-.35-.494-.647 8.036-1.41 10.68 1.126 9.496 5.377a14.4 14.4 0 0 1-7.782 8.973c-6.612 3.045-6.35-2.623-1.86-6.735 2.216-1.919 3.372-.378 1.33 0-4.134.61-14.692 1.743-9.112-7.993 3.32-5.813 8.792-9.49 12.905-10.688 1.642-.53 1.082-3.459-1.235-2.66M49.84 13.31h-4.67v-3.034h12.7v3.033h-4.677v11.92H49.84zM58.96 17.796v-.043a7.949 7.949 0 1 1 15.898-.044v.044a7.956 7.956 0 0 1-15.898.043m12.458 0v-.043a4.547 4.547 0 0 0-4.509-4.662 4.47 4.47 0 0 0-4.487 4.654v.044a4.547 4.547 0 0 0 4.487 4.662 4.473 4.473 0 0 0 4.51-4.655M77.607 10.276h6.756a5.97 5.97 0 0 1 4.364 1.513 4.71 4.71 0 0 1 1.28 3.418v.066a4.65 4.65 0 0 1-3.208 4.64l3.637 5.338h-3.847l-3.208-4.786h-2.509v4.786h-3.287zm6.472 7.273c1.608 0 2.524-.85 2.524-2.11v-.043c0-1.41-.982-2.138-2.582-2.138H80.83v4.291zM92.923 10.276h11.2v2.91h-7.927v3.032h6.967v2.91h-6.967v3.134h8v2.909H92.923zM113.847 16.276c-2.582-.662-3.222-.982-3.222-1.963v-.044c0-.727.662-1.302 1.92-1.302a6.55 6.55 0 0 1 3.426 1.164l2.181-2.182a8.65 8.65 0 0 0-5.556-1.905c-3.054 0-5.236 1.796-5.236 4.509v.043c0 2.968 1.942 3.804 4.96 4.575 2.494.64 3.011 1.062 3.011 1.898v.044c0 .872-.815 1.41-2.182 1.41a6.68 6.68 0 0 1-4.247-1.643l-2.182 2.182a9.5 9.5 0 0 0 6.378 2.392c3.229 0 5.491-1.665 5.491-4.632v-.044c0-2.596-1.709-3.709-4.742-4.502M38.938 16.276c-2.582-.662-3.222-.982-3.222-1.963v-.044c0-.727.662-1.302 1.92-1.302a6.55 6.55 0 0 1 3.425 1.164l2.182-2.182a8.64 8.64 0 0 0-5.556-1.905c-3.055 0-5.236 1.796-5.236 4.509v.043c0 2.968 1.949 3.804 4.96 4.575 2.501.64 3.01 1.062 3.01 1.898v.044c0 .872-.807 1.41-2.181 1.41a6.7 6.7 0 0 1-4.248-1.643l-2.181 2.182a9.5 9.5 0 0 0 6.385 2.392c3.222 0 5.49-1.665 5.49-4.632v-.044c0-2.596-1.708-3.709-4.748-4.502" })
  }
);
const SvgStores$1 = SvgStores;

const SvgStoresAyments = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 160 32",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M126.561 14.699a12.2 12.2 0 0 1 2.968 1.947l-1.198 1.26a10.3 10.3 0 0 0-2.744-2.009zm1.818 4.577 1.317.955a39.5 39.5 0 0 1-2.338 5.011l-1.542-1.021a32 32 0 0 0 2.563-4.945m-1.236-8.844a12 12 0 0 1 2.758 1.785l-1.183 1.265a11 11 0 0 0-2.568-1.833zm13.626 13.32-1.184 1.59a8.34 8.34 0 0 1-4.849-4.381c-.73 1.642-2.157 3.13-4.706 4.4l-1.264-1.398c3.193-1.432 4.395-3.112 4.72-5.16h-3.928v-1.637h4.042v-2.92h-3.231v-1.623h3.231V10.27h1.8v2.339h3.718v4.543h1.522v1.637h-4.992a6.96 6.96 0 0 0 5.126 4.964zm-3.436-6.585v-2.921H135.4v2.92zM143.26 14.699a12.2 12.2 0 0 1 2.974 1.947l-1.203 1.26a10.3 10.3 0 0 0-2.744-2.009zm1.819 4.591 1.312 1.003a39 39 0 0 1-2.333 4.997l-1.542-1.022a31 31 0 0 0 2.563-4.978m-1.231-8.858a11.8 11.8 0 0 1 2.758 1.785l-1.183 1.265a11 11 0 0 0-2.563-1.833zm5.86 11.86a6.3 6.3 0 0 1-1.885 3.098l-1.541-1.002a4.81 4.81 0 0 0 1.933-4.057v-2.482q-.419.094-.845.143l-.926-1.432a14 14 0 0 0 4.104-.954 8.5 8.5 0 0 1-2.138-2.339h-1.642v-1.47h4.272V10.27h1.814v1.527h4.496v1.49h-1.819a8.4 8.4 0 0 1-1.981 2.29c1.287.467 2.631.756 3.995.86l-.997 1.47c-.258-.034-.501-.082-.745-.13v7.565h-1.77v-3.05zm4.329-4.037v-.635h1.007a13.3 13.3 0 0 1-2.983-1.07 12.7 12.7 0 0 1-2.825 1.07h.697v.635zm0 2.625v-1.232h-4.104v1.232zm-2.014-6.033a6.6 6.6 0 0 0 1.604-1.56h-3.389a6.6 6.6 0 0 0 1.785 1.56M16.297.137A26.78 26.78 0 0 0 4.126 9.133c-7.346 8.922-5.232 16.922 9.162 15.258 7.572-.777 4.614-9.961-1.998-5.18-8.719 6.357-5.159 17.024 5.399 11.015 10.68-6.249 13.725-22.67-4.876-19.015-4.52.893-4.178 7.026.727 6.176 3.328-.582 7.542-5.69 7.542-9.38 0-2.108-1.453-3.38-2.87-2.95-1.417.428-1.38 2.412-.247 2.833 1.65.603-.21 4.236-3.916 6.62-1.454.915-2.18-.35-.494-.647 8.036-1.41 10.68 1.126 9.496 5.377a14.4 14.4 0 0 1-7.782 8.973c-6.612 3.045-6.35-2.623-1.86-6.735 2.216-1.919 3.372-.378 1.33 0-4.134.61-14.692 1.743-9.112-7.993 3.32-5.813 8.792-9.49 12.905-10.688 1.642-.53 1.082-3.459-1.235-2.66M49.84 13.31h-4.67v-3.034h12.7v3.033h-4.677v11.92H49.84zM58.96 17.796v-.043a7.949 7.949 0 1 1 15.898-.044v.044a7.956 7.956 0 0 1-15.898.043m12.458 0v-.043a4.547 4.547 0 0 0-4.509-4.662 4.47 4.47 0 0 0-4.487 4.654v.044a4.547 4.547 0 0 0 4.487 4.662 4.473 4.473 0 0 0 4.51-4.655M77.607 10.276h6.756a5.97 5.97 0 0 1 4.364 1.513 4.71 4.71 0 0 1 1.28 3.418v.066a4.65 4.65 0 0 1-3.208 4.64l3.637 5.338h-3.847l-3.208-4.786h-2.509v4.786h-3.287zm6.472 7.273c1.608 0 2.524-.85 2.524-2.11v-.043c0-1.41-.982-2.138-2.582-2.138H80.83v4.291zM92.923 10.276h11.2v2.91h-7.927v3.032h6.967v2.91h-6.967v3.134h8v2.909H92.923zM113.847 16.276c-2.582-.662-3.222-.982-3.222-1.963v-.044c0-.727.662-1.302 1.92-1.302a6.55 6.55 0 0 1 3.426 1.164l2.181-2.182a8.65 8.65 0 0 0-5.556-1.905c-3.054 0-5.236 1.796-5.236 4.509v.043c0 2.968 1.942 3.804 4.96 4.575 2.494.64 3.011 1.062 3.011 1.898v.044c0 .872-.815 1.41-2.182 1.41a6.68 6.68 0 0 1-4.247-1.643l-2.182 2.182a9.5 9.5 0 0 0 6.378 2.392c3.229 0 5.491-1.665 5.491-4.632v-.044c0-2.596-1.709-3.709-4.742-4.502M38.938 16.276c-2.582-.662-3.222-.982-3.222-1.963v-.044c0-.727.662-1.302 1.92-1.302a6.55 6.55 0 0 1 3.425 1.164l2.182-2.182a8.64 8.64 0 0 0-5.556-1.905c-3.055 0-5.236 1.796-5.236 4.509v.043c0 2.968 1.949 3.804 4.96 4.575 2.501.64 3.01 1.062 3.01 1.898v.044c0 .872-.807 1.41-2.181 1.41a6.7 6.7 0 0 1-4.248-1.643l-2.181 2.182a9.5 9.5 0 0 0 6.385 2.392c3.222 0 5.49-1.665 5.49-4.632v-.044c0-2.596-1.708-3.709-4.748-4.502" })
  }
);
const SvgStoresAyments$1 = SvgStoresAyments;

const SvgStoresBrandapps = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 224 32",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#stores-brandapps_svg__a)", children: [
        /* @__PURE__ */ jsx("path", { d: "m137.5 12.58 1.48.79c-1.19 5.23-3.82 9.11-8.8 11.26l-1.31-1.54c4.68-1.83 7-5 7.83-8.75h-9.5v-1.76zM141.07 11.81l-.94.6a8.2 8.2 0 0 0-1.51-2.07l.92-.63c.596.633 1.11 1.339 1.53 2.1M180.75 19.59l-1.23 1.57a39 39 0 0 0-5.9-3.48v7h-1.94v-13.9h1.93v4.76a53 53 0 0 1 7.14 4.05m-3.8-6.71c.63.532 1.206 1.125 1.72 1.77l-.78.68a11 11 0 0 0-1.69-1.78zm1.53-1.3a12.4 12.4 0 0 1 1.77 1.77l-.78.67a9.8 9.8 0 0 0-1.72-1.75zM212.14 12.12a1.72 1.72 0 0 1-2.061 1.676 1.718 1.718 0 0 1-1.247-2.346 1.722 1.722 0 0 1 3.183.007c.085.21.128.436.125.663m-2.58 0a.858.858 0 0 0 1.034.832.86.86 0 0 0-.174-1.702.87.87 0 0 0-.86.87M216.68 11.19v7.65h-2v-7.65zm7.07 0v5.94c0 3.49-1.67 6-5.38 7.53l-1.27-1.59c3.52-1.28 4.69-3.27 4.69-6v-5.89z" }),
        /* @__PURE__ */ jsx("path", { d: "M136.68 11.02c.58.6 1.081 1.272 1.49 2 .24-.13.62-.38.94-.57-.444-.74-.96-1.433-1.54-2.07zM208.82 12.58l1.471.79c-1.18 5.23-3.811 9.11-8.791 11.26l-1.31-1.54c4.67-1.83 7.001-5 7.831-8.75h-9.5v-1.76zM194.83 11.89l1.11 1.31a38.6 38.6 0 0 1-4 5.07l-1.43-1.2a20 20 0 0 0 2.81-3.43h-10.37v-1.75zm-5 3.1c0 5.65-.36 7.18-4.18 9.67l-1.25-1.49c3.4-2.33 3.52-2.64 3.52-8.18zM161.92 14.87l-1.25 1.56a25 25 0 0 0-4.08-2.84l1.17-1.54a35 35 0 0 1 4.16 2.82m5.75.41 1.39 1.16a21.33 21.33 0 0 1-11.18 8l-.94-1.83a19.2 19.2 0 0 0 10.74-7.33zM153.07 15.21l1.25 1.12a12.253 12.253 0 0 1-7.93 8.34l-1-1.72c3.59-1.32 5.86-3.45 6.56-6h-9.5v-1.73zm-.13-3.64v1.72h-9.18v-1.72zM16.297.137A26.78 26.78 0 0 0 4.126 9.133c-7.346 8.922-5.232 16.922 9.162 15.258 7.572-.777 4.614-9.961-1.998-5.18-8.719 6.357-5.159 17.024 5.399 11.015 10.68-6.249 13.725-22.67-4.876-19.015-4.52.893-4.178 7.026.727 6.176 3.328-.582 7.542-5.69 7.542-9.38 0-2.108-1.453-3.38-2.87-2.95-1.417.428-1.38 2.412-.247 2.833 1.65.603-.21 4.236-3.916 6.62-1.454.915-2.18-.35-.494-.647 8.036-1.41 10.68 1.126 9.496 5.377a14.4 14.4 0 0 1-7.782 8.973c-6.612 3.045-6.35-2.623-1.86-6.735 2.216-1.919 3.372-.378 1.33 0-4.134.61-14.692 1.743-9.112-7.993 3.32-5.813 8.792-9.49 12.905-10.688 1.642-.53 1.082-3.459-1.235-2.66M49.84 13.31h-4.67v-3.034h12.7v3.033h-4.677v11.92H49.84zM58.96 17.796v-.043a7.949 7.949 0 1 1 15.898-.044v.044a7.956 7.956 0 0 1-15.898.043m12.458 0v-.043a4.547 4.547 0 0 0-4.509-4.662 4.47 4.47 0 0 0-4.487 4.654v.044a4.547 4.547 0 0 0 4.487 4.662 4.473 4.473 0 0 0 4.51-4.655M77.607 10.276h6.756a5.97 5.97 0 0 1 4.364 1.513 4.71 4.71 0 0 1 1.28 3.418v.066a4.65 4.65 0 0 1-3.208 4.64l3.637 5.338h-3.847l-3.208-4.786h-2.509v4.786h-3.287zm6.472 7.273c1.608 0 2.524-.85 2.524-2.11v-.043c0-1.41-.982-2.138-2.582-2.138H80.83v4.291zM92.923 10.276h11.2v2.91h-7.927v3.032h6.967v2.91h-6.967v3.134h8v2.909H92.923zM113.847 16.276c-2.582-.662-3.222-.982-3.222-1.963v-.044c0-.727.662-1.302 1.92-1.302a6.55 6.55 0 0 1 3.426 1.164l2.181-2.182a8.65 8.65 0 0 0-5.556-1.905c-3.054 0-5.236 1.796-5.236 4.509v.043c0 2.968 1.942 3.804 4.96 4.575 2.494.64 3.011 1.062 3.011 1.898v.044c0 .872-.815 1.41-2.182 1.41a6.68 6.68 0 0 1-4.247-1.643l-2.182 2.182a9.5 9.5 0 0 0 6.378 2.392c3.229 0 5.491-1.665 5.491-4.632v-.044c0-2.596-1.709-3.709-4.742-4.502M38.938 16.276c-2.582-.662-3.222-.982-3.222-1.963v-.044c0-.727.662-1.302 1.92-1.302a6.55 6.55 0 0 1 3.425 1.164l2.182-2.182a8.64 8.64 0 0 0-5.556-1.905c-3.055 0-5.236 1.796-5.236 4.509v.043c0 2.968 1.949 3.804 4.96 4.575 2.501.64 3.01 1.062 3.01 1.898v.044c0 .872-.807 1.41-2.181 1.41a6.7 6.7 0 0 1-4.248-1.643l-2.181 2.182a9.5 9.5 0 0 0 6.385 2.392c3.222 0 5.49-1.665 5.49-4.632v-.044c0-2.596-1.708-3.709-4.748-4.502" })
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "stores-brandapps_svg__a", children: /* @__PURE__ */ jsx("path", { d: "M0 0h224v32H0z" }) }) })
    ]
  }
);
const SvgStoresBrandapps$1 = SvgStoresBrandapps;

const SvgStoresInvoice = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 208 32",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M132.348 12.824v1.409h-6.104v-1.409zm-3.991 6.625h3.451v4.883h-3.451v.638h-1.535V19.45h1.535m3.286-4.343v1.291h-4.662v-1.29zm0 2.17v1.295h-4.662v-1.296zm-.126-6.625v1.31h-4.357v-1.31zm-1.259 12.244v-2.01h-1.878v2.01zm5.634-7.512v-.789h-2.666v-1.178h2.666v-.737h-3.112v-1.23h3.112v-1.291h1.728v1.29h3.127v1.23h-3.127v.738h2.714v1.178h-2.714v.784h3.46v1.212h-8.746v-1.212zm-1.089 7.08v2.507h-1.69v-7.728h7.277v6.353c0 .784-.207 1.197-.878 1.328q-.906.1-1.817.047l-.258-1.408q.488.03.976 0c.174 0 .24-.094.24-.254v-.845zm3.85-3.08v-.774h-3.85v.798zm0 1.916v-.812h-3.85v.83zM148.418 19.078l.432 1.371c-1.544 1.056-3.878 2.526-5.202 3.338l-.91-1.516c1.394-.733 4.009-2.17 5.68-3.193m9.019 3.099-1.178 1.497a11.86 11.86 0 0 1-5.301-4.183v3.53c0 1.132-.319 1.757-1.408 1.93q-1.107.095-2.216.033l-.324-1.737a14 14 0 0 0 1.69.033c.366-.033.47-.211.47-.559v-8.22h-6.254v-1.526h6.272v-2.817h1.789v2.817h6.287v1.549h-6.287v2.01c1.165 2.835 3.606 4.732 6.479 5.629zm-11.836-7.216a12.8 12.8 0 0 1 2.137 3.018l-1.578.799a11 11 0 0 0-1.948-3.052c1.324-.733 1.338-.747 1.389-.766m7.757-4.803a12.5 12.5 0 0 1 2.455 1.788l-1.324.972a10.7 10.7 0 0 0-2.249-1.821zm2.629 5.52a30 30 0 0 1-2.376 3.18l-1.357-.719a23 23 0 0 0 2.108-3.192zM165.583 18.139v-.704h-5.235v-1.052h5.235v-.685h-4.995v-1.09h4.995v-.746h-6.465v-1.07h6.465v-.733h-4.901v-1.09h4.901v-.811h1.789v.812h4.822v1.821h1.737v1.07h-1.737v1.837h-4.822v.685h5.409v1.052h-5.409v.704h6.573v1.131h-14.827V18.14zm-2.887 6.493v.338h-1.709v-5.014h11.061v5.014h-1.77v-.338zm7.582-2.789v-.75h-7.582v.75zm0 1.69v-.765h-7.582v.765zm.141-10.742v-.732h-3.047v.732zm-3.047 1.07v.747h3.047v-.746zM176.485 14.515a12 12 0 0 1 2.92 1.915l-1.178 1.24a10.1 10.1 0 0 0-2.7-1.977zm1.789 4.502 1.295.939a39 39 0 0 1-2.3 4.93l-1.517-1.005a31.5 31.5 0 0 0 2.522-4.864m-1.216-8.7a11.7 11.7 0 0 1 2.713 1.756l-1.164 1.244a10.8 10.8 0 0 0-2.526-1.803zm13.404 13.104-1.165 1.563a8.2 8.2 0 0 1-4.77-4.31c-.718 1.615-2.122 3.08-4.629 4.33l-1.244-1.377c3.141-1.408 4.324-3.06 4.643-5.075h-3.864v-1.61h3.977v-2.873h-3.179v-1.597h3.179v-2.314h1.77v2.3h3.657v4.47h1.498v1.61h-4.911a6.86 6.86 0 0 0 5.042 4.883zm-3.381-6.48V14.07h-1.901v2.873zM192.913 14.515a12 12 0 0 1 2.925 1.915l-1.184 1.24a10.2 10.2 0 0 0-2.699-1.977zm1.788 4.516 1.291.986a39 39 0 0 1-2.295 4.916l-1.517-1.005a30.4 30.4 0 0 0 2.521-4.897m-1.211-8.714a11.7 11.7 0 0 1 2.714 1.756l-1.165 1.244a10.7 10.7 0 0 0-2.521-1.803zm5.765 11.667a6.2 6.2 0 0 1-1.854 3.047l-1.516-.986a4.735 4.735 0 0 0 1.901-3.99v-2.442a8 8 0 0 1-.831.141l-.911-1.408a13.8 13.8 0 0 0 4.038-.94 8.4 8.4 0 0 1-2.104-2.3h-1.615V11.66h4.202v-1.502h1.784v1.502h4.423v1.465h-1.789a8.2 8.2 0 0 1-1.948 2.253c1.265.46 2.587.744 3.93.846l-.982 1.445a11 11 0 0 1-.732-.126v7.441h-1.742v-3zm4.259-3.972v-.624h.99a13 13 0 0 1-2.934-1.052c-.881.46-1.814.813-2.779 1.052h.685v.624zm0 2.582v-1.21h-4.038v1.2109999999999999zm-1.981-5.934a6.5 6.5 0 0 0 1.577-1.535h-3.333a6.5 6.5 0 0 0 1.756 1.535M16.297.137A26.78 26.78 0 0 0 4.126 9.133c-7.346 8.922-5.232 16.922 9.162 15.258 7.572-.777 4.614-9.961-1.998-5.18-8.719 6.357-5.159 17.024 5.399 11.015 10.68-6.249 13.725-22.67-4.876-19.015-4.52.893-4.178 7.026.727 6.176 3.328-.582 7.542-5.69 7.542-9.38 0-2.108-1.453-3.38-2.87-2.95-1.417.428-1.38 2.412-.247 2.833 1.65.603-.21 4.236-3.916 6.62-1.454.915-2.18-.35-.494-.647 8.036-1.41 10.68 1.126 9.496 5.377a14.4 14.4 0 0 1-7.782 8.973c-6.612 3.045-6.35-2.623-1.86-6.735 2.216-1.919 3.372-.378 1.33 0-4.134.61-14.692 1.743-9.112-7.993 3.32-5.813 8.792-9.49 12.905-10.688 1.642-.53 1.082-3.459-1.235-2.66M49.84 13.31h-4.67v-3.034h12.7v3.033h-4.677v11.92H49.84zM58.96 17.796v-.043a7.949 7.949 0 1 1 15.898-.044v.044a7.956 7.956 0 0 1-15.898.043m12.458 0v-.043a4.547 4.547 0 0 0-4.509-4.662 4.47 4.47 0 0 0-4.487 4.654v.044a4.547 4.547 0 0 0 4.487 4.662 4.473 4.473 0 0 0 4.51-4.655M77.607 10.276h6.756a5.97 5.97 0 0 1 4.364 1.513 4.71 4.71 0 0 1 1.28 3.418v.066a4.65 4.65 0 0 1-3.208 4.64l3.637 5.338h-3.847l-3.208-4.786h-2.509v4.786h-3.287zm6.472 7.273c1.608 0 2.524-.85 2.524-2.11v-.043c0-1.41-.982-2.138-2.582-2.138H80.83v4.291zM92.923 10.276h11.2v2.91h-7.927v3.032h6.967v2.91h-6.967v3.134h8v2.909H92.923zM113.847 16.276c-2.582-.662-3.222-.982-3.222-1.963v-.044c0-.727.662-1.302 1.92-1.302a6.55 6.55 0 0 1 3.426 1.164l2.181-2.182a8.65 8.65 0 0 0-5.556-1.905c-3.054 0-5.236 1.796-5.236 4.509v.043c0 2.968 1.942 3.804 4.96 4.575 2.494.64 3.011 1.062 3.011 1.898v.044c0 .872-.815 1.41-2.182 1.41a6.68 6.68 0 0 1-4.247-1.643l-2.182 2.182a9.5 9.5 0 0 0 6.378 2.392c3.229 0 5.491-1.665 5.491-4.632v-.044c0-2.596-1.709-3.709-4.742-4.502M38.938 16.276c-2.582-.662-3.222-.982-3.222-1.963v-.044c0-.727.662-1.302 1.92-1.302a6.55 6.55 0 0 1 3.425 1.164l2.182-2.182a8.64 8.64 0 0 0-5.556-1.905c-3.055 0-5.236 1.796-5.236 4.509v.043c0 2.968 1.949 3.804 4.96 4.575 2.501.64 3.01 1.062 3.01 1.898v.044c0 .872-.807 1.41-2.181 1.41a6.7 6.7 0 0 1-4.248-1.643l-2.181 2.182a9.5 9.5 0 0 0 6.385 2.392c3.222 0 5.49-1.665 5.49-4.632v-.044c0-2.596-1.708-3.709-4.748-4.502" })
  }
);
const SvgStoresInvoice$1 = SvgStoresInvoice;

const SvgStoresNetshop = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 224 32",
    ...props,
    children: [
      /* @__PURE__ */ jsx("g", { clipPath: "url(#stores-netshop_svg__a)", children: /* @__PURE__ */ jsx("path", { d: "M221.83 10c-1 0-1.79.79-1.79 1.79 0 .17.03.34.08.5h-10.7v1.84h9.9c-.87 3.96-3.29 7.21-8.17 9.12l1.37 1.6c5.05-2.17 7.76-6.06 9.05-11.29.08.01.17.03.26.03 1 0 1.79-.81 1.79-1.77v-.02c0-1-.79-1.79-1.79-1.79zm0 2.68c-.48 0-.89-.41-.89-.88 0-.5.41-.91.89-.91s.89.41.89.89-.41.89-.89.89zM140.13 20.89l-1.18 1.47c-1.49-1.04-3.06-1.93-4.66-2.91v5.31h-2v-4.91c-1.57 1.05-3.43 2.05-5.04 2.65l-.71-1.84c3.9-1.44 7.46-4.13 9.35-6.32h-8.48v-1.82h4.88v-2.14h2v2.14h3.67l.91 1.13c-1.1 1.5-2.05 2.73-3.64 4.06 1.61.9 3.21 2 4.9 3.17zM197.11 15.45c.56 1.27.95 2.11 1.55 3.44l-1.57.66c-.46-1.08-.96-2.15-1.52-3.42l1.53-.68zm9.71.3c-.75 4.28-3.42 7.76-7.29 9.25l-1.1-1.59c3.8-1.27 5.94-4.16 6.59-8.08zm-6.36-.77c.54 1.34.88 2.17 1.43 3.49l-1.57.65c-.49-1.26-.82-2.07-1.4-3.53l1.53-.61zM143.32 15.45c.56 1.27.95 2.11 1.55 3.44l-1.57.66c-.46-1.08-.96-2.15-1.52-3.42l1.53-.68zm9.71.3c-.75 4.28-3.42 7.76-7.29 9.25l-1.1-1.59c3.8-1.27 5.94-4.16 6.59-8.08zm-6.36-.77c.54 1.34.88 2.17 1.43 3.49l-1.57.65c-.49-1.26-.82-2.07-1.4-3.53l1.53-.61zM165.02 19l-.94 1.7c-2.13-1.17-4.22-2.06-6.09-2.93v6.99h-2.02V10.38h2.02v5.14c2.35 1.15 4.05 1.93 7.03 3.48M172.46 16.14l-.64 1.74c-1.28-.48-3.13-.96-4.57-1.22l.65-1.76c1.48.27 3.44.83 4.56 1.24m7.22-2.21 1.55 1.34c-2.14 3.83-6.71 7.95-11.58 9.51l-.84-1.87c4.72-1.67 8.54-4.92 10.87-8.98m-6.06-1.68-.68 1.71c-1.25-.51-3.02-1.04-4.44-1.35l.66-1.71c1.54.33 3.34.91 4.46 1.34zM184.75 20.87v-1.6h6.08v-2.22h-6.81v-1.64h8.62v9.54h-8.63v-1.64h6.83v-2.44h-6.09M16.297.137A26.78 26.78 0 0 0 4.126 9.133c-7.346 8.922-5.232 16.922 9.162 15.258 7.572-.777 4.614-9.961-1.998-5.18-8.719 6.357-5.159 17.024 5.399 11.015 10.68-6.249 13.725-22.67-4.876-19.015-4.52.893-4.178 7.026.727 6.176 3.328-.582 7.542-5.69 7.542-9.38 0-2.108-1.453-3.38-2.87-2.95-1.417.428-1.38 2.412-.247 2.833 1.65.603-.21 4.236-3.916 6.62-1.454.915-2.18-.35-.494-.647 8.036-1.41 10.68 1.126 9.496 5.377a14.4 14.4 0 0 1-7.782 8.973c-6.612 3.045-6.35-2.623-1.86-6.735 2.216-1.919 3.372-.378 1.33 0-4.134.61-14.692 1.743-9.112-7.993 3.32-5.813 8.792-9.49 12.905-10.688 1.642-.53 1.082-3.459-1.235-2.66M49.84 13.31h-4.67v-3.034h12.7v3.033h-4.677v11.92H49.84zM58.96 17.796v-.043a7.949 7.949 0 1 1 15.898-.044v.044a7.956 7.956 0 0 1-15.898.043m12.458 0v-.043a4.547 4.547 0 0 0-4.509-4.662 4.47 4.47 0 0 0-4.487 4.654v.044a4.547 4.547 0 0 0 4.487 4.662 4.473 4.473 0 0 0 4.51-4.655M77.607 10.276h6.756a5.97 5.97 0 0 1 4.364 1.513 4.71 4.71 0 0 1 1.28 3.418v.066a4.65 4.65 0 0 1-3.208 4.64l3.637 5.338h-3.847l-3.208-4.786h-2.509v4.786h-3.287zm6.472 7.273c1.608 0 2.524-.85 2.524-2.11v-.043c0-1.41-.982-2.138-2.582-2.138H80.83v4.291zM92.923 10.276h11.2v2.91h-7.927v3.032h6.967v2.91h-6.967v3.134h8v2.909H92.923zM113.847 16.276c-2.582-.662-3.222-.982-3.222-1.963v-.044c0-.727.662-1.302 1.92-1.302a6.55 6.55 0 0 1 3.426 1.164l2.181-2.182a8.65 8.65 0 0 0-5.556-1.905c-3.054 0-5.236 1.796-5.236 4.509v.043c0 2.968 1.942 3.804 4.96 4.575 2.494.64 3.011 1.062 3.011 1.898v.044c0 .872-.815 1.41-2.182 1.41a6.68 6.68 0 0 1-4.247-1.643l-2.182 2.182a9.5 9.5 0 0 0 6.378 2.392c3.229 0 5.491-1.665 5.491-4.632v-.044c0-2.596-1.709-3.709-4.742-4.502M38.938 16.276c-2.582-.662-3.222-.982-3.222-1.963v-.044c0-.727.662-1.302 1.92-1.302a6.55 6.55 0 0 1 3.425 1.164l2.182-2.182a8.64 8.64 0 0 0-5.556-1.905c-3.055 0-5.236 1.796-5.236 4.509v.043c0 2.968 1.949 3.804 4.96 4.575 2.501.64 3.01 1.062 3.01 1.898v.044c0 .872-.807 1.41-2.181 1.41a6.7 6.7 0 0 1-4.248-1.643l-2.181 2.182a9.5 9.5 0 0 0 6.385 2.392c3.222 0 5.49-1.665 5.49-4.632v-.044c0-2.596-1.708-3.709-4.748-4.502" }) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "stores-netshop_svg__a", children: /* @__PURE__ */ jsx("path", { d: "M0 0h224v32H0z" }) }) })
    ]
  }
);
const SvgStoresNetshop$1 = SvgStoresNetshop;

const SvgStoresRegi = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 160 32",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M127.175 10.639v13.574l1.603.74c3.979-1.373 7.764-3.873 10.053-6.779l-1.423-1.51c-2.126 2.686-5.239 4.619-8.085 5.595V10.64zM154.018 10.163a12.5 12.5 0 0 1 2.025 2.06l.933-.845c-.669-.827-1.215-1.408-2.043-2.042zm-1.919 1.55a10 10 0 0 1 2.007 2.042l.951-.845a11.4 11.4 0 0 0-2.06-2.06zm-7.189-1.206-.812 1.823c1.426.546 3.088 1.337 4.303 2.077l.986-1.673c-1.091-.634-2.928-1.628-4.477-2.227m-1.982 3.98-.802 1.84c1.461.51 3.212 1.266 4.462 1.97l.95-1.707c-1.091-.616-3.113-1.575-4.61-2.104m.286 8.48.803 2.057c5.21-1.698 9.5-4.63 12.503-9.503l-1.727-1.08c-2.377 3.927-6.914 7.347-11.579 8.526M16.297.137A26.78 26.78 0 0 0 4.126 9.133c-7.346 8.922-5.232 16.922 9.162 15.258 7.572-.777 4.614-9.961-1.998-5.18-8.719 6.357-5.159 17.024 5.399 11.015 10.68-6.249 13.725-22.67-4.876-19.015-4.52.893-4.178 7.026.727 6.176 3.328-.582 7.542-5.69 7.542-9.38 0-2.108-1.453-3.38-2.87-2.95-1.417.428-1.38 2.412-.247 2.833 1.65.603-.21 4.236-3.916 6.62-1.454.915-2.18-.35-.494-.647 8.036-1.41 10.68 1.126 9.496 5.377a14.4 14.4 0 0 1-7.782 8.973c-6.612 3.045-6.35-2.623-1.86-6.735 2.216-1.919 3.372-.378 1.33 0-4.134.61-14.692 1.743-9.112-7.993 3.32-5.813 8.792-9.49 12.905-10.688 1.642-.53 1.082-3.459-1.235-2.66M49.84 13.31h-4.67v-3.034h12.7v3.033h-4.677v11.92H49.84zM58.96 17.796v-.043a7.949 7.949 0 1 1 15.898-.044v.044a7.956 7.956 0 0 1-15.898.043m12.458 0v-.043a4.547 4.547 0 0 0-4.509-4.662 4.47 4.47 0 0 0-4.487 4.654v.044a4.547 4.547 0 0 0 4.487 4.662 4.473 4.473 0 0 0 4.51-4.655M77.607 10.276h6.756a5.97 5.97 0 0 1 4.364 1.513 4.71 4.71 0 0 1 1.28 3.418v.066a4.65 4.65 0 0 1-3.208 4.64l3.637 5.338h-3.847l-3.208-4.786h-2.509v4.786h-3.287zm6.472 7.273c1.608 0 2.524-.85 2.524-2.11v-.043c0-1.41-.982-2.138-2.582-2.138H80.83v4.291zM92.923 10.276h11.2v2.91h-7.927v3.032h6.967v2.91h-6.967v3.134h8v2.909H92.923zM113.847 16.276c-2.582-.662-3.222-.982-3.222-1.963v-.044c0-.727.662-1.302 1.92-1.302a6.55 6.55 0 0 1 3.426 1.164l2.181-2.182a8.65 8.65 0 0 0-5.556-1.905c-3.054 0-5.236 1.796-5.236 4.509v.043c0 2.968 1.942 3.804 4.96 4.575 2.494.64 3.011 1.062 3.011 1.898v.044c0 .872-.815 1.41-2.182 1.41a6.68 6.68 0 0 1-4.247-1.643l-2.182 2.182a9.5 9.5 0 0 0 6.378 2.392c3.229 0 5.491-1.665 5.491-4.632v-.044c0-2.596-1.709-3.709-4.742-4.502M38.938 16.276c-2.582-.662-3.222-.982-3.222-1.963v-.044c0-.727.662-1.302 1.92-1.302a6.55 6.55 0 0 1 3.425 1.164l2.182-2.182a8.64 8.64 0 0 0-5.556-1.905c-3.055 0-5.236 1.796-5.236 4.509v.043c0 2.968 1.949 3.804 4.96 4.575 2.501.64 3.01 1.062 3.01 1.898v.044c0 .872-.807 1.41-2.181 1.41a6.7 6.7 0 0 1-4.248-1.643l-2.181 2.182a9.5 9.5 0 0 0 6.385 2.392c3.222 0 5.49-1.665 5.49-4.632v-.044c0-2.596-1.708-3.709-4.748-4.502" })
  }
);
const SvgStoresRegi$1 = SvgStoresRegi;

const SvgStoresReserve = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 160 32",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M134.472 23.228c0 1.075-.314 1.676-1.32 1.823-.916.08-1.837.09-2.754.032l-.403-1.773q1.082.09 2.166.047c.343-.031.441-.195.441-.506v-5.847H126v-1.572h6.68a20 20 0 0 0-2.685-1.965l1.22-1.075c.849.506 1.597.994 2.282 1.5a27 27 0 0 0 2.232-1.858h-7.368v-1.572h9.638l1.154.783a35 35 0 0 1-4.486 3.637c.21.18.559.569.559.569h4.555l1.107.27a28.6 28.6 0 0 1-3.144 4.505l-1.923-.537a21.5 21.5 0 0 0 2.15-2.657h-3.499zM147.285 25.099h-1.744V18.72a108 108 0 0 1-2.786.277l-.314-1.628 1.125-.048c.472-.572.928-1.156 1.384-1.76a16.5 16.5 0 0 0-2.346-2.267l.944-1.172c.16.132.314.26.471.393A19 19 0 0 0 145.591 10l1.572.685a31 31 0 0 1-2.003 2.867c.261.261.503.522.717.767a34 34 0 0 0 1.858-2.85l1.594.732a58 58 0 0 1-3.773 5.03l2.345-.145a11 11 0 0 0-.861-1.258l1.352-.7c.163.21.314.42.471.65a13.9 13.9 0 0 0 2.33-5.769l1.76.315a19 19 0 0 1-.585 2.345h5.112c-.129 7.151-.469 11.128-1.107 12.002-.286.358-.691.428-1.295.428h-1.965l-.292-1.745c.522.035 1.352.06 1.742.04.242 0 .345-.03.462-.226.295-.506.562-3.25.628-8.855h-3.923a14.7 14.7 0 0 1-1.301 2.298l-1.5-.767a12 12 0 0 1 1.336 2.559c-.521.26-.962.487-1.402.716a8 8 0 0 0-.276-.7c-.39.047-.83.097-1.302.128zm-2.235-5.307a14.6 14.6 0 0 1-1.308 4.257c-.031-.02-.062-.035-1.471-.63a12.1 12.1 0 0 0 1.258-3.966zm4.231-.452c.5 1.068.884 2.186 1.148 3.335-.588.204-1.063.377-1.553.54a14.5 14.5 0 0 0-1.113-3.316zm2.691-2.867a13 13 0 0 1 2.83 3.53l-1.506 1.021a12.2 12.2 0 0 0-2.594-3.574zM16.297.137A26.78 26.78 0 0 0 4.126 9.133c-7.346 8.922-5.232 16.922 9.162 15.258 7.572-.777 4.614-9.961-1.998-5.18-8.719 6.357-5.159 17.024 5.399 11.015 10.68-6.249 13.725-22.67-4.876-19.015-4.52.893-4.178 7.026.727 6.176 3.328-.582 7.542-5.69 7.542-9.38 0-2.108-1.453-3.38-2.87-2.95-1.417.428-1.38 2.412-.247 2.833 1.65.603-.21 4.236-3.916 6.62-1.454.915-2.18-.35-.494-.647 8.036-1.41 10.68 1.126 9.496 5.377a14.4 14.4 0 0 1-7.782 8.973c-6.612 3.045-6.35-2.623-1.86-6.735 2.216-1.919 3.372-.378 1.33 0-4.134.61-14.692 1.743-9.112-7.993 3.32-5.813 8.792-9.49 12.905-10.688 1.642-.53 1.082-3.459-1.235-2.66M49.84 13.31h-4.67v-3.034h12.7v3.033h-4.677v11.92H49.84zM58.96 17.796v-.043a7.949 7.949 0 1 1 15.898-.044v.044a7.956 7.956 0 0 1-15.898.043m12.458 0v-.043a4.547 4.547 0 0 0-4.509-4.662 4.47 4.47 0 0 0-4.487 4.654v.044a4.547 4.547 0 0 0 4.487 4.662 4.473 4.473 0 0 0 4.51-4.655M77.607 10.276h6.756a5.97 5.97 0 0 1 4.364 1.513 4.71 4.71 0 0 1 1.28 3.418v.066a4.65 4.65 0 0 1-3.208 4.64l3.637 5.338h-3.847l-3.208-4.786h-2.509v4.786h-3.287zm6.472 7.273c1.608 0 2.524-.85 2.524-2.11v-.043c0-1.41-.982-2.138-2.582-2.138H80.83v4.291zM92.923 10.276h11.2v2.91h-7.927v3.032h6.967v2.91h-6.967v3.134h8v2.909H92.923zM113.847 16.276c-2.582-.662-3.222-.982-3.222-1.963v-.044c0-.727.662-1.302 1.92-1.302a6.55 6.55 0 0 1 3.426 1.164l2.181-2.182a8.65 8.65 0 0 0-5.556-1.905c-3.054 0-5.236 1.796-5.236 4.509v.043c0 2.968 1.942 3.804 4.96 4.575 2.494.64 3.011 1.062 3.011 1.898v.044c0 .872-.815 1.41-2.182 1.41a6.68 6.68 0 0 1-4.247-1.643l-2.182 2.182a9.5 9.5 0 0 0 6.378 2.392c3.229 0 5.491-1.665 5.491-4.632v-.044c0-2.596-1.709-3.709-4.742-4.502M38.938 16.276c-2.582-.662-3.222-.982-3.222-1.963v-.044c0-.727.662-1.302 1.92-1.302a6.55 6.55 0 0 1 3.425 1.164l2.182-2.182a8.64 8.64 0 0 0-5.556-1.905c-3.055 0-5.236 1.796-5.236 4.509v.043c0 2.968 1.949 3.804 4.96 4.575 2.501.64 3.01 1.062 3.01 1.898v.044c0 .872-.807 1.41-2.181 1.41a6.7 6.7 0 0 1-4.248-1.643l-2.181 2.182a9.5 9.5 0 0 0 6.385 2.392c3.222 0 5.49-1.665 5.49-4.632v-.044c0-2.596-1.708-3.709-4.748-4.502" })
  }
);
const SvgStoresReserve$1 = SvgStoresReserve;

const SvgSupport = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M41.9 23.7v-3.3c0-9.9-8-17.9-17.9-17.9s-17.9 8-17.9 17.9v3.3c-2.4 2.3-3.5 5.7-2.6 9.1s3.6 6 7.1 6.7c.5 0 1 .2 1.5.2h.2c1.4 0 2.7-.6 3.6-1.7 1-1.2 1.3-2.7 1-4.1l-2-8.4c-.4-1.5-1.4-2.7-2.8-3.3-.8-.3-1.7-.5-2.5-.3v-1.4c0-8 6.5-14.5 14.5-14.5s14.5 6.5 14.5 14.5v1.4c-.8-.1-1.7 0-2.5.3-1.4.6-2.4 1.8-2.8 3.3l-2 8.3c-.4 1.5 0 3 1 4.1.2.3.5.5.8.7-2.4 3.5-4.5 3.5-8.2 3.4h-1.8c-.9 0-1.7.8-1.7 1.7s.8 1.7 1.7 1.7h3.4c3.6 0 6.9-.6 10-5.9.4 0 .7 0 1.1-.1 3.4-.7 6.2-3.3 7.1-6.6.9-3.4-.2-6.9-2.6-9.1zm-31.2 1.6c.4.2.7.5.8.9l2 8.4c.1.4 0 .9-.3 1.2-.2.2-.5.5-1 .5-.3 0-.6 0-1-.1-2.1-.4-3.9-2.1-4.4-4.2-.8-3 .8-5.5 2.7-6.6.5-.3.9-.2 1.2 0zM41.2 32c-.5 2.1-2.3 3.7-4.4 4.2-.3 0-.6 0-.9.1-.5 0-.9-.3-1-.5-.3-.3-.4-.8-.3-1.2l2-8.3c.1-.4.4-.8.8-.9.1 0 .3-.1.5-.1s.4 0 .6.2c1.9 1.1 3.5 3.6 2.7 6.6z" })
  }
);
const SvgSupport$1 = SvgSupport;

const SvgSync = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M34.505 33.53c-.616-.356-1.388-.235-1.922.235A12.95 12.95 0 0 1 24 37c-7.18 0-13-5.82-13-13q0-.429.027-.853l1.912 1.913a1.5 1.5 0 0 0 2.122-2.122l-4-4a1.5 1.5 0 0 0-2.122 0l-4 4a1.5 1.5 0 0 0 2.122 2.122l.94-.94c.064 8.782 7.202 15.88 15.999 15.88 4.172 0 7.972-1.597 10.82-4.214.71-.65.519-1.776-.315-2.258M35.06 22.94l1.912 1.911q.028-.42.028-.85c0-7.18-5.82-13-13-13a12.95 12.95 0 0 0-8.582 3.235c-.534.47-1.306.59-1.922.236-.834-.482-1.024-1.607-.315-2.259A15.94 15.94 0 0 1 24 8.001c8.796 0 15.934 7.098 16 15.878l.94-.94a1.5 1.5 0 0 1 2.12 2.122l-4 4a1.5 1.5 0 0 1-2.12 0l-4-4a1.5 1.5 0 0 1 2.12-2.122" })
  }
);
const SvgSync$1 = SvgSync;

const SvgSyncSolid = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m9.993-19.628-1.432-1.433a1.5 1.5 0 0 0-2.122 2.122l4 4a1.5 1.5 0 0 0 2.122 0l4-4a1.5 1.5 0 0 0-2.122-2.122l-1.444 1.445Q37 24.193 37 24c0-7.18-5.82-13-13-13a12.94 12.94 0 0 0-8.001 2.753c-.791.619-.619 1.806.25 2.308.59.34 1.323.248 1.873-.152A9.96 9.96 0 0 1 24 14c5.523 0 10 4.477 10 10q0 .187-.007.372m-4.115 7.719c.55-.4 1.284-.492 1.872-.152.87.502 1.042 1.69.251 2.308A12.94 12.94 0 0 1 24 37c-7.18 0-13-5.82-13-13q0-.193.006-.384L9.56 25.06a1.5 1.5 0 1 1-2.122-2.122l4-4a1.5 1.5 0 0 1 2.122 0l4 4a1.5 1.5 0 0 1-2.122 2.122l-1.432-1.433Q14 23.812 14 24c0 5.523 4.477 10 10 10a9.96 9.96 0 0 0 5.878-1.91",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgSyncSolid$1 = SvgSyncSolid;

const SvgTable = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M19.5 9v12H39v-9a3 3 0 0 0-3-3zm-3 0v12H9v-9a3 3 0 0 1 3-3zm0-3H12a6 6 0 0 0-6 6v24a6 6 0 0 0 6 6h24a6 6 0 0 0 6-6V12a6 6 0 0 0-6-6H16.5M39 24H19.5v15H36a3 3 0 0 0 3-3zM16.5 39V24H9v12a3 3 0 0 0 3 3z",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgTable$1 = SvgTable;

const SvgTag = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M11.828 6.7A5.13 5.13 0 0 0 6.7 11.829v11.279a5.3 5.3 0 0 0 1.546 3.74l10.721 10.759L37.634 18.94 26.849 8.238A5.3 5.3 0 0 0 23.117 6.7zm28.22 14.635-18.68 18.68 1.558 1.564a5.3 5.3 0 0 0 7.502.007l11.193-11.193a5.3 5.3 0 0 0-.014-7.51zM5.797 5.798a8.53 8.53 0 0 1 6.03-2.498h11.288a8.7 8.7 0 0 1 6.128 2.525L44.002 20.47a8.7 8.7 0 0 1 .023 12.327L32.832 43.99a8.7 8.7 0 0 1-12.314-.01L5.838 29.249A8.7 8.7 0 0 1 3.3 23.108v-11.28c0-2.261.899-4.43 2.498-6.03m11.05 9.114c-1.094-.005-1.914.815-1.92 1.88-.006.974.838 1.835 1.847 1.837 1.03.003 1.868-.845 1.872-1.825m-1.785-5.292c-2.953-.013-5.316 2.302-5.335 5.258v.002c-.016 2.878 2.37 5.251 5.24 5.258 2.874.006 5.267-2.325 5.28-5.21.013-2.869-2.29-5.298-5.185-5.308m1.785 5.292c.005-1.062-.853-1.89-1.798-1.892h-.001",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgTag$1 = SvgTag;

const SvgTerminal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M7.3 12A8.7 8.7 0 0 1 16 3.3h16a8.7 8.7 0 0 1 8.7 8.7v24a8.7 8.7 0 0 1-8.7 8.7H16A8.7 8.7 0 0 1 7.3 36zM16 6.7a5.3 5.3 0 0 0-5.3 5.3v24a5.3 5.3 0 0 0 5.3 5.3h16a5.3 5.3 0 0 0 5.3-5.3V12A5.3 5.3 0 0 0 32 6.7z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M17 16a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H19a2 2 0 0 1-2-2z" })
    ]
  }
);
const SvgTerminal$1 = SvgTerminal;

const SvgTerminalOffline = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M16 4a8 8 0 0 0-8 8v24a8 8 0 0 0 8 8h11.056c-.797-.89-1.463-1.9-1.968-3H16a5 5 0 0 1-5-5V12a5 5 0 0 1 5-5h16a5 5 0 0 1 5 5v12.04a12 12 0 0 1 3 .643V12a8 8 0 0 0-8-8zm2 12a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M41.657 41.657a8 8 0 1 1-11.314-11.315 8 8 0 0 1 11.314 11.315" })
    ]
  }
);
const SvgTerminalOffline$1 = SvgTerminalOffline;

const SvgText = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M6.266 35.219c.703 0 1.109-.328 1.375-1.078l1.984-5.594h8.922l2 5.594c.265.75.672 1.078 1.375 1.078.812 0 1.406-.516 1.406-1.235 0-.203-.047-.437-.172-.78l-7.265-19.626c-.344-.922-.907-1.344-1.766-1.344-.922 0-1.5.438-1.844 1.36l-7.25 19.61c-.125.343-.172.577-.172.78 0 .72.594 1.235 1.407 1.235m4.172-9.063 3.609-10.281h.094l3.609 10.281zM33.5 35.281c2.188 0 4.266-1.218 5.234-3.078h.063v1.703c0 .813.531 1.375 1.297 1.375.75 0 1.281-.562 1.281-1.375v-10.14c0-3.235-2.406-5.297-6.219-5.297-2.64 0-5.015 1.172-5.937 2.953-.219.39-.328.781-.328 1.125 0 .734.5 1.219 1.203 1.219.515 0 .875-.203 1.125-.657.906-1.609 2.11-2.25 3.875-2.25 2.25 0 3.562 1.188 3.562 3.172v1.36l-4.672.265c-3.75.219-5.89 1.969-5.89 4.75 0 2.922 2.172 4.875 5.406 4.875m.61-2.312c-1.954 0-3.25-1.016-3.25-2.563 0-1.531 1.25-2.5 3.437-2.64l4.36-.266v1.328c0 2.344-1.985 4.14-4.548 4.14" })
  }
);
const SvgText$1 = SvgText;

const SvgTextBald = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M12.992 43c-2.502 0-3.977-1.527-3.977-4.16V9.133C9.015 6.527 10.49 5 12.992 5h12.561c7.137 0 11.613 3.66 11.613 9.48 0 4.161-3.107 7.637-7.136 8.243v.21c5.161.395 8.953 4.161 8.953 9.191 0 6.689-5.03 10.876-13.14 10.876zm3.976-22.2h5.715c4.24 0 6.662-1.87 6.662-5.082 0-3.055-2.133-4.793-5.846-4.793h-6.53zm0 16.275h6.847c4.582 0 7.057-1.949 7.057-5.583 0-3.555-2.554-5.451-7.241-5.451h-6.663z" })
  }
);
const SvgTextBald$1 = SvgTextBald;

const SvgTextSmall = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M9.992 32.188c.68 0 1.067-.329 1.313-1.09l1.277-3.633h6.469l1.289 3.644c.234.75.62 1.078 1.324 1.078.762 0 1.313-.503 1.313-1.195 0-.223-.047-.445-.165-.773l-5.156-13.957c-.351-.938-.914-1.36-1.828-1.36-.926 0-1.5.434-1.84 1.371L8.844 30.22a2.3 2.3 0 0 0-.164.773c0 .715.527 1.195 1.312 1.195m3.258-6.868 2.52-7.418h.07l2.543 7.418zM30.863 32.21c1.606 0 3.176-.866 3.89-2.237h.06v1.043c.023.75.503 1.207 1.206 1.207.715 0 1.22-.48 1.22-1.278v-7.441c0-2.473-1.91-4.055-4.9-4.055-2.214 0-4.077.89-4.722 2.285a1.7 1.7 0 0 0-.223.82c0 .634.458 1.055 1.09 1.055.446 0 .774-.164 1.032-.539.703-1.125 1.511-1.558 2.73-1.558 1.547 0 2.473.82 2.473 2.191v.95l-3.387.199c-2.918.164-4.582 1.488-4.582 3.644 0 2.215 1.7 3.715 4.113 3.715m.692-2.003c-1.348 0-2.25-.703-2.25-1.781 0-1.055.855-1.723 2.367-1.828l3.047-.188v.973c0 1.605-1.395 2.824-3.164 2.824" })
  }
);
const SvgTextSmall$1 = SvgTextSmall;

const SvgTextUnderline = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsxs(
      "g",
      {
        style: {
          mixBlendMode: "multiply"
        },
        children: [
          /* @__PURE__ */ jsx("path", { d: "M24 39c-8.543 0-13.783-5.192-13.783-12.532V6.738c0-1.7.991-2.738 2.643-2.738 1.629 0 2.644 1.038 2.644 2.738V26.02c0 4.861 3.068 8.283 8.496 8.283s8.52-3.422 8.52-8.283V6.738c0-1.7.991-2.738 2.643-2.738 1.629 0 2.62 1.038 2.62 2.738v19.73C37.783 33.808 32.543 39 24 39" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8 42.5A1.5 1.5 0 0 1 9.5 41h29a1.5 1.5 0 0 1 0 3h-29A1.5 1.5 0 0 1 8 42.5",
              clipRule: "evenodd"
            }
          )
        ]
      }
    )
  }
);
const SvgTextUnderline$1 = SvgTextUnderline;

const SvgTicket = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M27.7 6.8a1.7 1.7 0 0 1 1.7 1.7v4.84a1.7 1.7 0 1 1-3.4 0V8.5a1.7 1.7 0 0 1 1.7-1.7M27.7 33.82a1.7 1.7 0 0 1 1.7 1.7v4.048a1.7 1.7 0 1 1-3.4 0V35.52a1.7 1.7 0 0 1 1.7-1.7M27.7 17.307a1.7 1.7 0 0 1 1.7 1.7v9.642a1.7 1.7 0 1 1-3.4 0v-9.642a1.7 1.7 0 0 1 1.7-1.7",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M2.302 14.513c0-4.558 3.736-8.213 8.296-8.213h26.804c4.56 0 8.295 3.655 8.296 8.213L45.7 19.7a1.7 1.7 0 0 1-1.7 1.7c-1.492 0-2.653 1.179-2.653 2.602s1.16 2.6 2.653 2.6a1.7 1.7 0 0 1 1.7 1.7v5.184c0 4.558-3.733 8.214-8.296 8.214H10.596c-4.563 0-8.296-3.656-8.296-8.214v-5.185a1.7 1.7 0 0 1 1.7-1.7c1.493 0 2.653-1.176 2.653-2.599 0-1.336-1.07-2.432-2.653-2.432a1.7 1.7 0 0 1-1.7-1.7zM10.598 9.7c-2.724 0-4.896 2.174-4.896 4.814l-.001 3.883c2.464.676 4.352 2.798 4.352 5.605 0 2.749-1.844 5.036-4.353 5.76v3.724c0 2.64 2.17 4.814 4.896 4.814h26.808c2.726 0 4.896-2.174 4.896-4.814v-3.724c-2.51-.724-4.353-3.011-4.353-5.76s1.843-5.037 4.352-5.762l-.001-3.726c0-2.64-2.172-4.814-4.896-4.814z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgTicket$1 = SvgTicket;

const SvgTicketCircle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M27 23.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M11 20a4.5 4.5 0 0 1 4.5-4.5h17A4.5 4.5 0 0 1 37 20v8a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 11 28zm4.5-1.5A1.5 1.5 0 0 0 14 20v8a1.5 1.5 0 0 0 1.5 1.5h11.882a1.5 1.5 0 1 1 2.236 0H32.5A1.5 1.5 0 0 0 34 28v-8a1.5 1.5 0 0 0-1.5-1.5H30a1.5 1.5 0 0 1-3 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M44 24c0 11.046-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4s20 8.954 20 20m-3 0c0 9.389-7.611 17-17 17S7 33.389 7 24 14.611 7 24 7s17 7.611 17 17",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgTicketCircle$1 = SvgTicketCircle;

const SvgTicketDiscount = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "m13.06 32.06 13-13a1.5 1.5 0 0 0-2.12-2.12l-13 13a1.5 1.5 0 0 0 2.12 2.12" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 33a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M18 19a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M34.5 18a1.5 1.5 0 0 0-1.5 1.5v2a1.5 1.5 0 0 0 3 0v-2a1.5 1.5 0 0 0-1.5-1.5M33 26.5a1.5 1.5 0 0 1 3 0v2a1.5 1.5 0 0 1-3 0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M10 38a6 6 0 0 1-6-6V16a6 6 0 0 1 6-6h28a6 6 0 0 1 6 6v16a6 6 0 0 1-6 6zm0-25h23v.5a1.5 1.5 0 0 0 3 0V13h2a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3h-2v-.5a1.5 1.5 0 0 0-3 0v.5H10a3 3 0 0 1-3-3V16a3 3 0 0 1 3-3",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgTicketDiscount$1 = SvgTicketDiscount;

const SvgTimesCircle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M33.062 14.94a1.5 1.5 0 0 1 0 2.12L26.122 24l6.939 6.94a1.5 1.5 0 0 1-2.122 2.12L24 26.123l-6.938 6.939a1.5 1.5 0 0 1-2.122-2.122L21.88 24l-6.94-6.94a1.5 1.5 0 0 1 2.12-2.12L24 21.88l6.94-6.94a1.5 1.5 0 0 1 2.122 0" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m0-3c9.389 0 17-7.611 17-17S33.389 7 24 7 7 14.611 7 24s7.611 17 17 17",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgTimesCircle$1 = SvgTimesCircle;

const SvgTimesCircleSolid = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#000E2B",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 3,
        d: "M24 5.5c10.217 0 18.5 8.283 18.5 18.5S34.217 42.5 24 42.5 5.5 34.217 5.5 24 13.783 5.5 24 5.5m10.122 8.379a3 3 0 0 0-4.243 0L24 19.758l-5.879-5.88a3 3 0 1 0-4.242 4.243L19.758 24l-5.88 5.879a3 3 0 0 0 4.244 4.242L24 28.242l5.879 5.88a3 3 0 1 0 4.242-4.243L28.242 24l5.88-5.879a3 3 0 0 0 0-4.242"
      }
    )
  }
);
const SvgTimesCircleSolid$1 = SvgTimesCircleSolid;

const SvgTrash = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M10.043 17.053a1.7 1.7 0 0 1 1.82 1.572l1.224 16.751a4.935 4.935 0 0 0 4.92 4.577h11.986a4.934 4.934 0 0 0 4.92-4.575l1.224-16.753a1.7 1.7 0 0 1 3.391.248l-1.224 16.753a8.334 8.334 0 0 1-8.311 7.727H18.007a8.335 8.335 0 0 1-8.311-7.729L8.472 18.873a1.7 1.7 0 0 1 1.571-1.82M5.77 12.46a1.7 1.7 0 0 1 1.7-1.7h33.06a1.7 1.7 0 1 1 0 3.4H7.47a1.7 1.7 0 0 1-1.7-1.7",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M19.885 3.955h8.24a4.196 4.196 0 0 1 4.077 3.212l1.006 4.952a1.7 1.7 0 0 1-3.332.677l-.993-4.887a.8.8 0 0 0-.758-.554h-8.248a.8.8 0 0 0-.764.554l-.982 4.884a1.7 1.7 0 1 1-3.334-.67l.997-4.952q.01-.053.024-.106a4.2 4.2 0 0 1 4.067-3.11M20.203 21.518a1.7 1.7 0 0 1 1.7 1.7v9.017a1.7 1.7 0 1 1-3.4 0v-9.017a1.7 1.7 0 0 1 1.7-1.7m6.76 0a1.7 1.7 0 0 1 1.7 1.7v9.017a1.7 1.7 0 1 1-3.4 0v-9.017a1.7 1.7 0 0 1 1.7-1.7",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgTrash$1 = SvgTrash;

const SvgTriangle = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M35.076 40.584H12.96c-2.916 0-5.532-1.5-6.996-4.02s-1.488-5.532-.048-8.064L16.98 8.952c1.452-2.58 4.092-4.116 7.044-4.116s5.592 1.536 7.056 4.116L42.144 28.5a8.01 8.01 0 0 1-.048 8.064c-1.464 2.52-4.08 4.02-6.996 4.02zM24.012 9.036c-1.428 0-2.688.744-3.396 1.98L9.552 30.564a3.85 3.85 0 0 0 .024 3.888 3.86 3.86 0 0 0 3.372 1.932h22.116c1.404 0 2.664-.72 3.372-1.932a3.85 3.85 0 0 0 .024-3.888L27.396 11.016A3.86 3.86 0 0 0 24 9.036z" })
  }
);
const SvgTriangle$1 = SvgTriangle;

const SvgUser = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M24 6.474a7.88 7.88 0 0 0-7.88 7.883A7.882 7.882 0 1 0 24 6.474m-11.28 7.883c0-6.23 5.05-11.283 11.28-11.283 6.232 0 11.282 5.053 11.282 11.283S30.232 25.639 24 25.639c-6.23 0-11.28-5.053-11.28-11.282M12.924 30.468c3.012-1.01 6.992-1.312 11.076-1.312 4.107 0 8.09.313 11.098 1.336 1.514.514 2.905 1.249 3.933 2.326 1.066 1.118 1.669 2.534 1.669 4.204 0 1.673-.609 3.087-1.682 4.201-1.032 1.072-2.428 1.8-3.943 2.308-3.013 1.01-6.993 1.313-11.075 1.313-4.106 0-8.089-.313-11.098-1.336-1.513-.515-2.904-1.249-3.932-2.326-1.067-1.118-1.67-2.534-1.67-4.204 0-1.673.608-3.088 1.68-4.202 1.033-1.073 2.429-1.8 3.944-2.308m-1.494 4.666c-.475.493-.73 1.068-.73 1.844 0 .78.255 1.36.73 1.857.514.538 1.347 1.04 2.567 1.454 2.457.835 5.974 1.155 10.003 1.155 4.01 0 7.529-.31 9.993-1.137 1.224-.41 2.061-.908 2.577-1.443.475-.493.73-1.068.73-1.842 0-.78-.255-1.36-.73-1.857-.513-.538-1.346-1.04-2.566-1.454-2.457-.835-5.974-1.155-10.004-1.155-4.012 0-7.531.31-9.995 1.136-1.224.41-2.06.907-2.575 1.442",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgUser$1 = SvgUser;

const SvgUserEmpty = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M24 6q-.31 0-.616.017a1.5 1.5 0 0 0 .166 2.995 8 8 0 0 1 .9 0 1.5 1.5 0 0 0 .166-2.995Q24.31 6 24 6M31.33 8.798a1.5 1.5 0 0 0-2 2.236q.336.3.636.636a1.5 1.5 0 0 0 2.236-2 11 11 0 0 0-.872-.872M18.67 11.034a1.5 1.5 0 0 0-2-2.236 11 11 0 0 0-.872.872 1.5 1.5 0 1 0 2.236 2q.3-.336.636-.636M34.983 16.384a1.5 1.5 0 0 0-2.995.166 8 8 0 0 1 0 .9 1.5 1.5 0 1 0 2.995.166 11 11 0 0 0 0-1.232M16.012 16.55a1.5 1.5 0 1 0-2.995-.166 11 11 0 0 0 0 1.232 1.5 1.5 0 0 0 2.995-.166 8 8 0 0 1 0-.9M32.202 24.33a1.5 1.5 0 1 0-2.236-2q-.3.336-.636.636a1.5 1.5 0 0 0 2 2.236q.46-.411.872-.872M18.034 22.33a1.5 1.5 0 0 0-2.236 2q.411.46.872.872a1.5 1.5 0 1 0 2-2.236 8 8 0 0 1-.636-.636M25.424 25.278a1.499 1.499 0 0 1-.907 2.73 16 16 0 0 0-1.034 0 1.5 1.5 0 0 1-.906-2.73c.271-.2.61-.31.973-.29a8 8 0 0 0 .9 0c.363-.02.703.09.974.29M16.506 29.822a1.5 1.5 0 1 0-1.359-2.675 20 20 0 0 0-1.072.586 1.5 1.5 0 1 0 1.518 2.588q.446-.261.913-.5M32.853 27.147a1.5 1.5 0 1 0-1.36 2.675q.468.237.915.5a1.5 1.5 0 1 0 1.517-2.589q-.525-.306-1.072-.586M40.175 33.534a1.5 1.5 0 1 0-2.493 1.668q.142.213.274.428.097.159.16.303a1.5 1.5 0 1 0 2.743-1.215 6 6 0 0 0-.347-.66q-.162-.263-.337-.524M10.318 35.202a1.5 1.5 0 1 0-2.493-1.668q-.175.261-.337.525a6 6 0 0 0-.347.659 1.5 1.5 0 0 0 2.742 1.215q.064-.144.16-.303.133-.215.275-.428M12.598 38.981a1.5 1.5 0 1 0-.282 2.987Q12.653 42 13 42h.458a1.5 1.5 0 0 0 0-3H13q-.204 0-.402-.019M35.684 41.968a1.5 1.5 0 1 0-.282-2.987A4 4 0 0 1 35 39h-.458a1.5 1.5 0 0 0 0 3H35q.346 0 .684-.032M19.875 39a1.5 1.5 0 0 0 0 3h.917a1.5 1.5 0 1 0 0-3zM27.208 39a1.5 1.5 0 0 0 0 3h.917a1.5 1.5 0 0 0 0-3z" })
  }
);
const SvgUserEmpty$1 = SvgUserEmpty;

const SvgWallet = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M33.938 20.019a2.55 2.55 0 0 0-2.551 2.55v2.346a2.55 2.55 0 0 0 2.55 2.55h9.33a1.7 1.7 0 1 1 0 3.4h-9.33a5.95 5.95 0 0 1-5.95-5.95v-2.346a5.95 5.95 0 0 1 5.95-5.95h9.33a1.7 1.7 0 1 1 0 3.4z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M32.982 23.62a1.7 1.7 0 0 1 1.7-1.7h.006a1.7 1.7 0 1 1 0 3.4h-.006a1.7 1.7 0 0 1-1.7-1.7",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M15.275 7.9A8.875 8.875 0 0 0 6.4 16.775v14.461a8.875 8.875 0 0 0 8.875 8.876H32.69a8.875 8.875 0 0 0 8.876-8.876v-14.46A8.875 8.875 0 0 0 32.69 7.9zM3 16.775C3 9.995 8.495 4.5 15.275 4.5H32.69c6.78 0 12.276 5.495 12.276 12.275v14.461c0 6.78-5.496 12.276-12.276 12.276H15.275C8.495 43.512 3 38.016 3 31.236z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgWallet$1 = SvgWallet;

const SvgWarehouse = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M19.181 5.665a7.72 7.72 0 0 1 9.581 0l.006.005 12.452 9.941a6.31 6.31 0 0 1 2.477 4.912V41.7a1.7 1.7 0 1 1-3.4 0V20.567a2.91 2.91 0 0 0-1.183-2.287L26.653 8.332l-.003-.002a4.32 4.32 0 0 0-5.356-.001L8.887 18.285l-.04.031A2.89 2.89 0 0 0 7.7 20.58V41.7a1.7 1.7 0 1 1-3.4 0V20.55a6.29 6.29 0 0 1 2.477-4.931z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M18.045 27.37c-.432.463-.747 1.198-.747 2.22v7.417c0 1.024.314 1.758.744 2.22.416.448 1.063.774 2.02.774h7.874c.955 0 1.603-.326 2.02-.775.43-.462.746-1.196.746-2.219V29.59c0-1.024-.315-1.758-.746-2.22-.417-.448-1.065-.774-2.02-.774h-7.875c-.95 0-1.598.325-2.017.775m-2.488-2.317c1.127-1.21 2.711-1.857 4.504-1.857h7.875c1.796 0 3.381.646 4.509 1.857 1.115 1.198 1.657 2.81 1.657 4.537v7.417c0 1.726-.542 3.339-1.657 4.536-1.128 1.211-2.713 1.858-4.509 1.858h-7.875c-1.796 0-3.382-.647-4.509-1.858-1.114-1.198-1.654-2.81-1.654-4.536V29.59c0-1.728.544-3.34 1.659-4.537",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M19.984 31.59a1.7 1.7 0 0 1 1.7-1.7h4.629a1.7 1.7 0 1 1 0 3.4h-4.63a1.7 1.7 0 0 1-1.7-1.7",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const SvgWarehouse$1 = SvgWarehouse;

const SvgWarning = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M19.029 8.375c2.256-3.91 7.905-3.896 10.142.027l14.477 25.407v.001l.194.367c1.848 3.827-.93 8.372-5.274 8.372H9.431c-4.499 0-7.31-4.868-5.063-8.765v-.001zm7.189 1.71c-.907-1.59-3.154-1.645-4.152-.159l-.093.149-14.66 25.407c-.94 1.631.237 3.668 2.118 3.668h29.137c1.875 0 3.054-2.026 2.125-3.657v-.001z" }),
      /* @__PURE__ */ jsx("path", { d: "M22.32 33.002v-.101a1.7 1.7 0 0 1 3.392-.174l.009.174v.101l-.01.174a1.7 1.7 0 0 1-3.382 0zm.004-6.334v-6.263a1.7 1.7 0 0 1 3.392-.174l.008.174v6.264l-.008.173a1.7 1.7 0 0 1-3.383 0z" })
    ]
  }
);
const SvgWarning$1 = SvgWarning;

const SvgWarningCircleSolid = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M3.9 24C3.9 12.756 12.912 3.612 24 3.612S44.1 12.756 44.1 24 35.088 44.388 24 44.388 3.9 35.244 3.9 24m18-9.284c0-1.164.936-2.1 2.1-2.1s2.1.936 2.1 2.1v10.5c0 1.164-.936 2.1-2.1 2.1s-2.1-.936-2.1-2.1zm3.756 19.488a2.37 2.37 0 0 1-1.656.684 2.37 2.37 0 0 1-1.656-.684 2.35 2.35 0 0 1-.684-1.656c0-.624.252-1.224.684-1.656.876-.876 2.436-.876 3.312 0 .432.432.684 1.044.684 1.656s-.252 1.224-.684 1.656",
        clipRule: "evenodd"
      }
    )
  }
);
const SvgWarningCircleSolid$1 = SvgWarningCircleSolid;

const SvgWarningSolid = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M43.392 31.692 31.14 8.856C29.7 6.18 27.036 4.584 24 4.584s-5.7 1.596-7.14 4.272L4.608 31.692a8.05 8.05 0 0 0 .18 7.992 8.02 8.02 0 0 0 6.948 3.936h24.516a8.04 8.04 0 0 0 6.948-3.936c1.476-2.472 1.548-5.46.18-7.992zM21.9 16.716c0-1.164.936-2.1 2.1-2.1s2.1.936 2.1 2.1v10.5c0 1.164-.936 2.1-2.1 2.1s-2.1-.936-2.1-2.1zm3.756 19.488a2.37 2.37 0 0 1-1.656.684 2.37 2.37 0 0 1-1.656-.684 2.35 2.35 0 0 1-.684-1.656c0-.624.252-1.224.684-1.656.876-.876 2.436-.876 3.312 0 .432.432.684 1.044.684 1.656s-.252 1.224-.684 1.656" })
  }
);
const WarningSolidIcon = SvgWarningSolid;

const SvgYen = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M16.233 9.146a1.5 1.5 0 0 0-2.466 1.708L21.83 22.5H16a1.5 1.5 0 0 0 0 3h6.5v3H16a1.5 1.5 0 0 0 0 3h6.5V38a1.5 1.5 0 0 0 3 0v-6.5H32a1.5 1.5 0 0 0 0-3h-6.5v-3H32a1.5 1.5 0 0 0 0-3h-5.83l8.063-11.646a1.5 1.5 0 1 0-2.466-1.708L24 20.365z" })
  }
);
const SvgYen$1 = SvgYen;

const SvgYenPayment = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M22.5 9.121V17.5a1.5 1.5 0 1 0 3 0V9.121l3.44 3.44a1.5 1.5 0 0 0 2.12-2.122L25.07 4.447a1.5 1.5 0 0 0-.465-.32 1.5 1.5 0 0 0-1.153-.023 1.5 1.5 0 0 0-.512.335l-6 6a1.5 1.5 0 0 0 2.122 2.122zM20.615 21.497a1.5 1.5 0 1 0-2.23 2.006L21.532 27H19.5a1.5 1.5 0 0 0 0 3h3v2h-3a1.5 1.5 0 0 0 0 3h3v1.5a1.5 1.5 0 0 0 3 0V35h3a1.5 1.5 0 0 0 0-3h-3v-2h3a1.5 1.5 0 0 0 0-3h-2.032l3.147-3.497a1.5 1.5 0 0 0-2.23-2.006L24 25.257z" }),
      /* @__PURE__ */ jsx("path", { d: "M8 32.5a1.5 1.5 0 0 1 3 0V38a3 3 0 0 0 3 3h20a3 3 0 0 0 3-3v-5.5a1.5 1.5 0 0 1 3 0V38a6 6 0 0 1-6 6H14a6 6 0 0 1-6-6z" })
    ]
  }
);
const SvgYenPayment$1 = SvgYenPayment;

const SvgYenWithdrawal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0A0A0A",
    viewBox: "0 0 48 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M20.615 4.497a1.5 1.5 0 0 0-2.23 2.006L21.532 10H19.5a1.5 1.5 0 0 0 0 3h3v2h-3a1.5 1.5 0 0 0 0 3h3v1.5a1.5 1.5 0 0 0 3 0V18h3a1.5 1.5 0 0 0 0-3h-3v-2h3a1.5 1.5 0 0 0 0-3h-2.032l3.147-3.497a1.5 1.5 0 0 0-2.23-2.006L24 8.257zM24 24a1.5 1.5 0 0 1 1.5 1.5v7.379l3.44-3.44a1.5 1.5 0 0 1 2.12 2.122l-6 6a1.495 1.495 0 0 1-1.634.325 1.5 1.5 0 0 1-.487-.325l-6-6a1.5 1.5 0 0 1 2.122-2.122l3.439 3.44V25.5A1.5 1.5 0 0 1 24 24" }),
      /* @__PURE__ */ jsx("path", { d: "M8 32.5a1.5 1.5 0 0 1 3 0V38a3 3 0 0 0 3 3h20a3 3 0 0 0 3-3v-5.5a1.5 1.5 0 0 1 3 0V38a6 6 0 0 1-6 6H14a6 6 0 0 1-6-6z" })
    ]
  }
);
const SvgYenWithdrawal$1 = SvgYenWithdrawal;

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e)){var o=e.length;for(t=0;t<o;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);}else for(f in e)e[f]&&(n&&(n+=" "),n+=f);return n}function clsx(){for(var e,t,f=0,n="",o=arguments.length;f<o;f++)(e=arguments[f])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

const StandRadio = forwardRef(
  ({ isError, children, ...props }, ref) => {
    delete props.className;
    return /* @__PURE__ */ jsxs(
      "label",
      {
        className: clsx(
          "inline-flex",
          "gap-x-xs",
          "items-center",
          "text-label-primary",
          !props.disabled ? "cursor-pointer" : "cursor-not-allowed"
        ),
        children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              ...props,
              ref,
              type: "radio",
              "data-is-error": isError,
              className: clsx(
                "shrink-0",
                "appearance-none",
                "outline-none",
                "focus:outline-none",
                "inline-block",
                "w-20",
                "h-20",
                "rounded-full",
                "border",
                "border-border-secondary",
                "cursor-pointer",
                "focus-visible:ring-1",
                "focus-visible:ring-border-emphasis",
                "focus-visible:ring-offset-1",
                "checked:border-border-primary",
                "checked:relative",
                'checked:after:content-[""]',
                "checked:after:absolute",
                "checked:after:top-1/2",
                "checked:after:left-1/2",
                "checked:after:w-10",
                "checked:after:h-10",
                "checked:after:bg-border-primary",
                "checked:after:rounded-full",
                "checked:after:-translate-x-1/2",
                "checked:after:-translate-y-1/2",
                "disabled:cursor-not-allowed",
                "disabled:border-border-tertiary",
                "disabled:checked:after:bg-border-tertiary",
                isError && "!border-function-negative checked:after:!bg-function-negative"
              )
            }
          ),
          children && /* @__PURE__ */ jsx(
            "span",
            {
              className: clsx("text-body-md", {
                "text-label-tertiary": props.disabled,
                "text-function-negative": isError
              }),
              children
            }
          )
        ]
      }
    );
  }
);
StandRadio.displayName = "StandRadio";

const StandRadioGroup = ({
  name,
  value,
  direction = "vertical",
  disabled = false,
  isError = false,
  children,
  onChange
}) => {
  const clonedChildren = React.Children.map(children, (child) => {
    if (isValidElement(child)) {
      return cloneElement(child, {
        name,
        checked: child.props.value === value,
        disabled: disabled || child.props.disabled,
        isError: isError || child.props.isError,
        onChange: (event) => {
          if (onChange) {
            onChange(event);
          }
        }
      });
    }
    return child;
  });
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: clsx(
        "flex",
        direction === "horizontal" ? "flex-row gap-x-md" : "flex-col gap-y-xs"
      ),
      children: clonedChildren
    }
  );
};
StandRadioGroup.displayName = "StandRadioGroup";

const StandRadioWithLabel = forwardRef(({ labelText, ...props }, ref) => {
  delete props.className;
  return /* @__PURE__ */ jsx(StandRadio, { ...props, ref, children: labelText });
});
StandRadioWithLabel.displayName = "StandRadioWithLabel";

const StandCheckbox = forwardRef(
  ({
    indeterminate,
    isIndeterminate,
    size = "md",
    outline,
    isError,
    hasError,
    children,
    checked,
    disabled,
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsxs(
      "label",
      {
        "data-size": size,
        className: clsx(
          "group",
          "relative",
          "flex",
          "items-center",
          "gap-xs",
          "text-body-md",
          "data-[size=sm]:min-h-[40px]",
          "data-[size=md]:min-h-48",
          "data-[size=lg]:min-h-56",
          "has-[:disabled]:cursor-not-allowed",
          outline && "rounded-md border border-solid border-border-tertiary px-md py-2xs",
          outline && !disabled && "transition duration-100 hover:bg-surface-hover/[0.05]"
        ),
        children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              ref,
              type: "checkbox",
              checked,
              disabled,
              "data-is-error": isError || hasError,
              "data-size": size,
              className: clsx(
                "absolute",
                "peer",
                "h-[1px]",
                "m-[-1px]",
                "overflow-hidden",
                "border-0",
                "opacity-0"
              ),
              ...props
            }
          ),
          /* @__PURE__ */ jsxs(
            "span",
            {
              className: clsx(
                "shrink-0",
                "bg-surface-primary",
                "w-20",
                "h-20",
                "rounded-2xs",
                "border-1",
                "border-solid",
                "transition",
                "duration-100",
                "border-border-secondary",
                "group-hover:border-border-primary",
                "peer-checked:bg-label-primary",
                "peer-checked:border-transparent",
                "group-hover:peer-disabled:border-transparent",
                "peer-disabled:bg-label-tertiary",
                "peer-not-checked:peer-disabled:bg-surface-primary",
                "peer-not-checked:peer-disabled:border-border-tertiary",
                "peer-data-[is-error=true]:border-function-negative",
                "peer-data-[is-error=true]:peer-checked:bg-function-negative",
                "peer-focus-visible:border-border-emphasis"
              ),
              children: [
                /* @__PURE__ */ jsx(
                  CheckIcon,
                  {
                    width: 20,
                    height: 20,
                    fill: "currentColor",
                    className: clsx(
                      "text-label-inverse",
                      indeterminate || isIndeterminate ? "hidden" : "block"
                    )
                  }
                ),
                /* @__PURE__ */ jsx(
                  MinusIcon,
                  {
                    width: 20,
                    height: 20,
                    fill: "currentColor",
                    className: clsx(
                      "text-label-inverse",
                      indeterminate || isIndeterminate ? "block" : "hidden"
                    )
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsx(
            "span",
            {
              className: clsx(
                isError || hasError ? "text-function-negative" : "text-label-primary",
                disabled && "text-label-tertiary"
              ),
              children
            }
          )
        ]
      }
    );
  }
);
StandCheckbox.displayName = "StandCheckbox";

const StandCheckboxWithLabel = forwardRef(
  ({ labelText, ...props }, ref) => {
    return /* @__PURE__ */ jsx(StandCheckbox, { ref, ...props, children: labelText });
  }
);
StandCheckboxWithLabel.displayName = "StandCheckboxWithLabel";

function mergeRefs(...refs) {
  return (node) => {
    for (const ref of refs) {
      if (typeof ref === "function") {
        ref(node);
      } else if (ref && "current" in ref) {
        ref.current = node;
      }
    }
  };
}
const SharedButton = forwardRef(
  ({
    render,
    variant = "fill_emphasis",
    size = "md",
    icon,
    children,
    fullWidth,
    isBlock,
    disabled,
    ...props
  }, ref) => {
    const [elementWidth, setElementWidth] = useState(0);
    const elementRef = useRef(null);
    useEffect(() => {
      if (elementRef.current) {
        setElementWidth(elementRef.current.offsetWidth);
      }
    }, []);
    const styles = {
      "--button-width": elementWidth
    };
    return cloneElement(render, {
      style: {
        ...styles
      },
      "data-has-icon": !!icon,
      "data-variant": variant,
      "data-size": size,
      disabled,
      className: clsx(
        (fullWidth || isBlock) && "w-full",
        "inline-flex",
        "items-center",
        "justify-center",
        "group",
        "rounded-md",
        "whitespace-nowrap",
        "data-[has-icon=true]:gap-2xs",
        "disabled:cursor-not-allowed disabled:text-label-tertiary",
        "transition-all duration-150 ease-[cubic-bezier(0.4,0,0.2,1)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-emphasis focus-visible:ring-offset-2",
        size === "2xs" && "h-28 px-sm text-body-sm data-[has-icon=true]:pl-xs data-[has-icon=true]:pr-sm",
        size === "xs" && "h-32 px-md text-body-md data-[has-icon=true]:pl-xs data-[has-icon=true]:pr-sm",
        size === "sm" && "h-[40px] px-md text-body-md font-bold data-[has-icon=true]:pl-sm data-[has-icon=true]:pr-md",
        size === "md" && "h-48 px-lg text-body-lg font-bold data-[has-icon=true]:pl-sm data-[has-icon=true]:pr-md",
        size === "lg" && "h-56 px-lg text-body-lg font-bold data-[has-icon=true]:pl-sm data-[has-icon=true]:pr-md",
        variant === "fill" && "bg-surface-inverse text-label-inverse disabled:bg-surface-fill-gray hover:[&:not(:disabled)]:bg-surface-hover-inverse",
        variant === "fill_emphasis" && "bg-surface-emphasis text-label-inverse disabled:bg-surface-fill-gray hover:[&:not(:disabled)]:brightness-95",
        variant === "fill_destructive" && "bg-function-negative-fix text-label-inverse disabled:bg-surface-fill-gray hover:[&:not(:disabled)]:brightness-95",
        variant === "fill_gray" && "bg-surface-fill-gray text-label-secondary disabled:bg-surface-fill-gray hover:[&:not(:disabled)]:brightness-95",
        variant === "outlined" && "border border-solid border-border-secondary bg-surface-primary text-label-secondary disabled:bg-surface-fill-gray hover:[&:not(:disabled)]:brightness-95",
        variant === "outlined_emphasis" && "border border-solid border-border-secondary bg-surface-primary text-label-emphasis disabled:bg-surface-fill-gray hover:[&:not(:disabled)]:brightness-95",
        variant === "text" && "bg-surface-primary text-label-emphasis hover:[&:not(:disabled)]:brightness-95",
        variant === "text_destructive" && "bg-surface-primary text-function-negative hover:[&:not(:disabled)]:brightness-95",
        variant === "text_gray" && "bg-surface-primary text-label-secondary hover:[&:not(:disabled)]:brightness-95",
        !disabled && "active:scale-[calc(1-4/var(--button-width))] active:transition-transform active:duration-100"
      ),
      ...props,
      ref: mergeRefs(
        ref,
        elementRef
      ),
      children: /* @__PURE__ */ jsxs(Fragment, { children: [
        icon && /* @__PURE__ */ jsx(
          "span",
          {
            className: clsx(
              "inline-block",
              size === "2xs" && "size-md",
              (size === "xs" || size === "sm") && "size-[20px]",
              (size === "md" || size === "lg") && "size-lg"
            ),
            children: icon
          }
        ),
        children
      ] })
    });
  }
);
SharedButton.displayName = "SharedButton";

const StandButton = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(SharedButton, { render: /* @__PURE__ */ jsx("button", {}), ref, ...props });
});
StandButton.displayName = "StandButton";

const StandLinkButton = forwardRef(
  ({ render, target, rel, isSelf, ...props }, ref) => {
    const anchorOpt = {
      target,
      rel
    };
    if (isSelf !== void 0) {
      anchorOpt.target = isSelf ? "_self" : "_blank";
      anchorOpt.rel = isSelf ? void 0 : "noopener noreferrer";
    }
    if (render) {
      return /* @__PURE__ */ jsx(SharedButton, { render, ref, ...props, ...anchorOpt });
    }
    return /* @__PURE__ */ jsx(SharedButton, { render: /* @__PURE__ */ jsx("a", {}), ref, ...props, ...anchorOpt });
  }
);
StandLinkButton.displayName = "StandLinkButton";

const StandInputText = forwardRef(
  (props, ref) => {
    const {
      label,
      // css の :placeholder-shown を機能させるために無い場合は空文字を入れる
      placeholder = " ",
      isError = false,
      hasError,
      ...rest
    } = props;
    const id = useId();
    const noApperanceClasses = "[-moz-appearance:_textfield] [&::-webkit-inner-spin-button]:m-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-none [&::-webkit-outer-spin-button]:appearance-none";
    return /* @__PURE__ */ jsx(
      "div",
      {
        "data-is-error": isError || hasError,
        className: "flex h-56 w-full items-center rounded-md border border-solid border-border-secondary text-label-secondary focus:outline-none has-[input:focus]:border-border-emphasis has-[input:disabled]:bg-surface-secondary data-[is-error=true]:border-function-negative  data-[is-error=true]:bg-function-negative-pale-secondary data-[is-error=true]:text-function-negative",
        children: /* @__PURE__ */ jsxs("label", { className: "relative flex size-full items-center px-md", children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              ref,
              className: `peer mt-[18px] w-full bg-transparent text-label-primary outline-none placeholder:text-label-tertiary placeholder:opacity-0 focus:placeholder:opacity-100 focus:placeholder:transition-opacity focus:placeholder:duration-100 disabled:text-label-secondary ${noApperanceClasses}`,
              id: rest.id ?? id,
              placeholder,
              ...rest
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "absolute left-md translate-y-[-10px] text-body-xs transition-all peer-placeholder-shown:translate-y-none peer-placeholder-shown:text-body-lg peer-focus:translate-y-[-10px] peer-focus:text-body-xs", children: label })
        ] })
      }
    );
  }
);
StandInputText.displayName = "StandInputText";

const StandTextArea = forwardRef(
  (props, ref) => {
    const {
      label,
      // css の :placeholder-shown を機能させるために無い場合は空文字を入れる
      placeholder = " ",
      isError = false,
      hasError,
      ...rest
    } = props;
    const id = useId();
    return /* @__PURE__ */ jsx(
      "div",
      {
        "data-is-error": isError || hasError,
        className: "size-full min-h-120 rounded-md border border-solid border-border-secondary text-label-secondary focus:outline-none has-[textarea:focus]:border-border-emphasis has-[textarea:disabled]:bg-surface-secondary data-[is-error=true]:border-function-negative  data-[is-error=true]:bg-function-negative-pale-secondary data-[is-error=true]:text-function-negative",
        children: /* @__PURE__ */ jsxs("label", { className: "relative flex size-full px-md", children: [
          /* @__PURE__ */ jsx(
            "textarea",
            {
              ref,
              className: "peer mt-xl size-full resize-none bg-transparent text-label-primary outline-none placeholder:text-label-tertiary placeholder:opacity-0 focus:placeholder:opacity-100 focus:placeholder:transition-opacity focus:placeholder:duration-100 disabled:text-label-secondary",
              id: rest.id ?? id,
              placeholder,
              ...rest
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "absolute left-md translate-y-md text-body-xs transition-all peer-placeholder-shown:translate-y-md peer-placeholder-shown:text-body-lg peer-focus:text-body-xs", children: label })
        ] })
      }
    );
  }
);
StandTextArea.displayName = "StandTextArea";

const StandSwitch = forwardRef((props, ref) => {
  const {
    disabled = false,
    id,
    onKeyDown,
    checked,
    defaultChecked,
    isOn,
    defaultIsOn,
    ...rest
  } = props;
  const finalChecked = checked ?? isOn;
  const finalDefaultChecked = defaultChecked ?? defaultIsOn;
  const generatedId = useId();
  const switchId = id || generatedId;
  const handleKeyDown = (event) => {
    if (event.key === " " || event.key === "Enter") {
      event.preventDefault();
      const target = event.currentTarget;
      target.click();
    }
    onKeyDown?.(event);
  };
  const inputProps = {
    ...rest,
    ...finalChecked !== void 0 && { checked: finalChecked },
    ...finalDefaultChecked !== void 0 && {
      defaultChecked: finalDefaultChecked
    }
  };
  return /* @__PURE__ */ jsx(
    "input",
    {
      ref,
      type: "checkbox",
      role: "switch",
      id: switchId,
      disabled,
      "aria-checked": finalChecked,
      onKeyDown: handleKeyDown,
      ...inputProps,
      className: clsx(
        "appearance-none",
        "inline-block",
        "outline-none",
        "w-40",
        "h-24",
        "rounded-full",
        "bg-function-neutral",
        "cursor-pointer",
        "focus-visible:ring-1",
        "focus-visible:ring-label-emphasis",
        "checked:bg-function-positive",
        "relative",
        "after:absolute",
        "after:top-[2px]",
        "after:left-[2px]",
        "after:size-[20px]",
        "after:bg-white",
        "after:rounded-full",
        "after:transition",
        "duration-100",
        "checked:after:translate-x-[16px]",
        "disabled:cursor-not-allowed",
        "disabled:opacity-[20%]"
      )
    }
  );
});
StandSwitch.displayName = "StandSwitch";

const StandNote = ({ type = "default", children }) => {
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-xs rounded-md bg-surface-tertiary px-md py-sm", children: [
    type === "caution" ? /* @__PURE__ */ jsx(
      WarningSolidIcon,
      {
        width: 24,
        height: 24,
        fill: "currentColor",
        "aria-hidden": "true",
        focusable: "false",
        className: "text-function-caution"
      }
    ) : null,
    /* @__PURE__ */ jsx("div", { className: "flex-1", children })
  ] });
};
StandNote.displayName = "StandNote";

const StandNavi = (props) => {
  useEffect(() => {
    mutateStandNaviA11yDOMStyle();
  }, []);
  return React.createElement(StandNavi$1, props);
};
const StandLegacyNavi = (props) => {
  useEffect(() => {
    mutateStandNaviA11yDOMStyle();
  }, []);
  return React.createElement(StandLegacyNavi$1, props);
};

export { SvgAddSquare$1 as AddSquareIcon, SvgAnnounce$1 as AnnounceIcon, SvgArrowDown$1 as ArrowDownIcon, SvgArrowLeft$1 as ArrowLeftIcon, SvgArrowRight$1 as ArrowRightIcon, SvgArrowUp$1 as ArrowUpIcon, SvgArrowsH$1 as ArrowsHIcon, SvgArrowsV$1 as ArrowsVIcon, SvgAscendingOrder$1 as AscendingOrderIcon, SvgBadge$1 as BadgeIcon, SvgBan$1 as BanIcon, SvgBarcode$1 as BarcodeIcon, SvgBarcodeScan$1 as BarcodeScanIcon, SvgBarcodeScanner$1 as BarcodeScannerIcon, SvgBarcodeScannerOffline$1 as BarcodeScannerOfflineIcon, SvgBars$1 as BarsIcon, SvgBluetooth$1 as BluetoothIcon, SvgBoxOpen$1 as BoxOpenIcon, SvgBrandFacebook$1 as BrandFacebookIcon, SvgBrandInstagram$1 as BrandInstagramIcon, SvgBrandLine$1 as BrandLineIcon, SvgBrandPinterest$1 as BrandPinterestIcon, SvgBrandTwitter$1 as BrandTwitterIcon, SvgBrandWechat$1 as BrandWechatIcon, SvgBrandWechatRefund$1 as BrandWechatRefundIcon, SvgBrandX$1 as BrandXIcon, SvgBrandYoutube$1 as BrandYoutubeIcon, SvgBrowserEdit$1 as BrowserEditIcon, SvgBrowser$1 as BrowserIcon, SvgCalculator$1 as CalculatorIcon, SvgCalculatorSolid$1 as CalculatorSolidIcon, SvgCalendar$1 as CalendarIcon, SvgCamera$1 as CameraIcon, SvgCameraRotate$1 as CameraRotateIcon, SvgCardIc$1 as CardIcIcon, SvgCardIcRefund$1 as CardIcRefundIcon, SvgCaretDown$1 as CaretDownIcon, SvgCaretLeft$1 as CaretLeftIcon, SvgCaretRight$1 as CaretRightIcon, SvgCaretUpDown$1 as CaretUpDownIcon, SvgCaretUp$1 as CaretUpIcon, SvgCartCheck$1 as CartCheckIcon, SvgCart$1 as CartIcon, SvgCartTimer$1 as CartTimerIcon, SvgCash$1 as CashIcon, SvgCatalog$1 as CatalogIcon, SvgChart$1 as ChartIcon, SvgCheckCircle$1 as CheckCircleIcon, SvgCheckCircleSolid$1 as CheckCircleSolidIcon, CheckIcon, SvgChevronDoubleLeft$1 as ChevronDoubleLeftIcon, SvgChevronDoubleRight$1 as ChevronDoubleRightIcon, SvgCircle$1 as CircleIcon, SvgClock$1 as ClockIcon, SvgClose$1 as CloseIcon, SvgCloudUpload$1 as CloudUploadIcon, SvgCog$1 as CogIcon, SvgComment$1 as CommentIcon, SvgContactLine$1 as ContactLineIcon, SvgContactSolid$1 as ContactSolidIcon, SvgCopy$1 as CopyIcon, SvgCounterClockwiseUndo$1 as CounterClockwiseUndoIcon, SvgCustomerDisplay$1 as CustomerDisplayIcon, SvgCustomerDisplayOffline$1 as CustomerDisplayOfflineIcon, SvgCustomer$1 as CustomerIcon, SvgDescendingOrder$1 as DescendingOrderIcon, SvgDiscovery$1 as DiscoveryIcon, SvgDocumentCircle$1 as DocumentCircleIcon, SvgDocument$1 as DocumentIcon, SvgDownload$1 as DownloadIcon, SvgEMoney$1 as EMoneyIcon, SvgEdit$1 as EditIcon, SvgExchange$1 as ExchangeIcon, SvgExternalLink$1 as ExternalLinkIcon, SvgEye$1 as EyeIcon, SvgEyeSlash$1 as EyeSlashIcon, SvgFaceRecognition$1 as FaceRecognitionIcon, SvgFilter$1 as FilterIcon, SvgGiftCertificates$1 as GiftCertificatesIcon, SvgGift$1 as GiftIcon, SvgGlobe$1 as GlobeIcon, SvgGridMultiItems$1 as GridMultiItemsIcon, SvgHandle$1 as HandleIcon, SvgHeart$1 as HeartIcon, SvgHeartSolid$1 as HeartSolidIcon, SvgHierarchy$1 as HierarchyIcon, SvgHome$1 as HomeIcon, SvgHorizontalRule$1 as HorizontalRuleIcon, SvgIdCard$1 as IdCardIcon, SvgImageAdd$1 as ImageAddIcon, SvgImageCaption$1 as ImageCaptionIcon, SvgImageCircle$1 as ImageCircleIcon, SvgImage$1 as ImageIcon, SvgInbox$1 as InboxIcon, SvgInfinity$1 as InfinityIcon, SvgInfoCircle$1 as InfoCircleIcon, SvgInfo$1 as InfoIcon, SvgInfoSolid$1 as InfoSolidIcon, SvgInquiry$1 as InquiryIcon, SvgInvoice$1 as InvoiceIcon, SvgItemAdd$1 as ItemAddIcon, SvgItem$1 as ItemIcon, SvgItemset$1 as ItemsetIcon, SvgKey$1 as KeyIcon, SvgKeypad$1 as KeypadIcon, SvgKnifeAndFork$1 as KnifeAndForkIcon, SvgLamp$1 as LampIcon, SvgLgChevronDown$1 as LgChevronDownIcon, SvgLgChevronLeft$1 as LgChevronLeftIcon, SvgLgChevronRight$1 as LgChevronRightIcon, SvgLgChevronUp$1 as LgChevronUpIcon, SvgListBullet$1 as ListBulletIcon, SvgListNumber$1 as ListNumberIcon, SvgLockCheck$1 as LockCheckIcon, SvgLock$1 as LockIcon, SvgLogoStores$1 as LogoStoresIcon, SvgLogout$1 as LogoutIcon, SvgMapMarker$1 as MapMarkerIcon, SvgMessage$1 as MessageIcon, SvgMinusCircle$1 as MinusCircleIcon, SvgMinusCircleSolid$1 as MinusCircleSolidIcon, MinusIcon, SvgMoney$1 as MoneyIcon, SvgMoneyReceived$1 as MoneyReceivedIcon, SvgMoreHoriz$1 as MoreHorizIcon, SvgMoreSquareHoriz$1 as MoreSquareHorizIcon, SvgMoreVert$1 as MoreVertIcon, SvgMovie$1 as MovieIcon, SvgNewsletter$1 as NewsletterIcon, SvgNoteShield$1 as NoteShieldIcon, SvgNotification$1 as NotificationIcon, SvgNumberCircle0$1 as NumberCircle0Icon, SvgNumberCircle1$1 as NumberCircle1Icon, SvgNumberCircle2$1 as NumberCircle2Icon, SvgNumberCircle3$1 as NumberCircle3Icon, SvgNumberCircle4$1 as NumberCircle4Icon, SvgNumberCircle5$1 as NumberCircle5Icon, SvgNumberCircle6$1 as NumberCircle6Icon, SvgNumberCircle7$1 as NumberCircle7Icon, SvgNumberCircle8$1 as NumberCircle8Icon, SvgNumberCircle9$1 as NumberCircle9Icon, SvgOldBars$1 as OldBarsIcon, SvgOldBrowser$1 as OldBrowserIcon, SvgOldCalendar$1 as OldCalendarIcon, SvgOldCardIc$1 as OldCardIcIcon, SvgOldCart$1 as OldCartIcon, SvgOldCheckCircle$1 as OldCheckCircleIcon, SvgOldCheck$1 as OldCheckIcon, SvgOldClock$1 as OldClockIcon, SvgOldClose$1 as OldCloseIcon, SvgOldCog$1 as OldCogIcon, SvgOldComment$1 as OldCommentIcon, SvgOldContactLine$1 as OldContactLineIcon, SvgOldEdit$1 as OldEditIcon, SvgOldExchange$1 as OldExchangeIcon, SvgOldExternalLink$1 as OldExternalLinkIcon, SvgOldEye$1 as OldEyeIcon, SvgOldGridMultiitems$1 as OldGridMultiitemsIcon, SvgOldInvoice$1 as OldInvoiceIcon, SvgOldItem$1 as OldItemIcon, SvgOldLgChevronDown$1 as OldLgChevronDownIcon, SvgOldLgChevronLeft$1 as OldLgChevronLeftIcon, SvgOldLgChevronRight$1 as OldLgChevronRightIcon, SvgOldLgChevronUp$1 as OldLgChevronUpIcon, SvgOldListBullet$1 as OldListBulletIcon, SvgOldLogout$1 as OldLogoutIcon, SvgOldMapMarker$1 as OldMapMarkerIcon, SvgOldMinus$1 as OldMinusIcon, SvgOldNotification$1 as OldNotificationIcon, SvgOldOrganization$1 as OldOrganizationIcon, SvgOldPlus$1 as OldPlusIcon, SvgOldQuestionCircle$1 as OldQuestionCircleIcon, SvgOldSearch$1 as OldSearchIcon, SvgOldShop$1 as OldShopIcon, SvgOldStar$1 as OldStarIcon, SvgOldStock$1 as OldStockIcon, SvgOldTerminal$1 as OldTerminalIcon, SvgOldTicket$1 as OldTicketIcon, SvgOldTrash$1 as OldTrashIcon, SvgOldUser$1 as OldUserIcon, SvgOldWarehouse$1 as OldWarehouseIcon, SvgOldWarning$1 as OldWarningIcon, SvgOrganization$1 as OrganizationIcon, SvgOrganizationInfo$1 as OrganizationInfoIcon, SvgParagraphCenter$1 as ParagraphCenterIcon, SvgParagraphLeft$1 as ParagraphLeftIcon, SvgParagraphRight$1 as ParagraphRightIcon, SvgPennant$1 as PennantIcon, SvgPercent$1 as PercentIcon, SvgPhone$1 as PhoneIcon, SvgPlayCircle$1 as PlayCircleIcon, SvgPlay$1 as PlayIcon, SvgPlus$1 as PlusIcon, SvgPrinter$1 as PrinterIcon, SvgPrinterOffline$1 as PrinterOfflineIcon, SvgQuestionCircle$1 as QuestionCircleIcon, SvgQuestionCircleSolid$1 as QuestionCircleSolidIcon, SvgQuestion$1 as QuestionIcon, SvgReceipt$1 as ReceiptIcon, SvgRefresh$1 as RefreshIcon, SvgReport$1 as ReportIcon, SvgReturn$1 as ReturnIcon, SvgRhombus$1 as RhombusIcon, SvgRingnote$1 as RingnoteIcon, SvgRocket$1 as RocketIcon, SvgRss$1 as RssIcon, SvgScaleDown$1 as ScaleDownIcon, SvgScaleUp$1 as ScaleUpIcon, SvgSearch$1 as SearchIcon, SvgShareAndroid$1 as ShareAndroidIcon, SvgShareIos$1 as ShareIosIcon, SvgShiftManagement$1 as ShiftManagementIcon, SvgShop$1 as ShopIcon, SvgShopInfo$1 as ShopInfoIcon, SvgSidebarLeft$1 as SidebarLeftIcon, SvgSidebarRight$1 as SidebarRightIcon, SvgSmChevronDown$1 as SmChevronDownIcon, SvgSmChevronLeft$1 as SmChevronLeftIcon, SvgSmChevronRight$1 as SmChevronRightIcon, SvgSmChevronUp$1 as SmChevronUpIcon, SvgSoundCircle$1 as SoundCircleIcon, SvgSparkle$1 as SparkleIcon, SvgSpinner$1 as SpinnerIcon, SvgStaff$1 as StaffIcon, StandButton, StandCheckbox, StandCheckboxWithLabel, StandInputText, StandLegacyNavi, StandLinkButton, StandNavi, StandNote, StandRadio, StandRadioGroup, StandRadioWithLabel, StandSwitch, StandTextArea, StandSwitch as StandToggle, SvgStandard$1 as StandardIcon, SvgStar$1 as StarIcon, SvgStarSolid$1 as StarSolidIcon, SvgStock$1 as StockIcon, SvgStockLink$1 as StockLinkIcon, SvgStockMove$1 as StockMoveIcon, SvgStocks$1 as StocksIcon, SvgStoresAyments$1 as StoresAymentsIcon, SvgStoresBrandapps$1 as StoresBrandappsIcon, SvgStores$1 as StoresIcon, SvgStoresInvoice$1 as StoresInvoiceIcon, SvgStoresNetshop$1 as StoresNetshopIcon, SvgStoresRegi$1 as StoresRegiIcon, SvgStoresReserve$1 as StoresReserveIcon, SvgSupport$1 as SupportIcon, SvgSync$1 as SyncIcon, SvgSyncSolid$1 as SyncSolidIcon, SvgTable$1 as TableIcon, SvgTag$1 as TagIcon, SvgTerminal$1 as TerminalIcon, SvgTerminalOffline$1 as TerminalOfflineIcon, SvgTextBald$1 as TextBaldIcon, SvgText$1 as TextIcon, SvgTextSmall$1 as TextSmallIcon, SvgTextUnderline$1 as TextUnderlineIcon, SvgTicketCircle$1 as TicketCircleIcon, SvgTicketDiscount$1 as TicketDiscountIcon, SvgTicket$1 as TicketIcon, SvgTimesCircle$1 as TimesCircleIcon, SvgTimesCircleSolid$1 as TimesCircleSolidIcon, SvgTrash$1 as TrashIcon, SvgTriangle$1 as TriangleIcon, SvgUserEmpty$1 as UserEmptyIcon, SvgUser$1 as UserIcon, SvgWallet$1 as WalletIcon, SvgWarehouse$1 as WarehouseIcon, SvgWarningCircleSolid$1 as WarningCircleSolidIcon, SvgWarning$1 as WarningIcon, WarningSolidIcon, SvgYen$1 as YenIcon, SvgYenPayment$1 as YenPaymentIcon, SvgYenWithdrawal$1 as YenWithdrawalIcon, detectAppId, getDefaultSettings, getNaviSchema, useStandNavi };
